/**
 * @file Generated by js-routes 2.3.7. Based on Rails 7.0.10 routes of Dashboard::Application.
 * @version d05506c13e09827a18bfa921756a73c8db94e96ce2b87ca42ef8612f49457421
 * @see https://github.com/railsware/js-routes
 */
"use strict";
const __jsr = (() => {
    const hasProp = (value, key) => Object.prototype.hasOwnProperty.call(value, key);
    let NodeTypes;
    (function (NodeTypes) {
        NodeTypes[NodeTypes["GROUP"] = 1] = "GROUP";
        NodeTypes[NodeTypes["CAT"] = 2] = "CAT";
        NodeTypes[NodeTypes["SYMBOL"] = 3] = "SYMBOL";
        NodeTypes[NodeTypes["OR"] = 4] = "OR";
        NodeTypes[NodeTypes["STAR"] = 5] = "STAR";
        NodeTypes[NodeTypes["LITERAL"] = 6] = "LITERAL";
        NodeTypes[NodeTypes["SLASH"] = 7] = "SLASH";
        NodeTypes[NodeTypes["DOT"] = 8] = "DOT";
    })(NodeTypes || (NodeTypes = {}));
    const isBrowser = typeof window !== "undefined";
    const UnescapedSpecials = "-._~!$&'()*+,;=:@"
        .split("")
        .map((s) => s.charCodeAt(0));
    const UnescapedRanges = [
        ["a", "z"],
        ["A", "Z"],
        ["0", "9"],
    ].map((range) => range.map((s) => s.charCodeAt(0)));
    const ModuleReferences = {
        CJS: {
            define(routes) {
                if (module) {
                    // Some javascript processors (like vite/rolldown)
                    // warn on using module dot exports in an ESM module.
                    // This just obfuscates that assignment a little so
                    // users don't get a warning they can't fix.
                    const _mod = module;
                    _mod.exports = routes;
                }
            },
            isSupported() {
                return typeof module === "object";
            },
        },
        AMD: {
            define(routes) {
                if (define) {
                    define([], function () {
                        return routes;
                    });
                }
            },
            isSupported() {
                return typeof define === "function" && !!define.amd;
            },
        },
        UMD: {
            define(routes) {
                if (ModuleReferences.AMD.isSupported()) {
                    ModuleReferences.AMD.define(routes);
                }
                else {
                    if (ModuleReferences.CJS.isSupported()) {
                        try {
                            ModuleReferences.CJS.define(routes);
                        }
                        catch (error) {
                            if (error.name !== "TypeError")
                                throw error;
                        }
                    }
                }
            },
            isSupported() {
                return (ModuleReferences.AMD.isSupported() ||
                    ModuleReferences.CJS.isSupported());
            },
        },
        ESM: {
            define() {
                // Module can only be defined using ruby code generation
            },
            isSupported() {
                // Its impossible to check if "export" keyword is supported
                return true;
            },
        },
        NIL: {
            define() {
                // Defined using RubyVariables . WRAPPER
            },
            isSupported() {
                return true;
            },
        },
        DTS: {
            // Acts the same as ESM
            define(routes) {
                ModuleReferences.ESM.define(routes);
            },
            isSupported() {
                return ModuleReferences.ESM.isSupported();
            },
        },
    };
    class ParametersMissing extends Error {
        constructor(...keys) {
            super(`Route missing required keys: ${keys.join(", ")}`);
            this.keys = keys;
            Object.setPrototypeOf(this, Object.getPrototypeOf(this));
            this.name = ParametersMissing.name;
        }
    }
    const ReservedOptions = [
        "anchor",
        "trailing_slash",
        "subdomain",
        "host",
        "port",
        "protocol",
        "script_name",
    ];
    class UtilsClass {
        constructor() {
            this.configuration = {
                prefix: "",
                default_url_options: {},
                special_options_key: "_options",
                serializer: null || this.default_serializer.bind(this),
            };
        }
        default_serializer(value, prefix) {
            if (!prefix && !this.is_object(value)) {
                throw new Error("Url parameters should be a javascript hash");
            }
            prefix = prefix || "";
            const result = [];
            if (this.is_array(value)) {
                for (const element of value) {
                    result.push(this.default_serializer(element, prefix + "[]"));
                }
            }
            else if (this.is_object(value)) {
                for (let key in value) {
                    if (!hasProp(value, key))
                        continue;
                    let prop = value[key];
                    if (prefix) {
                        key = prefix + "[" + key + "]";
                    }
                    const subvalue = this.default_serializer(prop, key);
                    if (subvalue.length) {
                        result.push(subvalue);
                    }
                }
            }
            else {
                const key = encodeURIComponent(prefix);
                result.push(this.is_not_nullable(value) ||
                    true
                    ? key + "=" + encodeURIComponent("" + (value !== null && value !== void 0 ? value : ""))
                    : key);
            }
            return result.join("&");
        }
        serialize(object) {
            return this.configuration.serializer(object);
        }
        extract_options(number_of_params, args) {
            const last_el = args[args.length - 1];
            if ((args.length > number_of_params && last_el === 0) ||
                (this.is_object(last_el) && !this.looks_like_serialized_model(last_el))) {
                if (this.is_object(last_el)) {
                    delete last_el[this.configuration.special_options_key];
                }
                return {
                    args: args.slice(0, args.length - 1),
                    options: last_el,
                };
            }
            else {
                return { args, options: {} };
            }
        }
        looks_like_serialized_model(object) {
            return (this.is_object(object) &&
                !(this.configuration.special_options_key in object) &&
                ("id" in object || "to_param" in object || "toParam" in object));
        }
        path_identifier(object) {
            const result = this.unwrap_path_identifier(object);
            return this.is_nullable(result) ||
                (false && result === false)
                ? ""
                : "" + result;
        }
        unwrap_path_identifier(object) {
            let result = object;
            if (!this.is_object(object)) {
                return object;
            }
            if ("to_param" in object) {
                result = object.to_param;
            }
            else if ("toParam" in object) {
                result = object.toParam;
            }
            else if ("id" in object) {
                result = object.id;
            }
            else {
                result = object;
            }
            return this.is_callable(result) ? result.call(object) : result;
        }
        partition_parameters(parts, required_params, default_options, call_arguments) {
            let { args, options } = this.extract_options(parts.length, call_arguments);
            if (args.length > parts.length) {
                throw new Error("Too many parameters provided for path");
            }
            let use_all_parts = args.length > required_params.length;
            const parts_options = {
                ...this.configuration.default_url_options,
            };
            for (const key in options) {
                const value = options[key];
                if (!hasProp(options, key))
                    continue;
                use_all_parts = true;
                if (parts.includes(key)) {
                    parts_options[key] = value;
                }
            }
            options = {
                ...this.configuration.default_url_options,
                ...default_options,
                ...options,
            };
            const keyword_parameters = {};
            let query_parameters = {};
            for (const key in options) {
                if (!hasProp(options, key))
                    continue;
                const value = options[key];
                if (key === "params") {
                    if (this.is_object(value)) {
                        query_parameters = {
                            ...query_parameters,
                            ...value,
                        };
                    }
                    else {
                        throw new Error("params value should always be an object");
                    }
                }
                else if (this.is_reserved_option(key)) {
                    keyword_parameters[key] = value;
                }
                else {
                    if (!this.is_nullable(value) &&
                        (value !== default_options[key] || required_params.includes(key))) {
                        query_parameters[key] = value;
                    }
                }
            }
            const route_parts = use_all_parts ? parts : required_params;
            let i = 0;
            for (const part of route_parts) {
                if (i < args.length) {
                    const value = args[i];
                    if (!hasProp(parts_options, part)) {
                        query_parameters[part] = value;
                        ++i;
                    }
                }
            }
            return { keyword_parameters, query_parameters };
        }
        build_route(parts, required_params, default_options, route, absolute, args) {
            const { keyword_parameters, query_parameters } = this.partition_parameters(parts, required_params, default_options, args);
            let { trailing_slash, anchor, script_name } = keyword_parameters;
            const missing_params = required_params.filter((param) => !hasProp(query_parameters, param) ||
                this.is_nullable(query_parameters[param]));
            if (missing_params.length) {
                throw new ParametersMissing(...missing_params);
            }
            let result = this.get_prefix() + this.visit(route, query_parameters);
            if (trailing_slash) {
                result = result.replace(/(.*?)[/]?$/, "$1/");
            }
            const url_params = this.serialize(query_parameters);
            if (url_params.length) {
                result += "?" + url_params;
            }
            if (anchor) {
                result += "#" + anchor;
            }
            if (script_name) {
                const last_index = script_name.length - 1;
                if (script_name[last_index] == "/" && result[0] == "/") {
                    script_name = script_name.slice(0, last_index);
                }
                result = script_name + result;
            }
            if (absolute) {
                result = this.route_url(keyword_parameters) + result;
            }
            return result;
        }
        visit(route, parameters, optional = false) {
            switch (route[0]) {
                case NodeTypes.GROUP:
                    return this.visit(route[1], parameters, true);
                case NodeTypes.CAT:
                    return this.visit_cat(route, parameters, optional);
                case NodeTypes.SYMBOL:
                    return this.visit_symbol(route, parameters, optional);
                case NodeTypes.STAR:
                    return this.visit_globbing(route[1], parameters, true);
                case NodeTypes.LITERAL:
                case NodeTypes.SLASH:
                case NodeTypes.DOT:
                    return route[1];
                default:
                    throw new Error("Unknown Rails node type");
            }
        }
        is_not_nullable(object) {
            return !this.is_nullable(object);
        }
        is_nullable(object) {
            return object === undefined || object === null;
        }
        visit_cat(
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        [_type, left, right], parameters, optional) {
            const left_part = this.visit(left, parameters, optional);
            let right_part = this.visit(right, parameters, optional);
            if (optional &&
                ((this.is_optional_node(left[0]) && !left_part) ||
                    (this.is_optional_node(right[0]) && !right_part))) {
                return "";
            }
            // if left_part ends on '/' and right_part starts on '/'
            if (left_part[left_part.length - 1] === "/" && right_part[0] === "/") {
                // strip slash from right_part
                // to prevent double slash
                right_part = right_part.substring(1);
            }
            return left_part + right_part;
        }
        visit_symbol(
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        [_type, key], parameters, optional) {
            const value = this.path_identifier(parameters[key]);
            delete parameters[key];
            if (value.length) {
                return this.encode_segment(value);
            }
            if (optional) {
                return "";
            }
            else {
                throw new ParametersMissing(key);
            }
        }
        encode_segment(segment) {
            if (segment.match(/^[a-zA-Z0-9-]$/)) {
                // Performance optimization for 99% of cases
                return segment;
            }
            return (segment.match(/./gu) || [])
                .map((ch) => {
                const code = ch.charCodeAt(0);
                if (UnescapedRanges.find((range) => code >= range[0] && code <= range[1]) ||
                    UnescapedSpecials.includes(code)) {
                    return ch;
                }
                else {
                    return encodeURIComponent(ch);
                }
            })
                .join("");
        }
        is_optional_node(node) {
            return [NodeTypes.STAR, NodeTypes.SYMBOL, NodeTypes.CAT].includes(node);
        }
        build_path_spec(route, wildcard = false) {
            let key;
            switch (route[0]) {
                case NodeTypes.GROUP:
                    return `(${this.build_path_spec(route[1])})`;
                case NodeTypes.CAT:
                    return (this.build_path_spec(route[1]) + this.build_path_spec(route[2]));
                case NodeTypes.STAR:
                    return this.build_path_spec(route[1], true);
                case NodeTypes.SYMBOL:
                    key = route[1];
                    if (wildcard) {
                        return (key.startsWith("*") ? "" : "*") + key;
                    }
                    else {
                        return ":" + key;
                    }
                    break;
                case NodeTypes.SLASH:
                case NodeTypes.DOT:
                case NodeTypes.LITERAL:
                    return route[1];
                default:
                    throw new Error("Unknown Rails node type");
            }
        }
        visit_globbing(route, parameters, optional) {
            const key = route[1];
            let value = parameters[key];
            delete parameters[key];
            if (this.is_nullable(value)) {
                return this.visit(route, parameters, optional);
            }
            if (this.is_array(value)) {
                value = value.join("/");
            }
            const result = this.path_identifier(value);
            return encodeURI(result);
        }
        get_prefix() {
            const prefix = this.configuration.prefix;
            return prefix.match("/$")
                ? prefix.substring(0, prefix.length - 1)
                : prefix;
        }
        route(parts_table, route_spec, absolute = false) {
            const required_params = [];
            const parts = [];
            const default_options = {};
            for (const [part, { r: required, d: value }] of Object.entries(parts_table)) {
                parts.push(part);
                if (required) {
                    required_params.push(part);
                }
                if (this.is_not_nullable(value)) {
                    default_options[part] = value;
                }
            }
            const result = (...args) => {
                return this.build_route(parts, required_params, default_options, route_spec, absolute, args);
            };
            result.requiredParams = () => required_params;
            result.toString = () => {
                return this.build_path_spec(route_spec);
            };
            return result;
        }
        route_url(route_defaults) {
            const hostname = route_defaults.host || this.current_host();
            if (!hostname) {
                return "";
            }
            const subdomain = route_defaults.subdomain
                ? route_defaults.subdomain + "."
                : "";
            const protocol = route_defaults.protocol || this.current_protocol();
            let port = route_defaults.port ||
                (!route_defaults.host ? this.current_port() : undefined);
            port = port ? ":" + port : "";
            return protocol + "://" + subdomain + hostname + port;
        }
        current_host() {
            var _a;
            return (isBrowser && ((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.hostname)) || "";
        }
        current_protocol() {
            var _a, _b;
            return ((isBrowser && ((_b = (_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.protocol) === null || _b === void 0 ? void 0 : _b.replace(/:$/, ""))) || "http");
        }
        current_port() {
            var _a;
            return (isBrowser && ((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.port)) || "";
        }
        is_object(value) {
            return (typeof value === "object" &&
                Object.prototype.toString.call(value) === "[object Object]");
        }
        is_array(object) {
            return object instanceof Array;
        }
        is_callable(object) {
            return typeof object === "function" && !!object.call;
        }
        is_reserved_option(key) {
            return ReservedOptions.includes(key);
        }
        configure(new_config) {
            if (new_config.prefix) {
                console.warn("JsRoutes configuration prefix option is deprecated in favor of default_url_options.script_name.");
            }
            this.configuration = { ...this.configuration, ...new_config };
            return this.configuration;
        }
        config() {
            return { ...this.configuration };
        }
        is_module_supported(name) {
            return ModuleReferences[name].isSupported();
        }
        ensure_module_supported(name) {
            if (!this.is_module_supported(name)) {
                throw new Error(`${name} is not supported by runtime`);
            }
        }
        define_module(name, module) {
            this.ensure_module_supported(name);
            ModuleReferences[name].define(module);
            return module;
        }
    }
    const utils = new UtilsClass();
    // We want this helper name to be short
    const __jsr = {
        r: utils.route.bind(utils),
    };
    return utils.define_module("ESM", {
        ...__jsr,
        configure: utils.configure.bind(utils),
        config: utils.config.bind(utils),
        serialize: utils.serialize.bind(utils),
        ...{},
    });
})();
export const configure = __jsr.configure;

export const config = __jsr.config;

export const serialize = __jsr.serialize;

/**
 * Generates rails route to
 * /api/v1/section_instructors/:id/accept(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const accept_api_v1_section_instructor_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"section_instructors"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"accept"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/v1/section_instructors/:id/accept(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const accept_api_v1_section_instructor_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"section_instructors"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"accept"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/invitation/accept(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const accept_user_invitation_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"invitation"],[2,[7,"/"],[2,[6,"accept"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /users/invitation/accept(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const accept_user_invitation_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"invitation"],[2,[7,"/"],[2,[6,"accept"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/account_repair(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_repair_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"account_repair"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /admin/account_repair(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_repair_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"account_repair"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/account_repair(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_repair_form_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"account_repair"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /admin/account_repair(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_repair_form_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"account_repair"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /activity_hints/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const activity_hint_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"activity_hints"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /activity_hints/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const activity_hint_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"activity_hints"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /p/adaptations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adaptations_p_index_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[6,"adaptations"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /p/adaptations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adaptations_p_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[6,"adaptations"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /projects/adaptations/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adaptations_project_create_new_projects_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"adaptations"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/adaptations/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adaptations_project_create_new_projects_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"adaptations"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/adaptations/:channel_id/edit(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adaptations_project_edit_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"adaptations"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/adaptations/:channel_id/edit(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adaptations_project_edit_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"adaptations"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/adaptations/:channel_id/export_config(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adaptations_project_export_config_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"adaptations"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"export_config"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/adaptations/:channel_id/export_config(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adaptations_project_export_config_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"adaptations"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"export_config"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/adaptations/:channel_id/export_create_channel(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adaptations_project_export_create_channel_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"adaptations"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"export_create_channel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/adaptations/:channel_id/export_create_channel(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adaptations_project_export_create_channel_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"adaptations"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"export_create_channel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/adaptations/:channel_id/embed_app_and_code(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adaptations_project_iframe_embed_app_and_code_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"adaptations"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"embed_app_and_code"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/adaptations/:channel_id/embed_app_and_code(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adaptations_project_iframe_embed_app_and_code_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"adaptations"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"embed_app_and_code"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/adaptations/:channel_id/embed(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adaptations_project_iframe_embed_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"adaptations"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"embed"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/adaptations/:channel_id/embed(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adaptations_project_iframe_embed_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"adaptations"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"embed"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/adaptations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adaptations_project_projects_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"adaptations"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /projects/adaptations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adaptations_project_projects_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"adaptations"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /projects/adaptations/:channel_id/remix(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adaptations_project_remix_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"adaptations"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"remix"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/adaptations/:channel_id/remix(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adaptations_project_remix_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"adaptations"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"remix"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/adaptations/:channel_id(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adaptations_project_share_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"adaptations"],[2,[7,"/"],[2,[3,"channel_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/adaptations/:channel_id(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adaptations_project_share_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"adaptations"],[2,[7,"/"],[2,[3,"channel_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/adaptations/:channel_id/view(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adaptations_project_view_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"adaptations"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"view"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/adaptations/:channel_id/view(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adaptations_project_view_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"adaptations"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"view"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /datablock_storage/:channel_id/add_column(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const add_column_datablock_storage_index_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"datablock_storage"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"add_column"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /datablock_storage/:channel_id/add_column(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const add_column_datablock_storage_index_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"datablock_storage"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"add_column"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /regional_partners/:id/add_mapping(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const add_mapping_regional_partner_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"regional_partners"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"add_mapping"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /regional_partners/:id/add_mapping(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const add_mapping_regional_partner_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"regional_partners"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"add_mapping"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /datablock_storage/:channel_id/add_shared_table(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const add_shared_table_datablock_storage_index_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"datablock_storage"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"add_shared_table"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /datablock_storage/:channel_id/add_shared_table(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const add_shared_table_datablock_storage_index_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"datablock_storage"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"add_shared_table"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /levels/:id/add_skill(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const add_skill_level_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"levels"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"add_skill"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /levels/:id/add_skill(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const add_skill_level_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"levels"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"add_skill"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/pilots/add_to_pilot(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const add_to_pilot_admin_pilots_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"pilots"],[2,[7,"/"],[2,[6,"add_to_pilot"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/pilots/add_to_pilot(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const add_to_pilot_admin_pilots_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"pilots"],[2,[7,"/"],[2,[6,"add_to_pilot"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/debug(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_debug_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"debug"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /admin/debug(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_debug_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"debug"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_directory_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /admin(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_directory_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /admin/pilots/:pilot_name(.:format)
 * @param {any} pilot_name
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_pilot_url = /*#__PURE__*/ __jsr.r({"pilot_name":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"pilots"],[2,[7,"/"],[2,[3,"pilot_name"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/pilots/:pilot_name(.:format)
 * @param {any} pilot_name
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_pilot_path = /*#__PURE__*/ __jsr.r({"pilot_name":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"pilots"],[2,[7,"/"],[2,[3,"pilot_name"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/pilots(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_pilots_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"pilots"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /admin/pilots(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_pilots_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"pilots"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/styleguide(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_styleguide_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"styleguide"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /admin/styleguide(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_styleguide_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"styleguide"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/sections/:id/ai_chat_access_level(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ai_chat_access_level_api_v1_section_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"sections"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"ai_chat_access_level"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/v1/sections/:id/ai_chat_access_level(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ai_chat_access_level_api_v1_section_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"sections"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"ai_chat_access_level"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /dashboardapi/sections/:id/ai_chat_access_level(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ai_chat_access_level_section_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"dashboardapi"],[2,[7,"/"],[2,[6,"sections"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"ai_chat_access_level"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /dashboardapi/sections/:id/ai_chat_access_level(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ai_chat_access_level_section_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"dashboardapi"],[2,[7,"/"],[2,[6,"sections"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"ai_chat_access_level"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rubrics/:id/ai_evaluation_status_for_all(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ai_evaluation_status_for_all_rubric_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rubrics"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"ai_evaluation_status_for_all"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /rubrics/:id/ai_evaluation_status_for_all(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ai_evaluation_status_for_all_rubric_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rubrics"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"ai_evaluation_status_for_all"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /rubrics/:id/ai_evaluation_status_for_user(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ai_evaluation_status_for_user_rubric_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rubrics"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"ai_evaluation_status_for_user"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /rubrics/:id/ai_evaluation_status_for_user(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ai_evaluation_status_for_user_rubric_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rubrics"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"ai_evaluation_status_for_user"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /ai_gateway/access_token(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ai_gateway_access_token_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"ai_gateway"],[2,[7,"/"],[2,[6,"access_token"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /ai_gateway/access_token(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ai_gateway_access_token_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"ai_gateway"],[2,[7,"/"],[2,[6,"access_token"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /student_snapshots/ai_generated_lesson_feedback(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ai_generated_lesson_feedback_student_snapshots_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"student_snapshots"],[2,[7,"/"],[2,[6,"ai_generated_lesson_feedback"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /student_snapshots/ai_generated_lesson_feedback(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ai_generated_lesson_feedback_student_snapshots_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"student_snapshots"],[2,[7,"/"],[2,[6,"ai_generated_lesson_feedback"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /ai_interaction_feedback(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ai_interaction_feedback_index_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"ai_interaction_feedback"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /ai_interaction_feedback(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ai_interaction_feedback_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"ai_interaction_feedback"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /ai_iteration/image_safety_eval(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ai_iteration_image_safety_eval_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"ai_iteration"],[2,[7,"/"],[2,[6,"image_safety_eval"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /ai_iteration/image_safety_eval(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ai_iteration_image_safety_eval_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"ai_iteration"],[2,[7,"/"],[2,[6,"image_safety_eval"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /ai_iteration/tools(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ai_iteration_tools_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"ai_iteration"],[2,[7,"/"],[2,[6,"tools"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /ai_iteration/tools(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ai_iteration_tools_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"ai_iteration"],[2,[7,"/"],[2,[6,"tools"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /ai_lesson_summaries(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ai_lesson_summaries_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"ai_lesson_summaries"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /ai_lesson_summaries(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ai_lesson_summaries_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"ai_lesson_summaries"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /ai_lesson_summaries/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ai_lesson_summary_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"ai_lesson_summaries"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /ai_lesson_summaries/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ai_lesson_summary_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"ai_lesson_summaries"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /ai_lesson_summary_podcasts/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ai_lesson_summary_podcast_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"ai_lesson_summary_podcasts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /ai_lesson_summary_podcasts/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ai_lesson_summary_podcast_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"ai_lesson_summary_podcasts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /ai_lesson_summaries/ai_lesson_summary_podcast_script(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ai_lesson_summary_podcast_script_ai_lesson_summaries_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"ai_lesson_summaries"],[2,[7,"/"],[2,[6,"ai_lesson_summary_podcast_script"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /ai_lesson_summaries/ai_lesson_summary_podcast_script(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ai_lesson_summary_podcast_script_ai_lesson_summaries_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"ai_lesson_summaries"],[2,[7,"/"],[2,[6,"ai_lesson_summary_podcast_script"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /ai_lesson_summary_podcasts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ai_lesson_summary_podcasts_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"ai_lesson_summary_podcasts"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /ai_lesson_summary_podcasts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ai_lesson_summary_podcasts_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"ai_lesson_summary_podcasts"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /ai_observability/add_internal_ai_tutor_dataset_item(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ai_observability_add_internal_ai_tutor_dataset_item_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"ai_observability"],[2,[7,"/"],[2,[6,"add_internal_ai_tutor_dataset_item"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /ai_observability/add_internal_ai_tutor_dataset_item(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ai_observability_add_internal_ai_tutor_dataset_item_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"ai_observability"],[2,[7,"/"],[2,[6,"add_internal_ai_tutor_dataset_item"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /ai_prompt_management/get_prompt(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ai_prompt_management_get_prompt_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"ai_prompt_management"],[2,[7,"/"],[2,[6,"get_prompt"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /ai_prompt_management/get_prompt(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ai_prompt_management_get_prompt_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"ai_prompt_management"],[2,[7,"/"],[2,[6,"get_prompt"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /ai_student_podcasts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ai_student_podcasts_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"ai_student_podcasts"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /ai_student_podcasts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ai_student_podcasts_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"ai_student_podcasts"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /aichat_events/chat_history(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const aichat_events_chat_history_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"aichat_events"],[2,[7,"/"],[2,[6,"chat_history"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /aichat_events/chat_history(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const aichat_events_chat_history_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"aichat_events"],[2,[7,"/"],[2,[6,"chat_history"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /aichat_events/log_chat_event(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const aichat_events_log_chat_event_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"aichat_events"],[2,[7,"/"],[2,[6,"log_chat_event"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /aichat_events/log_chat_event(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const aichat_events_log_chat_event_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"aichat_events"],[2,[7,"/"],[2,[6,"log_chat_event"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /aichat_events/submit_teacher_feedback(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const aichat_events_submit_teacher_feedback_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"aichat_events"],[2,[7,"/"],[2,[6,"submit_teacher_feedback"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /aichat_events/submit_teacher_feedback(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const aichat_events_submit_teacher_feedback_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"aichat_events"],[2,[7,"/"],[2,[6,"submit_teacher_feedback"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /aichat/find_toxicity(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const aichat_find_toxicity_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"aichat"],[2,[7,"/"],[2,[6,"find_toxicity"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /aichat/find_toxicity(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const aichat_find_toxicity_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"aichat"],[2,[7,"/"],[2,[6,"find_toxicity"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /aichat_requests/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const aichat_request_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"aichat_requests"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /aichat_requests/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const aichat_request_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"aichat_requests"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /aichat_request/start_chat_completion(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const aichat_request_start_chat_completion_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"aichat_request"],[2,[7,"/"],[2,[6,"start_chat_completion"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /aichat_request/start_chat_completion(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const aichat_request_start_chat_completion_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"aichat_request"],[2,[7,"/"],[2,[6,"start_chat_completion"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /aichat_requests(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const aichat_requests_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"aichat_requests"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /aichat_requests(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const aichat_requests_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"aichat_requests"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /aidiff_artifacts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const aidiff_artifacts_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"aidiff_artifacts"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /aidiff_artifacts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const aidiff_artifacts_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"aidiff_artifacts"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /aidiff_exit_tickets/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const aidiff_exit_ticket_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"aidiff_exit_tickets"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /aidiff_exit_tickets/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const aidiff_exit_ticket_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"aidiff_exit_tickets"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /aidiff_exit_tickets(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const aidiff_exit_tickets_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"aidiff_exit_tickets"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /aidiff_exit_tickets(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const aidiff_exit_tickets_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"aidiff_exit_tickets"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /aidiff_lesson_hooks/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const aidiff_lesson_hook_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"aidiff_lesson_hooks"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /aidiff_lesson_hooks/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const aidiff_lesson_hook_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"aidiff_lesson_hooks"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /aidiff_lesson_hooks(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const aidiff_lesson_hooks_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"aidiff_lesson_hooks"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /aidiff_lesson_hooks(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const aidiff_lesson_hooks_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"aidiff_lesson_hooks"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /aidiff_threads/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const aidiff_thread_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"aidiff_threads"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /aidiff_threads/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const aidiff_thread_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"aidiff_threads"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /aidiff_threads(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const aidiff_threads_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"aidiff_threads"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /aidiff_threads(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const aidiff_threads_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"aidiff_threads"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /p/algebra_game(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const algebra_game_p_index_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[6,"algebra_game"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /p/algebra_game(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const algebra_game_p_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[6,"algebra_game"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /projects/algebra_game/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const algebra_game_project_create_new_projects_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"algebra_game"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/algebra_game/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const algebra_game_project_create_new_projects_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"algebra_game"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/algebra_game/:channel_id/edit(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const algebra_game_project_edit_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"algebra_game"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/algebra_game/:channel_id/edit(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const algebra_game_project_edit_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"algebra_game"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/algebra_game/:channel_id/export_config(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const algebra_game_project_export_config_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"algebra_game"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"export_config"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/algebra_game/:channel_id/export_config(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const algebra_game_project_export_config_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"algebra_game"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"export_config"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/algebra_game/:channel_id/export_create_channel(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const algebra_game_project_export_create_channel_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"algebra_game"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"export_create_channel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/algebra_game/:channel_id/export_create_channel(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const algebra_game_project_export_create_channel_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"algebra_game"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"export_create_channel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/algebra_game/:channel_id/embed_app_and_code(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const algebra_game_project_iframe_embed_app_and_code_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"algebra_game"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"embed_app_and_code"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/algebra_game/:channel_id/embed_app_and_code(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const algebra_game_project_iframe_embed_app_and_code_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"algebra_game"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"embed_app_and_code"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/algebra_game/:channel_id/embed(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const algebra_game_project_iframe_embed_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"algebra_game"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"embed"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/algebra_game/:channel_id/embed(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const algebra_game_project_iframe_embed_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"algebra_game"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"embed"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/algebra_game(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const algebra_game_project_projects_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"algebra_game"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /projects/algebra_game(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const algebra_game_project_projects_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"algebra_game"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /projects/algebra_game/:channel_id/remix(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const algebra_game_project_remix_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"algebra_game"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"remix"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/algebra_game/:channel_id/remix(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const algebra_game_project_remix_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"algebra_game"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"remix"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/algebra_game/:channel_id(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const algebra_game_project_share_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"algebra_game"],[2,[7,"/"],[2,[3,"channel_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/algebra_game/:channel_id(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const algebra_game_project_share_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"algebra_game"],[2,[7,"/"],[2,[3,"channel_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/algebra_game/:channel_id/view(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const algebra_game_project_view_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"algebra_game"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"view"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/algebra_game/:channel_id/view(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const algebra_game_project_view_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"algebra_game"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"view"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /courses/all(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const all_courses_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"courses"],[2,[7,"/"],[2,[6,"all"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /courses/all(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const all_courses_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"courses"],[2,[7,"/"],[2,[6,"all"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/clever_classrooms(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_clever_classrooms_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"clever_classrooms"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /api/clever_classrooms(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_clever_classrooms_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"clever_classrooms"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/course_summary(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_course_summary_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"course_summary"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /api/course_summary(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_course_summary_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"course_summary"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/example_solutions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_example_solutions_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"example_solutions"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /api/example_solutions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_example_solutions_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"example_solutions"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/firehose_unreachable(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_firehose_unreachable_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"firehose_unreachable"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /api/firehose_unreachable(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_firehose_unreachable_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"firehose_unreachable"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/google_classrooms(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_google_classrooms_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"google_classrooms"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /api/google_classrooms(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_google_classrooms_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"google_classrooms"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/immersive_reader_token(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_immersive_reader_token_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"immersive_reader_token"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /api/immersive_reader_token(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_immersive_reader_token_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"immersive_reader_token"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/import_clever_classroom(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_import_clever_classroom_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"import_clever_classroom"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /api/import_clever_classroom(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_import_clever_classroom_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"import_clever_classroom"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/import_google_classroom(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_import_google_classroom_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"import_google_classroom"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /api/import_google_classroom(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_import_google_classroom_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"import_google_classroom"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/lesson_materials(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_lesson_materials_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"lesson_materials"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /api/lesson_materials(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_lesson_materials_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"lesson_materials"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/lock_status(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_lock_status_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"lock_status"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /api/lock_status(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_lock_status_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"lock_status"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/lockable_state(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_lockable_state_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"lockable_state"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /api/lockable_state(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_lockable_state_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"lockable_state"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/script_standards(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_script_standards_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"script_standards"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /api/script_standards(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_script_standards_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"script_standards"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/script_structure(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_script_structure_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"script_structure"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /api/script_structure(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_script_structure_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"script_structure"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/section(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_section_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"section"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /api/section(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_section_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"section"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/section_level_progress(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_section_level_progress_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"section_level_progress"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /api/section_level_progress(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_section_level_progress_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"section_level_progress"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/section_text_responses(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_section_text_responses_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"section_text_responses"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /api/section_text_responses(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_section_text_responses_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"section_text_responses"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/sections/transfers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_sections_transfers_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"sections"],[2,[7,"/"],[2,[6,"transfers"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/sections/transfers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_sections_transfers_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"sections"],[2,[7,"/"],[2,[6,"transfers"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/show_courses_with_progress(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_show_courses_with_progress_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"show_courses_with_progress"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /api/show_courses_with_progress(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_show_courses_with_progress_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"show_courses_with_progress"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/sign_cookies(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_sign_cookies_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"sign_cookies"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /api/sign_cookies(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_sign_cookies_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"sign_cookies"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/teacher_panel_progress(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_teacher_panel_progress_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"teacher_panel_progress"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /api/teacher_panel_progress(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_teacher_panel_progress_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"teacher_panel_progress"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/teacher_panel_section(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_teacher_panel_section_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"teacher_panel_section"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /api/teacher_panel_section(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_teacher_panel_section_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"teacher_panel_section"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/unit_summary(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_unit_summary_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"unit_summary"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /api/unit_summary(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_unit_summary_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"unit_summary"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/update_lockable_state(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_update_lockable_state_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"update_lockable_state"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /api/update_lockable_state(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_update_lockable_state_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"update_lockable_state"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/user_app_options(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_user_app_options_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"user_app_options"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /api/user_app_options(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_user_app_options_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"user_app_options"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/user_menu(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_user_menu_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"user_menu"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /api/user_menu(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_user_menu_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"user_menu"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/user_progress(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_user_progress_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"user_progress"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /api/user_progress(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_user_progress_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"user_progress"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/users/:user_id/using_text_mode(.:format)
 * @param {any} user_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_url = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"using_text_mode"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/v1/users/:user_id/using_text_mode(.:format)
 * @param {any} user_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"using_text_mode"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/ml_models/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_ml_model_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"ml_models"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/v1/ml_models/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_ml_model_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"ml_models"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/pd/enrollments/:enrollment_code(.:format)
 * @param {any} enrollment_code
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_pd_url = /*#__PURE__*/ __jsr.r({"enrollment_code":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"pd"],[2,[7,"/"],[2,[6,"enrollments"],[2,[7,"/"],[2,[3,"enrollment_code"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/v1/pd/enrollments/:enrollment_code(.:format)
 * @param {any} enrollment_code
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_pd_path = /*#__PURE__*/ __jsr.r({"enrollment_code":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"pd"],[2,[7,"/"],[2,[6,"enrollments"],[2,[7,"/"],[2,[3,"enrollment_code"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/pd/applications/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_pd_application_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"pd"],[2,[7,"/"],[2,[6,"applications"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/v1/pd/applications/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_pd_application_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"pd"],[2,[7,"/"],[2,[6,"applications"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/pd/applications(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_pd_applications_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"pd"],[2,[7,"/"],[2,[6,"applications"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/v1/pd/applications(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_pd_applications_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"pd"],[2,[7,"/"],[2,[6,"applications"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/pd/course_facilitators(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_pd_course_facilitators_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"pd"],[2,[7,"/"],[2,[6,"course_facilitators"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/v1/pd/course_facilitators(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_pd_course_facilitators_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"pd"],[2,[7,"/"],[2,[6,"course_facilitators"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/pd/enrollments/move(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_pd_enrollments_move_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"pd"],[2,[7,"/"],[2,[6,"enrollments"],[2,[7,"/"],[2,[6,"move"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/v1/pd/enrollments/move(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_pd_enrollments_move_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"pd"],[2,[7,"/"],[2,[6,"enrollments"],[2,[7,"/"],[2,[6,"move"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/pd/foorm/forms/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_pd_foorm_forms_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"pd"],[2,[7,"/"],[2,[6,"foorm"],[2,[7,"/"],[2,[6,"forms"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/v1/pd/foorm/forms/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_pd_foorm_forms_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"pd"],[2,[7,"/"],[2,[6,"foorm"],[2,[7,"/"],[2,[6,"forms"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/pd/foorm/forms/form_names(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_pd_foorm_forms_form_names_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"pd"],[2,[7,"/"],[2,[6,"foorm"],[2,[7,"/"],[2,[6,"forms"],[2,[7,"/"],[2,[6,"form_names"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/v1/pd/foorm/forms/form_names(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_pd_foorm_forms_form_names_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"pd"],[2,[7,"/"],[2,[6,"foorm"],[2,[7,"/"],[2,[6,"forms"],[2,[7,"/"],[2,[6,"form_names"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/pd/foorm/forms/form_with_library_items(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_pd_foorm_forms_form_with_library_items_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"pd"],[2,[7,"/"],[2,[6,"foorm"],[2,[7,"/"],[2,[6,"forms"],[2,[7,"/"],[2,[6,"form_with_library_items"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/v1/pd/foorm/forms/form_with_library_items(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_pd_foorm_forms_form_with_library_items_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"pd"],[2,[7,"/"],[2,[6,"foorm"],[2,[7,"/"],[2,[6,"forms"],[2,[7,"/"],[2,[6,"form_with_library_items"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/pd/foorm/forms/submissions_csv(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_pd_foorm_forms_submissions_csv_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"pd"],[2,[7,"/"],[2,[6,"foorm"],[2,[7,"/"],[2,[6,"forms"],[2,[7,"/"],[2,[6,"submissions_csv"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/v1/pd/foorm/forms/submissions_csv(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_pd_foorm_forms_submissions_csv_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"pd"],[2,[7,"/"],[2,[6,"foorm"],[2,[7,"/"],[2,[6,"forms"],[2,[7,"/"],[2,[6,"submissions_csv"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/pd/foorm/forms/validate_form(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_pd_foorm_forms_validate_form_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"pd"],[2,[7,"/"],[2,[6,"foorm"],[2,[7,"/"],[2,[6,"forms"],[2,[7,"/"],[2,[6,"validate_form"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/v1/pd/foorm/forms/validate_form(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_pd_foorm_forms_validate_form_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"pd"],[2,[7,"/"],[2,[6,"foorm"],[2,[7,"/"],[2,[6,"forms"],[2,[7,"/"],[2,[6,"validate_form"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/pd/foorm/library_questions/validate_library_question(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_pd_foorm_library_questions_validate_library_question_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"pd"],[2,[7,"/"],[2,[6,"foorm"],[2,[7,"/"],[2,[6,"library_questions"],[2,[7,"/"],[2,[6,"validate_library_question"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/v1/pd/foorm/library_questions/validate_library_question(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_pd_foorm_library_questions_validate_library_question_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"pd"],[2,[7,"/"],[2,[6,"foorm"],[2,[7,"/"],[2,[6,"library_questions"],[2,[7,"/"],[2,[6,"validate_library_question"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/pd/foorm/workshop_survey_submission(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_pd_foorm_workshop_survey_submission_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"pd"],[2,[7,"/"],[2,[6,"foorm"],[2,[7,"/"],[2,[6,"workshop_survey_submission"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/v1/pd/foorm/workshop_survey_submission(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_pd_foorm_workshop_survey_submission_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"pd"],[2,[7,"/"],[2,[6,"foorm"],[2,[7,"/"],[2,[6,"workshop_survey_submission"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/pd/international_opt_ins(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_pd_international_opt_ins_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"pd"],[2,[7,"/"],[2,[6,"international_opt_ins"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/v1/pd/international_opt_ins(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_pd_international_opt_ins_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"pd"],[2,[7,"/"],[2,[6,"international_opt_ins"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/pd/legacy_survey_summaries(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_pd_legacy_survey_summaries_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"pd"],[2,[7,"/"],[2,[6,"legacy_survey_summaries"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/v1/pd/legacy_survey_summaries(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_pd_legacy_survey_summaries_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"pd"],[2,[7,"/"],[2,[6,"legacy_survey_summaries"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/pd/pre_workshop_surveys(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_pd_pre_workshop_surveys_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"pd"],[2,[7,"/"],[2,[6,"pre_workshop_surveys"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/v1/pd/pre_workshop_surveys(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_pd_pre_workshop_surveys_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"pd"],[2,[7,"/"],[2,[6,"pre_workshop_surveys"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/pd/regional_partner_mini_contacts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_pd_regional_partner_mini_contacts_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"pd"],[2,[7,"/"],[2,[6,"regional_partner_mini_contacts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/v1/pd/regional_partner_mini_contacts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_pd_regional_partner_mini_contacts_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"pd"],[2,[7,"/"],[2,[6,"regional_partner_mini_contacts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/pd/regional_partner_workshops(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_pd_regional_partner_workshops_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"pd"],[2,[7,"/"],[2,[6,"regional_partner_workshops"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/v1/pd/regional_partner_workshops(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_pd_regional_partner_workshops_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"pd"],[2,[7,"/"],[2,[6,"regional_partner_workshops"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/pd/regional_partner_workshops/find(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_pd_regional_partner_workshops_find_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"pd"],[2,[7,"/"],[2,[6,"regional_partner_workshops"],[2,[7,"/"],[2,[6,"find"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/v1/pd/regional_partner_workshops/find(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_pd_regional_partner_workshops_find_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"pd"],[2,[7,"/"],[2,[6,"regional_partner_workshops"],[2,[7,"/"],[2,[6,"find"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/pd/regional_partners/find(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_pd_regional_partners_find_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"pd"],[2,[7,"/"],[2,[6,"regional_partners"],[2,[7,"/"],[2,[6,"find"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/v1/pd/regional_partners/find(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_pd_regional_partners_find_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"pd"],[2,[7,"/"],[2,[6,"regional_partners"],[2,[7,"/"],[2,[6,"find"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/pd/teacher_attendance_report(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_pd_teacher_attendance_report_index_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"pd"],[2,[7,"/"],[2,[6,"teacher_attendance_report"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/v1/pd/teacher_attendance_report(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_pd_teacher_attendance_report_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"pd"],[2,[7,"/"],[2,[6,"teacher_attendance_report"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/pd/teachercon_surveys(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_pd_teachercon_surveys_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"pd"],[2,[7,"/"],[2,[6,"teachercon_surveys"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/v1/pd/teachercon_surveys(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_pd_teachercon_surveys_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"pd"],[2,[7,"/"],[2,[6,"teachercon_surveys"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/pd/workshops/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_pd_workshop_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"pd"],[2,[7,"/"],[2,[6,"workshops"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/v1/pd/workshops/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_pd_workshop_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"pd"],[2,[7,"/"],[2,[6,"workshops"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/pd/workshops/:workshop_id/attendance(.:format)
 * @param {any} workshop_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_pd_workshop_attendance_url = /*#__PURE__*/ __jsr.r({"workshop_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"pd"],[2,[7,"/"],[2,[6,"workshops"],[2,[7,"/"],[2,[3,"workshop_id"],[2,[7,"/"],[2,[6,"attendance"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/v1/pd/workshops/:workshop_id/attendance(.:format)
 * @param {any} workshop_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_pd_workshop_attendance_path = /*#__PURE__*/ __jsr.r({"workshop_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"pd"],[2,[7,"/"],[2,[6,"workshops"],[2,[7,"/"],[2,[3,"workshop_id"],[2,[7,"/"],[2,[6,"attendance"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/pd/workshops/:workshop_id/enrollments/:id(.:format)
 * @param {any} workshop_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_pd_workshop_enrollment_url = /*#__PURE__*/ __jsr.r({"workshop_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"pd"],[2,[7,"/"],[2,[6,"workshops"],[2,[7,"/"],[2,[3,"workshop_id"],[2,[7,"/"],[2,[6,"enrollments"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/v1/pd/workshops/:workshop_id/enrollments/:id(.:format)
 * @param {any} workshop_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_pd_workshop_enrollment_path = /*#__PURE__*/ __jsr.r({"workshop_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"pd"],[2,[7,"/"],[2,[6,"workshops"],[2,[7,"/"],[2,[3,"workshop_id"],[2,[7,"/"],[2,[6,"enrollments"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/pd/workshops/:workshop_id/enrollments(.:format)
 * @param {any} workshop_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_pd_workshop_enrollments_url = /*#__PURE__*/ __jsr.r({"workshop_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"pd"],[2,[7,"/"],[2,[6,"workshops"],[2,[7,"/"],[2,[3,"workshop_id"],[2,[7,"/"],[2,[6,"enrollments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/v1/pd/workshops/:workshop_id/enrollments(.:format)
 * @param {any} workshop_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_pd_workshop_enrollments_path = /*#__PURE__*/ __jsr.r({"workshop_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"pd"],[2,[7,"/"],[2,[6,"workshops"],[2,[7,"/"],[2,[3,"workshop_id"],[2,[7,"/"],[2,[6,"enrollments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/pd/workshops/:workshop_id/experiment_survey_report(.:format)
 * @param {any} workshop_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_pd_workshop_experiment_survey_report_url = /*#__PURE__*/ __jsr.r({"workshop_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"pd"],[2,[7,"/"],[2,[6,"workshops"],[2,[7,"/"],[2,[3,"workshop_id"],[2,[7,"/"],[2,[6,"experiment_survey_report"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/v1/pd/workshops/:workshop_id/experiment_survey_report(.:format)
 * @param {any} workshop_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_pd_workshop_experiment_survey_report_path = /*#__PURE__*/ __jsr.r({"workshop_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"pd"],[2,[7,"/"],[2,[6,"workshops"],[2,[7,"/"],[2,[3,"workshop_id"],[2,[7,"/"],[2,[6,"experiment_survey_report"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/pd/workshops/:workshop_id/foorm/csv_survey_report(.:format)
 * @param {any} workshop_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_pd_workshop_foorm_csv_survey_report_url = /*#__PURE__*/ __jsr.r({"workshop_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"pd"],[2,[7,"/"],[2,[6,"workshops"],[2,[7,"/"],[2,[3,"workshop_id"],[2,[7,"/"],[2,[6,"foorm"],[2,[7,"/"],[2,[6,"csv_survey_report"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/v1/pd/workshops/:workshop_id/foorm/csv_survey_report(.:format)
 * @param {any} workshop_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_pd_workshop_foorm_csv_survey_report_path = /*#__PURE__*/ __jsr.r({"workshop_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"pd"],[2,[7,"/"],[2,[6,"workshops"],[2,[7,"/"],[2,[3,"workshop_id"],[2,[7,"/"],[2,[6,"foorm"],[2,[7,"/"],[2,[6,"csv_survey_report"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/pd/workshops/:workshop_id/foorm/forms_for_workshop(.:format)
 * @param {any} workshop_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_pd_workshop_foorm_forms_for_workshop_url = /*#__PURE__*/ __jsr.r({"workshop_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"pd"],[2,[7,"/"],[2,[6,"workshops"],[2,[7,"/"],[2,[3,"workshop_id"],[2,[7,"/"],[2,[6,"foorm"],[2,[7,"/"],[2,[6,"forms_for_workshop"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/v1/pd/workshops/:workshop_id/foorm/forms_for_workshop(.:format)
 * @param {any} workshop_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_pd_workshop_foorm_forms_for_workshop_path = /*#__PURE__*/ __jsr.r({"workshop_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"pd"],[2,[7,"/"],[2,[6,"workshops"],[2,[7,"/"],[2,[3,"workshop_id"],[2,[7,"/"],[2,[6,"foorm"],[2,[7,"/"],[2,[6,"forms_for_workshop"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/pd/workshops/:workshop_id/foorm/generic_survey_report(.:format)
 * @param {any} workshop_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_pd_workshop_foorm_generic_survey_report_url = /*#__PURE__*/ __jsr.r({"workshop_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"pd"],[2,[7,"/"],[2,[6,"workshops"],[2,[7,"/"],[2,[3,"workshop_id"],[2,[7,"/"],[2,[6,"foorm"],[2,[7,"/"],[2,[6,"generic_survey_report"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/v1/pd/workshops/:workshop_id/foorm/generic_survey_report(.:format)
 * @param {any} workshop_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_pd_workshop_foorm_generic_survey_report_path = /*#__PURE__*/ __jsr.r({"workshop_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"pd"],[2,[7,"/"],[2,[6,"workshops"],[2,[7,"/"],[2,[3,"workshop_id"],[2,[7,"/"],[2,[6,"foorm"],[2,[7,"/"],[2,[6,"generic_survey_report"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/pd/workshops/:workshop_id/foorm/workshop_survey_summary(.:format)
 * @param {any} workshop_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_pd_workshop_foorm_workshop_survey_summary_url = /*#__PURE__*/ __jsr.r({"workshop_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"pd"],[2,[7,"/"],[2,[6,"workshops"],[2,[7,"/"],[2,[3,"workshop_id"],[2,[7,"/"],[2,[6,"foorm"],[2,[7,"/"],[2,[6,"workshop_survey_summary"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/v1/pd/workshops/:workshop_id/foorm/workshop_survey_summary(.:format)
 * @param {any} workshop_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_pd_workshop_foorm_workshop_survey_summary_path = /*#__PURE__*/ __jsr.r({"workshop_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"pd"],[2,[7,"/"],[2,[6,"workshops"],[2,[7,"/"],[2,[3,"workshop_id"],[2,[7,"/"],[2,[6,"foorm"],[2,[7,"/"],[2,[6,"workshop_survey_summary"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/pd/workshops/:workshop_id/generic_survey_report(.:format)
 * @param {any} workshop_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_pd_workshop_generic_survey_report_url = /*#__PURE__*/ __jsr.r({"workshop_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"pd"],[2,[7,"/"],[2,[6,"workshops"],[2,[7,"/"],[2,[3,"workshop_id"],[2,[7,"/"],[2,[6,"generic_survey_report"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/v1/pd/workshops/:workshop_id/generic_survey_report(.:format)
 * @param {any} workshop_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_pd_workshop_generic_survey_report_path = /*#__PURE__*/ __jsr.r({"workshop_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"pd"],[2,[7,"/"],[2,[6,"workshops"],[2,[7,"/"],[2,[3,"workshop_id"],[2,[7,"/"],[2,[6,"generic_survey_report"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/pd/workshop_organizers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_pd_workshop_organizers_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"pd"],[2,[7,"/"],[2,[6,"workshop_organizers"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/v1/pd/workshop_organizers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_pd_workshop_organizers_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"pd"],[2,[7,"/"],[2,[6,"workshop_organizers"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/pd/workshop_summary_report(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_pd_workshop_summary_report_index_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"pd"],[2,[7,"/"],[2,[6,"workshop_summary_report"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/v1/pd/workshop_summary_report(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_pd_workshop_summary_report_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"pd"],[2,[7,"/"],[2,[6,"workshop_summary_report"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/pd/workshops/:workshop_id/teachercon_survey_report(.:format)
 * @param {any} workshop_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_pd_workshop_teachercon_survey_report_url = /*#__PURE__*/ __jsr.r({"workshop_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"pd"],[2,[7,"/"],[2,[6,"workshops"],[2,[7,"/"],[2,[3,"workshop_id"],[2,[7,"/"],[2,[6,"teachercon_survey_report"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/v1/pd/workshops/:workshop_id/teachercon_survey_report(.:format)
 * @param {any} workshop_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_pd_workshop_teachercon_survey_report_path = /*#__PURE__*/ __jsr.r({"workshop_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"pd"],[2,[7,"/"],[2,[6,"workshops"],[2,[7,"/"],[2,[3,"workshop_id"],[2,[7,"/"],[2,[6,"teachercon_survey_report"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/pd/workshops/:workshop_id/workshop_organizer_survey_report(.:format)
 * @param {any} workshop_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_pd_workshop_workshop_organizer_survey_report_url = /*#__PURE__*/ __jsr.r({"workshop_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"pd"],[2,[7,"/"],[2,[6,"workshops"],[2,[7,"/"],[2,[3,"workshop_id"],[2,[7,"/"],[2,[6,"workshop_organizer_survey_report"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/v1/pd/workshops/:workshop_id/workshop_organizer_survey_report(.:format)
 * @param {any} workshop_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_pd_workshop_workshop_organizer_survey_report_path = /*#__PURE__*/ __jsr.r({"workshop_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"pd"],[2,[7,"/"],[2,[6,"workshops"],[2,[7,"/"],[2,[3,"workshop_id"],[2,[7,"/"],[2,[6,"workshop_organizer_survey_report"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/pd/workshops/:workshop_id/workshop_survey_report(.:format)
 * @param {any} workshop_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_pd_workshop_workshop_survey_report_url = /*#__PURE__*/ __jsr.r({"workshop_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"pd"],[2,[7,"/"],[2,[6,"workshops"],[2,[7,"/"],[2,[3,"workshop_id"],[2,[7,"/"],[2,[6,"workshop_survey_report"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/v1/pd/workshops/:workshop_id/workshop_survey_report(.:format)
 * @param {any} workshop_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_pd_workshop_workshop_survey_report_path = /*#__PURE__*/ __jsr.r({"workshop_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"pd"],[2,[7,"/"],[2,[6,"workshops"],[2,[7,"/"],[2,[3,"workshop_id"],[2,[7,"/"],[2,[6,"workshop_survey_report"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/pd/workshops(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_pd_workshops_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"pd"],[2,[7,"/"],[2,[6,"workshops"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/v1/pd/workshops(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_pd_workshops_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"pd"],[2,[7,"/"],[2,[6,"workshops"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/pd/workshops_user_enrolled_in(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_pd_workshops_user_enrolled_in_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"pd"],[2,[7,"/"],[2,[6,"workshops_user_enrolled_in"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/v1/pd/workshops_user_enrolled_in(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_pd_workshops_user_enrolled_in_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"pd"],[2,[7,"/"],[2,[6,"workshops_user_enrolled_in"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/peer_review_submissions/index(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_peer_review_submissions_index_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"peer_review_submissions"],[2,[7,"/"],[2,[6,"index"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/v1/peer_review_submissions/index(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_peer_review_submissions_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"peer_review_submissions"],[2,[7,"/"],[2,[6,"index"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/peer_review_submissions/report_csv(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_peer_review_submissions_report_csv_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"peer_review_submissions"],[2,[7,"/"],[2,[6,"report_csv"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/v1/peer_review_submissions/report_csv(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_peer_review_submissions_report_csv_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"peer_review_submissions"],[2,[7,"/"],[2,[6,"report_csv"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/projects/personal(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_projects_personal_url = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"personal"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/v1/projects/personal(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_projects_personal_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"personal"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/regional_partners(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_regional_partners_url = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"regional_partners"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/v1/regional_partners(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_regional_partners_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"regional_partners"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/regional_partners/capacity(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_regional_partners_capacity_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"regional_partners"],[2,[7,"/"],[2,[6,"capacity"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/v1/regional_partners/capacity(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_regional_partners_capacity_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"regional_partners"],[2,[7,"/"],[2,[6,"capacity"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/regional_partners/enrolled(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_regional_partners_enrolled_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"regional_partners"],[2,[7,"/"],[2,[6,"enrolled"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/v1/regional_partners/enrolled(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_regional_partners_enrolled_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"regional_partners"],[2,[7,"/"],[2,[6,"enrolled"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/scrapbook_entries(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_scrapbook_entries_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"scrapbook_entries"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/v1/scrapbook_entries(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_scrapbook_entries_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"scrapbook_entries"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/scrapbook_entries/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_scrapbook_entry_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"scrapbook_entries"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/v1/scrapbook_entries/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_scrapbook_entry_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"scrapbook_entries"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/sections/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_section_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"sections"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/v1/sections/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_section_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"sections"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/section_instructors/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_section_instructor_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"section_instructors"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/v1/section_instructors/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_section_instructor_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"section_instructors"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/section_instructors(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_section_instructors_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"section_instructors"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/v1/section_instructors(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_section_instructors_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"section_instructors"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/section_instructors/check(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_section_instructors_check_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"section_instructors"],[2,[7,"/"],[2,[6,"check"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/v1/section_instructors/check(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_section_instructors_check_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"section_instructors"],[2,[7,"/"],[2,[6,"check"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/section_libraries(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_section_libraries_url = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"section_libraries"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/v1/section_libraries(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_section_libraries_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"section_libraries"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/sections/:section_id/students/:id(.:format)
 * @param {any} section_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_section_student_url = /*#__PURE__*/ __jsr.r({"section_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"sections"],[2,[7,"/"],[2,[3,"section_id"],[2,[7,"/"],[2,[6,"students"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/v1/sections/:section_id/students/:id(.:format)
 * @param {any} section_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_section_student_path = /*#__PURE__*/ __jsr.r({"section_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"sections"],[2,[7,"/"],[2,[3,"section_id"],[2,[7,"/"],[2,[6,"students"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/sections/:section_id/students(.:format)
 * @param {any} section_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_section_students_url = /*#__PURE__*/ __jsr.r({"section_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"sections"],[2,[7,"/"],[2,[3,"section_id"],[2,[7,"/"],[2,[6,"students"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/v1/sections/:section_id/students(.:format)
 * @param {any} section_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_section_students_path = /*#__PURE__*/ __jsr.r({"section_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"sections"],[2,[7,"/"],[2,[3,"section_id"],[2,[7,"/"],[2,[6,"students"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/sections(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_sections_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"sections"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/v1/sections(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_sections_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"sections"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/teacher_feedbacks(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_teacher_feedbacks_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"teacher_feedbacks"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/v1/teacher_feedbacks(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_teacher_feedbacks_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"teacher_feedbacks"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/users/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_user_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/v1/users/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_user_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/user_school_infos(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_user_school_infos_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"user_school_infos"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/v1/user_school_infos(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_user_school_infos_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"user_school_infos"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/users(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_users_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"users"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/v1/users(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_users_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"users"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/users/ai_differentiation_enabled(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_users_ai_differentiation_enabled_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"ai_differentiation_enabled"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/v1/users/ai_differentiation_enabled(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_users_ai_differentiation_enabled_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"ai_differentiation_enabled"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/users/ai_rubrics_disabled(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_users_ai_rubrics_disabled_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"ai_rubrics_disabled"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/v1/users/ai_rubrics_disabled(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_users_ai_rubrics_disabled_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"ai_rubrics_disabled"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/users/cached_page_auth_redirect(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_users_cached_page_auth_redirect_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"cached_page_auth_redirect"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/v1/users/cached_page_auth_redirect(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_users_cached_page_auth_redirect_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"cached_page_auth_redirect"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/users/current(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_users_current_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"current"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/v1/users/current(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_users_current_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"current"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/users/current/permissions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_users_current_permissions_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"current"],[2,[7,"/"],[2,[6,"permissions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/v1/users/current/permissions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_users_current_permissions_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"current"],[2,[7,"/"],[2,[6,"permissions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/users/disable_lti_roster_sync(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_users_disable_lti_roster_sync_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"disable_lti_roster_sync"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/v1/users/disable_lti_roster_sync(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_users_disable_lti_roster_sync_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"disable_lti_roster_sync"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/users/has_completed_ai_differentiation_welcome(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_users_has_completed_ai_differentiation_welcome_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"has_completed_ai_differentiation_welcome"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/v1/users/has_completed_ai_differentiation_welcome(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_users_has_completed_ai_differentiation_welcome_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"has_completed_ai_differentiation_welcome"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/users/has_dismissed_personalization_alert(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_users_has_dismissed_personalization_alert_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"has_dismissed_personalization_alert"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/v1/users/has_dismissed_personalization_alert(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_users_has_dismissed_personalization_alert_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"has_dismissed_personalization_alert"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/users/has_seen_ai_assessments_announcement(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_users_has_seen_ai_assessments_announcement_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"has_seen_ai_assessments_announcement"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/v1/users/has_seen_ai_assessments_announcement(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_users_has_seen_ai_assessments_announcement_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"has_seen_ai_assessments_announcement"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/users/netsim_signed_in(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_users_netsim_signed_in_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"netsim_signed_in"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/v1/users/netsim_signed_in(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_users_netsim_signed_in_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"netsim_signed_in"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/users/set_seen_ta_scores(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_users_set_seen_ta_scores_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"set_seen_ta_scores"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/v1/users/set_seen_ta_scores(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_users_set_seen_ta_scores_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"set_seen_ta_scores"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/users/me/settings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_users_settings_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"me"],[2,[7,"/"],[2,[6,"settings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/v1/users/me/settings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_users_settings_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"me"],[2,[7,"/"],[2,[6,"settings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/users/sort_by_family_name(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_users_sort_by_family_name_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"sort_by_family_name"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/v1/users/sort_by_family_name(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_users_sort_by_family_name_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"sort_by_family_name"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/users/teacher_onboarding_hidden(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_users_teacher_onboarding_hidden_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"teacher_onboarding_hidden"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/v1/users/teacher_onboarding_hidden(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_users_teacher_onboarding_hidden_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"teacher_onboarding_hidden"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /p/applab(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const applab_p_index_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[6,"applab"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /p/applab(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const applab_p_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[6,"applab"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /projects/applab/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const applab_project_create_new_projects_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"applab"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/applab/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const applab_project_create_new_projects_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"applab"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/applab/:channel_id/edit(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const applab_project_edit_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"applab"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/applab/:channel_id/edit(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const applab_project_edit_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"applab"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/applab/:channel_id/export_config(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const applab_project_export_config_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"applab"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"export_config"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/applab/:channel_id/export_config(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const applab_project_export_config_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"applab"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"export_config"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/applab/:channel_id/export_create_channel(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const applab_project_export_create_channel_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"applab"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"export_create_channel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/applab/:channel_id/export_create_channel(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const applab_project_export_create_channel_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"applab"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"export_create_channel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/applab/:channel_id/embed_app_and_code(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const applab_project_iframe_embed_app_and_code_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"applab"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"embed_app_and_code"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/applab/:channel_id/embed_app_and_code(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const applab_project_iframe_embed_app_and_code_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"applab"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"embed_app_and_code"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/applab/:channel_id/embed(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const applab_project_iframe_embed_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"applab"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"embed"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/applab/:channel_id/embed(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const applab_project_iframe_embed_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"applab"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"embed"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/applab(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const applab_project_projects_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"applab"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /projects/applab(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const applab_project_projects_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"applab"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /projects/applab/:channel_id/remix(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const applab_project_remix_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"applab"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"remix"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/applab/:channel_id/remix(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const applab_project_remix_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"applab"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"remix"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/applab/:channel_id(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const applab_project_share_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"applab"],[2,[7,"/"],[2,[3,"channel_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/applab/:channel_id(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const applab_project_share_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"applab"],[2,[7,"/"],[2,[3,"channel_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/applab/:channel_id/view(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const applab_project_view_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"applab"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"view"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/applab/:channel_id/view(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const applab_project_view_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"applab"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"view"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /sections/archive_all(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const archive_all_sections_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"sections"],[2,[7,"/"],[2,[6,"archive_all"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /sections/archive_all(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const archive_all_sections_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"sections"],[2,[7,"/"],[2,[6,"archive_all"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /p/artist_k1(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const artist_k1_p_index_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[6,"artist_k1"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /p/artist_k1(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const artist_k1_p_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[6,"artist_k1"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /projects/artist_k1/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const artist_k1_project_create_new_projects_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"artist_k1"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/artist_k1/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const artist_k1_project_create_new_projects_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"artist_k1"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/artist_k1/:channel_id/edit(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const artist_k1_project_edit_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"artist_k1"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/artist_k1/:channel_id/edit(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const artist_k1_project_edit_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"artist_k1"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/artist_k1/:channel_id/export_config(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const artist_k1_project_export_config_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"artist_k1"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"export_config"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/artist_k1/:channel_id/export_config(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const artist_k1_project_export_config_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"artist_k1"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"export_config"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/artist_k1/:channel_id/export_create_channel(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const artist_k1_project_export_create_channel_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"artist_k1"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"export_create_channel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/artist_k1/:channel_id/export_create_channel(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const artist_k1_project_export_create_channel_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"artist_k1"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"export_create_channel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/artist_k1/:channel_id/embed_app_and_code(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const artist_k1_project_iframe_embed_app_and_code_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"artist_k1"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"embed_app_and_code"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/artist_k1/:channel_id/embed_app_and_code(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const artist_k1_project_iframe_embed_app_and_code_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"artist_k1"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"embed_app_and_code"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/artist_k1/:channel_id/embed(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const artist_k1_project_iframe_embed_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"artist_k1"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"embed"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/artist_k1/:channel_id/embed(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const artist_k1_project_iframe_embed_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"artist_k1"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"embed"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/artist_k1(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const artist_k1_project_projects_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"artist_k1"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /projects/artist_k1(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const artist_k1_project_projects_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"artist_k1"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /projects/artist_k1/:channel_id/remix(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const artist_k1_project_remix_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"artist_k1"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"remix"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/artist_k1/:channel_id/remix(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const artist_k1_project_remix_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"artist_k1"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"remix"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/artist_k1/:channel_id(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const artist_k1_project_share_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"artist_k1"],[2,[7,"/"],[2,[3,"channel_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/artist_k1/:channel_id(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const artist_k1_project_share_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"artist_k1"],[2,[7,"/"],[2,[3,"channel_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/artist_k1/:channel_id/view(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const artist_k1_project_view_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"artist_k1"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"view"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/artist_k1/:channel_id/view(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const artist_k1_project_view_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"artist_k1"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"view"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /artist/lang/ar(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const artist_lang_ar_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"artist"],[2,[7,"/"],[2,[6,"lang"],[2,[7,"/"],[2,[6,"ar"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /artist/lang/ar(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const artist_lang_ar_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"artist"],[2,[7,"/"],[2,[6,"lang"],[2,[7,"/"],[2,[6,"ar"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /p/artist(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const artist_p_index_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[6,"artist"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /p/artist(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const artist_p_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[6,"artist"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /projects/artist/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const artist_project_create_new_projects_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"artist"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/artist/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const artist_project_create_new_projects_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"artist"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/artist/:channel_id/edit(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const artist_project_edit_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"artist"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/artist/:channel_id/edit(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const artist_project_edit_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"artist"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/artist/:channel_id/export_config(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const artist_project_export_config_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"artist"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"export_config"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/artist/:channel_id/export_config(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const artist_project_export_config_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"artist"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"export_config"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/artist/:channel_id/export_create_channel(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const artist_project_export_create_channel_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"artist"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"export_create_channel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/artist/:channel_id/export_create_channel(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const artist_project_export_create_channel_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"artist"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"export_create_channel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/artist/:channel_id/embed_app_and_code(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const artist_project_iframe_embed_app_and_code_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"artist"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"embed_app_and_code"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/artist/:channel_id/embed_app_and_code(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const artist_project_iframe_embed_app_and_code_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"artist"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"embed_app_and_code"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/artist/:channel_id/embed(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const artist_project_iframe_embed_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"artist"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"embed"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/artist/:channel_id/embed(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const artist_project_iframe_embed_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"artist"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"embed"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/artist(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const artist_project_projects_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"artist"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /projects/artist(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const artist_project_projects_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"artist"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /projects/artist/:channel_id/remix(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const artist_project_remix_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"artist"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"remix"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/artist/:channel_id/remix(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const artist_project_remix_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"artist"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"remix"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/artist/:channel_id(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const artist_project_share_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"artist"],[2,[7,"/"],[2,[3,"channel_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/artist/:channel_id(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const artist_project_share_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"artist"],[2,[7,"/"],[2,[3,"channel_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/artist/:channel_id/view(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const artist_project_view_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"artist"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"view"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/artist/:channel_id/view(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const artist_project_view_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"artist"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"view"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /dashboardapi/assessments(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const assessments_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dashboardapi"],[2,[7,"/"],[2,[6,"assessments"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /dashboardapi/assessments(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const assessments_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dashboardapi"],[2,[7,"/"],[2,[6,"assessments"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /regional_partners/:id/assign_program_manager(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const assign_program_manager_regional_partner_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"regional_partners"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"assign_program_manager"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /regional_partners/:id/assign_program_manager(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const assign_program_manager_regional_partner_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"regional_partners"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"assign_program_manager"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/sections/assigned_essential_ai_dependency(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const assigned_essential_ai_dependency_api_v1_sections_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"sections"],[2,[7,"/"],[2,[6,"assigned_essential_ai_dependency"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/v1/sections/assigned_essential_ai_dependency(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const assigned_essential_ai_dependency_api_v1_sections_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"sections"],[2,[7,"/"],[2,[6,"assigned_essential_ai_dependency"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /dashboardapi/sections/assigned_essential_ai_dependency(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const assigned_essential_ai_dependency_sections_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dashboardapi"],[2,[7,"/"],[2,[6,"sections"],[2,[7,"/"],[2,[6,"assigned_essential_ai_dependency"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /dashboardapi/sections/assigned_essential_ai_dependency(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const assigned_essential_ai_dependency_sections_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dashboardapi"],[2,[7,"/"],[2,[6,"sections"],[2,[7,"/"],[2,[6,"assigned_essential_ai_dependency"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/assume_identity(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const assume_identity_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"assume_identity"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /admin/assume_identity(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const assume_identity_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"assume_identity"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/assume_identity(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const assume_identity_form_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"assume_identity"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /admin/assume_identity(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const assume_identity_form_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"assume_identity"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /levels/:level_id/quiz_question_placements/:id/attach(.:format)
 * @param {any} level_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const attach_level_quiz_question_placement_url = /*#__PURE__*/ __jsr.r({"level_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"levels"],[2,[7,"/"],[2,[3,"level_id"],[2,[7,"/"],[2,[6,"quiz_question_placements"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"attach"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /levels/:level_id/quiz_question_placements/:id/attach(.:format)
 * @param {any} level_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const attach_level_quiz_question_placement_path = /*#__PURE__*/ __jsr.r({"level_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"levels"],[2,[7,"/"],[2,[3,"level_id"],[2,[7,"/"],[2,[6,"quiz_question_placements"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"attach"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /authored_hint_view_requests(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const authored_hint_view_requests_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"authored_hint_view_requests"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /authored_hint_view_requests(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const authored_hint_view_requests_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"authored_hint_view_requests"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /api/v1/sections/available_participant_types(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const available_participant_types_api_v1_sections_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"sections"],[2,[7,"/"],[2,[6,"available_participant_types"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/v1/sections/available_participant_types(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const available_participant_types_api_v1_sections_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"sections"],[2,[7,"/"],[2,[6,"available_participant_types"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /dashboardapi/sections/available_participant_types(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const available_participant_types_sections_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dashboardapi"],[2,[7,"/"],[2,[6,"sections"],[2,[7,"/"],[2,[6,"available_participant_types"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /dashboardapi/sections/available_participant_types(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const available_participant_types_sections_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dashboardapi"],[2,[7,"/"],[2,[6,"sections"],[2,[7,"/"],[2,[6,"available_participant_types"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /backpacks/channels(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backpacks_channels_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"backpacks"],[2,[7,"/"],[2,[6,"channels"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /backpacks/channels(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backpacks_channels_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"backpacks"],[2,[7,"/"],[2,[6,"channels"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /p/basketball(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const basketball_p_index_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[6,"basketball"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /p/basketball(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const basketball_p_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[6,"basketball"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /projects/basketball/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const basketball_project_create_new_projects_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"basketball"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/basketball/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const basketball_project_create_new_projects_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"basketball"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/basketball/:channel_id/edit(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const basketball_project_edit_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"basketball"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/basketball/:channel_id/edit(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const basketball_project_edit_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"basketball"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/basketball/:channel_id/export_config(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const basketball_project_export_config_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"basketball"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"export_config"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/basketball/:channel_id/export_config(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const basketball_project_export_config_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"basketball"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"export_config"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/basketball/:channel_id/export_create_channel(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const basketball_project_export_create_channel_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"basketball"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"export_create_channel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/basketball/:channel_id/export_create_channel(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const basketball_project_export_create_channel_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"basketball"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"export_create_channel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/basketball/:channel_id/embed_app_and_code(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const basketball_project_iframe_embed_app_and_code_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"basketball"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"embed_app_and_code"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/basketball/:channel_id/embed_app_and_code(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const basketball_project_iframe_embed_app_and_code_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"basketball"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"embed_app_and_code"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/basketball/:channel_id/embed(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const basketball_project_iframe_embed_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"basketball"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"embed"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/basketball/:channel_id/embed(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const basketball_project_iframe_embed_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"basketball"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"embed"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/basketball(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const basketball_project_projects_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"basketball"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /projects/basketball(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const basketball_project_projects_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"basketball"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /projects/basketball/:channel_id/remix(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const basketball_project_remix_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"basketball"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"remix"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/basketball/:channel_id/remix(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const basketball_project_remix_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"basketball"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"remix"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/basketball/:channel_id(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const basketball_project_share_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"basketball"],[2,[7,"/"],[2,[3,"channel_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/basketball/:channel_id(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const basketball_project_share_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"basketball"],[2,[7,"/"],[2,[3,"channel_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/basketball/:channel_id/view(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const basketball_project_view_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"basketball"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"view"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/basketball/:channel_id/view(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const basketball_project_view_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"basketball"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"view"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /certificates/batch(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const batch_certificates_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"certificates"],[2,[7,"/"],[2,[6,"batch"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /certificates/batch(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const batch_certificates_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"certificates"],[2,[7,"/"],[2,[6,"batch"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /print_certificates/batch(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const batch_print_certificates_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"print_certificates"],[2,[7,"/"],[2,[6,"batch"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /print_certificates/batch(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const batch_print_certificates_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"print_certificates"],[2,[7,"/"],[2,[6,"batch"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /beta(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const beta_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"beta"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /beta(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const beta_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"beta"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /certificates/blank(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const blank_certificates_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"certificates"],[2,[7,"/"],[2,[6,"blank"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /certificates/blank(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const blank_certificates_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"certificates"],[2,[7,"/"],[2,[6,"blank"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /pools/:pool/blocks/:id(.:format)
 * @param {any} pool
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const block_url = /*#__PURE__*/ __jsr.r({"pool":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"pools"],[2,[7,"/"],[2,[3,"pool"],[2,[7,"/"],[2,[6,"blocks"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /pools/:pool/blocks/:id(.:format)
 * @param {any} pool
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const block_path = /*#__PURE__*/ __jsr.r({"pool":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"pools"],[2,[7,"/"],[2,[3,"pool"],[2,[7,"/"],[2,[6,"blocks"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /pools/:pool/blocks(.:format)
 * @param {any} pool
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const blocks_url = /*#__PURE__*/ __jsr.r({"pool":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"pools"],[2,[7,"/"],[2,[3,"pool"],[2,[7,"/"],[2,[6,"blocks"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /pools/:pool/blocks(.:format)
 * @param {any} pool
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const blocks_path = /*#__PURE__*/ __jsr.r({"pool":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"pools"],[2,[7,"/"],[2,[3,"pool"],[2,[7,"/"],[2,[6,"blocks"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /p/bounce(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bounce_p_index_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[6,"bounce"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /p/bounce(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bounce_p_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[6,"bounce"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /projects/bounce/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bounce_project_create_new_projects_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"bounce"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/bounce/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bounce_project_create_new_projects_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"bounce"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/bounce/:channel_id/edit(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bounce_project_edit_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"bounce"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/bounce/:channel_id/edit(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bounce_project_edit_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"bounce"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/bounce/:channel_id/export_config(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bounce_project_export_config_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"bounce"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"export_config"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/bounce/:channel_id/export_config(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bounce_project_export_config_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"bounce"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"export_config"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/bounce/:channel_id/export_create_channel(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bounce_project_export_create_channel_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"bounce"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"export_create_channel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/bounce/:channel_id/export_create_channel(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bounce_project_export_create_channel_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"bounce"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"export_create_channel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/bounce/:channel_id/embed_app_and_code(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bounce_project_iframe_embed_app_and_code_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"bounce"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"embed_app_and_code"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/bounce/:channel_id/embed_app_and_code(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bounce_project_iframe_embed_app_and_code_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"bounce"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"embed_app_and_code"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/bounce/:channel_id/embed(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bounce_project_iframe_embed_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"bounce"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"embed"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/bounce/:channel_id/embed(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bounce_project_iframe_embed_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"bounce"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"embed"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/bounce(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bounce_project_projects_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"bounce"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /projects/bounce(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bounce_project_projects_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"bounce"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /projects/bounce/:channel_id/remix(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bounce_project_remix_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"bounce"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"remix"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/bounce/:channel_id/remix(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bounce_project_remix_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"bounce"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"remix"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/bounce/:channel_id(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bounce_project_share_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"bounce"],[2,[7,"/"],[2,[3,"channel_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/bounce/:channel_id(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bounce_project_share_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"bounce"],[2,[7,"/"],[2,[3,"channel_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/bounce/:channel_id/view(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bounce_project_view_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"bounce"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"view"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/bounce/:channel_id/view(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bounce_project_view_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"bounce"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"view"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /browser_events/put_logs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const browser_events_put_logs_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"browser_events"],[2,[7,"/"],[2,[6,"put_logs"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /browser_events/put_logs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const browser_events_put_logs_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"browser_events"],[2,[7,"/"],[2,[6,"put_logs"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /browser_events/put_metric_data(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const browser_events_put_metric_data_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"browser_events"],[2,[7,"/"],[2,[6,"put_metric_data"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /browser_events/put_metric_data(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const browser_events_put_metric_data_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"browser_events"],[2,[7,"/"],[2,[6,"put_metric_data"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /levels/:id/build_quiz_questions(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const build_quiz_questions_level_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"levels"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"build_quiz_questions"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /levels/:id/build_quiz_questions(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const build_quiz_questions_level_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"levels"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"build_quiz_questions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/sections/:section_id/students/bulk_add(.:format)
 * @param {any} section_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bulk_add_api_v1_section_students_url = /*#__PURE__*/ __jsr.r({"section_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"sections"],[2,[7,"/"],[2,[3,"section_id"],[2,[7,"/"],[2,[6,"students"],[2,[7,"/"],[2,[6,"bulk_add"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/v1/sections/:section_id/students/bulk_add(.:format)
 * @param {any} section_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bulk_add_api_v1_section_students_path = /*#__PURE__*/ __jsr.r({"section_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"sections"],[2,[7,"/"],[2,[3,"section_id"],[2,[7,"/"],[2,[6,"students"],[2,[7,"/"],[2,[6,"bulk_add"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /dashboardapi/sections/:section_id/students/bulk_add(.:format)
 * @param {any} section_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bulk_add_section_students_url = /*#__PURE__*/ __jsr.r({"section_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"dashboardapi"],[2,[7,"/"],[2,[6,"sections"],[2,[7,"/"],[2,[3,"section_id"],[2,[7,"/"],[2,[6,"students"],[2,[7,"/"],[2,[6,"bulk_add"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /dashboardapi/sections/:section_id/students/bulk_add(.:format)
 * @param {any} section_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bulk_add_section_students_path = /*#__PURE__*/ __jsr.r({"section_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"dashboardapi"],[2,[7,"/"],[2,[6,"sections"],[2,[7,"/"],[2,[3,"section_id"],[2,[7,"/"],[2,[6,"students"],[2,[7,"/"],[2,[6,"bulk_add"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/bulk_grant_permission(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bulk_grant_permission_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"bulk_grant_permission"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /admin/bulk_grant_permission(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bulk_grant_permission_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"bulk_grant_permission"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /lti/v1/sections/bulk_update_owners(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bulk_update_owners_lti_v1_sections_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"lti"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"sections"],[2,[7,"/"],[2,[6,"bulk_update_owners"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /lti/v1/sections/bulk_update_owners(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bulk_update_owners_lti_v1_sections_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"lti"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"sections"],[2,[7,"/"],[2,[6,"bulk_update_owners"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /levels/by_name(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const by_name_levels_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"levels"],[2,[7,"/"],[2,[6,"by_name"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /levels/by_name(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const by_name_levels_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"levels"],[2,[7,"/"],[2,[6,"by_name"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /p/calc(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const calc_p_index_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[6,"calc"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /p/calc(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const calc_p_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[6,"calc"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /projects/calc/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const calc_project_create_new_projects_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"calc"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/calc/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const calc_project_create_new_projects_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"calc"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/calc/:channel_id/edit(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const calc_project_edit_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"calc"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/calc/:channel_id/edit(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const calc_project_edit_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"calc"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/calc/:channel_id/export_config(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const calc_project_export_config_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"calc"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"export_config"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/calc/:channel_id/export_config(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const calc_project_export_config_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"calc"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"export_config"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/calc/:channel_id/export_create_channel(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const calc_project_export_create_channel_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"calc"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"export_create_channel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/calc/:channel_id/export_create_channel(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const calc_project_export_create_channel_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"calc"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"export_create_channel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/calc/:channel_id/embed_app_and_code(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const calc_project_iframe_embed_app_and_code_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"calc"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"embed_app_and_code"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/calc/:channel_id/embed_app_and_code(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const calc_project_iframe_embed_app_and_code_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"calc"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"embed_app_and_code"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/calc/:channel_id/embed(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const calc_project_iframe_embed_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"calc"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"embed"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/calc/:channel_id/embed(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const calc_project_iframe_embed_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"calc"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"embed"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/calc(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const calc_project_projects_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"calc"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /projects/calc(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const calc_project_projects_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"calc"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /projects/calc/:channel_id/remix(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const calc_project_remix_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"calc"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"remix"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/calc/:channel_id/remix(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const calc_project_remix_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"calc"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"remix"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/calc/:channel_id(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const calc_project_share_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"calc"],[2,[7,"/"],[2,[3,"channel_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/calc/:channel_id(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const calc_project_share_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"calc"],[2,[7,"/"],[2,[3,"channel_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/calc/:channel_id/view(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const calc_project_view_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"calc"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"view"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/calc/:channel_id/view(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const calc_project_view_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"calc"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"view"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /callouts/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const callout_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"callouts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /callouts/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const callout_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"callouts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /callouts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const callouts_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"callouts"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /callouts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const callouts_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"callouts"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /users/cancel(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cancel_user_registration_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"cancel"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /users/cancel(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cancel_user_registration_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"cancel"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/cap_actions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cap_actions_form_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"cap_actions"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /admin/cap_actions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cap_actions_form_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"cap_actions"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /catalog(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const catalog_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"catalog"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /catalog(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const catalog_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"catalog"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /certificates/:encoded_params(.:format)
 * @param {any} encoded_params
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const certificate_url = /*#__PURE__*/ __jsr.r({"encoded_params":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"certificates"],[2,[7,"/"],[2,[3,"encoded_params"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /certificates/:encoded_params(.:format)
 * @param {any} encoded_params
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const certificate_path = /*#__PURE__*/ __jsr.r({"encoded_params":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"certificates"],[2,[7,"/"],[2,[3,"encoded_params"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /certificate_images/:filename(.:format)
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const certificate_image_url = /*#__PURE__*/ __jsr.r({"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"certificate_images"],[2,[7,"/"],[2,[3,"filename"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /certificate_images/:filename(.:format)
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const certificate_image_path = /*#__PURE__*/ __jsr.r({"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"certificate_images"],[2,[7,"/"],[2,[3,"filename"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /challenges/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const challenge_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"challenges"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /challenges/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const challenge_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"challenges"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /challenge_responses/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const challenge_response_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"challenge_responses"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /challenge_responses/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const challenge_response_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"challenge_responses"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /challenge_response_assets/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const challenge_response_asset_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"challenge_response_assets"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /challenge_response_assets/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const challenge_response_asset_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"challenge_response_assets"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /challenge_responses/:challenge_response_id/reactions/:emoji(.:format)
 * @param {any} challenge_response_id
 * @param {any} emoji
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const challenge_response_reaction_url = /*#__PURE__*/ __jsr.r({"challenge_response_id":{"r":true},"emoji":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"challenge_responses"],[2,[7,"/"],[2,[3,"challenge_response_id"],[2,[7,"/"],[2,[6,"reactions"],[2,[7,"/"],[2,[3,"emoji"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /challenge_responses/:challenge_response_id/reactions/:emoji(.:format)
 * @param {any} challenge_response_id
 * @param {any} emoji
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const challenge_response_reaction_path = /*#__PURE__*/ __jsr.r({"challenge_response_id":{"r":true},"emoji":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"challenge_responses"],[2,[7,"/"],[2,[3,"challenge_response_id"],[2,[7,"/"],[2,[6,"reactions"],[2,[7,"/"],[2,[3,"emoji"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /challenge_responses/:challenge_response_id/reactions(.:format)
 * @param {any} challenge_response_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const challenge_response_reactions_url = /*#__PURE__*/ __jsr.r({"challenge_response_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"challenge_responses"],[2,[7,"/"],[2,[3,"challenge_response_id"],[2,[7,"/"],[2,[6,"reactions"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /challenge_responses/:challenge_response_id/reactions(.:format)
 * @param {any} challenge_response_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const challenge_response_reactions_path = /*#__PURE__*/ __jsr.r({"challenge_response_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"challenge_responses"],[2,[7,"/"],[2,[3,"challenge_response_id"],[2,[7,"/"],[2,[6,"reactions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /challenge_responses(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const challenge_responses_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"challenge_responses"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /challenge_responses(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const challenge_responses_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"challenge_responses"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /challenges(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const challenges_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"challenges"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /challenges(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const challenges_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"challenges"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /aidiff_threads/:id/chat_completion(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const chat_completion_aidiff_thread_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"aidiff_threads"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"chat_completion"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /aidiff_threads/:id/chat_completion(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const chat_completion_aidiff_thread_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"aidiff_threads"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"chat_completion"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /chatter/index(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const chatter_index_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"chatter"],[2,[7,"/"],[2,[6,"index"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /chatter/index(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const chatter_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"chatter"],[2,[7,"/"],[2,[6,"index"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/sections/demo/check_staleness(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const check_demo_section_staleness_api_v1_sections_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"sections"],[2,[7,"/"],[2,[6,"demo"],[2,[7,"/"],[2,[6,"check_staleness"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/v1/sections/demo/check_staleness(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const check_demo_section_staleness_api_v1_sections_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"sections"],[2,[7,"/"],[2,[6,"demo"],[2,[7,"/"],[2,[6,"check_staleness"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /dashboardapi/sections/demo/check_staleness(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const check_demo_section_staleness_sections_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dashboardapi"],[2,[7,"/"],[2,[6,"sections"],[2,[7,"/"],[2,[6,"demo"],[2,[7,"/"],[2,[6,"check_staleness"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /dashboardapi/sections/demo/check_staleness(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const check_demo_section_staleness_sections_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dashboardapi"],[2,[7,"/"],[2,[6,"sections"],[2,[7,"/"],[2,[6,"demo"],[2,[7,"/"],[2,[6,"check_staleness"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /datablock_storage/:channel_id/clear_all_data(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const clear_all_data_datablock_storage_index_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"datablock_storage"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"clear_all_data"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /datablock_storage/:channel_id/clear_all_data(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const clear_all_data_datablock_storage_index_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"datablock_storage"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"clear_all_data"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /datablock_storage/:channel_id/clear_table(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const clear_table_datablock_storage_index_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"datablock_storage"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"clear_table"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /datablock_storage/:channel_id/clear_table(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const clear_table_datablock_storage_index_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"datablock_storage"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"clear_table"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /lessons/:id/clone(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const clone_lesson_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"lessons"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"clone"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /lessons/:id/clone(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const clone_lesson_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"lessons"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"clone"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /levels/:id/clone(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const clone_level_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"levels"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"clone"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /levels/:id/clone(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const clone_level_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"levels"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"clone"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /programming_classes/:id/clone(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const clone_programming_class_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"programming_classes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"clone"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /programming_classes/:id/clone(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const clone_programming_class_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"programming_classes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"clone"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /programming_expressions/:id/clone(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const clone_programming_expression_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"programming_expressions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"clone"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /programming_expressions/:id/clone(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const clone_programming_expression_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"programming_expressions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"clone"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /courses/:course_name/code(.:format)
 * @param {any} course_name
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const code_course_url = /*#__PURE__*/ __jsr.r({"course_name":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"courses"],[2,[7,"/"],[2,[3,"course_name"],[2,[7,"/"],[2,[6,"code"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /courses/:course_name/code(.:format)
 * @param {any} course_name
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const code_course_path = /*#__PURE__*/ __jsr.r({"course_name":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"courses"],[2,[7,"/"],[2,[3,"course_name"],[2,[7,"/"],[2,[6,"code"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /courses/:course_course_name/units/:position/code(.:format)
 * @param {any} course_course_name
 * @param {any} position
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const code_course_unit_url = /*#__PURE__*/ __jsr.r({"course_course_name":{"r":true},"position":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"courses"],[2,[7,"/"],[2,[3,"course_course_name"],[2,[7,"/"],[2,[6,"units"],[2,[7,"/"],[2,[3,"position"],[2,[7,"/"],[2,[6,"code"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /courses/:course_course_name/units/:position/code(.:format)
 * @param {any} course_course_name
 * @param {any} position
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const code_course_unit_path = /*#__PURE__*/ __jsr.r({"course_course_name":{"r":true},"position":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"courses"],[2,[7,"/"],[2,[3,"course_course_name"],[2,[7,"/"],[2,[6,"units"],[2,[7,"/"],[2,[3,"position"],[2,[7,"/"],[2,[6,"code"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /code_reviews/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const code_review_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"code_reviews"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /code_reviews/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const code_review_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"code_reviews"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /code_review_comments/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const code_review_comment_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"code_review_comments"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /code_review_comments/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const code_review_comment_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"code_review_comments"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /code_review_comments(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const code_review_comments_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"code_review_comments"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /code_review_comments(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const code_review_comments_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"code_review_comments"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /api/v1/sections/:id/code_review_enabled(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const code_review_enabled_api_v1_section_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"sections"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"code_review_enabled"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/v1/sections/:id/code_review_enabled(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const code_review_enabled_api_v1_section_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"sections"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"code_review_enabled"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /dashboardapi/sections/:id/code_review_enabled(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const code_review_enabled_section_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"dashboardapi"],[2,[7,"/"],[2,[6,"sections"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"code_review_enabled"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /dashboardapi/sections/:id/code_review_enabled(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const code_review_enabled_section_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"dashboardapi"],[2,[7,"/"],[2,[6,"sections"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"code_review_enabled"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/sections/:id/code_review_groups(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const code_review_groups_api_v1_section_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"sections"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"code_review_groups"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/v1/sections/:id/code_review_groups(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const code_review_groups_api_v1_section_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"sections"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"code_review_groups"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /dashboardapi/sections/:id/code_review_groups(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const code_review_groups_section_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"dashboardapi"],[2,[7,"/"],[2,[6,"sections"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"code_review_groups"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /dashboardapi/sections/:id/code_review_groups(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const code_review_groups_section_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"dashboardapi"],[2,[7,"/"],[2,[6,"sections"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"code_review_groups"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /code_reviews(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const code_reviews_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"code_reviews"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /code_reviews(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const code_reviews_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"code_reviews"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /s/:id/code(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const code_script_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"s"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"code"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /s/:id/code(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const code_script_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"s"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"code"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /datablock_storage/:channel_id/coerce_column(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const coerce_column_datablock_storage_index_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"datablock_storage"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"coerce_column"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /datablock_storage/:channel_id/coerce_column(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const coerce_column_datablock_storage_index_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"datablock_storage"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"coerce_column"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/pd/applications/cohort_view(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cohort_view_api_v1_pd_applications_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"pd"],[2,[7,"/"],[2,[6,"applications"],[2,[7,"/"],[2,[6,"cohort_view"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/v1/pd/applications/cohort_view(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cohort_view_api_v1_pd_applications_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"pd"],[2,[7,"/"],[2,[6,"applications"],[2,[7,"/"],[2,[6,"cohort_view"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/sections/:section_id/students/completed_levels_count(.:format)
 * @param {any} section_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const completed_levels_count_api_v1_section_students_url = /*#__PURE__*/ __jsr.r({"section_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"sections"],[2,[7,"/"],[2,[3,"section_id"],[2,[7,"/"],[2,[6,"students"],[2,[7,"/"],[2,[6,"completed_levels_count"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/v1/sections/:section_id/students/completed_levels_count(.:format)
 * @param {any} section_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const completed_levels_count_api_v1_section_students_path = /*#__PURE__*/ __jsr.r({"section_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"sections"],[2,[7,"/"],[2,[3,"section_id"],[2,[7,"/"],[2,[6,"students"],[2,[7,"/"],[2,[6,"completed_levels_count"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /dashboardapi/sections/:section_id/students/completed_levels_count(.:format)
 * @param {any} section_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const completed_levels_count_section_students_url = /*#__PURE__*/ __jsr.r({"section_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"dashboardapi"],[2,[7,"/"],[2,[6,"sections"],[2,[7,"/"],[2,[3,"section_id"],[2,[7,"/"],[2,[6,"students"],[2,[7,"/"],[2,[6,"completed_levels_count"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /dashboardapi/sections/:section_id/students/completed_levels_count(.:format)
 * @param {any} section_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const completed_levels_count_section_students_path = /*#__PURE__*/ __jsr.r({"section_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"dashboardapi"],[2,[7,"/"],[2,[6,"sections"],[2,[7,"/"],[2,[3,"section_id"],[2,[7,"/"],[2,[6,"students"],[2,[7,"/"],[2,[6,"completed_levels_count"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /congrats/:course_name(.:format)
 * @param {any} course_name
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const congrat_url = /*#__PURE__*/ __jsr.r({"course_name":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"congrats"],[2,[7,"/"],[2,[3,"course_name"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /congrats/:course_name(.:format)
 * @param {any} course_name
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const congrat_path = /*#__PURE__*/ __jsr.r({"course_name":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"congrats"],[2,[7,"/"],[2,[3,"course_name"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /congrats(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const congrats_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"congrats"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /congrats(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const congrats_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"congrats"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /json_videos/:id/content(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const content_json_video_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"json_videos"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"content"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /json_videos/:id/content(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const content_json_video_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"json_videos"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"content"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/convert_usernames_to_ids(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const convert_usernames_to_ids_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"convert_usernames_to_ids"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /admin/convert_usernames_to_ids(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const convert_usernames_to_ids_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"convert_usernames_to_ids"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/teacher_feedbacks/count(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const count_api_v1_teacher_feedbacks_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"teacher_feedbacks"],[2,[7,"/"],[2,[6,"count"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/v1/teacher_feedbacks/count(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const count_api_v1_teacher_feedbacks_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"teacher_feedbacks"],[2,[7,"/"],[2,[6,"count"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /courses/:course_name(.:format)
 * @param {any} course_name
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const course_url = /*#__PURE__*/ __jsr.r({"course_name":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"courses"],[2,[7,"/"],[2,[3,"course_name"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /courses/:course_name(.:format)
 * @param {any} course_name
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const course_path = /*#__PURE__*/ __jsr.r({"course_name":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"courses"],[2,[7,"/"],[2,[3,"course_name"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /course_offerings/:key(.:format)
 * @param {any} key
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const course_offering_url = /*#__PURE__*/ __jsr.r({"key":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"course_offerings"],[2,[7,"/"],[2,[3,"key"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /course_offerings/:key(.:format)
 * @param {any} key
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const course_offering_path = /*#__PURE__*/ __jsr.r({"key":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"course_offerings"],[2,[7,"/"],[2,[3,"key"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /course_offerings/self_paced_pl_course_offerings_for_workshops(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const course_offerings_self_paced_pl_course_offerings_for_workshops_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"course_offerings"],[2,[7,"/"],[2,[6,"self_paced_pl_course_offerings_for_workshops"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /course_offerings/self_paced_pl_course_offerings_for_workshops(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const course_offerings_self_paced_pl_course_offerings_for_workshops_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"course_offerings"],[2,[7,"/"],[2,[6,"self_paced_pl_course_offerings_for_workshops"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /courses/:course_course_name/guides/:key(.:format)
 * @param {any} course_course_name
 * @param {any} key
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const course_reference_guide_url = /*#__PURE__*/ __jsr.r({"course_course_name":{"r":true},"key":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"courses"],[2,[7,"/"],[2,[3,"course_course_name"],[2,[7,"/"],[2,[6,"guides"],[2,[7,"/"],[2,[3,"key"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /courses/:course_course_name/guides/:key(.:format)
 * @param {any} course_course_name
 * @param {any} key
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const course_reference_guide_path = /*#__PURE__*/ __jsr.r({"course_course_name":{"r":true},"key":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"courses"],[2,[7,"/"],[2,[3,"course_course_name"],[2,[7,"/"],[2,[6,"guides"],[2,[7,"/"],[2,[3,"key"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /courses/:course_course_name/guides(.:format)
 * @param {any} course_course_name
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const course_reference_guides_url = /*#__PURE__*/ __jsr.r({"course_course_name":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"courses"],[2,[7,"/"],[2,[3,"course_course_name"],[2,[7,"/"],[2,[6,"guides"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /courses/:course_course_name/guides(.:format)
 * @param {any} course_course_name
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const course_reference_guides_path = /*#__PURE__*/ __jsr.r({"course_course_name":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"courses"],[2,[7,"/"],[2,[3,"course_course_name"],[2,[7,"/"],[2,[6,"guides"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /courses/:course_course_name/units/:position(.:format)
 * @param {any} course_course_name
 * @param {any} position
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const course_unit_url = /*#__PURE__*/ __jsr.r({"course_course_name":{"r":true},"position":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"courses"],[2,[7,"/"],[2,[3,"course_course_name"],[2,[7,"/"],[2,[6,"units"],[2,[7,"/"],[2,[3,"position"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /courses/:course_course_name/units/:position(.:format)
 * @param {any} course_course_name
 * @param {any} position
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const course_unit_path = /*#__PURE__*/ __jsr.r({"course_course_name":{"r":true},"position":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"courses"],[2,[7,"/"],[2,[3,"course_course_name"],[2,[7,"/"],[2,[6,"units"],[2,[7,"/"],[2,[3,"position"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /courses/:course_course_name/units/:unit_position/confirm_assignments(.:format)
 * @param {any} course_course_name
 * @param {any} unit_position
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const course_unit_confirm_assignments_url = /*#__PURE__*/ __jsr.r({"course_course_name":{"r":true},"unit_position":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"courses"],[2,[7,"/"],[2,[3,"course_course_name"],[2,[7,"/"],[2,[6,"units"],[2,[7,"/"],[2,[3,"unit_position"],[2,[7,"/"],[2,[6,"confirm_assignments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /courses/:course_course_name/units/:unit_position/confirm_assignments(.:format)
 * @param {any} course_course_name
 * @param {any} unit_position
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const course_unit_confirm_assignments_path = /*#__PURE__*/ __jsr.r({"course_course_name":{"r":true},"unit_position":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"courses"],[2,[7,"/"],[2,[3,"course_course_name"],[2,[7,"/"],[2,[6,"units"],[2,[7,"/"],[2,[3,"unit_position"],[2,[7,"/"],[2,[6,"confirm_assignments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /courses/:course_course_name/units/:unit_position/hidden_lessons(.:format)
 * @param {any} course_course_name
 * @param {any} unit_position
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const course_unit_hidden_lessons_url = /*#__PURE__*/ __jsr.r({"course_course_name":{"r":true},"unit_position":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"courses"],[2,[7,"/"],[2,[3,"course_course_name"],[2,[7,"/"],[2,[6,"units"],[2,[7,"/"],[2,[3,"unit_position"],[2,[7,"/"],[2,[6,"hidden_lessons"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /courses/:course_course_name/units/:unit_position/hidden_lessons(.:format)
 * @param {any} course_course_name
 * @param {any} unit_position
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const course_unit_hidden_lessons_path = /*#__PURE__*/ __jsr.r({"course_course_name":{"r":true},"unit_position":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"courses"],[2,[7,"/"],[2,[3,"course_course_name"],[2,[7,"/"],[2,[6,"units"],[2,[7,"/"],[2,[3,"unit_position"],[2,[7,"/"],[2,[6,"hidden_lessons"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /courses/:course_course_name/units/:unit_position/lessons/:position
 * @param {any} course_course_name
 * @param {any} unit_position
 * @param {any} position
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const course_unit_lesson_url = /*#__PURE__*/ __jsr.r({"course_course_name":{"r":true},"unit_position":{"r":true},"position":{"r":true}}, [2,[7,"/"],[2,[6,"courses"],[2,[7,"/"],[2,[3,"course_course_name"],[2,[7,"/"],[2,[6,"units"],[2,[7,"/"],[2,[3,"unit_position"],[2,[7,"/"],[2,[6,"lessons"],[2,[7,"/"],[3,"position"]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /courses/:course_course_name/units/:unit_position/lessons/:position
 * @param {any} course_course_name
 * @param {any} unit_position
 * @param {any} position
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const course_unit_lesson_path = /*#__PURE__*/ __jsr.r({"course_course_name":{"r":true},"unit_position":{"r":true},"position":{"r":true}}, [2,[7,"/"],[2,[6,"courses"],[2,[7,"/"],[2,[3,"course_course_name"],[2,[7,"/"],[2,[6,"units"],[2,[7,"/"],[2,[3,"unit_position"],[2,[7,"/"],[2,[6,"lessons"],[2,[7,"/"],[3,"position"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /courses/:course_course_name/units/:unit_position/lessons/:lesson_position/edit
 * @param {any} course_course_name
 * @param {any} unit_position
 * @param {any} lesson_position
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const course_unit_lesson_edit_url = /*#__PURE__*/ __jsr.r({"course_course_name":{"r":true},"unit_position":{"r":true},"lesson_position":{"r":true}}, [2,[7,"/"],[2,[6,"courses"],[2,[7,"/"],[2,[3,"course_course_name"],[2,[7,"/"],[2,[6,"units"],[2,[7,"/"],[2,[3,"unit_position"],[2,[7,"/"],[2,[6,"lessons"],[2,[7,"/"],[2,[3,"lesson_position"],[2,[7,"/"],[6,"edit"]]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /courses/:course_course_name/units/:unit_position/lessons/:lesson_position/edit
 * @param {any} course_course_name
 * @param {any} unit_position
 * @param {any} lesson_position
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const course_unit_lesson_edit_path = /*#__PURE__*/ __jsr.r({"course_course_name":{"r":true},"unit_position":{"r":true},"lesson_position":{"r":true}}, [2,[7,"/"],[2,[6,"courses"],[2,[7,"/"],[2,[3,"course_course_name"],[2,[7,"/"],[2,[6,"units"],[2,[7,"/"],[2,[3,"unit_position"],[2,[7,"/"],[2,[6,"lessons"],[2,[7,"/"],[2,[3,"lesson_position"],[2,[7,"/"],[6,"edit"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /courses/:course_course_name/units/:unit_position/lessons/:lesson_position/extras
 * @param {any} course_course_name
 * @param {any} unit_position
 * @param {any} lesson_position
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const course_unit_lesson_extras_url = /*#__PURE__*/ __jsr.r({"course_course_name":{"r":true},"unit_position":{"r":true},"lesson_position":{"r":true}}, [2,[7,"/"],[2,[6,"courses"],[2,[7,"/"],[2,[3,"course_course_name"],[2,[7,"/"],[2,[6,"units"],[2,[7,"/"],[2,[3,"unit_position"],[2,[7,"/"],[2,[6,"lessons"],[2,[7,"/"],[2,[3,"lesson_position"],[2,[7,"/"],[6,"extras"]]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /courses/:course_course_name/units/:unit_position/lessons/:lesson_position/extras
 * @param {any} course_course_name
 * @param {any} unit_position
 * @param {any} lesson_position
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const course_unit_lesson_extras_path = /*#__PURE__*/ __jsr.r({"course_course_name":{"r":true},"unit_position":{"r":true},"lesson_position":{"r":true}}, [2,[7,"/"],[2,[6,"courses"],[2,[7,"/"],[2,[3,"course_course_name"],[2,[7,"/"],[2,[6,"units"],[2,[7,"/"],[2,[3,"unit_position"],[2,[7,"/"],[2,[6,"lessons"],[2,[7,"/"],[2,[3,"lesson_position"],[2,[7,"/"],[6,"extras"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /courses/:course_course_name/units/:unit_position/lessons/:lesson_position/generate
 * @param {any} course_course_name
 * @param {any} unit_position
 * @param {any} lesson_position
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const course_unit_lesson_generate_url = /*#__PURE__*/ __jsr.r({"course_course_name":{"r":true},"unit_position":{"r":true},"lesson_position":{"r":true}}, [2,[7,"/"],[2,[6,"courses"],[2,[7,"/"],[2,[3,"course_course_name"],[2,[7,"/"],[2,[6,"units"],[2,[7,"/"],[2,[3,"unit_position"],[2,[7,"/"],[2,[6,"lessons"],[2,[7,"/"],[2,[3,"lesson_position"],[2,[7,"/"],[6,"generate"]]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /courses/:course_course_name/units/:unit_position/lessons/:lesson_position/generate
 * @param {any} course_course_name
 * @param {any} unit_position
 * @param {any} lesson_position
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const course_unit_lesson_generate_path = /*#__PURE__*/ __jsr.r({"course_course_name":{"r":true},"unit_position":{"r":true},"lesson_position":{"r":true}}, [2,[7,"/"],[2,[6,"courses"],[2,[7,"/"],[2,[3,"course_course_name"],[2,[7,"/"],[2,[6,"units"],[2,[7,"/"],[2,[3,"unit_position"],[2,[7,"/"],[2,[6,"lessons"],[2,[7,"/"],[2,[3,"lesson_position"],[2,[7,"/"],[6,"generate"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /courses/:course_course_name/units/:unit_position/lessons/:lesson_position/level_properties
 * @param {any} course_course_name
 * @param {any} unit_position
 * @param {any} lesson_position
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const course_unit_lesson_level_properties_url = /*#__PURE__*/ __jsr.r({"course_course_name":{"r":true},"unit_position":{"r":true},"lesson_position":{"r":true}}, [2,[7,"/"],[2,[6,"courses"],[2,[7,"/"],[2,[3,"course_course_name"],[2,[7,"/"],[2,[6,"units"],[2,[7,"/"],[2,[3,"unit_position"],[2,[7,"/"],[2,[6,"lessons"],[2,[7,"/"],[2,[3,"lesson_position"],[2,[7,"/"],[6,"level_properties"]]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /courses/:course_course_name/units/:unit_position/lessons/:lesson_position/level_properties
 * @param {any} course_course_name
 * @param {any} unit_position
 * @param {any} lesson_position
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const course_unit_lesson_level_properties_path = /*#__PURE__*/ __jsr.r({"course_course_name":{"r":true},"unit_position":{"r":true},"lesson_position":{"r":true}}, [2,[7,"/"],[2,[6,"courses"],[2,[7,"/"],[2,[3,"course_course_name"],[2,[7,"/"],[2,[6,"units"],[2,[7,"/"],[2,[3,"unit_position"],[2,[7,"/"],[2,[6,"lessons"],[2,[7,"/"],[2,[3,"lesson_position"],[2,[7,"/"],[6,"level_properties"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /courses/:course_course_name/units/:unit_position/lessons/:lesson_position/levels/:id
 * @param {any} course_course_name
 * @param {any} unit_position
 * @param {any} lesson_position
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const course_unit_lesson_script_level_url = /*#__PURE__*/ __jsr.r({"course_course_name":{"r":true},"unit_position":{"r":true},"lesson_position":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"courses"],[2,[7,"/"],[2,[3,"course_course_name"],[2,[7,"/"],[2,[6,"units"],[2,[7,"/"],[2,[3,"unit_position"],[2,[7,"/"],[2,[6,"lessons"],[2,[7,"/"],[2,[3,"lesson_position"],[2,[7,"/"],[2,[6,"levels"],[2,[7,"/"],[3,"id"]]]]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /courses/:course_course_name/units/:unit_position/lessons/:lesson_position/levels/:id
 * @param {any} course_course_name
 * @param {any} unit_position
 * @param {any} lesson_position
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const course_unit_lesson_script_level_path = /*#__PURE__*/ __jsr.r({"course_course_name":{"r":true},"unit_position":{"r":true},"lesson_position":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"courses"],[2,[7,"/"],[2,[3,"course_course_name"],[2,[7,"/"],[2,[6,"units"],[2,[7,"/"],[2,[3,"unit_position"],[2,[7,"/"],[2,[6,"lessons"],[2,[7,"/"],[2,[3,"lesson_position"],[2,[7,"/"],[2,[6,"levels"],[2,[7,"/"],[3,"id"]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /courses/:course_course_name/units/:unit_position/lessons/:lesson_position/slides
 * @param {any} course_course_name
 * @param {any} unit_position
 * @param {any} lesson_position
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const course_unit_lesson_slides_url = /*#__PURE__*/ __jsr.r({"course_course_name":{"r":true},"unit_position":{"r":true},"lesson_position":{"r":true}}, [2,[7,"/"],[2,[6,"courses"],[2,[7,"/"],[2,[3,"course_course_name"],[2,[7,"/"],[2,[6,"units"],[2,[7,"/"],[2,[3,"unit_position"],[2,[7,"/"],[2,[6,"lessons"],[2,[7,"/"],[2,[3,"lesson_position"],[2,[7,"/"],[6,"slides"]]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /courses/:course_course_name/units/:unit_position/lessons/:lesson_position/slides
 * @param {any} course_course_name
 * @param {any} unit_position
 * @param {any} lesson_position
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const course_unit_lesson_slides_path = /*#__PURE__*/ __jsr.r({"course_course_name":{"r":true},"unit_position":{"r":true},"lesson_position":{"r":true}}, [2,[7,"/"],[2,[6,"courses"],[2,[7,"/"],[2,[3,"course_course_name"],[2,[7,"/"],[2,[6,"units"],[2,[7,"/"],[2,[3,"unit_position"],[2,[7,"/"],[2,[6,"lessons"],[2,[7,"/"],[2,[3,"lesson_position"],[2,[7,"/"],[6,"slides"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /courses/:course_course_name/units/:unit_position/lessons/:lesson_position/slides/edit
 * @param {any} course_course_name
 * @param {any} unit_position
 * @param {any} lesson_position
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const course_unit_lesson_slides_edit_url = /*#__PURE__*/ __jsr.r({"course_course_name":{"r":true},"unit_position":{"r":true},"lesson_position":{"r":true}}, [2,[7,"/"],[2,[6,"courses"],[2,[7,"/"],[2,[3,"course_course_name"],[2,[7,"/"],[2,[6,"units"],[2,[7,"/"],[2,[3,"unit_position"],[2,[7,"/"],[2,[6,"lessons"],[2,[7,"/"],[2,[3,"lesson_position"],[2,[7,"/"],[2,[6,"slides"],[2,[7,"/"],[6,"edit"]]]]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /courses/:course_course_name/units/:unit_position/lessons/:lesson_position/slides/edit
 * @param {any} course_course_name
 * @param {any} unit_position
 * @param {any} lesson_position
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const course_unit_lesson_slides_edit_path = /*#__PURE__*/ __jsr.r({"course_course_name":{"r":true},"unit_position":{"r":true},"lesson_position":{"r":true}}, [2,[7,"/"],[2,[6,"courses"],[2,[7,"/"],[2,[3,"course_course_name"],[2,[7,"/"],[2,[6,"units"],[2,[7,"/"],[2,[3,"unit_position"],[2,[7,"/"],[2,[6,"lessons"],[2,[7,"/"],[2,[3,"lesson_position"],[2,[7,"/"],[2,[6,"slides"],[2,[7,"/"],[6,"edit"]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /courses/:course_course_name/units/:unit_position/lessons/:lesson_position/slides/generate
 * @param {any} course_course_name
 * @param {any} unit_position
 * @param {any} lesson_position
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const course_unit_lesson_slides_generate_url = /*#__PURE__*/ __jsr.r({"course_course_name":{"r":true},"unit_position":{"r":true},"lesson_position":{"r":true}}, [2,[7,"/"],[2,[6,"courses"],[2,[7,"/"],[2,[3,"course_course_name"],[2,[7,"/"],[2,[6,"units"],[2,[7,"/"],[2,[3,"unit_position"],[2,[7,"/"],[2,[6,"lessons"],[2,[7,"/"],[2,[3,"lesson_position"],[2,[7,"/"],[2,[6,"slides"],[2,[7,"/"],[6,"generate"]]]]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /courses/:course_course_name/units/:unit_position/lessons/:lesson_position/slides/generate
 * @param {any} course_course_name
 * @param {any} unit_position
 * @param {any} lesson_position
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const course_unit_lesson_slides_generate_path = /*#__PURE__*/ __jsr.r({"course_course_name":{"r":true},"unit_position":{"r":true},"lesson_position":{"r":true}}, [2,[7,"/"],[2,[6,"courses"],[2,[7,"/"],[2,[3,"course_course_name"],[2,[7,"/"],[2,[6,"units"],[2,[7,"/"],[2,[3,"unit_position"],[2,[7,"/"],[2,[6,"lessons"],[2,[7,"/"],[2,[3,"lesson_position"],[2,[7,"/"],[2,[6,"slides"],[2,[7,"/"],[6,"generate"]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /courses/:course_course_name/units/:unit_position/lessons/:lesson_position/student
 * @param {any} course_course_name
 * @param {any} unit_position
 * @param {any} lesson_position
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const course_unit_lesson_student_url = /*#__PURE__*/ __jsr.r({"course_course_name":{"r":true},"unit_position":{"r":true},"lesson_position":{"r":true}}, [2,[7,"/"],[2,[6,"courses"],[2,[7,"/"],[2,[3,"course_course_name"],[2,[7,"/"],[2,[6,"units"],[2,[7,"/"],[2,[3,"unit_position"],[2,[7,"/"],[2,[6,"lessons"],[2,[7,"/"],[2,[3,"lesson_position"],[2,[7,"/"],[6,"student"]]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /courses/:course_course_name/units/:unit_position/lessons/:lesson_position/student
 * @param {any} course_course_name
 * @param {any} unit_position
 * @param {any} lesson_position
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const course_unit_lesson_student_path = /*#__PURE__*/ __jsr.r({"course_course_name":{"r":true},"unit_position":{"r":true},"lesson_position":{"r":true}}, [2,[7,"/"],[2,[6,"courses"],[2,[7,"/"],[2,[3,"course_course_name"],[2,[7,"/"],[2,[6,"units"],[2,[7,"/"],[2,[3,"unit_position"],[2,[7,"/"],[2,[6,"lessons"],[2,[7,"/"],[2,[3,"lesson_position"],[2,[7,"/"],[6,"student"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /courses/:course_course_name/units/:unit_position/lessons/:lesson_position/summary_for_lesson_plans
 * @param {any} course_course_name
 * @param {any} unit_position
 * @param {any} lesson_position
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const course_unit_lesson_summary_for_lesson_plans_url = /*#__PURE__*/ __jsr.r({"course_course_name":{"r":true},"unit_position":{"r":true},"lesson_position":{"r":true}}, [2,[7,"/"],[2,[6,"courses"],[2,[7,"/"],[2,[3,"course_course_name"],[2,[7,"/"],[2,[6,"units"],[2,[7,"/"],[2,[3,"unit_position"],[2,[7,"/"],[2,[6,"lessons"],[2,[7,"/"],[2,[3,"lesson_position"],[2,[7,"/"],[6,"summary_for_lesson_plans"]]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /courses/:course_course_name/units/:unit_position/lessons/:lesson_position/summary_for_lesson_plans
 * @param {any} course_course_name
 * @param {any} unit_position
 * @param {any} lesson_position
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const course_unit_lesson_summary_for_lesson_plans_path = /*#__PURE__*/ __jsr.r({"course_course_name":{"r":true},"unit_position":{"r":true},"lesson_position":{"r":true}}, [2,[7,"/"],[2,[6,"courses"],[2,[7,"/"],[2,[3,"course_course_name"],[2,[7,"/"],[2,[6,"units"],[2,[7,"/"],[2,[3,"unit_position"],[2,[7,"/"],[2,[6,"lessons"],[2,[7,"/"],[2,[3,"lesson_position"],[2,[7,"/"],[6,"summary_for_lesson_plans"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /courses/:course_course_name/units/:unit_position/lessons/:lesson_position/tutor
 * @param {any} course_course_name
 * @param {any} unit_position
 * @param {any} lesson_position
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const course_unit_lesson_tutor_url = /*#__PURE__*/ __jsr.r({"course_course_name":{"r":true},"unit_position":{"r":true},"lesson_position":{"r":true}}, [2,[7,"/"],[2,[6,"courses"],[2,[7,"/"],[2,[3,"course_course_name"],[2,[7,"/"],[2,[6,"units"],[2,[7,"/"],[2,[3,"unit_position"],[2,[7,"/"],[2,[6,"lessons"],[2,[7,"/"],[2,[3,"lesson_position"],[2,[7,"/"],[6,"tutor"]]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /courses/:course_course_name/units/:unit_position/lessons/:lesson_position/tutor
 * @param {any} course_course_name
 * @param {any} unit_position
 * @param {any} lesson_position
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const course_unit_lesson_tutor_path = /*#__PURE__*/ __jsr.r({"course_course_name":{"r":true},"unit_position":{"r":true},"lesson_position":{"r":true}}, [2,[7,"/"],[2,[6,"courses"],[2,[7,"/"],[2,[3,"course_course_name"],[2,[7,"/"],[2,[6,"units"],[2,[7,"/"],[2,[3,"unit_position"],[2,[7,"/"],[2,[6,"lessons"],[2,[7,"/"],[2,[3,"lesson_position"],[2,[7,"/"],[6,"tutor"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /courses/:course_course_name/units/:unit_position/lessons/:lesson_position/tutor/gallery
 * @param {any} course_course_name
 * @param {any} unit_position
 * @param {any} lesson_position
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const course_unit_lesson_tutor_gallery_url = /*#__PURE__*/ __jsr.r({"course_course_name":{"r":true},"unit_position":{"r":true},"lesson_position":{"r":true}}, [2,[7,"/"],[2,[6,"courses"],[2,[7,"/"],[2,[3,"course_course_name"],[2,[7,"/"],[2,[6,"units"],[2,[7,"/"],[2,[3,"unit_position"],[2,[7,"/"],[2,[6,"lessons"],[2,[7,"/"],[2,[3,"lesson_position"],[2,[7,"/"],[2,[6,"tutor"],[2,[7,"/"],[6,"gallery"]]]]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /courses/:course_course_name/units/:unit_position/lessons/:lesson_position/tutor/gallery
 * @param {any} course_course_name
 * @param {any} unit_position
 * @param {any} lesson_position
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const course_unit_lesson_tutor_gallery_path = /*#__PURE__*/ __jsr.r({"course_course_name":{"r":true},"unit_position":{"r":true},"lesson_position":{"r":true}}, [2,[7,"/"],[2,[6,"courses"],[2,[7,"/"],[2,[3,"course_course_name"],[2,[7,"/"],[2,[6,"units"],[2,[7,"/"],[2,[3,"unit_position"],[2,[7,"/"],[2,[6,"lessons"],[2,[7,"/"],[2,[3,"lesson_position"],[2,[7,"/"],[2,[6,"tutor"],[2,[7,"/"],[6,"gallery"]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /courses/:course_course_name/units/:unit_position/lessons
 * @param {any} course_course_name
 * @param {any} unit_position
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const course_unit_lessons_url = /*#__PURE__*/ __jsr.r({"course_course_name":{"r":true},"unit_position":{"r":true}}, [2,[7,"/"],[2,[6,"courses"],[2,[7,"/"],[2,[3,"course_course_name"],[2,[7,"/"],[2,[6,"units"],[2,[7,"/"],[2,[3,"unit_position"],[2,[7,"/"],[6,"lessons"]]]]]]]]]], true);

/**
 * Generates rails route to
 * /courses/:course_course_name/units/:unit_position/lessons
 * @param {any} course_course_name
 * @param {any} unit_position
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const course_unit_lessons_path = /*#__PURE__*/ __jsr.r({"course_course_name":{"r":true},"unit_position":{"r":true}}, [2,[7,"/"],[2,[6,"courses"],[2,[7,"/"],[2,[3,"course_course_name"],[2,[7,"/"],[2,[6,"units"],[2,[7,"/"],[2,[3,"unit_position"],[2,[7,"/"],[6,"lessons"]]]]]]]]]]);

/**
 * Generates rails route to
 * /courses/:course_course_name/units/:unit_position/lockable/:lockable_lesson_position/levels/:id
 * @param {any} course_course_name
 * @param {any} unit_position
 * @param {any} lockable_lesson_position
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const course_unit_lockable_lesson_script_level_url = /*#__PURE__*/ __jsr.r({"course_course_name":{"r":true},"unit_position":{"r":true},"lockable_lesson_position":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"courses"],[2,[7,"/"],[2,[3,"course_course_name"],[2,[7,"/"],[2,[6,"units"],[2,[7,"/"],[2,[3,"unit_position"],[2,[7,"/"],[2,[6,"lockable"],[2,[7,"/"],[2,[3,"lockable_lesson_position"],[2,[7,"/"],[2,[6,"levels"],[2,[7,"/"],[3,"id"]]]]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /courses/:course_course_name/units/:unit_position/lockable/:lockable_lesson_position/levels/:id
 * @param {any} course_course_name
 * @param {any} unit_position
 * @param {any} lockable_lesson_position
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const course_unit_lockable_lesson_script_level_path = /*#__PURE__*/ __jsr.r({"course_course_name":{"r":true},"unit_position":{"r":true},"lockable_lesson_position":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"courses"],[2,[7,"/"],[2,[3,"course_course_name"],[2,[7,"/"],[2,[6,"units"],[2,[7,"/"],[2,[3,"unit_position"],[2,[7,"/"],[2,[6,"lockable"],[2,[7,"/"],[2,[3,"lockable_lesson_position"],[2,[7,"/"],[2,[6,"levels"],[2,[7,"/"],[3,"id"]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /courses/:course_course_name/units/:unit_position/lockable/:lockable_lesson_position/summary_for_lesson_plans
 * @param {any} course_course_name
 * @param {any} unit_position
 * @param {any} lockable_lesson_position
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const course_unit_lockable_lesson_summary_for_lesson_plans_url = /*#__PURE__*/ __jsr.r({"course_course_name":{"r":true},"unit_position":{"r":true},"lockable_lesson_position":{"r":true}}, [2,[7,"/"],[2,[6,"courses"],[2,[7,"/"],[2,[3,"course_course_name"],[2,[7,"/"],[2,[6,"units"],[2,[7,"/"],[2,[3,"unit_position"],[2,[7,"/"],[2,[6,"lockable"],[2,[7,"/"],[2,[3,"lockable_lesson_position"],[2,[7,"/"],[6,"summary_for_lesson_plans"]]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /courses/:course_course_name/units/:unit_position/lockable/:lockable_lesson_position/summary_for_lesson_plans
 * @param {any} course_course_name
 * @param {any} unit_position
 * @param {any} lockable_lesson_position
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const course_unit_lockable_lesson_summary_for_lesson_plans_path = /*#__PURE__*/ __jsr.r({"course_course_name":{"r":true},"unit_position":{"r":true},"lockable_lesson_position":{"r":true}}, [2,[7,"/"],[2,[6,"courses"],[2,[7,"/"],[2,[3,"course_course_name"],[2,[7,"/"],[2,[6,"units"],[2,[7,"/"],[2,[3,"unit_position"],[2,[7,"/"],[2,[6,"lockable"],[2,[7,"/"],[2,[3,"lockable_lesson_position"],[2,[7,"/"],[6,"summary_for_lesson_plans"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /courses/:course_course_name/units/:unit_position/next(.:format)
 * @param {any} course_course_name
 * @param {any} unit_position
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const course_unit_next_url = /*#__PURE__*/ __jsr.r({"course_course_name":{"r":true},"unit_position":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"courses"],[2,[7,"/"],[2,[3,"course_course_name"],[2,[7,"/"],[2,[6,"units"],[2,[7,"/"],[2,[3,"unit_position"],[2,[7,"/"],[2,[6,"next"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /courses/:course_course_name/units/:unit_position/next(.:format)
 * @param {any} course_course_name
 * @param {any} unit_position
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const course_unit_next_path = /*#__PURE__*/ __jsr.r({"course_course_name":{"r":true},"unit_position":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"courses"],[2,[7,"/"],[2,[3,"course_course_name"],[2,[7,"/"],[2,[6,"units"],[2,[7,"/"],[2,[3,"unit_position"],[2,[7,"/"],[2,[6,"next"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /courses/:course_course_name/units/:unit_position/preview-assignments(.:format)
 * @param {any} course_course_name
 * @param {any} unit_position
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const course_unit_preview_assignments_url = /*#__PURE__*/ __jsr.r({"course_course_name":{"r":true},"unit_position":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"courses"],[2,[7,"/"],[2,[3,"course_course_name"],[2,[7,"/"],[2,[6,"units"],[2,[7,"/"],[2,[3,"unit_position"],[2,[7,"/"],[2,[6,"preview-assignments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /courses/:course_course_name/units/:unit_position/preview-assignments(.:format)
 * @param {any} course_course_name
 * @param {any} unit_position
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const course_unit_preview_assignments_path = /*#__PURE__*/ __jsr.r({"course_course_name":{"r":true},"unit_position":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"courses"],[2,[7,"/"],[2,[3,"course_course_name"],[2,[7,"/"],[2,[6,"units"],[2,[7,"/"],[2,[3,"unit_position"],[2,[7,"/"],[2,[6,"preview-assignments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /courses/:course_course_name/units/:unit_position/pull-review(.:format)
 * @param {any} course_course_name
 * @param {any} unit_position
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const course_unit_pull_review_url = /*#__PURE__*/ __jsr.r({"course_course_name":{"r":true},"unit_position":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"courses"],[2,[7,"/"],[2,[3,"course_course_name"],[2,[7,"/"],[2,[6,"units"],[2,[7,"/"],[2,[3,"unit_position"],[2,[7,"/"],[2,[6,"pull-review"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /courses/:course_course_name/units/:unit_position/pull-review(.:format)
 * @param {any} course_course_name
 * @param {any} unit_position
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const course_unit_pull_review_path = /*#__PURE__*/ __jsr.r({"course_course_name":{"r":true},"unit_position":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"courses"],[2,[7,"/"],[2,[3,"course_course_name"],[2,[7,"/"],[2,[6,"units"],[2,[7,"/"],[2,[3,"unit_position"],[2,[7,"/"],[2,[6,"pull-review"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /courses/:course_course_name/units/:unit_position/reset(.:format)
 * @param {any} course_course_name
 * @param {any} unit_position
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const course_unit_reset_url = /*#__PURE__*/ __jsr.r({"course_course_name":{"r":true},"unit_position":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"courses"],[2,[7,"/"],[2,[3,"course_course_name"],[2,[7,"/"],[2,[6,"units"],[2,[7,"/"],[2,[3,"unit_position"],[2,[7,"/"],[2,[6,"reset"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /courses/:course_course_name/units/:unit_position/reset(.:format)
 * @param {any} course_course_name
 * @param {any} unit_position
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const course_unit_reset_path = /*#__PURE__*/ __jsr.r({"course_course_name":{"r":true},"unit_position":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"courses"],[2,[7,"/"],[2,[3,"course_course_name"],[2,[7,"/"],[2,[6,"units"],[2,[7,"/"],[2,[3,"unit_position"],[2,[7,"/"],[2,[6,"reset"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /quiz_questions/course_unit_search(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const course_unit_search_quiz_questions_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"quiz_questions"],[2,[7,"/"],[2,[6,"course_unit_search"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /quiz_questions/course_unit_search(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const course_unit_search_quiz_questions_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"quiz_questions"],[2,[7,"/"],[2,[6,"course_unit_search"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /courses/:course_course_name/units/:unit_position/toggle_hidden(.:format)
 * @param {any} course_course_name
 * @param {any} unit_position
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const course_unit_toggle_hidden_url = /*#__PURE__*/ __jsr.r({"course_course_name":{"r":true},"unit_position":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"courses"],[2,[7,"/"],[2,[3,"course_course_name"],[2,[7,"/"],[2,[6,"units"],[2,[7,"/"],[2,[3,"unit_position"],[2,[7,"/"],[2,[6,"toggle_hidden"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /courses/:course_course_name/units/:unit_position/toggle_hidden(.:format)
 * @param {any} course_course_name
 * @param {any} unit_position
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const course_unit_toggle_hidden_path = /*#__PURE__*/ __jsr.r({"course_course_name":{"r":true},"unit_position":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"courses"],[2,[7,"/"],[2,[3,"course_course_name"],[2,[7,"/"],[2,[6,"units"],[2,[7,"/"],[2,[3,"unit_position"],[2,[7,"/"],[2,[6,"toggle_hidden"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /courses/:course_course_name/units(.:format)
 * @param {any} course_course_name
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const course_units_url = /*#__PURE__*/ __jsr.r({"course_course_name":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"courses"],[2,[7,"/"],[2,[3,"course_course_name"],[2,[7,"/"],[2,[6,"units"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /courses/:course_course_name/units(.:format)
 * @param {any} course_course_name
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const course_units_path = /*#__PURE__*/ __jsr.r({"course_course_name":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"courses"],[2,[7,"/"],[2,[3,"course_course_name"],[2,[7,"/"],[2,[6,"units"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /courses(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const courses_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"courses"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /courses(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const courses_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"courses"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /teacher_dashboard/sections/:section_id/courses(.:format)
 * @param {any} section_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const courses_teacher_dashboard_section_url = /*#__PURE__*/ __jsr.r({"section_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"teacher_dashboard"],[2,[7,"/"],[2,[6,"sections"],[2,[7,"/"],[2,[3,"section_id"],[2,[7,"/"],[2,[6,"courses"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /teacher_dashboard/sections/:section_id/courses(.:format)
 * @param {any} section_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const courses_teacher_dashboard_section_path = /*#__PURE__*/ __jsr.r({"section_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"teacher_dashboard"],[2,[7,"/"],[2,[6,"sections"],[2,[7,"/"],[2,[3,"section_id"],[2,[7,"/"],[2,[6,"courses"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/sections/demo/create/:demo_type(.:format)
 * @param {any} demo_type
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const create_demo_api_v1_sections_url = /*#__PURE__*/ __jsr.r({"demo_type":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"sections"],[2,[7,"/"],[2,[6,"demo"],[2,[7,"/"],[2,[6,"create"],[2,[7,"/"],[2,[3,"demo_type"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/v1/sections/demo/create/:demo_type(.:format)
 * @param {any} demo_type
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const create_demo_api_v1_sections_path = /*#__PURE__*/ __jsr.r({"demo_type":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"sections"],[2,[7,"/"],[2,[6,"demo"],[2,[7,"/"],[2,[6,"create"],[2,[7,"/"],[2,[3,"demo_type"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /dashboardapi/sections/demo/create/:demo_type(.:format)
 * @param {any} demo_type
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const create_demo_sections_url = /*#__PURE__*/ __jsr.r({"demo_type":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"dashboardapi"],[2,[7,"/"],[2,[6,"sections"],[2,[7,"/"],[2,[6,"demo"],[2,[7,"/"],[2,[6,"create"],[2,[7,"/"],[2,[3,"demo_type"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /dashboardapi/sections/demo/create/:demo_type(.:format)
 * @param {any} demo_type
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const create_demo_sections_path = /*#__PURE__*/ __jsr.r({"demo_type":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"dashboardapi"],[2,[7,"/"],[2,[6,"sections"],[2,[7,"/"],[2,[6,"demo"],[2,[7,"/"],[2,[6,"create"],[2,[7,"/"],[2,[3,"demo_type"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /datablock_storage/:channel_id/create_record(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const create_record_datablock_storage_index_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"datablock_storage"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"create_record"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /datablock_storage/:channel_id/create_record(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const create_record_datablock_storage_index_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"datablock_storage"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"create_record"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /datablock_storage/:channel_id/create_table(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const create_table_datablock_storage_index_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"datablock_storage"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"create_table"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /datablock_storage/:channel_id/create_table(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const create_table_datablock_storage_index_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"datablock_storage"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"create_table"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /aidiff_threads/curriculum_courses(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const curriculum_courses_aidiff_threads_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"aidiff_threads"],[2,[7,"/"],[2,[6,"curriculum_courses"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /aidiff_threads/curriculum_courses(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const curriculum_courses_aidiff_threads_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"aidiff_threads"],[2,[7,"/"],[2,[6,"curriculum_courses"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /curriculum_tracking_pixel(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const curriculum_tracking_pixel_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"curriculum_tracking_pixel"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /curriculum_tracking_pixel(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const curriculum_tracking_pixel_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"curriculum_tracking_pixel"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /p/dance(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dance_p_index_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[6,"dance"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /p/dance(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dance_p_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[6,"dance"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /projects/dance/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dance_project_create_new_projects_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"dance"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/dance/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dance_project_create_new_projects_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"dance"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/dance/:channel_id/edit(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dance_project_edit_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"dance"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/dance/:channel_id/edit(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dance_project_edit_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"dance"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/dance/:channel_id/export_config(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dance_project_export_config_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"dance"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"export_config"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/dance/:channel_id/export_config(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dance_project_export_config_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"dance"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"export_config"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/dance/:channel_id/export_create_channel(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dance_project_export_create_channel_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"dance"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"export_create_channel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/dance/:channel_id/export_create_channel(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dance_project_export_create_channel_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"dance"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"export_create_channel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/dance/:channel_id/embed_app_and_code(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dance_project_iframe_embed_app_and_code_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"dance"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"embed_app_and_code"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/dance/:channel_id/embed_app_and_code(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dance_project_iframe_embed_app_and_code_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"dance"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"embed_app_and_code"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/dance/:channel_id/embed(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dance_project_iframe_embed_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"dance"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"embed"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/dance/:channel_id/embed(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dance_project_iframe_embed_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"dance"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"embed"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/dance(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dance_project_projects_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"dance"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /projects/dance(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dance_project_projects_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"dance"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /projects/dance/:channel_id/remix(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dance_project_remix_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"dance"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"remix"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/dance/:channel_id/remix(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dance_project_remix_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"dance"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"remix"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/dance/:channel_id(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dance_project_share_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"dance"],[2,[7,"/"],[2,[3,"channel_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/dance/:channel_id(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dance_project_share_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"dance"],[2,[7,"/"],[2,[3,"channel_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/dance/:channel_id/view(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dance_project_view_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"dance"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"view"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/dance/:channel_id/view(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dance_project_view_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"dance"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"view"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /dashboardapi/clever_classrooms(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboardapi_clever_classrooms_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dashboardapi"],[2,[7,"/"],[2,[6,"clever_classrooms"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /dashboardapi/clever_classrooms(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboardapi_clever_classrooms_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dashboardapi"],[2,[7,"/"],[2,[6,"clever_classrooms"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /dashboardapi/course_summary(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboardapi_course_summary_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dashboardapi"],[2,[7,"/"],[2,[6,"course_summary"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /dashboardapi/course_summary(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboardapi_course_summary_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dashboardapi"],[2,[7,"/"],[2,[6,"course_summary"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /dashboardapi/example_solutions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboardapi_example_solutions_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dashboardapi"],[2,[7,"/"],[2,[6,"example_solutions"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /dashboardapi/example_solutions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboardapi_example_solutions_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dashboardapi"],[2,[7,"/"],[2,[6,"example_solutions"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /dashboardapi/firehose_unreachable(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboardapi_firehose_unreachable_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dashboardapi"],[2,[7,"/"],[2,[6,"firehose_unreachable"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /dashboardapi/firehose_unreachable(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboardapi_firehose_unreachable_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dashboardapi"],[2,[7,"/"],[2,[6,"firehose_unreachable"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /dashboardapi/google_classrooms(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboardapi_google_classrooms_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dashboardapi"],[2,[7,"/"],[2,[6,"google_classrooms"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /dashboardapi/google_classrooms(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboardapi_google_classrooms_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dashboardapi"],[2,[7,"/"],[2,[6,"google_classrooms"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /dashboardapi/immersive_reader_token(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboardapi_immersive_reader_token_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dashboardapi"],[2,[7,"/"],[2,[6,"immersive_reader_token"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /dashboardapi/immersive_reader_token(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboardapi_immersive_reader_token_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dashboardapi"],[2,[7,"/"],[2,[6,"immersive_reader_token"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /dashboardapi/import_clever_classroom(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboardapi_import_clever_classroom_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dashboardapi"],[2,[7,"/"],[2,[6,"import_clever_classroom"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /dashboardapi/import_clever_classroom(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboardapi_import_clever_classroom_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dashboardapi"],[2,[7,"/"],[2,[6,"import_clever_classroom"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /dashboardapi/import_google_classroom(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboardapi_import_google_classroom_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dashboardapi"],[2,[7,"/"],[2,[6,"import_google_classroom"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /dashboardapi/import_google_classroom(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboardapi_import_google_classroom_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dashboardapi"],[2,[7,"/"],[2,[6,"import_google_classroom"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /dashboardapi/lesson_materials(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboardapi_lesson_materials_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dashboardapi"],[2,[7,"/"],[2,[6,"lesson_materials"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /dashboardapi/lesson_materials(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboardapi_lesson_materials_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dashboardapi"],[2,[7,"/"],[2,[6,"lesson_materials"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /dashboardapi/lockable_state(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboardapi_lockable_state_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dashboardapi"],[2,[7,"/"],[2,[6,"lockable_state"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /dashboardapi/lockable_state(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboardapi_lockable_state_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dashboardapi"],[2,[7,"/"],[2,[6,"lockable_state"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /dashboardapi/script_standards(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboardapi_script_standards_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dashboardapi"],[2,[7,"/"],[2,[6,"script_standards"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /dashboardapi/script_standards(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboardapi_script_standards_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dashboardapi"],[2,[7,"/"],[2,[6,"script_standards"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /dashboardapi/script_structure(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboardapi_script_structure_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dashboardapi"],[2,[7,"/"],[2,[6,"script_structure"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /dashboardapi/script_structure(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboardapi_script_structure_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dashboardapi"],[2,[7,"/"],[2,[6,"script_structure"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /dashboardapi/section(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboardapi_section_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dashboardapi"],[2,[7,"/"],[2,[6,"section"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /dashboardapi/section(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboardapi_section_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dashboardapi"],[2,[7,"/"],[2,[6,"section"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /dashboardapi/section_level_progress(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboardapi_section_level_progress_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dashboardapi"],[2,[7,"/"],[2,[6,"section_level_progress"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /dashboardapi/section_level_progress(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboardapi_section_level_progress_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dashboardapi"],[2,[7,"/"],[2,[6,"section_level_progress"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /dashboardapi/section_text_responses(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboardapi_section_text_responses_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dashboardapi"],[2,[7,"/"],[2,[6,"section_text_responses"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /dashboardapi/section_text_responses(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboardapi_section_text_responses_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dashboardapi"],[2,[7,"/"],[2,[6,"section_text_responses"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /dashboardapi/sections/transfers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboardapi_sections_transfers_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dashboardapi"],[2,[7,"/"],[2,[6,"sections"],[2,[7,"/"],[2,[6,"transfers"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /dashboardapi/sections/transfers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboardapi_sections_transfers_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dashboardapi"],[2,[7,"/"],[2,[6,"sections"],[2,[7,"/"],[2,[6,"transfers"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /dashboardapi/show_courses_with_progress(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboardapi_show_courses_with_progress_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dashboardapi"],[2,[7,"/"],[2,[6,"show_courses_with_progress"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /dashboardapi/show_courses_with_progress(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboardapi_show_courses_with_progress_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dashboardapi"],[2,[7,"/"],[2,[6,"show_courses_with_progress"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /dashboardapi/sign_cookies(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboardapi_sign_cookies_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dashboardapi"],[2,[7,"/"],[2,[6,"sign_cookies"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /dashboardapi/sign_cookies(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboardapi_sign_cookies_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dashboardapi"],[2,[7,"/"],[2,[6,"sign_cookies"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /dashboardapi/teacher_panel_progress(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboardapi_teacher_panel_progress_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dashboardapi"],[2,[7,"/"],[2,[6,"teacher_panel_progress"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /dashboardapi/teacher_panel_progress(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboardapi_teacher_panel_progress_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dashboardapi"],[2,[7,"/"],[2,[6,"teacher_panel_progress"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /dashboardapi/teacher_panel_section(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboardapi_teacher_panel_section_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dashboardapi"],[2,[7,"/"],[2,[6,"teacher_panel_section"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /dashboardapi/teacher_panel_section(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboardapi_teacher_panel_section_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dashboardapi"],[2,[7,"/"],[2,[6,"teacher_panel_section"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /dashboardapi/terms-and-privacy(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboardapi_terms_and_privacy_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dashboardapi"],[2,[7,"/"],[2,[6,"terms-and-privacy"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /dashboardapi/terms-and-privacy(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboardapi_terms_and_privacy_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dashboardapi"],[2,[7,"/"],[2,[6,"terms-and-privacy"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /dashboardapi/unit_summary(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboardapi_unit_summary_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dashboardapi"],[2,[7,"/"],[2,[6,"unit_summary"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /dashboardapi/unit_summary(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboardapi_unit_summary_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dashboardapi"],[2,[7,"/"],[2,[6,"unit_summary"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /dashboardapi/update_lockable_state(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboardapi_update_lockable_state_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dashboardapi"],[2,[7,"/"],[2,[6,"update_lockable_state"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /dashboardapi/update_lockable_state(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboardapi_update_lockable_state_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dashboardapi"],[2,[7,"/"],[2,[6,"update_lockable_state"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /dashboardapi/user_app_options(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboardapi_user_app_options_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dashboardapi"],[2,[7,"/"],[2,[6,"user_app_options"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /dashboardapi/user_app_options(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboardapi_user_app_options_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dashboardapi"],[2,[7,"/"],[2,[6,"user_app_options"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /dashboardapi/user_menu(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboardapi_user_menu_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dashboardapi"],[2,[7,"/"],[2,[6,"user_menu"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /dashboardapi/user_menu(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboardapi_user_menu_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dashboardapi"],[2,[7,"/"],[2,[6,"user_menu"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /dashboardapi/user_progress(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboardapi_user_progress_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dashboardapi"],[2,[7,"/"],[2,[6,"user_progress"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /dashboardapi/user_progress(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboardapi_user_progress_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dashboardapi"],[2,[7,"/"],[2,[6,"user_progress"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /dashboardapi/users(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboardapi_users_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dashboardapi"],[2,[7,"/"],[2,[6,"users"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /dashboardapi/users(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboardapi_users_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dashboardapi"],[2,[7,"/"],[2,[6,"users"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /dashboardapi/v1/amazon_future_engineer_submit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboardapi_v1_amazon_future_engineer_submit_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dashboardapi"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"amazon_future_engineer_submit"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /dashboardapi/v1/amazon_future_engineer_submit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboardapi_v1_amazon_future_engineer_submit_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dashboardapi"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"amazon_future_engineer_submit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /dashboardapi/v1/foorm/simple_survey_submission(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboardapi_v1_foorm_simple_survey_submission_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dashboardapi"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"foorm"],[2,[7,"/"],[2,[6,"simple_survey_submission"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /dashboardapi/v1/foorm/simple_survey_submission(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboardapi_v1_foorm_simple_survey_submission_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dashboardapi"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"foorm"],[2,[7,"/"],[2,[6,"simple_survey_submission"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /dashboardapi/v1/pd/regional_partner_mini_contacts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboardapi_v1_pd_regional_partner_mini_contacts_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dashboardapi"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"pd"],[2,[7,"/"],[2,[6,"regional_partner_mini_contacts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /dashboardapi/v1/pd/regional_partner_mini_contacts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboardapi_v1_pd_regional_partner_mini_contacts_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dashboardapi"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"pd"],[2,[7,"/"],[2,[6,"regional_partner_mini_contacts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /dashboardapi/v1/pd/workshops_as_facilitator_for_pl_page(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboardapi_v1_pd_workshops_as_facilitator_for_pl_page_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dashboardapi"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"pd"],[2,[7,"/"],[2,[6,"workshops_as_facilitator_for_pl_page"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /dashboardapi/v1/pd/workshops_as_facilitator_for_pl_page(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboardapi_v1_pd_workshops_as_facilitator_for_pl_page_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dashboardapi"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"pd"],[2,[7,"/"],[2,[6,"workshops_as_facilitator_for_pl_page"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /dashboardapi/v1/pd/workshops_as_organizer_for_pl_page(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboardapi_v1_pd_workshops_as_organizer_for_pl_page_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dashboardapi"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"pd"],[2,[7,"/"],[2,[6,"workshops_as_organizer_for_pl_page"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /dashboardapi/v1/pd/workshops_as_organizer_for_pl_page(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboardapi_v1_pd_workshops_as_organizer_for_pl_page_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dashboardapi"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"pd"],[2,[7,"/"],[2,[6,"workshops_as_organizer_for_pl_page"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /dashboardapi/v1/pd/workshops_as_program_manager_for_pl_page(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboardapi_v1_pd_workshops_as_program_manager_for_pl_page_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dashboardapi"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"pd"],[2,[7,"/"],[2,[6,"workshops_as_program_manager_for_pl_page"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /dashboardapi/v1/pd/workshops_as_program_manager_for_pl_page(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboardapi_v1_pd_workshops_as_program_manager_for_pl_page_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dashboardapi"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"pd"],[2,[7,"/"],[2,[6,"workshops_as_program_manager_for_pl_page"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /dashboardapi/v1/regional_partners/find(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboardapi_v1_regional_partners_find_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dashboardapi"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"regional_partners"],[2,[7,"/"],[2,[6,"find"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /dashboardapi/v1/regional_partners/find(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboardapi_v1_regional_partners_find_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dashboardapi"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"regional_partners"],[2,[7,"/"],[2,[6,"find"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /dashboardapi/v1/teacher_scores(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboardapi_v1_teacher_scores_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dashboardapi"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"teacher_scores"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /dashboardapi/v1/teacher_scores(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboardapi_v1_teacher_scores_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dashboardapi"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"teacher_scores"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /dashboardapi/v1/text_to_speech/azure(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboardapi_v1_text_to_speech_azure_url = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"dashboardapi"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"text_to_speech"],[2,[7,"/"],[2,[6,"azure"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /dashboardapi/v1/text_to_speech/azure(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboardapi_v1_text_to_speech_azure_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"dashboardapi"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"text_to_speech"],[2,[7,"/"],[2,[6,"azure"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /dashboardapi/v1/user_product_tours(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboardapi_v1_user_product_tours_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dashboardapi"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"user_product_tours"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /dashboardapi/v1/user_product_tours(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboardapi_v1_user_product_tours_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dashboardapi"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"user_product_tours"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /dashboardapi/v1/users/accept_data_transfer_agreement(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboardapi_v1_users_accept_data_transfer_agreement_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dashboardapi"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"accept_data_transfer_agreement"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /dashboardapi/v1/users/accept_data_transfer_agreement(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboardapi_v1_users_accept_data_transfer_agreement_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dashboardapi"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"accept_data_transfer_agreement"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /data_docs/:key(.:format)
 * @param {any} key
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const data_doc_url = /*#__PURE__*/ __jsr.r({"key":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"data_docs"],[2,[7,"/"],[2,[3,"key"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /data_docs/:key(.:format)
 * @param {any} key
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const data_doc_path = /*#__PURE__*/ __jsr.r({"key":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"data_docs"],[2,[7,"/"],[2,[3,"key"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /data_docs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const data_docs_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"data_docs"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /data_docs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const data_docs_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"data_docs"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /datasets/:dataset_name(.:format)
 * @param {any} dataset_name
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dataset_url = /*#__PURE__*/ __jsr.r({"dataset_name":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"datasets"],[2,[7,"/"],[2,[3,"dataset_name"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /datasets/:dataset_name(.:format)
 * @param {any} dataset_name
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dataset_path = /*#__PURE__*/ __jsr.r({"dataset_name":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"datasets"],[2,[7,"/"],[2,[3,"dataset_name"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /datasets(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const datasets_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"datasets"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /datasets(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const datasets_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"datasets"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /admin/dcdo(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dcdo_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"dcdo"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /admin/dcdo(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dcdo_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"dcdo"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/section_instructors/:id/decline(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const decline_api_v1_section_instructor_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"section_instructors"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"decline"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/v1/section_instructors/:id/decline(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const decline_api_v1_section_instructor_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"section_instructors"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"decline"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /deeper-learning(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const deeper_learning_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"deeper-learning"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /deeper-learning(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const deeper_learning_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"deeper-learning"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /sprites/default_sprites_editor(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const default_sprites_editor_sprites_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"sprites"],[2,[7,"/"],[2,[6,"default_sprites_editor"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /sprites/default_sprites_editor(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const default_sprites_editor_sprites_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"sprites"],[2,[7,"/"],[2,[6,"default_sprites_editor"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /datablock_storage/:channel_id/delete_column(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const delete_column_datablock_storage_index_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"datablock_storage"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"delete_column"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /datablock_storage/:channel_id/delete_column(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const delete_column_datablock_storage_index_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"datablock_storage"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"delete_column"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /datablock_storage/:channel_id/delete_key_value(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const delete_key_value_datablock_storage_index_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"datablock_storage"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"delete_key_value"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /datablock_storage/:channel_id/delete_key_value(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const delete_key_value_datablock_storage_index_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"datablock_storage"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"delete_key_value"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /delete_predict_level_progress(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const delete_predict_level_progress_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"delete_predict_level_progress"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /delete_predict_level_progress(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const delete_predict_level_progress_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"delete_predict_level_progress"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /admin/delete_progress(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const delete_progress_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"delete_progress"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /admin/delete_progress(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const delete_progress_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"delete_progress"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/delete_progress(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const delete_progress_form_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"delete_progress"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /admin/delete_progress(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const delete_progress_form_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"delete_progress"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /datablock_storage/:channel_id/delete_record(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const delete_record_datablock_storage_index_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"datablock_storage"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"delete_record"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /datablock_storage/:channel_id/delete_record(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const delete_record_datablock_storage_index_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"datablock_storage"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"delete_record"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /datablock_storage/:channel_id/delete_table(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const delete_table_datablock_storage_index_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"datablock_storage"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"delete_table"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /datablock_storage/:channel_id/delete_table(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const delete_table_datablock_storage_index_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"datablock_storage"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"delete_table"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/delete_user(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const delete_user_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"delete_user"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /admin/delete_user(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const delete_user_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"delete_user"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/delete_user_progress(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const delete_user_progress_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"delete_user_progress"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /admin/delete_user_progress(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const delete_user_progress_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"delete_user_progress"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/sign_out(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const destroy_user_session_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"sign_out"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /users/sign_out(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const destroy_user_session_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"sign_out"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /levels/:level_id/quiz_question_placements/:id/detach(.:format)
 * @param {any} level_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const detach_level_quiz_question_placement_url = /*#__PURE__*/ __jsr.r({"level_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"levels"],[2,[7,"/"],[2,[3,"level_id"],[2,[7,"/"],[2,[6,"quiz_question_placements"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"detach"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /levels/:level_id/quiz_question_placements/:id/detach(.:format)
 * @param {any} level_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const detach_level_quiz_question_placement_path = /*#__PURE__*/ __jsr.r({"level_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"levels"],[2,[7,"/"],[2,[3,"level_id"],[2,[7,"/"],[2,[6,"quiz_question_placements"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"detach"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /discourse/sso(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const discourse_sso_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"discourse"],[2,[7,"/"],[2,[6,"sso"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /discourse/sso(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const discourse_sso_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"discourse"],[2,[7,"/"],[2,[6,"sso"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /docs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const docs_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"docs"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /docs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const docs_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"docs"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /docs/concepts/data-library(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const docs_concepts_data_library_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"docs"],[2,[7,"/"],[2,[6,"concepts"],[2,[7,"/"],[2,[6,"data-library"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /docs/concepts/data-library(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const docs_concepts_data_library_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"docs"],[2,[7,"/"],[2,[6,"concepts"],[2,[7,"/"],[2,[6,"data-library"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/dynamic_config(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dynamic_config_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"dynamic_config"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /admin/dynamic_config(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dynamic_config_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"dynamic_config"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /p/ecosystems(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ecosystems_p_index_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[6,"ecosystems"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /p/ecosystems(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ecosystems_p_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[6,"ecosystems"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /projects/ecosystems/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ecosystems_project_create_new_projects_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"ecosystems"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/ecosystems/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ecosystems_project_create_new_projects_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"ecosystems"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/ecosystems/:channel_id/edit(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ecosystems_project_edit_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"ecosystems"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/ecosystems/:channel_id/edit(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ecosystems_project_edit_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"ecosystems"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/ecosystems/:channel_id/export_config(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ecosystems_project_export_config_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"ecosystems"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"export_config"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/ecosystems/:channel_id/export_config(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ecosystems_project_export_config_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"ecosystems"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"export_config"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/ecosystems/:channel_id/export_create_channel(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ecosystems_project_export_create_channel_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"ecosystems"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"export_create_channel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/ecosystems/:channel_id/export_create_channel(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ecosystems_project_export_create_channel_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"ecosystems"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"export_create_channel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/ecosystems/:channel_id/embed_app_and_code(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ecosystems_project_iframe_embed_app_and_code_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"ecosystems"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"embed_app_and_code"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/ecosystems/:channel_id/embed_app_and_code(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ecosystems_project_iframe_embed_app_and_code_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"ecosystems"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"embed_app_and_code"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/ecosystems/:channel_id/embed(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ecosystems_project_iframe_embed_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"ecosystems"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"embed"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/ecosystems/:channel_id/embed(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ecosystems_project_iframe_embed_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"ecosystems"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"embed"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/ecosystems(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ecosystems_project_projects_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"ecosystems"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /projects/ecosystems(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ecosystems_project_projects_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"ecosystems"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /projects/ecosystems/:channel_id/remix(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ecosystems_project_remix_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"ecosystems"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"remix"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/ecosystems/:channel_id/remix(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ecosystems_project_remix_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"ecosystems"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"remix"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/ecosystems/:channel_id(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ecosystems_project_share_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"ecosystems"],[2,[7,"/"],[2,[3,"channel_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/ecosystems/:channel_id(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ecosystems_project_share_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"ecosystems"],[2,[7,"/"],[2,[3,"channel_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/ecosystems/:channel_id/view(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ecosystems_project_view_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"ecosystems"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"view"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/ecosystems/:channel_id/view(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ecosystems_project_view_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"ecosystems"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"view"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /ai_lesson_summary_podcasts/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_ai_lesson_summary_podcast_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"ai_lesson_summary_podcasts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /ai_lesson_summary_podcasts/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_ai_lesson_summary_podcast_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"ai_lesson_summary_podcasts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /jit_pl_concepts/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_all_jit_pl_concepts_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"jit_pl_concepts"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /jit_pl_concepts/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_all_jit_pl_concepts_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"jit_pl_concepts"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /courses/:course_course_name/guides/edit(.:format)
 * @param {any} course_course_name
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_all_reference_guides_url = /*#__PURE__*/ __jsr.r({"course_course_name":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"courses"],[2,[7,"/"],[2,[3,"course_course_name"],[2,[7,"/"],[2,[6,"guides"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /courses/:course_course_name/guides/edit(.:format)
 * @param {any} course_course_name
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_all_reference_guides_path = /*#__PURE__*/ __jsr.r({"course_course_name":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"courses"],[2,[7,"/"],[2,[3,"course_course_name"],[2,[7,"/"],[2,[6,"guides"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/pd/workshops/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_api_v1_pd_workshop_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"pd"],[2,[7,"/"],[2,[6,"workshops"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/v1/pd/workshops/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_api_v1_pd_workshop_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"pd"],[2,[7,"/"],[2,[6,"workshops"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/users/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_api_v1_user_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/v1/users/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_api_v1_user_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /pools/:pool/blocks/:id/edit(.:format)
 * @param {any} pool
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_block_url = /*#__PURE__*/ __jsr.r({"pool":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"pools"],[2,[7,"/"],[2,[3,"pool"],[2,[7,"/"],[2,[6,"blocks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /pools/:pool/blocks/:id/edit(.:format)
 * @param {any} pool
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_block_path = /*#__PURE__*/ __jsr.r({"pool":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"pools"],[2,[7,"/"],[2,[3,"pool"],[2,[7,"/"],[2,[6,"blocks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /levels/:id/edit_blocks/:type(.:format)
 * @param {any} id
 * @param {any} type
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_blocks_level_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"type":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"levels"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit_blocks"],[2,[7,"/"],[2,[3,"type"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /levels/:id/edit_blocks/:type(.:format)
 * @param {any} id
 * @param {any} type
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_blocks_level_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"type":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"levels"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit_blocks"],[2,[7,"/"],[2,[3,"type"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /callouts/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_callout_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"callouts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /callouts/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_callout_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"callouts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /courses/:course_name/edit(.:format)
 * @param {any} course_name
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_course_url = /*#__PURE__*/ __jsr.r({"course_name":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"courses"],[2,[7,"/"],[2,[3,"course_name"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /courses/:course_name/edit(.:format)
 * @param {any} course_name
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_course_path = /*#__PURE__*/ __jsr.r({"course_name":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"courses"],[2,[7,"/"],[2,[3,"course_name"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /course_offerings/:key/edit(.:format)
 * @param {any} key
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_course_offering_url = /*#__PURE__*/ __jsr.r({"key":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"course_offerings"],[2,[7,"/"],[2,[3,"key"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /course_offerings/:key/edit(.:format)
 * @param {any} key
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_course_offering_path = /*#__PURE__*/ __jsr.r({"key":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"course_offerings"],[2,[7,"/"],[2,[3,"key"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /courses/:course_course_name/guides/:key/edit(.:format)
 * @param {any} course_course_name
 * @param {any} key
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_course_reference_guide_url = /*#__PURE__*/ __jsr.r({"course_course_name":{"r":true},"key":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"courses"],[2,[7,"/"],[2,[3,"course_course_name"],[2,[7,"/"],[2,[6,"guides"],[2,[7,"/"],[2,[3,"key"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /courses/:course_course_name/guides/:key/edit(.:format)
 * @param {any} course_course_name
 * @param {any} key
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_course_reference_guide_path = /*#__PURE__*/ __jsr.r({"course_course_name":{"r":true},"key":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"courses"],[2,[7,"/"],[2,[3,"course_course_name"],[2,[7,"/"],[2,[6,"guides"],[2,[7,"/"],[2,[3,"key"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /courses/:course_course_name/units/:position/edit(.:format)
 * @param {any} course_course_name
 * @param {any} position
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_course_unit_url = /*#__PURE__*/ __jsr.r({"course_course_name":{"r":true},"position":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"courses"],[2,[7,"/"],[2,[3,"course_course_name"],[2,[7,"/"],[2,[6,"units"],[2,[7,"/"],[2,[3,"position"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /courses/:course_course_name/units/:position/edit(.:format)
 * @param {any} course_course_name
 * @param {any} position
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_course_unit_path = /*#__PURE__*/ __jsr.r({"course_course_name":{"r":true},"position":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"courses"],[2,[7,"/"],[2,[3,"course_course_name"],[2,[7,"/"],[2,[6,"units"],[2,[7,"/"],[2,[3,"position"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /data_docs/:key/edit(.:format)
 * @param {any} key
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_data_doc_url = /*#__PURE__*/ __jsr.r({"key":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"data_docs"],[2,[7,"/"],[2,[3,"key"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /data_docs/:key/edit(.:format)
 * @param {any} key
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_data_doc_path = /*#__PURE__*/ __jsr.r({"key":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"data_docs"],[2,[7,"/"],[2,[3,"key"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /data_docs/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_data_docs_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"data_docs"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /data_docs/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_data_docs_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"data_docs"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /levels/:id/edit_exemplar(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_exemplar_level_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"levels"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit_exemplar"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /levels/:id/edit_exemplar(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_exemplar_level_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"levels"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit_exemplar"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /feedback/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_feedback_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"feedback"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /feedback/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_feedback_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"feedback"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /jit_pl_concepts/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_jit_pl_concept_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"jit_pl_concepts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /jit_pl_concepts/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_jit_pl_concept_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"jit_pl_concepts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /lessons/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_lesson_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"lessons"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /lessons/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_lesson_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"lessons"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /levels/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_level_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"levels"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /levels/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_level_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"levels"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /c/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_level_source_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"c"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /c/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_level_source_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"c"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /libraries/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_library_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"libraries"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /libraries/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_library_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"libraries"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /r/:level_source_id_and_user_id/edit(.:format)
 * @param {any} level_source_id_and_user_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_obfuscated_level_source_url = /*#__PURE__*/ __jsr.r({"level_source_id_and_user_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"r"],[2,[7,"/"],[2,[3,"level_source_id_and_user_id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /r/:level_source_id_and_user_id/edit(.:format)
 * @param {any} level_source_id_and_user_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_obfuscated_level_source_path = /*#__PURE__*/ __jsr.r({"level_source_id_and_user_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"r"],[2,[7,"/"],[2,[3,"level_source_id_and_user_id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /peer_reviews/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_peer_review_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"peer_reviews"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /peer_reviews/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_peer_review_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"peer_reviews"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /plc/user_course_enrollments/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_plc_user_course_enrollment_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"plc"],[2,[7,"/"],[2,[6,"user_course_enrollments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /plc/user_course_enrollments/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_plc_user_course_enrollment_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"plc"],[2,[7,"/"],[2,[6,"user_course_enrollments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /programming_classes/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_programming_class_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"programming_classes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /programming_classes/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_programming_class_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"programming_classes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /programming_environments/:name/edit(.:format)
 * @param {any} name
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_programming_environment_url = /*#__PURE__*/ __jsr.r({"name":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"programming_environments"],[2,[7,"/"],[2,[3,"name"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /programming_environments/:name/edit(.:format)
 * @param {any} name
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_programming_environment_path = /*#__PURE__*/ __jsr.r({"name":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"programming_environments"],[2,[7,"/"],[2,[3,"name"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /docs/ide/:programming_environment_name/classes/:programming_class_key/edit(.:format)
 * @param {any} programming_environment_name
 * @param {any} programming_class_key
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_programming_environment_programming_class_url = /*#__PURE__*/ __jsr.r({"programming_environment_name":{"r":true},"programming_class_key":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"docs"],[2,[7,"/"],[2,[6,"ide"],[2,[7,"/"],[2,[3,"programming_environment_name"],[2,[7,"/"],[2,[6,"classes"],[2,[7,"/"],[2,[3,"programming_class_key"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /docs/ide/:programming_environment_name/classes/:programming_class_key/edit(.:format)
 * @param {any} programming_environment_name
 * @param {any} programming_class_key
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_programming_environment_programming_class_path = /*#__PURE__*/ __jsr.r({"programming_environment_name":{"r":true},"programming_class_key":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"docs"],[2,[7,"/"],[2,[6,"ide"],[2,[7,"/"],[2,[3,"programming_environment_name"],[2,[7,"/"],[2,[6,"classes"],[2,[7,"/"],[2,[3,"programming_class_key"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /docs/ide/:programming_environment_name/expressions/:programming_expression_key/edit(.:format)
 * @param {any} programming_environment_name
 * @param {any} programming_expression_key
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_programming_environment_programming_expression_url = /*#__PURE__*/ __jsr.r({"programming_environment_name":{"r":true},"programming_expression_key":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"docs"],[2,[7,"/"],[2,[6,"ide"],[2,[7,"/"],[2,[3,"programming_environment_name"],[2,[7,"/"],[2,[6,"expressions"],[2,[7,"/"],[2,[3,"programming_expression_key"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /docs/ide/:programming_environment_name/expressions/:programming_expression_key/edit(.:format)
 * @param {any} programming_environment_name
 * @param {any} programming_expression_key
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_programming_environment_programming_expression_path = /*#__PURE__*/ __jsr.r({"programming_environment_name":{"r":true},"programming_expression_key":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"docs"],[2,[7,"/"],[2,[6,"ide"],[2,[7,"/"],[2,[3,"programming_environment_name"],[2,[7,"/"],[2,[6,"expressions"],[2,[7,"/"],[2,[3,"programming_expression_key"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /programming_expressions/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_programming_expression_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"programming_expressions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /programming_expressions/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_programming_expression_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"programming_expressions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /programming_methods/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_programming_method_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"programming_methods"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /programming_methods/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_programming_method_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"programming_methods"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/inbound_emails/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_rails_conductor_inbound_email_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/inbound_emails/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_rails_conductor_inbound_email_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /regional_partners/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_regional_partner_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"regional_partners"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /regional_partners/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_regional_partner_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"regional_partners"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /rubrics/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_rubric_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rubrics"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /rubrics/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_rubric_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rubrics"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /s/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_script_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"s"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /s/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_script_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"s"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /sections/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_section_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"sections"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /sections/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_section_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"sections"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /functions/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_shared_blockly_function_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"functions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /functions/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_shared_blockly_function_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"functions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/password/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_user_password_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"password"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /users/password/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_user_password_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"password"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_user_registration_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /users/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_user_registration_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /videos/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_video_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"videos"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /videos/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_video_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"videos"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /foorm/forms/editor(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editor_foorm_forms_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"foorm"],[2,[7,"/"],[2,[6,"forms"],[2,[7,"/"],[2,[6,"editor"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /foorm/forms/editor(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editor_foorm_forms_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"foorm"],[2,[7,"/"],[2,[6,"forms"],[2,[7,"/"],[2,[6,"editor"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /foorm/libraries/editor(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editor_foorm_libraries_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"foorm"],[2,[7,"/"],[2,[6,"libraries"],[2,[7,"/"],[2,[6,"editor"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /foorm/libraries/editor(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editor_foorm_libraries_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"foorm"],[2,[7,"/"],[2,[6,"libraries"],[2,[7,"/"],[2,[6,"editor"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /user_preference/editor_settings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editor_settings_user_preference_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"user_preference"],[2,[7,"/"],[2,[6,"editor_settings"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /user_preference/editor_settings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editor_settings_user_preference_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"user_preference"],[2,[7,"/"],[2,[6,"editor_settings"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /levels/:id/embed_level(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const embed_level_level_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"levels"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"embed_level"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /levels/:id/embed_level(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const embed_level_level_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"levels"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"embed_level"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/pd/workshops/:id/end(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const end_api_v1_pd_workshop_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"pd"],[2,[7,"/"],[2,[6,"workshops"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"end"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/v1/pd/workshops/:id/end(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const end_api_v1_pd_workshop_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"pd"],[2,[7,"/"],[2,[6,"workshops"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"end"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /p/eval(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const eval_p_index_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[6,"eval"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /p/eval(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const eval_p_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[6,"eval"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /projects/eval/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const eval_project_create_new_projects_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"eval"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/eval/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const eval_project_create_new_projects_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"eval"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/eval/:channel_id/edit(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const eval_project_edit_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"eval"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/eval/:channel_id/edit(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const eval_project_edit_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"eval"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/eval/:channel_id/export_config(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const eval_project_export_config_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"eval"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"export_config"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/eval/:channel_id/export_config(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const eval_project_export_config_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"eval"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"export_config"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/eval/:channel_id/export_create_channel(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const eval_project_export_create_channel_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"eval"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"export_create_channel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/eval/:channel_id/export_create_channel(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const eval_project_export_create_channel_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"eval"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"export_create_channel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/eval/:channel_id/embed_app_and_code(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const eval_project_iframe_embed_app_and_code_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"eval"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"embed_app_and_code"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/eval/:channel_id/embed_app_and_code(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const eval_project_iframe_embed_app_and_code_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"eval"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"embed_app_and_code"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/eval/:channel_id/embed(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const eval_project_iframe_embed_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"eval"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"embed"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/eval/:channel_id/embed(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const eval_project_iframe_embed_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"eval"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"embed"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/eval(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const eval_project_projects_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"eval"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /projects/eval(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const eval_project_projects_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"eval"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /projects/eval/:channel_id/remix(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const eval_project_remix_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"eval"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"remix"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/eval/:channel_id/remix(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const eval_project_remix_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"eval"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"remix"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/eval/:channel_id(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const eval_project_share_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"eval"],[2,[7,"/"],[2,[3,"channel_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/eval/:channel_id(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const eval_project_share_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"eval"],[2,[7,"/"],[2,[3,"channel_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/eval/:channel_id/view(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const eval_project_view_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"eval"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"view"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/eval/:channel_id/view(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const eval_project_view_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"eval"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"view"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /challenge_responses/:id/evaluate(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const evaluate_challenge_response_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"challenge_responses"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"evaluate"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /challenge_responses/:id/evaluate(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const evaluate_challenge_response_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"challenge_responses"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"evaluate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /experiments(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const experiments_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"experiments"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /experiments(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const experiments_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"experiments"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /expire_other(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const expire_other_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"expire_other"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /expire_other(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const expire_other_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"expire_other"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /datablock_storage/:channel_id/export_csv(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const export_csv_datablock_storage_index_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"datablock_storage"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"export_csv"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /datablock_storage/:channel_id/export_csv(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const export_csv_datablock_storage_index_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"datablock_storage"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"export_csv"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /levels/:id/extra_links(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const extra_links_level_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"levels"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"extra_links"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /levels/:id/extra_links(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const extra_links_level_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"levels"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"extra_links"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/feature_mode(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const feature_mode_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"feature_mode"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /admin/feature_mode(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const feature_mode_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"feature_mode"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /feedback/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const feedback_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"feedback"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /feedback/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const feedback_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"feedback"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /feedback(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const feedback_index_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"feedback"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /feedback(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const feedback_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"feedback"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /api/v1/pd/workshops/filter(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const filter_api_v1_pd_workshops_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"pd"],[2,[7,"/"],[2,[6,"workshops"],[2,[7,"/"],[2,[6,"filter"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/v1/pd/workshops/filter(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const filter_api_v1_pd_workshops_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"pd"],[2,[7,"/"],[2,[6,"workshops"],[2,[7,"/"],[2,[6,"filter"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rubrics/find(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const find_rubrics_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rubrics"],[2,[7,"/"],[2,[6,"find"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /rubrics/find(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const find_rubrics_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rubrics"],[2,[7,"/"],[2,[6,"find"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/find_students(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const find_students_admin_search_index_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"find_students"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /admin/find_students(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const find_students_admin_search_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"find_students"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/hour/finish(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const finish_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"hour"],[2,[7,"/"],[2,[6,"finish"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/hour/finish(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const finish_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"hour"],[2,[7,"/"],[2,[6,"finish"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/pd/applications/fit_cohort(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const fit_cohort_api_v1_pd_applications_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"pd"],[2,[7,"/"],[2,[6,"applications"],[2,[7,"/"],[2,[6,"fit_cohort"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/v1/pd/applications/fit_cohort(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const fit_cohort_api_v1_pd_applications_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"pd"],[2,[7,"/"],[2,[6,"applications"],[2,[7,"/"],[2,[6,"fit_cohort"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /flappy/:chapter
 * @param {any} chapter
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const flappy_chapter_url = /*#__PURE__*/ __jsr.r({"chapter":{"r":true}}, [2,[7,"/"],[2,[6,"flappy"],[2,[7,"/"],[3,"chapter"]]]], true);

/**
 * Generates rails route to
 * /flappy/:chapter
 * @param {any} chapter
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const flappy_chapter_path = /*#__PURE__*/ __jsr.r({"chapter":{"r":true}}, [2,[7,"/"],[2,[6,"flappy"],[2,[7,"/"],[3,"chapter"]]]]);

/**
 * Generates rails route to
 * /flappy/lang/ar(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const flappy_lang_ar_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"flappy"],[2,[7,"/"],[2,[6,"lang"],[2,[7,"/"],[2,[6,"ar"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /flappy/lang/ar(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const flappy_lang_ar_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"flappy"],[2,[7,"/"],[2,[6,"lang"],[2,[7,"/"],[2,[6,"ar"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /p/flappy(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const flappy_p_index_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[6,"flappy"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /p/flappy(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const flappy_p_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[6,"flappy"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /projects/flappy/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const flappy_project_create_new_projects_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"flappy"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/flappy/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const flappy_project_create_new_projects_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"flappy"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/flappy/:channel_id/edit(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const flappy_project_edit_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"flappy"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/flappy/:channel_id/edit(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const flappy_project_edit_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"flappy"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/flappy/:channel_id/export_config(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const flappy_project_export_config_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"flappy"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"export_config"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/flappy/:channel_id/export_config(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const flappy_project_export_config_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"flappy"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"export_config"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/flappy/:channel_id/export_create_channel(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const flappy_project_export_create_channel_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"flappy"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"export_create_channel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/flappy/:channel_id/export_create_channel(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const flappy_project_export_create_channel_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"flappy"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"export_create_channel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/flappy/:channel_id/embed_app_and_code(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const flappy_project_iframe_embed_app_and_code_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"flappy"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"embed_app_and_code"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/flappy/:channel_id/embed_app_and_code(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const flappy_project_iframe_embed_app_and_code_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"flappy"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"embed_app_and_code"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/flappy/:channel_id/embed(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const flappy_project_iframe_embed_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"flappy"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"embed"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/flappy/:channel_id/embed(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const flappy_project_iframe_embed_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"flappy"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"embed"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/flappy(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const flappy_project_projects_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"flappy"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /projects/flappy(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const flappy_project_projects_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"flappy"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /projects/flappy/:channel_id/remix(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const flappy_project_remix_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"flappy"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"remix"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/flappy/:channel_id/remix(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const flappy_project_remix_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"flappy"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"remix"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/flappy/:channel_id(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const flappy_project_share_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"flappy"],[2,[7,"/"],[2,[3,"channel_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/flappy/:channel_id(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const flappy_project_share_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"flappy"],[2,[7,"/"],[2,[3,"channel_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/flappy/:channel_id/view(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const flappy_project_view_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"flappy"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"view"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/flappy/:channel_id/view(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const flappy_project_view_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"flappy"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"view"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /user_preference/font_size/console(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const font_size_console_user_preference_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"user_preference"],[2,[7,"/"],[2,[6,"font_size"],[2,[7,"/"],[2,[6,"console"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /user_preference/font_size/console(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const font_size_console_user_preference_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"user_preference"],[2,[7,"/"],[2,[6,"font_size"],[2,[7,"/"],[2,[6,"console"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /user_preference/font_size/editor(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const font_size_editor_user_preference_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"user_preference"],[2,[7,"/"],[2,[6,"font_size"],[2,[7,"/"],[2,[6,"editor"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /user_preference/font_size/editor(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const font_size_editor_user_preference_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"user_preference"],[2,[7,"/"],[2,[6,"font_size"],[2,[7,"/"],[2,[6,"editor"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /foorm/forms(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const foorm_forms_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"foorm"],[2,[7,"/"],[2,[6,"forms"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /foorm/forms(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const foorm_forms_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"foorm"],[2,[7,"/"],[2,[6,"forms"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /foorm/library_questions/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const foorm_library_question_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"foorm"],[2,[7,"/"],[2,[6,"library_questions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /foorm/library_questions/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const foorm_library_question_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"foorm"],[2,[7,"/"],[2,[6,"library_questions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /foorm/library_questions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const foorm_library_questions_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"foorm"],[2,[7,"/"],[2,[6,"library_questions"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /foorm/library_questions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const foorm_library_questions_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"foorm"],[2,[7,"/"],[2,[6,"library_questions"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /foorm/preview(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const foorm_preview_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"foorm"],[2,[7,"/"],[2,[6,"preview"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /foorm/preview(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const foorm_preview_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"foorm"],[2,[7,"/"],[2,[6,"preview"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /foorm/simple_survey_forms(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const foorm_simple_survey_forms_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"foorm"],[2,[7,"/"],[2,[6,"simple_survey_forms"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /foorm/simple_survey_forms(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const foorm_simple_survey_forms_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"foorm"],[2,[7,"/"],[2,[6,"simple_survey_forms"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/force_cap_permission(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const force_cap_permission_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"force_cap_permission"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /admin/force_cap_permission(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const force_cap_permission_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"force_cap_permission"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /free_response_answers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const free_response_answers_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"free_response_answers"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /free_response_answers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const free_response_answers_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"free_response_answers"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /p/frozen(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const frozen_p_index_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[6,"frozen"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /p/frozen(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const frozen_p_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[6,"frozen"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /projects/frozen/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const frozen_project_create_new_projects_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"frozen"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/frozen/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const frozen_project_create_new_projects_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"frozen"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/frozen/:channel_id/edit(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const frozen_project_edit_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"frozen"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/frozen/:channel_id/edit(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const frozen_project_edit_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"frozen"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/frozen/:channel_id/export_config(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const frozen_project_export_config_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"frozen"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"export_config"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/frozen/:channel_id/export_config(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const frozen_project_export_config_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"frozen"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"export_config"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/frozen/:channel_id/export_create_channel(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const frozen_project_export_create_channel_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"frozen"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"export_create_channel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/frozen/:channel_id/export_create_channel(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const frozen_project_export_create_channel_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"frozen"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"export_create_channel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/frozen/:channel_id/embed_app_and_code(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const frozen_project_iframe_embed_app_and_code_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"frozen"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"embed_app_and_code"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/frozen/:channel_id/embed_app_and_code(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const frozen_project_iframe_embed_app_and_code_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"frozen"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"embed_app_and_code"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/frozen/:channel_id/embed(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const frozen_project_iframe_embed_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"frozen"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"embed"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/frozen/:channel_id/embed(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const frozen_project_iframe_embed_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"frozen"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"embed"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/frozen(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const frozen_project_projects_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"frozen"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /projects/frozen(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const frozen_project_projects_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"frozen"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /projects/frozen/:channel_id/remix(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const frozen_project_remix_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"frozen"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"remix"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/frozen/:channel_id/remix(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const frozen_project_remix_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"frozen"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"remix"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/frozen/:channel_id(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const frozen_project_share_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"frozen"],[2,[7,"/"],[2,[3,"channel_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/frozen/:channel_id(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const frozen_project_share_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"frozen"],[2,[7,"/"],[2,[3,"channel_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/frozen/:channel_id/view(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const frozen_project_view_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"frozen"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"view"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/frozen/:channel_id/view(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const frozen_project_view_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"frozen"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"view"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /gallery(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const gallery_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"gallery"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /gallery(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const gallery_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"gallery"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /p/game_design(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const game_design_p_index_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[6,"game_design"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /p/game_design(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const game_design_p_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[6,"game_design"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /projects/game_design/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const game_design_project_create_new_projects_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"game_design"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/game_design/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const game_design_project_create_new_projects_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"game_design"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/game_design/:channel_id/edit(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const game_design_project_edit_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"game_design"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/game_design/:channel_id/edit(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const game_design_project_edit_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"game_design"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/game_design/:channel_id/export_config(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const game_design_project_export_config_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"game_design"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"export_config"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/game_design/:channel_id/export_config(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const game_design_project_export_config_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"game_design"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"export_config"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/game_design/:channel_id/export_create_channel(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const game_design_project_export_create_channel_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"game_design"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"export_create_channel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/game_design/:channel_id/export_create_channel(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const game_design_project_export_create_channel_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"game_design"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"export_create_channel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/game_design/:channel_id/embed_app_and_code(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const game_design_project_iframe_embed_app_and_code_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"game_design"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"embed_app_and_code"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/game_design/:channel_id/embed_app_and_code(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const game_design_project_iframe_embed_app_and_code_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"game_design"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"embed_app_and_code"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/game_design/:channel_id/embed(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const game_design_project_iframe_embed_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"game_design"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"embed"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/game_design/:channel_id/embed(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const game_design_project_iframe_embed_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"game_design"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"embed"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/game_design(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const game_design_project_projects_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"game_design"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /projects/game_design(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const game_design_project_projects_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"game_design"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /projects/game_design/:channel_id/remix(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const game_design_project_remix_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"game_design"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"remix"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/game_design/:channel_id/remix(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const game_design_project_remix_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"game_design"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"remix"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/game_design/:channel_id(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const game_design_project_share_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"game_design"],[2,[7,"/"],[2,[3,"channel_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/game_design/:channel_id(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const game_design_project_share_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"game_design"],[2,[7,"/"],[2,[3,"channel_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/game_design/:channel_id/view(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const game_design_project_view_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"game_design"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"view"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/game_design/:channel_id/view(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const game_design_project_view_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"game_design"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"view"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /p/gamelab_jr(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const gamelab_jr_p_index_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[6,"gamelab_jr"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /p/gamelab_jr(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const gamelab_jr_p_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[6,"gamelab_jr"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /projects/gamelab_jr/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const gamelab_jr_project_create_new_projects_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"gamelab_jr"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/gamelab_jr/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const gamelab_jr_project_create_new_projects_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"gamelab_jr"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/gamelab_jr/:channel_id/edit(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const gamelab_jr_project_edit_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"gamelab_jr"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/gamelab_jr/:channel_id/edit(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const gamelab_jr_project_edit_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"gamelab_jr"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/gamelab_jr/:channel_id/export_config(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const gamelab_jr_project_export_config_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"gamelab_jr"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"export_config"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/gamelab_jr/:channel_id/export_config(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const gamelab_jr_project_export_config_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"gamelab_jr"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"export_config"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/gamelab_jr/:channel_id/export_create_channel(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const gamelab_jr_project_export_create_channel_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"gamelab_jr"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"export_create_channel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/gamelab_jr/:channel_id/export_create_channel(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const gamelab_jr_project_export_create_channel_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"gamelab_jr"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"export_create_channel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/gamelab_jr/:channel_id/embed_app_and_code(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const gamelab_jr_project_iframe_embed_app_and_code_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"gamelab_jr"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"embed_app_and_code"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/gamelab_jr/:channel_id/embed_app_and_code(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const gamelab_jr_project_iframe_embed_app_and_code_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"gamelab_jr"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"embed_app_and_code"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/gamelab_jr/:channel_id/embed(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const gamelab_jr_project_iframe_embed_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"gamelab_jr"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"embed"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/gamelab_jr/:channel_id/embed(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const gamelab_jr_project_iframe_embed_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"gamelab_jr"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"embed"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/gamelab_jr(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const gamelab_jr_project_projects_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"gamelab_jr"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /projects/gamelab_jr(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const gamelab_jr_project_projects_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"gamelab_jr"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /projects/gamelab_jr/:channel_id/remix(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const gamelab_jr_project_remix_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"gamelab_jr"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"remix"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/gamelab_jr/:channel_id/remix(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const gamelab_jr_project_remix_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"gamelab_jr"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"remix"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/gamelab_jr/:channel_id(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const gamelab_jr_project_share_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"gamelab_jr"],[2,[7,"/"],[2,[3,"channel_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/gamelab_jr/:channel_id(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const gamelab_jr_project_share_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"gamelab_jr"],[2,[7,"/"],[2,[3,"channel_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/gamelab_jr/:channel_id/view(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const gamelab_jr_project_view_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"gamelab_jr"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"view"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/gamelab_jr/:channel_id/view(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const gamelab_jr_project_view_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"gamelab_jr"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"view"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /p/gamelab(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const gamelab_p_index_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[6,"gamelab"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /p/gamelab(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const gamelab_p_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[6,"gamelab"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /projects/gamelab/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const gamelab_project_create_new_projects_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"gamelab"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/gamelab/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const gamelab_project_create_new_projects_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"gamelab"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/gamelab/:channel_id/edit(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const gamelab_project_edit_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"gamelab"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/gamelab/:channel_id/edit(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const gamelab_project_edit_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"gamelab"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/gamelab/:channel_id/export_config(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const gamelab_project_export_config_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"gamelab"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"export_config"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/gamelab/:channel_id/export_config(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const gamelab_project_export_config_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"gamelab"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"export_config"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/gamelab/:channel_id/export_create_channel(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const gamelab_project_export_create_channel_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"gamelab"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"export_create_channel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/gamelab/:channel_id/export_create_channel(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const gamelab_project_export_create_channel_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"gamelab"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"export_create_channel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/gamelab/:channel_id/embed_app_and_code(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const gamelab_project_iframe_embed_app_and_code_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"gamelab"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"embed_app_and_code"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/gamelab/:channel_id/embed_app_and_code(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const gamelab_project_iframe_embed_app_and_code_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"gamelab"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"embed_app_and_code"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/gamelab/:channel_id/embed(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const gamelab_project_iframe_embed_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"gamelab"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"embed"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/gamelab/:channel_id/embed(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const gamelab_project_iframe_embed_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"gamelab"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"embed"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/gamelab(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const gamelab_project_projects_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"gamelab"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /projects/gamelab(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const gamelab_project_projects_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"gamelab"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /projects/gamelab/:channel_id/remix(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const gamelab_project_remix_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"gamelab"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"remix"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/gamelab/:channel_id/remix(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const gamelab_project_remix_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"gamelab"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"remix"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/gamelab/:channel_id(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const gamelab_project_share_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"gamelab"],[2,[7,"/"],[2,[3,"channel_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/gamelab/:channel_id(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const gamelab_project_share_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"gamelab"],[2,[7,"/"],[2,[3,"channel_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/gamelab/:channel_id/view(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const gamelab_project_view_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"gamelab"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"view"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/gamelab/:channel_id/view(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const gamelab_project_view_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"gamelab"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"view"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/gatekeeper(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const gatekeeper_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"gatekeeper"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /admin/gatekeeper(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const gatekeeper_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"gatekeeper"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /courses/:course_course_name/units/:position/generate(.:format)
 * @param {any} course_course_name
 * @param {any} position
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const generate_course_unit_url = /*#__PURE__*/ __jsr.r({"course_course_name":{"r":true},"position":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"courses"],[2,[7,"/"],[2,[3,"course_course_name"],[2,[7,"/"],[2,[6,"units"],[2,[7,"/"],[2,[3,"position"],[2,[7,"/"],[2,[6,"generate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /courses/:course_course_name/units/:position/generate(.:format)
 * @param {any} course_course_name
 * @param {any} position
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const generate_course_unit_path = /*#__PURE__*/ __jsr.r({"course_course_name":{"r":true},"position":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"courses"],[2,[7,"/"],[2,[3,"course_course_name"],[2,[7,"/"],[2,[6,"units"],[2,[7,"/"],[2,[3,"position"],[2,[7,"/"],[2,[6,"generate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /c/:id/generate_image(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const generate_image_level_source_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"c"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"generate_image"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /c/:id/generate_image(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const generate_image_level_source_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"c"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"generate_image"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /r/:level_source_id_and_user_id/generate_image(.:format)
 * @param {any} level_source_id_and_user_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const generate_image_obfuscated_level_source_url = /*#__PURE__*/ __jsr.r({"level_source_id_and_user_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"r"],[2,[7,"/"],[2,[3,"level_source_id_and_user_id"],[2,[7,"/"],[2,[6,"generate_image"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /r/:level_source_id_and_user_id/generate_image(.:format)
 * @param {any} level_source_id_and_user_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const generate_image_obfuscated_level_source_path = /*#__PURE__*/ __jsr.r({"level_source_id_and_user_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"r"],[2,[7,"/"],[2,[3,"level_source_id_and_user_id"],[2,[7,"/"],[2,[6,"generate_image"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /lessons/:id/generate(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const generate_lesson_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"lessons"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"generate"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /lessons/:id/generate(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const generate_lesson_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"lessons"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"generate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /ai_lesson_summary_podcasts/generate_podcast(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const generate_podcast_ai_lesson_summary_podcasts_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"ai_lesson_summary_podcasts"],[2,[7,"/"],[2,[6,"generate_podcast"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /ai_lesson_summary_podcasts/generate_podcast(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const generate_podcast_ai_lesson_summary_podcasts_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"ai_lesson_summary_podcasts"],[2,[7,"/"],[2,[6,"generate_podcast"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /ai_student_podcasts/generate_podcast(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const generate_podcast_ai_student_podcasts_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"ai_student_podcasts"],[2,[7,"/"],[2,[6,"generate_podcast"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /ai_student_podcasts/generate_podcast(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const generate_podcast_ai_student_podcasts_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"ai_student_podcasts"],[2,[7,"/"],[2,[6,"generate_podcast"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /ai_lesson_summary_podcasts/generate_podcasts_by_unit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const generate_podcasts_by_unit_ai_lesson_summary_podcasts_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"ai_lesson_summary_podcasts"],[2,[7,"/"],[2,[6,"generate_podcasts_by_unit"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /ai_lesson_summary_podcasts/generate_podcasts_by_unit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const generate_podcasts_by_unit_ai_lesson_summary_podcasts_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"ai_lesson_summary_podcasts"],[2,[7,"/"],[2,[6,"generate_podcasts_by_unit"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /s/:id/generate(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const generate_script_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"s"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"generate"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /s/:id/generate(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const generate_script_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"s"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"generate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /lessons/:id/slides/generate(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const generate_slides_lesson_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"lessons"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"slides"],[2,[7,"/"],[2,[6,"generate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /lessons/:id/slides/generate(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const generate_slides_lesson_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"lessons"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"slides"],[2,[7,"/"],[2,[6,"generate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rubrics/:id/get_ai_evaluations(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const get_ai_evaluations_rubric_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rubrics"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"get_ai_evaluations"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /rubrics/:id/get_ai_evaluations(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const get_ai_evaluations_rubric_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rubrics"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"get_ai_evaluations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /rubrics/:id/get_ai_rubrics_tour_seen(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const get_ai_rubrics_tour_seen_rubric_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rubrics"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"get_ai_rubrics_tour_seen"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /rubrics/:id/get_ai_rubrics_tour_seen(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const get_ai_rubrics_tour_seen_rubric_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rubrics"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"get_ai_rubrics_tour_seen"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /learning_goal_ai_evaluation_feedbacks/get_by_ai_evaluation_id(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const get_by_ai_evaluation_id_learning_goal_ai_evaluation_feedbacks_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"learning_goal_ai_evaluation_feedbacks"],[2,[7,"/"],[2,[6,"get_by_ai_evaluation_id"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /learning_goal_ai_evaluation_feedbacks/get_by_ai_evaluation_id(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const get_by_ai_evaluation_id_learning_goal_ai_evaluation_feedbacks_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"learning_goal_ai_evaluation_feedbacks"],[2,[7,"/"],[2,[6,"get_by_ai_evaluation_id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /datablock_storage/:channel_id/get_column(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const get_column_datablock_storage_index_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"datablock_storage"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"get_column"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /datablock_storage/:channel_id/get_column(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const get_column_datablock_storage_index_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"datablock_storage"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"get_column"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /datablock_storage/:channel_id/get_columns_for_table(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const get_columns_for_table_datablock_storage_index_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"datablock_storage"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"get_columns_for_table"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /datablock_storage/:channel_id/get_columns_for_table(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const get_columns_for_table_datablock_storage_index_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"datablock_storage"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"get_columns_for_table"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /teacher_dashboard/get_drawer_data(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const get_drawer_data_teacher_dashboard_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"teacher_dashboard"],[2,[7,"/"],[2,[6,"get_drawer_data"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /teacher_dashboard/get_drawer_data(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const get_drawer_data_teacher_dashboard_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"teacher_dashboard"],[2,[7,"/"],[2,[6,"get_drawer_data"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /learning_goal_teacher_evaluations/get_evaluation(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const get_evaluation_learning_goal_teacher_evaluations_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"learning_goal_teacher_evaluations"],[2,[7,"/"],[2,[6,"get_evaluation"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /learning_goal_teacher_evaluations/get_evaluation(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const get_evaluation_learning_goal_teacher_evaluations_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"learning_goal_teacher_evaluations"],[2,[7,"/"],[2,[6,"get_evaluation"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/teacher_feedbacks/get_feedback_from_teacher(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const get_feedback_from_teacher_api_v1_teacher_feedbacks_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"teacher_feedbacks"],[2,[7,"/"],[2,[6,"get_feedback_from_teacher"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/v1/teacher_feedbacks/get_feedback_from_teacher(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const get_feedback_from_teacher_api_v1_teacher_feedbacks_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"teacher_feedbacks"],[2,[7,"/"],[2,[6,"get_feedback_from_teacher"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/teacher_feedbacks/get_feedbacks(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const get_feedbacks_api_v1_teacher_feedbacks_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"teacher_feedbacks"],[2,[7,"/"],[2,[6,"get_feedbacks"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/v1/teacher_feedbacks/get_feedbacks(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const get_feedbacks_api_v1_teacher_feedbacks_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"teacher_feedbacks"],[2,[7,"/"],[2,[6,"get_feedbacks"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /levels/get_filtered_levels(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const get_filtered_levels_levels_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"levels"],[2,[7,"/"],[2,[6,"get_filtered_levels"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /levels/get_filtered_levels(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const get_filtered_levels_levels_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"levels"],[2,[7,"/"],[2,[6,"get_filtered_levels"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /programming_classes/get_filtered_results(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const get_filtered_results_programming_classes_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"programming_classes"],[2,[7,"/"],[2,[6,"get_filtered_results"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /programming_classes/get_filtered_results(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const get_filtered_results_programming_classes_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"programming_classes"],[2,[7,"/"],[2,[6,"get_filtered_results"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /programming_expressions/get_filtered_results(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const get_filtered_results_programming_expressions_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"programming_expressions"],[2,[7,"/"],[2,[6,"get_filtered_results"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /programming_expressions/get_filtered_results(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const get_filtered_results_programming_expressions_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"programming_expressions"],[2,[7,"/"],[2,[6,"get_filtered_results"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /datablock_storage/:channel_id/get_key_value(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const get_key_value_datablock_storage_index_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"datablock_storage"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"get_key_value"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /datablock_storage/:channel_id/get_key_value(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const get_key_value_datablock_storage_index_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"datablock_storage"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"get_key_value"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /datablock_storage/:channel_id/get_key_values(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const get_key_values_datablock_storage_index_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"datablock_storage"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"get_key_values"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /datablock_storage/:channel_id/get_key_values(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const get_key_values_datablock_storage_index_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"datablock_storage"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"get_key_values"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /datablock_storage/:channel_id/get_library_manifest(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const get_library_manifest_datablock_storage_index_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"datablock_storage"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"get_library_manifest"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /datablock_storage/:channel_id/get_library_manifest(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const get_library_manifest_datablock_storage_index_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"datablock_storage"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"get_library_manifest"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /learning_goal_teacher_evaluations/get_or_create_evaluation(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const get_or_create_evaluation_learning_goal_teacher_evaluations_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"learning_goal_teacher_evaluations"],[2,[7,"/"],[2,[6,"get_or_create_evaluation"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /learning_goal_teacher_evaluations/get_or_create_evaluation(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const get_or_create_evaluation_learning_goal_teacher_evaluations_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"learning_goal_teacher_evaluations"],[2,[7,"/"],[2,[6,"get_or_create_evaluation"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /courses/:course_name/get_rollup_resources(.:format)
 * @param {any} course_name
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const get_rollup_resources_course_url = /*#__PURE__*/ __jsr.r({"course_name":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"courses"],[2,[7,"/"],[2,[3,"course_name"],[2,[7,"/"],[2,[6,"get_rollup_resources"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /courses/:course_name/get_rollup_resources(.:format)
 * @param {any} course_name
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const get_rollup_resources_course_path = /*#__PURE__*/ __jsr.r({"course_name":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"courses"],[2,[7,"/"],[2,[3,"course_name"],[2,[7,"/"],[2,[6,"get_rollup_resources"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /courses/:course_course_name/units/:position/get_rollup_resources(.:format)
 * @param {any} course_course_name
 * @param {any} position
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const get_rollup_resources_course_unit_url = /*#__PURE__*/ __jsr.r({"course_course_name":{"r":true},"position":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"courses"],[2,[7,"/"],[2,[3,"course_course_name"],[2,[7,"/"],[2,[6,"units"],[2,[7,"/"],[2,[3,"position"],[2,[7,"/"],[2,[6,"get_rollup_resources"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /courses/:course_course_name/units/:position/get_rollup_resources(.:format)
 * @param {any} course_course_name
 * @param {any} position
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const get_rollup_resources_course_unit_path = /*#__PURE__*/ __jsr.r({"course_course_name":{"r":true},"position":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"courses"],[2,[7,"/"],[2,[3,"course_course_name"],[2,[7,"/"],[2,[6,"units"],[2,[7,"/"],[2,[3,"position"],[2,[7,"/"],[2,[6,"get_rollup_resources"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /s/:id/get_rollup_resources(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const get_rollup_resources_script_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"s"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"get_rollup_resources"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /s/:id/get_rollup_resources(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const get_rollup_resources_script_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"s"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"get_rollup_resources"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /levels/:id/get_rubric(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const get_rubric_level_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"levels"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"get_rubric"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /levels/:id/get_rubric(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const get_rubric_level_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"levels"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"get_rubric"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /levels/:id/get_serialized_maze(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const get_serialized_maze_level_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"levels"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"get_serialized_maze"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /levels/:id/get_serialized_maze(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const get_serialized_maze_level_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"levels"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"get_serialized_maze"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /docs/ide/:programming_environment_name/classes/:programming_class_key/get_serialized(.:format)
 * @param {any} programming_environment_name
 * @param {any} programming_class_key
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const get_serialized_programming_environment_programming_class_url = /*#__PURE__*/ __jsr.r({"programming_environment_name":{"r":true},"programming_class_key":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"docs"],[2,[7,"/"],[2,[6,"ide"],[2,[7,"/"],[2,[3,"programming_environment_name"],[2,[7,"/"],[2,[6,"classes"],[2,[7,"/"],[2,[3,"programming_class_key"],[2,[7,"/"],[2,[6,"get_serialized"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /docs/ide/:programming_environment_name/classes/:programming_class_key/get_serialized(.:format)
 * @param {any} programming_environment_name
 * @param {any} programming_class_key
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const get_serialized_programming_environment_programming_class_path = /*#__PURE__*/ __jsr.r({"programming_environment_name":{"r":true},"programming_class_key":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"docs"],[2,[7,"/"],[2,[6,"ide"],[2,[7,"/"],[2,[3,"programming_environment_name"],[2,[7,"/"],[2,[6,"classes"],[2,[7,"/"],[2,[3,"programming_class_key"],[2,[7,"/"],[2,[6,"get_serialized"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /programming_environments/:name/get_summary_by_name(.:format)
 * @param {any} name
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const get_summary_by_name_programming_environment_url = /*#__PURE__*/ __jsr.r({"name":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"programming_environments"],[2,[7,"/"],[2,[3,"name"],[2,[7,"/"],[2,[6,"get_summary_by_name"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /programming_environments/:name/get_summary_by_name(.:format)
 * @param {any} name
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const get_summary_by_name_programming_environment_path = /*#__PURE__*/ __jsr.r({"name":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"programming_environments"],[2,[7,"/"],[2,[3,"name"],[2,[7,"/"],[2,[6,"get_summary_by_name"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /datablock_storage/:channel_id/get_table_names(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const get_table_names_datablock_storage_index_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"datablock_storage"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"get_table_names"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /datablock_storage/:channel_id/get_table_names(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const get_table_names_datablock_storage_index_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"datablock_storage"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"get_table_names"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /rubrics/:id/get_teacher_evaluations_for_all(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const get_teacher_evaluations_for_all_rubric_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rubrics"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"get_teacher_evaluations_for_all"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /rubrics/:id/get_teacher_evaluations_for_all(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const get_teacher_evaluations_for_all_rubric_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rubrics"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"get_teacher_evaluations_for_all"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /rubrics/:id/get_teacher_evaluations(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const get_teacher_evaluations_rubric_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rubrics"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"get_teacher_evaluations"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /rubrics/:id/get_teacher_evaluations(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const get_teacher_evaluations_rubric_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rubrics"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"get_teacher_evaluations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /get_token(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const get_token_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"get_token"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /get_token(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const get_token_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"get_token"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /libraries/get_updates(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const get_updates_libraries_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"libraries"],[2,[7,"/"],[2,[6,"get_updates"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /libraries/get_updates(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const get_updates_libraries_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"libraries"],[2,[7,"/"],[2,[6,"get_updates"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/grant_cap_permission(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const grant_cap_permission_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"grant_cap_permission"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /admin/grant_cap_permission(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const grant_cap_permission_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"grant_cap_permission"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/grant_permission(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const grant_permission_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"grant_permission"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /admin/grant_permission(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const grant_permission_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"grant_permission"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /p/gumball(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const gumball_p_index_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[6,"gumball"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /p/gumball(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const gumball_p_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[6,"gumball"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /projects/gumball/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const gumball_project_create_new_projects_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"gumball"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/gumball/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const gumball_project_create_new_projects_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"gumball"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/gumball/:channel_id/edit(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const gumball_project_edit_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"gumball"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/gumball/:channel_id/edit(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const gumball_project_edit_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"gumball"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/gumball/:channel_id/export_config(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const gumball_project_export_config_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"gumball"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"export_config"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/gumball/:channel_id/export_config(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const gumball_project_export_config_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"gumball"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"export_config"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/gumball/:channel_id/export_create_channel(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const gumball_project_export_create_channel_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"gumball"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"export_create_channel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/gumball/:channel_id/export_create_channel(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const gumball_project_export_create_channel_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"gumball"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"export_create_channel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/gumball/:channel_id/embed_app_and_code(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const gumball_project_iframe_embed_app_and_code_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"gumball"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"embed_app_and_code"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/gumball/:channel_id/embed_app_and_code(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const gumball_project_iframe_embed_app_and_code_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"gumball"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"embed_app_and_code"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/gumball/:channel_id/embed(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const gumball_project_iframe_embed_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"gumball"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"embed"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/gumball/:channel_id/embed(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const gumball_project_iframe_embed_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"gumball"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"embed"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/gumball(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const gumball_project_projects_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"gumball"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /projects/gumball(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const gumball_project_projects_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"gumball"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /projects/gumball/:channel_id/remix(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const gumball_project_remix_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"gumball"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"remix"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/gumball/:channel_id/remix(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const gumball_project_remix_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"gumball"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"remix"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/gumball/:channel_id(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const gumball_project_share_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"gumball"],[2,[7,"/"],[2,[3,"channel_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/gumball/:channel_id(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const gumball_project_share_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"gumball"],[2,[7,"/"],[2,[3,"channel_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/gumball/:channel_id/view(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const gumball_project_view_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"gumball"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"view"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/gumball/:channel_id/view(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const gumball_project_view_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"gumball"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"view"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /health_check(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const health_check_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"health_check"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /health_check(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const health_check_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"health_check"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /help(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const help_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"help"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /help(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const help_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"help"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /helpful_links(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const helpful_links_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"helpful_links"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /helpful_links(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const helpful_links_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"helpful_links"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /hint_view_requests(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const hint_view_requests_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"hint_view_requests"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /hint_view_requests(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const hint_view_requests_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"hint_view_requests"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /hoc/:chapter
 * @param {any} chapter
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const hoc_chapter_url = /*#__PURE__*/ __jsr.r({"chapter":{"r":true}}, [2,[7,"/"],[2,[6,"hoc"],[2,[7,"/"],[3,"chapter"]]]], true);

/**
 * Generates rails route to
 * /hoc/:chapter
 * @param {any} chapter
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const hoc_chapter_path = /*#__PURE__*/ __jsr.r({"chapter":{"r":true}}, [2,[7,"/"],[2,[6,"hoc"],[2,[7,"/"],[3,"chapter"]]]]);

/**
 * Generates rails route to
 * /hoc/reset(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const hoc_reset_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"hoc"],[2,[7,"/"],[2,[6,"reset"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /hoc/reset(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const hoc_reset_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"hoc"],[2,[7,"/"],[2,[6,"reset"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /home(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const home_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"home"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /home(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const home_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"home"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /home/health_check(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const home_health_check_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"home"],[2,[7,"/"],[2,[6,"health_check"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /home/health_check(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const home_health_check_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"home"],[2,[7,"/"],[2,[6,"health_check"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /home/home(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const home_home_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"home"],[2,[7,"/"],[2,[6,"home"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /home/home(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const home_home_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"home"],[2,[7,"/"],[2,[6,"home"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /home/home_insert(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const home_home_insert_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"home"],[2,[7,"/"],[2,[6,"home_insert"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /home/home_insert(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const home_home_insert_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"home"],[2,[7,"/"],[2,[6,"home_insert"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /home/index(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const home_index_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"home"],[2,[7,"/"],[2,[6,"index"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /home/index(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const home_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"home"],[2,[7,"/"],[2,[6,"index"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /home_insert(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const home_insert_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"home_insert"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /home_insert(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const home_insert_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"home_insert"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /home/set_locale(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const home_set_locale_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"home"],[2,[7,"/"],[2,[6,"set_locale"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /home/set_locale(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const home_set_locale_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"home"],[2,[7,"/"],[2,[6,"set_locale"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /teacher_dashboard/home(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const home_teacher_dashboard_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"teacher_dashboard"],[2,[7,"/"],[2,[6,"home"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /teacher_dashboard/home(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const home_teacher_dashboard_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"teacher_dashboard"],[2,[7,"/"],[2,[6,"home"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /home/terms_and_privacy(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const home_terms_and_privacy_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"home"],[2,[7,"/"],[2,[6,"terms_and_privacy"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /home/terms_and_privacy(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const home_terms_and_privacy_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"home"],[2,[7,"/"],[2,[6,"terms_and_privacy"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /p/iceage(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const iceage_p_index_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[6,"iceage"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /p/iceage(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const iceage_p_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[6,"iceage"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /projects/iceage/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const iceage_project_create_new_projects_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"iceage"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/iceage/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const iceage_project_create_new_projects_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"iceage"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/iceage/:channel_id/edit(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const iceage_project_edit_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"iceage"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/iceage/:channel_id/edit(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const iceage_project_edit_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"iceage"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/iceage/:channel_id/export_config(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const iceage_project_export_config_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"iceage"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"export_config"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/iceage/:channel_id/export_config(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const iceage_project_export_config_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"iceage"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"export_config"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/iceage/:channel_id/export_create_channel(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const iceage_project_export_create_channel_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"iceage"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"export_create_channel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/iceage/:channel_id/export_create_channel(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const iceage_project_export_create_channel_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"iceage"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"export_create_channel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/iceage/:channel_id/embed_app_and_code(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const iceage_project_iframe_embed_app_and_code_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"iceage"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"embed_app_and_code"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/iceage/:channel_id/embed_app_and_code(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const iceage_project_iframe_embed_app_and_code_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"iceage"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"embed_app_and_code"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/iceage/:channel_id/embed(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const iceage_project_iframe_embed_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"iceage"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"embed"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/iceage/:channel_id/embed(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const iceage_project_iframe_embed_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"iceage"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"embed"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/iceage(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const iceage_project_projects_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"iceage"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /projects/iceage(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const iceage_project_projects_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"iceage"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /projects/iceage/:channel_id/remix(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const iceage_project_remix_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"iceage"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"remix"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/iceage/:channel_id/remix(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const iceage_project_remix_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"iceage"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"remix"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/iceage/:channel_id(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const iceage_project_share_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"iceage"],[2,[7,"/"],[2,[3,"channel_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/iceage/:channel_id(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const iceage_project_share_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"iceage"],[2,[7,"/"],[2,[3,"channel_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/iceage/:channel_id/view(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const iceage_project_view_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"iceage"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"view"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/iceage/:channel_id/view(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const iceage_project_view_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"iceage"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"view"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/scrapbook_entries/image(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const image_api_v1_scrapbook_entries_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"scrapbook_entries"],[2,[7,"/"],[2,[6,"image"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/v1/scrapbook_entries/image(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const image_api_v1_scrapbook_entries_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"scrapbook_entries"],[2,[7,"/"],[2,[6,"image"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /datablock_storage/:channel_id/import_csv(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const import_csv_datablock_storage_index_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"datablock_storage"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"import_csv"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /datablock_storage/:channel_id/import_csv(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const import_csv_datablock_storage_index_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"datablock_storage"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"import_csv"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/teacher_feedbacks/:id/increment_visit_count(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const increment_visit_count_api_v1_teacher_feedback_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"teacher_feedbacks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"increment_visit_count"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/v1/teacher_feedbacks/:id/increment_visit_count(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const increment_visit_count_api_v1_teacher_feedback_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"teacher_feedbacks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"increment_visit_count"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /incubator(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const incubator_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"incubator"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /incubator(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const incubator_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"incubator"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /p/infinity(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const infinity_p_index_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[6,"infinity"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /p/infinity(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const infinity_p_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[6,"infinity"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /projects/infinity/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const infinity_project_create_new_projects_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"infinity"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/infinity/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const infinity_project_create_new_projects_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"infinity"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/infinity/:channel_id/edit(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const infinity_project_edit_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"infinity"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/infinity/:channel_id/edit(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const infinity_project_edit_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"infinity"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/infinity/:channel_id/export_config(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const infinity_project_export_config_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"infinity"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"export_config"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/infinity/:channel_id/export_config(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const infinity_project_export_config_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"infinity"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"export_config"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/infinity/:channel_id/export_create_channel(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const infinity_project_export_create_channel_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"infinity"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"export_create_channel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/infinity/:channel_id/export_create_channel(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const infinity_project_export_create_channel_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"infinity"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"export_create_channel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/infinity/:channel_id/embed_app_and_code(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const infinity_project_iframe_embed_app_and_code_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"infinity"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"embed_app_and_code"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/infinity/:channel_id/embed_app_and_code(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const infinity_project_iframe_embed_app_and_code_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"infinity"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"embed_app_and_code"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/infinity/:channel_id/embed(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const infinity_project_iframe_embed_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"infinity"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"embed"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/infinity/:channel_id/embed(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const infinity_project_iframe_embed_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"infinity"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"embed"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/infinity(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const infinity_project_projects_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"infinity"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /projects/infinity(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const infinity_project_projects_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"infinity"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /projects/infinity/:channel_id/remix(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const infinity_project_remix_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"infinity"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"remix"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/infinity/:channel_id/remix(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const infinity_project_remix_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"infinity"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"remix"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/infinity/:channel_id(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const infinity_project_share_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"infinity"],[2,[7,"/"],[2,[3,"channel_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/infinity/:channel_id(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const infinity_project_share_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"infinity"],[2,[7,"/"],[2,[3,"channel_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/infinity/:channel_id/view(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const infinity_project_view_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"infinity"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"view"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/infinity/:channel_id/view(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const infinity_project_view_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"infinity"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"view"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /courses/:course_course_name/units/:position/instructions(.:format)
 * @param {any} course_course_name
 * @param {any} position
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const instructions_course_unit_url = /*#__PURE__*/ __jsr.r({"course_course_name":{"r":true},"position":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"courses"],[2,[7,"/"],[2,[3,"course_course_name"],[2,[7,"/"],[2,[6,"units"],[2,[7,"/"],[2,[3,"position"],[2,[7,"/"],[2,[6,"instructions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /courses/:course_course_name/units/:position/instructions(.:format)
 * @param {any} course_course_name
 * @param {any} position
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const instructions_course_unit_path = /*#__PURE__*/ __jsr.r({"course_course_name":{"r":true},"position":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"courses"],[2,[7,"/"],[2,[3,"course_course_name"],[2,[7,"/"],[2,[6,"units"],[2,[7,"/"],[2,[3,"position"],[2,[7,"/"],[2,[6,"instructions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /s/:id/instructions(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const instructions_script_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"s"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"instructions"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /s/:id/instructions(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const instructions_script_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"s"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"instructions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /javabuilder/access_token(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const javabuilder_access_token_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"javabuilder"],[2,[7,"/"],[2,[6,"access_token"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /javabuilder/access_token(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const javabuilder_access_token_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"javabuilder"],[2,[7,"/"],[2,[6,"access_token"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /javabuilder/access_token_with_override_sources(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const javabuilder_access_token_with_override_sources_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"javabuilder"],[2,[7,"/"],[2,[6,"access_token_with_override_sources"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /javabuilder/access_token_with_override_sources(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const javabuilder_access_token_with_override_sources_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"javabuilder"],[2,[7,"/"],[2,[6,"access_token_with_override_sources"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /javabuilder/access_token_with_override_sources_and_validation(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const javabuilder_access_token_with_override_sources_and_validation_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"javabuilder"],[2,[7,"/"],[2,[6,"access_token_with_override_sources_and_validation"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /javabuilder/access_token_with_override_sources_and_validation(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const javabuilder_access_token_with_override_sources_and_validation_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"javabuilder"],[2,[7,"/"],[2,[6,"access_token_with_override_sources_and_validation"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /javabuilder/access_token_with_override_validation(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const javabuilder_access_token_with_override_validation_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"javabuilder"],[2,[7,"/"],[2,[6,"access_token_with_override_validation"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /javabuilder/access_token_with_override_validation(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const javabuilder_access_token_with_override_validation_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"javabuilder"],[2,[7,"/"],[2,[6,"access_token_with_override_validation"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /p/javalab(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const javalab_p_index_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[6,"javalab"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /p/javalab(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const javalab_p_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[6,"javalab"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /projects/javalab/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const javalab_project_create_new_projects_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"javalab"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/javalab/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const javalab_project_create_new_projects_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"javalab"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/javalab/:channel_id/edit(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const javalab_project_edit_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"javalab"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/javalab/:channel_id/edit(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const javalab_project_edit_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"javalab"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/javalab/:channel_id/export_config(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const javalab_project_export_config_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"javalab"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"export_config"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/javalab/:channel_id/export_config(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const javalab_project_export_config_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"javalab"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"export_config"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/javalab/:channel_id/export_create_channel(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const javalab_project_export_create_channel_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"javalab"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"export_create_channel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/javalab/:channel_id/export_create_channel(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const javalab_project_export_create_channel_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"javalab"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"export_create_channel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/javalab/:channel_id/embed_app_and_code(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const javalab_project_iframe_embed_app_and_code_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"javalab"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"embed_app_and_code"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/javalab/:channel_id/embed_app_and_code(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const javalab_project_iframe_embed_app_and_code_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"javalab"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"embed_app_and_code"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/javalab/:channel_id/embed(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const javalab_project_iframe_embed_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"javalab"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"embed"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/javalab/:channel_id/embed(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const javalab_project_iframe_embed_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"javalab"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"embed"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/javalab(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const javalab_project_projects_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"javalab"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /projects/javalab(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const javalab_project_projects_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"javalab"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /projects/javalab/:channel_id/remix(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const javalab_project_remix_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"javalab"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"remix"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/javalab/:channel_id/remix(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const javalab_project_remix_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"javalab"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"remix"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/javalab/:channel_id(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const javalab_project_share_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"javalab"],[2,[7,"/"],[2,[3,"channel_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/javalab/:channel_id(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const javalab_project_share_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"javalab"],[2,[7,"/"],[2,[3,"channel_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/javalab/:channel_id/view(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const javalab_project_view_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"javalab"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"view"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/javalab/:channel_id/view(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const javalab_project_view_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"javalab"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"view"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /jigsaw/:chapter
 * @param {any} chapter
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const jigsaw_chapter_url = /*#__PURE__*/ __jsr.r({"chapter":{"r":true}}, [2,[7,"/"],[2,[6,"jigsaw"],[2,[7,"/"],[3,"chapter"]]]], true);

/**
 * Generates rails route to
 * /jigsaw/:chapter
 * @param {any} chapter
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const jigsaw_chapter_path = /*#__PURE__*/ __jsr.r({"chapter":{"r":true}}, [2,[7,"/"],[2,[6,"jigsaw"],[2,[7,"/"],[3,"chapter"]]]]);

/**
 * Generates rails route to
 * /jit_pl_concepts/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const jit_pl_concept_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"jit_pl_concepts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /jit_pl_concepts/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const jit_pl_concept_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"jit_pl_concepts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /jit_pl_concepts/:jit_pl_concept_id/jit_pl_exemplars/:id(.:format)
 * @param {any} jit_pl_concept_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const jit_pl_concept_jit_pl_exemplar_url = /*#__PURE__*/ __jsr.r({"jit_pl_concept_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"jit_pl_concepts"],[2,[7,"/"],[2,[3,"jit_pl_concept_id"],[2,[7,"/"],[2,[6,"jit_pl_exemplars"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /jit_pl_concepts/:jit_pl_concept_id/jit_pl_exemplars/:id(.:format)
 * @param {any} jit_pl_concept_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const jit_pl_concept_jit_pl_exemplar_path = /*#__PURE__*/ __jsr.r({"jit_pl_concept_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"jit_pl_concepts"],[2,[7,"/"],[2,[3,"jit_pl_concept_id"],[2,[7,"/"],[2,[6,"jit_pl_exemplars"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /jit_pl_concepts/:jit_pl_concept_id/jit_pl_exemplars(.:format)
 * @param {any} jit_pl_concept_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const jit_pl_concept_jit_pl_exemplars_url = /*#__PURE__*/ __jsr.r({"jit_pl_concept_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"jit_pl_concepts"],[2,[7,"/"],[2,[3,"jit_pl_concept_id"],[2,[7,"/"],[2,[6,"jit_pl_exemplars"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /jit_pl_concepts/:jit_pl_concept_id/jit_pl_exemplars(.:format)
 * @param {any} jit_pl_concept_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const jit_pl_concept_jit_pl_exemplars_path = /*#__PURE__*/ __jsr.r({"jit_pl_concept_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"jit_pl_concepts"],[2,[7,"/"],[2,[3,"jit_pl_concept_id"],[2,[7,"/"],[2,[6,"jit_pl_exemplars"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /jit_pl_concepts/:jit_pl_concept_id/jit_pl_misconceptions/:id(.:format)
 * @param {any} jit_pl_concept_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const jit_pl_concept_jit_pl_misconception_url = /*#__PURE__*/ __jsr.r({"jit_pl_concept_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"jit_pl_concepts"],[2,[7,"/"],[2,[3,"jit_pl_concept_id"],[2,[7,"/"],[2,[6,"jit_pl_misconceptions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /jit_pl_concepts/:jit_pl_concept_id/jit_pl_misconceptions/:id(.:format)
 * @param {any} jit_pl_concept_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const jit_pl_concept_jit_pl_misconception_path = /*#__PURE__*/ __jsr.r({"jit_pl_concept_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"jit_pl_concepts"],[2,[7,"/"],[2,[3,"jit_pl_concept_id"],[2,[7,"/"],[2,[6,"jit_pl_misconceptions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /jit_pl_concepts/:jit_pl_concept_id/jit_pl_misconceptions/:jit_pl_misconception_id/jit_pl_exemplars/:id(.:format)
 * @param {any} jit_pl_concept_id
 * @param {any} jit_pl_misconception_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const jit_pl_concept_jit_pl_misconception_jit_pl_exemplar_url = /*#__PURE__*/ __jsr.r({"jit_pl_concept_id":{"r":true},"jit_pl_misconception_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"jit_pl_concepts"],[2,[7,"/"],[2,[3,"jit_pl_concept_id"],[2,[7,"/"],[2,[6,"jit_pl_misconceptions"],[2,[7,"/"],[2,[3,"jit_pl_misconception_id"],[2,[7,"/"],[2,[6,"jit_pl_exemplars"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /jit_pl_concepts/:jit_pl_concept_id/jit_pl_misconceptions/:jit_pl_misconception_id/jit_pl_exemplars/:id(.:format)
 * @param {any} jit_pl_concept_id
 * @param {any} jit_pl_misconception_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const jit_pl_concept_jit_pl_misconception_jit_pl_exemplar_path = /*#__PURE__*/ __jsr.r({"jit_pl_concept_id":{"r":true},"jit_pl_misconception_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"jit_pl_concepts"],[2,[7,"/"],[2,[3,"jit_pl_concept_id"],[2,[7,"/"],[2,[6,"jit_pl_misconceptions"],[2,[7,"/"],[2,[3,"jit_pl_misconception_id"],[2,[7,"/"],[2,[6,"jit_pl_exemplars"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /jit_pl_concepts/:jit_pl_concept_id/jit_pl_misconceptions/:jit_pl_misconception_id/jit_pl_exemplars(.:format)
 * @param {any} jit_pl_concept_id
 * @param {any} jit_pl_misconception_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const jit_pl_concept_jit_pl_misconception_jit_pl_exemplars_url = /*#__PURE__*/ __jsr.r({"jit_pl_concept_id":{"r":true},"jit_pl_misconception_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"jit_pl_concepts"],[2,[7,"/"],[2,[3,"jit_pl_concept_id"],[2,[7,"/"],[2,[6,"jit_pl_misconceptions"],[2,[7,"/"],[2,[3,"jit_pl_misconception_id"],[2,[7,"/"],[2,[6,"jit_pl_exemplars"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /jit_pl_concepts/:jit_pl_concept_id/jit_pl_misconceptions/:jit_pl_misconception_id/jit_pl_exemplars(.:format)
 * @param {any} jit_pl_concept_id
 * @param {any} jit_pl_misconception_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const jit_pl_concept_jit_pl_misconception_jit_pl_exemplars_path = /*#__PURE__*/ __jsr.r({"jit_pl_concept_id":{"r":true},"jit_pl_misconception_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"jit_pl_concepts"],[2,[7,"/"],[2,[3,"jit_pl_concept_id"],[2,[7,"/"],[2,[6,"jit_pl_misconceptions"],[2,[7,"/"],[2,[3,"jit_pl_misconception_id"],[2,[7,"/"],[2,[6,"jit_pl_exemplars"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /jit_pl_concepts/:jit_pl_concept_id/jit_pl_misconceptions(.:format)
 * @param {any} jit_pl_concept_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const jit_pl_concept_jit_pl_misconceptions_url = /*#__PURE__*/ __jsr.r({"jit_pl_concept_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"jit_pl_concepts"],[2,[7,"/"],[2,[3,"jit_pl_concept_id"],[2,[7,"/"],[2,[6,"jit_pl_misconceptions"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /jit_pl_concepts/:jit_pl_concept_id/jit_pl_misconceptions(.:format)
 * @param {any} jit_pl_concept_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const jit_pl_concept_jit_pl_misconceptions_path = /*#__PURE__*/ __jsr.r({"jit_pl_concept_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"jit_pl_concepts"],[2,[7,"/"],[2,[3,"jit_pl_concept_id"],[2,[7,"/"],[2,[6,"jit_pl_misconceptions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /jit_pl_concepts/:jit_pl_concept_id/jit_pl_teaching_tips/:id(.:format)
 * @param {any} jit_pl_concept_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const jit_pl_concept_jit_pl_teaching_tip_url = /*#__PURE__*/ __jsr.r({"jit_pl_concept_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"jit_pl_concepts"],[2,[7,"/"],[2,[3,"jit_pl_concept_id"],[2,[7,"/"],[2,[6,"jit_pl_teaching_tips"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /jit_pl_concepts/:jit_pl_concept_id/jit_pl_teaching_tips/:id(.:format)
 * @param {any} jit_pl_concept_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const jit_pl_concept_jit_pl_teaching_tip_path = /*#__PURE__*/ __jsr.r({"jit_pl_concept_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"jit_pl_concepts"],[2,[7,"/"],[2,[3,"jit_pl_concept_id"],[2,[7,"/"],[2,[6,"jit_pl_teaching_tips"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /jit_pl_concepts/:jit_pl_concept_id/jit_pl_teaching_tips(.:format)
 * @param {any} jit_pl_concept_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const jit_pl_concept_jit_pl_teaching_tips_url = /*#__PURE__*/ __jsr.r({"jit_pl_concept_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"jit_pl_concepts"],[2,[7,"/"],[2,[3,"jit_pl_concept_id"],[2,[7,"/"],[2,[6,"jit_pl_teaching_tips"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /jit_pl_concepts/:jit_pl_concept_id/jit_pl_teaching_tips(.:format)
 * @param {any} jit_pl_concept_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const jit_pl_concept_jit_pl_teaching_tips_path = /*#__PURE__*/ __jsr.r({"jit_pl_concept_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"jit_pl_concepts"],[2,[7,"/"],[2,[3,"jit_pl_concept_id"],[2,[7,"/"],[2,[6,"jit_pl_teaching_tips"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /jit_pl_concepts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const jit_pl_concepts_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"jit_pl_concepts"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /jit_pl_concepts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const jit_pl_concepts_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"jit_pl_concepts"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /api/v1/sections/:id/join(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const join_api_v1_section_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"sections"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"join"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/v1/sections/:id/join(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const join_api_v1_section_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"sections"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"join"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /dashboardapi/sections/:id/join(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const join_section_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"dashboardapi"],[2,[7,"/"],[2,[6,"sections"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"join"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /dashboardapi/sections/:id/join(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const join_section_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"dashboardapi"],[2,[7,"/"],[2,[6,"sections"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"join"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /json_videos/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const json_video_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"json_videos"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /json_videos/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const json_video_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"json_videos"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /json_videos(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const json_videos_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"json_videos"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /json_videos(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const json_videos_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"json_videos"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /plc/course_units/launch_plc_course(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const launch_plc_course_plc_course_units_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"plc"],[2,[7,"/"],[2,[6,"course_units"],[2,[7,"/"],[2,[6,"launch_plc_course"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /plc/course_units/launch_plc_course(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const launch_plc_course_plc_course_units_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"plc"],[2,[7,"/"],[2,[6,"course_units"],[2,[7,"/"],[2,[6,"launch_plc_course"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /plc/course_units/launch(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const launch_plc_course_units_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"plc"],[2,[7,"/"],[2,[6,"course_units"],[2,[7,"/"],[2,[6,"launch"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /plc/course_units/launch(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const launch_plc_course_units_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"plc"],[2,[7,"/"],[2,[6,"course_units"],[2,[7,"/"],[2,[6,"launch"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /learning_goal_ai_evaluation_feedbacks/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const learning_goal_ai_evaluation_feedback_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"learning_goal_ai_evaluation_feedbacks"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /learning_goal_ai_evaluation_feedbacks/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const learning_goal_ai_evaluation_feedback_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"learning_goal_ai_evaluation_feedbacks"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /learning_goal_ai_evaluation_feedbacks(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const learning_goal_ai_evaluation_feedbacks_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"learning_goal_ai_evaluation_feedbacks"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /learning_goal_ai_evaluation_feedbacks(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const learning_goal_ai_evaluation_feedbacks_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"learning_goal_ai_evaluation_feedbacks"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /learning_goal_teacher_evaluations/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const learning_goal_teacher_evaluation_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"learning_goal_teacher_evaluations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /learning_goal_teacher_evaluations/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const learning_goal_teacher_evaluation_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"learning_goal_teacher_evaluations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /learning_goal_teacher_evaluations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const learning_goal_teacher_evaluations_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"learning_goal_teacher_evaluations"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /learning_goal_teacher_evaluations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const learning_goal_teacher_evaluations_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"learning_goal_teacher_evaluations"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /api/v1/sections/:id/leave(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const leave_api_v1_section_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"sections"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"leave"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/v1/sections/:id/leave(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const leave_api_v1_section_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"sections"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"leave"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /dashboardapi/sections/:id/leave(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const leave_section_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"dashboardapi"],[2,[7,"/"],[2,[6,"sections"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"leave"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /dashboardapi/sections/:id/leave(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const leave_section_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"dashboardapi"],[2,[7,"/"],[2,[6,"sections"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"leave"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /lessons/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const lesson_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"lessons"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /lessons/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const lesson_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"lessons"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /lesson_feedbacks/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const lesson_feedback_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"lesson_feedbacks"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /lesson_feedbacks/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const lesson_feedback_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"lesson_feedbacks"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /lesson_feedbacks(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const lesson_feedbacks_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"lesson_feedbacks"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /lesson_feedbacks(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const lesson_feedbacks_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"lesson_feedbacks"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /lesson_feedbacks/by_student(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const lesson_feedbacks_by_student_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"lesson_feedbacks"],[2,[7,"/"],[2,[6,"by_student"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /lesson_feedbacks/by_student(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const lesson_feedbacks_by_student_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"lesson_feedbacks"],[2,[7,"/"],[2,[6,"by_student"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /lesson_feedbacks/saved_feedback(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const lesson_feedbacks_saved_feedback_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"lesson_feedbacks"],[2,[7,"/"],[2,[6,"saved_feedback"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /lesson_feedbacks/saved_feedback(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const lesson_feedbacks_saved_feedback_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"lesson_feedbacks"],[2,[7,"/"],[2,[6,"saved_feedback"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /student_snapshots/lesson_insight(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const lesson_insight_student_snapshots_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"student_snapshots"],[2,[7,"/"],[2,[6,"lesson_insight"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /student_snapshots/lesson_insight(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const lesson_insight_student_snapshots_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"student_snapshots"],[2,[7,"/"],[2,[6,"lesson_insight"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /courses/:course_course_name/units/:position/lesson_outlines(.:format)
 * @param {any} course_course_name
 * @param {any} position
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const lesson_outlines_course_unit_url = /*#__PURE__*/ __jsr.r({"course_course_name":{"r":true},"position":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"courses"],[2,[7,"/"],[2,[3,"course_course_name"],[2,[7,"/"],[2,[6,"units"],[2,[7,"/"],[2,[3,"position"],[2,[7,"/"],[2,[6,"lesson_outlines"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /courses/:course_course_name/units/:position/lesson_outlines(.:format)
 * @param {any} course_course_name
 * @param {any} position
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const lesson_outlines_course_unit_path = /*#__PURE__*/ __jsr.r({"course_course_name":{"r":true},"position":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"courses"],[2,[7,"/"],[2,[3,"course_course_name"],[2,[7,"/"],[2,[6,"units"],[2,[7,"/"],[2,[3,"position"],[2,[7,"/"],[2,[6,"lesson_outlines"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /s/:id/lesson_outlines(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const lesson_outlines_script_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"s"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"lesson_outlines"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /s/:id/lesson_outlines(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const lesson_outlines_script_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"s"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"lesson_outlines"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /teacher_dashboard/lesson_summaries_enabled_for_unit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const lesson_summaries_enabled_for_unit_teacher_dashboard_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"teacher_dashboard"],[2,[7,"/"],[2,[6,"lesson_summaries_enabled_for_unit"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /teacher_dashboard/lesson_summaries_enabled_for_unit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const lesson_summaries_enabled_for_unit_teacher_dashboard_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"teacher_dashboard"],[2,[7,"/"],[2,[6,"lesson_summaries_enabled_for_unit"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /levels/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const level_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"levels"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /levels/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const level_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"levels"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/level_answers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const level_answers_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"level_answers"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /admin/level_answers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const level_answers_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"level_answers"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /level_assets/upload(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const level_assets_upload_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"level_assets"],[2,[7,"/"],[2,[6,"upload"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /level_assets/upload(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const level_assets_upload_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"level_assets"],[2,[7,"/"],[2,[6,"upload"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/levels(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const level_completions_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"levels"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /admin/levels(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const level_completions_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"levels"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /lessons/:id/level_properties
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const level_properties_lesson_url = /*#__PURE__*/ __jsr.r({"id":{"r":true}}, [2,[7,"/"],[2,[6,"lessons"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"level_properties"]]]]]], true);

/**
 * Generates rails route to
 * /lessons/:id/level_properties
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const level_properties_lesson_path = /*#__PURE__*/ __jsr.r({"id":{"r":true}}, [2,[7,"/"],[2,[6,"lessons"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"level_properties"]]]]]]);

/**
 * Generates rails route to
 * /levels/:id/level_properties(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const level_properties_level_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"levels"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"level_properties"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /levels/:id/level_properties(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const level_properties_level_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"levels"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"level_properties"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /levels/:level_id/quiz_configuration(.:format)
 * @param {any} level_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const level_quiz_configuration_url = /*#__PURE__*/ __jsr.r({"level_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"levels"],[2,[7,"/"],[2,[3,"level_id"],[2,[7,"/"],[2,[6,"quiz_configuration"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /levels/:level_id/quiz_configuration(.:format)
 * @param {any} level_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const level_quiz_configuration_path = /*#__PURE__*/ __jsr.r({"level_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"levels"],[2,[7,"/"],[2,[3,"level_id"],[2,[7,"/"],[2,[6,"quiz_configuration"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /levels/:level_id/quiz_question_placements/:id(.:format)
 * @param {any} level_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const level_quiz_question_placement_url = /*#__PURE__*/ __jsr.r({"level_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"levels"],[2,[7,"/"],[2,[3,"level_id"],[2,[7,"/"],[2,[6,"quiz_question_placements"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /levels/:level_id/quiz_question_placements/:id(.:format)
 * @param {any} level_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const level_quiz_question_placement_path = /*#__PURE__*/ __jsr.r({"level_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"levels"],[2,[7,"/"],[2,[3,"level_id"],[2,[7,"/"],[2,[6,"quiz_question_placements"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /levels/:level_id/quiz_question_placements(.:format)
 * @param {any} level_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const level_quiz_question_placements_url = /*#__PURE__*/ __jsr.r({"level_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"levels"],[2,[7,"/"],[2,[3,"level_id"],[2,[7,"/"],[2,[6,"quiz_question_placements"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /levels/:level_id/quiz_question_placements(.:format)
 * @param {any} level_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const level_quiz_question_placements_path = /*#__PURE__*/ __jsr.r({"level_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"levels"],[2,[7,"/"],[2,[3,"level_id"],[2,[7,"/"],[2,[6,"quiz_question_placements"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /c/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const level_source_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"c"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /c/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const level_source_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"c"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /level_starter_assets/:level_name(.:format)
 * @param {any} level_name
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const level_starter_asset_url = /*#__PURE__*/ __jsr.r({"level_name":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"level_starter_assets"],[2,[7,"/"],[2,[3,"level_name"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /level_starter_assets/:level_name(.:format)
 * @param {any} level_name
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const level_starter_asset_path = /*#__PURE__*/ __jsr.r({"level_name":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"level_starter_assets"],[2,[7,"/"],[2,[3,"level_name"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /levels(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const levels_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"levels"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /levels(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const levels_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"levels"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /libraries(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const libraries_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"libraries"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /libraries(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const libraries_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"libraries"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /libraries/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const library_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"libraries"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /libraries/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const library_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"libraries"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /courses/:course_course_name/units/:position/listing(.:format)
 * @param {any} course_course_name
 * @param {any} position
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const listing_course_unit_url = /*#__PURE__*/ __jsr.r({"course_course_name":{"r":true},"position":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"courses"],[2,[7,"/"],[2,[3,"course_course_name"],[2,[7,"/"],[2,[6,"units"],[2,[7,"/"],[2,[3,"position"],[2,[7,"/"],[2,[6,"listing"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /courses/:course_course_name/units/:position/listing(.:format)
 * @param {any} course_course_name
 * @param {any} position
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const listing_course_unit_path = /*#__PURE__*/ __jsr.r({"course_course_name":{"r":true},"position":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"courses"],[2,[7,"/"],[2,[3,"course_course_name"],[2,[7,"/"],[2,[6,"units"],[2,[7,"/"],[2,[3,"position"],[2,[7,"/"],[2,[6,"listing"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /s/:id/listing(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const listing_script_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"s"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"listing"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /s/:id/listing(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const listing_script_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"s"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"listing"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /locale(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locale_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"locale"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /locale(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locale_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"locale"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /lockout(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const lockout_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"lockout"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /lockout(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const lockout_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"lockout"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /sections/:id/log_in(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const log_in_section_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"sections"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"log_in"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /sections/:id/log_in(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const log_in_section_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"sections"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"log_in"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /logged_out(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const logged_out_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"logged_out"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /logged_out(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const logged_out_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"logged_out"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /admin/lookup_by_email(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const lookup_by_email_form_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"lookup_by_email"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /admin/lookup_by_email(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const lookup_by_email_form_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"lookup_by_email"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/lookup_section(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const lookup_section_admin_search_index_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"lookup_section"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /admin/lookup_section(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const lookup_section_admin_search_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"lookup_section"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /lti/v1/account_linking/existing_account(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const lti_v1_account_linking_existing_account_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"lti"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"account_linking"],[2,[7,"/"],[2,[6,"existing_account"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /lti/v1/account_linking/existing_account(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const lti_v1_account_linking_existing_account_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"lti"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"account_linking"],[2,[7,"/"],[2,[6,"existing_account"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /lti/v1/account_linking/finish_link(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const lti_v1_account_linking_finish_link_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"lti"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"account_linking"],[2,[7,"/"],[2,[6,"finish_link"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /lti/v1/account_linking/finish_link(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const lti_v1_account_linking_finish_link_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"lti"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"account_linking"],[2,[7,"/"],[2,[6,"finish_link"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /lti/v1/account_linking/landing(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const lti_v1_account_linking_landing_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"lti"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"account_linking"],[2,[7,"/"],[2,[6,"landing"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /lti/v1/account_linking/landing(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const lti_v1_account_linking_landing_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"lti"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"account_linking"],[2,[7,"/"],[2,[6,"landing"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /lti/v1/account_linking/link_email(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const lti_v1_account_linking_link_email_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"lti"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"account_linking"],[2,[7,"/"],[2,[6,"link_email"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /lti/v1/account_linking/link_email(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const lti_v1_account_linking_link_email_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"lti"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"account_linking"],[2,[7,"/"],[2,[6,"link_email"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /lti/v1/account_linking/new_account(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const lti_v1_account_linking_new_account_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"lti"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"account_linking"],[2,[7,"/"],[2,[6,"new_account"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /lti/v1/account_linking/new_account(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const lti_v1_account_linking_new_account_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"lti"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"account_linking"],[2,[7,"/"],[2,[6,"new_account"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /lti/v1/account_linking/unlink(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const lti_v1_account_linking_unlink_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"lti"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"account_linking"],[2,[7,"/"],[2,[6,"unlink"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /lti/v1/account_linking/unlink(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const lti_v1_account_linking_unlink_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"lti"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"account_linking"],[2,[7,"/"],[2,[6,"unlink"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /lti/v1/authenticate(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const lti_v1_authenticate_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"lti"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"authenticate"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /lti/v1/authenticate(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const lti_v1_authenticate_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"lti"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"authenticate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /lti/v1/deep_linking(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const lti_v1_deep_linking_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"lti"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"deep_linking"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /lti/v1/deep_linking(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const lti_v1_deep_linking_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"lti"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"deep_linking"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /lti/v1/dynamic_registration(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const lti_v1_dynamic_registration_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"lti"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"dynamic_registration"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /lti/v1/dynamic_registration(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const lti_v1_dynamic_registration_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"lti"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"dynamic_registration"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /lti/v1/integrations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const lti_v1_integrations_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"lti"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"integrations"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /lti/v1/integrations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const lti_v1_integrations_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"lti"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"integrations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /lti/v1/sync_course(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const lti_v1_sync_course_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"lti"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"sync_course"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /lti/v1/sync_course(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const lti_v1_sync_course_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"lti"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"sync_course"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /lti/v1/upgrade_account(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const lti_v1_upgrade_account_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"lti"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"upgrade_account"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /lti/v1/upgrade_account(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const lti_v1_upgrade_account_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"lti"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"upgrade_account"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /p/makerlab(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const makerlab_p_index_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[6,"makerlab"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /p/makerlab(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const makerlab_p_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[6,"makerlab"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /projects/makerlab/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const makerlab_project_create_new_projects_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"makerlab"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/makerlab/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const makerlab_project_create_new_projects_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"makerlab"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/makerlab/:channel_id/edit(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const makerlab_project_edit_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"makerlab"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/makerlab/:channel_id/edit(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const makerlab_project_edit_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"makerlab"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/makerlab/:channel_id/export_config(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const makerlab_project_export_config_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"makerlab"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"export_config"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/makerlab/:channel_id/export_config(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const makerlab_project_export_config_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"makerlab"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"export_config"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/makerlab/:channel_id/export_create_channel(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const makerlab_project_export_create_channel_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"makerlab"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"export_create_channel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/makerlab/:channel_id/export_create_channel(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const makerlab_project_export_create_channel_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"makerlab"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"export_create_channel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/makerlab/:channel_id/embed_app_and_code(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const makerlab_project_iframe_embed_app_and_code_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"makerlab"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"embed_app_and_code"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/makerlab/:channel_id/embed_app_and_code(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const makerlab_project_iframe_embed_app_and_code_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"makerlab"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"embed_app_and_code"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/makerlab/:channel_id/embed(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const makerlab_project_iframe_embed_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"makerlab"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"embed"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/makerlab/:channel_id/embed(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const makerlab_project_iframe_embed_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"makerlab"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"embed"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/makerlab(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const makerlab_project_projects_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"makerlab"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /projects/makerlab(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const makerlab_project_projects_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"makerlab"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /projects/makerlab/:channel_id/remix(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const makerlab_project_remix_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"makerlab"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"remix"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/makerlab/:channel_id/remix(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const makerlab_project_remix_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"makerlab"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"remix"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/makerlab/:channel_id(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const makerlab_project_share_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"makerlab"],[2,[7,"/"],[2,[3,"channel_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/makerlab/:channel_id(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const makerlab_project_share_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"makerlab"],[2,[7,"/"],[2,[3,"channel_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/makerlab/:channel_id/view(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const makerlab_project_view_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"makerlab"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"view"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/makerlab/:channel_id/view(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const makerlab_project_view_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"makerlab"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"view"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /datasets/manifest/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const manifest_edit_datasets_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"datasets"],[2,[7,"/"],[2,[6,"manifest"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /datasets/manifest/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const manifest_edit_datasets_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"datasets"],[2,[7,"/"],[2,[6,"manifest"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /datasets/manifest/update(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const manifest_update_datasets_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"datasets"],[2,[7,"/"],[2,[6,"manifest"],[2,[7,"/"],[2,[6,"update"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /datasets/manifest/update(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const manifest_update_datasets_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"datasets"],[2,[7,"/"],[2,[6,"manifest"],[2,[7,"/"],[2,[6,"update"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/manual_pass(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const manual_pass_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"manual_pass"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /admin/manual_pass(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const manual_pass_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"manual_pass"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/manual_pass(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const manual_pass_form_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"manual_pass"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /admin/manual_pass(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const manual_pass_form_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"manual_pass"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /notifications/mark_as_read(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mark_as_read_notifications_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"notifications"],[2,[7,"/"],[2,[6,"mark_as_read"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /notifications/mark_as_read(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mark_as_read_notifications_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"notifications"],[2,[7,"/"],[2,[6,"mark_as_read"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /marketing/teacher/promotions/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const marketing_teacher_promotion_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"marketing"],[2,[7,"/"],[2,[6,"teacher"],[2,[7,"/"],[2,[6,"promotions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /marketing/teacher/promotions/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const marketing_teacher_promotion_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"marketing"],[2,[7,"/"],[2,[6,"teacher"],[2,[7,"/"],[2,[6,"promotions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/mass-delete-student-progress(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mass_delete_student_progress_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"mass-delete-student-progress"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /admin/mass-delete-student-progress(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mass_delete_student_progress_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"mass-delete-student-progress"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /media
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const media_url = /*#__PURE__*/ __jsr.r({}, [2,[7,"/"],[6,"media"]], true);

/**
 * Generates rails route to
 * /media
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const media_path = /*#__PURE__*/ __jsr.r({}, [2,[7,"/"],[6,"media"]]);

/**
 * Generates rails route to
 * /api/v1/sections/membership(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const membership_api_v1_sections_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"sections"],[2,[7,"/"],[2,[6,"membership"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/v1/sections/membership(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const membership_api_v1_sections_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"sections"],[2,[7,"/"],[2,[6,"membership"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /dashboardapi/sections/membership(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const membership_sections_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dashboardapi"],[2,[7,"/"],[2,[6,"sections"],[2,[7,"/"],[2,[6,"membership"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /dashboardapi/sections/membership(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const membership_sections_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dashboardapi"],[2,[7,"/"],[2,[6,"sections"],[2,[7,"/"],[2,[6,"membership"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /milestone/:user_id/:script_level_id(.:format)
 * @param {any} user_id
 * @param {any} script_level_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const milestone_url = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"script_level_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"milestone"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[3,"script_level_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /milestone/:user_id/:script_level_id(.:format)
 * @param {any} user_id
 * @param {any} script_level_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const milestone_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"script_level_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"milestone"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[3,"script_level_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /milestone/:user_id/level/:level_id(.:format)
 * @param {any} user_id
 * @param {any} level_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const milestone_level_url = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"level_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"milestone"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"level"],[2,[7,"/"],[2,[3,"level_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /milestone/:user_id/level/:level_id(.:format)
 * @param {any} user_id
 * @param {any} level_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const milestone_level_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"level_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"milestone"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"level"],[2,[7,"/"],[2,[3,"level_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /milestone/:user_id/:script_level_id/:level_id(.:format)
 * @param {any} user_id
 * @param {any} script_level_id
 * @param {any} level_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const milestone_script_level_url = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"script_level_id":{"r":true},"level_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"milestone"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[3,"script_level_id"],[2,[7,"/"],[2,[3,"level_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /milestone/:user_id/:script_level_id/:level_id(.:format)
 * @param {any} user_id
 * @param {any} script_level_id
 * @param {any} level_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const milestone_script_level_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"script_level_id":{"r":true},"level_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"milestone"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[3,"script_level_id"],[2,[7,"/"],[2,[3,"level_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /p/minecraft_adventurer(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const minecraft_adventurer_p_index_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[6,"minecraft_adventurer"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /p/minecraft_adventurer(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const minecraft_adventurer_p_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[6,"minecraft_adventurer"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /projects/minecraft_adventurer/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const minecraft_adventurer_project_create_new_projects_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"minecraft_adventurer"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/minecraft_adventurer/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const minecraft_adventurer_project_create_new_projects_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"minecraft_adventurer"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/minecraft_adventurer/:channel_id/edit(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const minecraft_adventurer_project_edit_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"minecraft_adventurer"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/minecraft_adventurer/:channel_id/edit(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const minecraft_adventurer_project_edit_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"minecraft_adventurer"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/minecraft_adventurer/:channel_id/export_config(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const minecraft_adventurer_project_export_config_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"minecraft_adventurer"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"export_config"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/minecraft_adventurer/:channel_id/export_config(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const minecraft_adventurer_project_export_config_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"minecraft_adventurer"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"export_config"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/minecraft_adventurer/:channel_id/export_create_channel(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const minecraft_adventurer_project_export_create_channel_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"minecraft_adventurer"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"export_create_channel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/minecraft_adventurer/:channel_id/export_create_channel(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const minecraft_adventurer_project_export_create_channel_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"minecraft_adventurer"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"export_create_channel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/minecraft_adventurer/:channel_id/embed_app_and_code(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const minecraft_adventurer_project_iframe_embed_app_and_code_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"minecraft_adventurer"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"embed_app_and_code"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/minecraft_adventurer/:channel_id/embed_app_and_code(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const minecraft_adventurer_project_iframe_embed_app_and_code_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"minecraft_adventurer"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"embed_app_and_code"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/minecraft_adventurer/:channel_id/embed(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const minecraft_adventurer_project_iframe_embed_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"minecraft_adventurer"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"embed"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/minecraft_adventurer/:channel_id/embed(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const minecraft_adventurer_project_iframe_embed_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"minecraft_adventurer"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"embed"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/minecraft_adventurer(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const minecraft_adventurer_project_projects_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"minecraft_adventurer"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /projects/minecraft_adventurer(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const minecraft_adventurer_project_projects_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"minecraft_adventurer"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /projects/minecraft_adventurer/:channel_id/remix(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const minecraft_adventurer_project_remix_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"minecraft_adventurer"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"remix"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/minecraft_adventurer/:channel_id/remix(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const minecraft_adventurer_project_remix_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"minecraft_adventurer"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"remix"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/minecraft_adventurer/:channel_id(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const minecraft_adventurer_project_share_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"minecraft_adventurer"],[2,[7,"/"],[2,[3,"channel_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/minecraft_adventurer/:channel_id(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const minecraft_adventurer_project_share_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"minecraft_adventurer"],[2,[7,"/"],[2,[3,"channel_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/minecraft_adventurer/:channel_id/view(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const minecraft_adventurer_project_view_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"minecraft_adventurer"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"view"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/minecraft_adventurer/:channel_id/view(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const minecraft_adventurer_project_view_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"minecraft_adventurer"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"view"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /p/minecraft_aquatic(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const minecraft_aquatic_p_index_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[6,"minecraft_aquatic"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /p/minecraft_aquatic(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const minecraft_aquatic_p_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[6,"minecraft_aquatic"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /projects/minecraft_aquatic/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const minecraft_aquatic_project_create_new_projects_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"minecraft_aquatic"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/minecraft_aquatic/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const minecraft_aquatic_project_create_new_projects_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"minecraft_aquatic"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/minecraft_aquatic/:channel_id/edit(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const minecraft_aquatic_project_edit_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"minecraft_aquatic"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/minecraft_aquatic/:channel_id/edit(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const minecraft_aquatic_project_edit_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"minecraft_aquatic"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/minecraft_aquatic/:channel_id/export_config(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const minecraft_aquatic_project_export_config_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"minecraft_aquatic"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"export_config"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/minecraft_aquatic/:channel_id/export_config(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const minecraft_aquatic_project_export_config_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"minecraft_aquatic"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"export_config"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/minecraft_aquatic/:channel_id/export_create_channel(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const minecraft_aquatic_project_export_create_channel_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"minecraft_aquatic"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"export_create_channel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/minecraft_aquatic/:channel_id/export_create_channel(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const minecraft_aquatic_project_export_create_channel_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"minecraft_aquatic"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"export_create_channel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/minecraft_aquatic/:channel_id/embed_app_and_code(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const minecraft_aquatic_project_iframe_embed_app_and_code_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"minecraft_aquatic"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"embed_app_and_code"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/minecraft_aquatic/:channel_id/embed_app_and_code(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const minecraft_aquatic_project_iframe_embed_app_and_code_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"minecraft_aquatic"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"embed_app_and_code"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/minecraft_aquatic/:channel_id/embed(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const minecraft_aquatic_project_iframe_embed_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"minecraft_aquatic"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"embed"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/minecraft_aquatic/:channel_id/embed(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const minecraft_aquatic_project_iframe_embed_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"minecraft_aquatic"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"embed"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/minecraft_aquatic(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const minecraft_aquatic_project_projects_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"minecraft_aquatic"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /projects/minecraft_aquatic(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const minecraft_aquatic_project_projects_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"minecraft_aquatic"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /projects/minecraft_aquatic/:channel_id/remix(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const minecraft_aquatic_project_remix_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"minecraft_aquatic"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"remix"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/minecraft_aquatic/:channel_id/remix(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const minecraft_aquatic_project_remix_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"minecraft_aquatic"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"remix"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/minecraft_aquatic/:channel_id(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const minecraft_aquatic_project_share_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"minecraft_aquatic"],[2,[7,"/"],[2,[3,"channel_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/minecraft_aquatic/:channel_id(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const minecraft_aquatic_project_share_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"minecraft_aquatic"],[2,[7,"/"],[2,[3,"channel_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/minecraft_aquatic/:channel_id/view(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const minecraft_aquatic_project_view_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"minecraft_aquatic"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"view"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/minecraft_aquatic/:channel_id/view(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const minecraft_aquatic_project_view_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"minecraft_aquatic"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"view"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /p/minecraft_codebuilder(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const minecraft_codebuilder_p_index_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[6,"minecraft_codebuilder"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /p/minecraft_codebuilder(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const minecraft_codebuilder_p_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[6,"minecraft_codebuilder"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /projects/minecraft_codebuilder/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const minecraft_codebuilder_project_create_new_projects_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"minecraft_codebuilder"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/minecraft_codebuilder/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const minecraft_codebuilder_project_create_new_projects_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"minecraft_codebuilder"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/minecraft_codebuilder/:channel_id/edit(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const minecraft_codebuilder_project_edit_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"minecraft_codebuilder"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/minecraft_codebuilder/:channel_id/edit(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const minecraft_codebuilder_project_edit_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"minecraft_codebuilder"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/minecraft_codebuilder/:channel_id/export_config(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const minecraft_codebuilder_project_export_config_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"minecraft_codebuilder"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"export_config"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/minecraft_codebuilder/:channel_id/export_config(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const minecraft_codebuilder_project_export_config_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"minecraft_codebuilder"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"export_config"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/minecraft_codebuilder/:channel_id/export_create_channel(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const minecraft_codebuilder_project_export_create_channel_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"minecraft_codebuilder"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"export_create_channel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/minecraft_codebuilder/:channel_id/export_create_channel(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const minecraft_codebuilder_project_export_create_channel_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"minecraft_codebuilder"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"export_create_channel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/minecraft_codebuilder/:channel_id/embed_app_and_code(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const minecraft_codebuilder_project_iframe_embed_app_and_code_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"minecraft_codebuilder"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"embed_app_and_code"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/minecraft_codebuilder/:channel_id/embed_app_and_code(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const minecraft_codebuilder_project_iframe_embed_app_and_code_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"minecraft_codebuilder"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"embed_app_and_code"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/minecraft_codebuilder/:channel_id/embed(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const minecraft_codebuilder_project_iframe_embed_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"minecraft_codebuilder"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"embed"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/minecraft_codebuilder/:channel_id/embed(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const minecraft_codebuilder_project_iframe_embed_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"minecraft_codebuilder"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"embed"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/minecraft_codebuilder(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const minecraft_codebuilder_project_projects_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"minecraft_codebuilder"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /projects/minecraft_codebuilder(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const minecraft_codebuilder_project_projects_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"minecraft_codebuilder"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /projects/minecraft_codebuilder/:channel_id/remix(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const minecraft_codebuilder_project_remix_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"minecraft_codebuilder"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"remix"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/minecraft_codebuilder/:channel_id/remix(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const minecraft_codebuilder_project_remix_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"minecraft_codebuilder"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"remix"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/minecraft_codebuilder/:channel_id(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const minecraft_codebuilder_project_share_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"minecraft_codebuilder"],[2,[7,"/"],[2,[3,"channel_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/minecraft_codebuilder/:channel_id(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const minecraft_codebuilder_project_share_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"minecraft_codebuilder"],[2,[7,"/"],[2,[3,"channel_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/minecraft_codebuilder/:channel_id/view(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const minecraft_codebuilder_project_view_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"minecraft_codebuilder"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"view"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/minecraft_codebuilder/:channel_id/view(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const minecraft_codebuilder_project_view_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"minecraft_codebuilder"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"view"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /p/minecraft_designer(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const minecraft_designer_p_index_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[6,"minecraft_designer"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /p/minecraft_designer(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const minecraft_designer_p_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[6,"minecraft_designer"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /projects/minecraft_designer/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const minecraft_designer_project_create_new_projects_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"minecraft_designer"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/minecraft_designer/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const minecraft_designer_project_create_new_projects_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"minecraft_designer"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/minecraft_designer/:channel_id/edit(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const minecraft_designer_project_edit_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"minecraft_designer"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/minecraft_designer/:channel_id/edit(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const minecraft_designer_project_edit_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"minecraft_designer"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/minecraft_designer/:channel_id/export_config(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const minecraft_designer_project_export_config_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"minecraft_designer"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"export_config"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/minecraft_designer/:channel_id/export_config(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const minecraft_designer_project_export_config_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"minecraft_designer"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"export_config"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/minecraft_designer/:channel_id/export_create_channel(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const minecraft_designer_project_export_create_channel_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"minecraft_designer"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"export_create_channel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/minecraft_designer/:channel_id/export_create_channel(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const minecraft_designer_project_export_create_channel_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"minecraft_designer"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"export_create_channel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/minecraft_designer/:channel_id/embed_app_and_code(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const minecraft_designer_project_iframe_embed_app_and_code_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"minecraft_designer"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"embed_app_and_code"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/minecraft_designer/:channel_id/embed_app_and_code(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const minecraft_designer_project_iframe_embed_app_and_code_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"minecraft_designer"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"embed_app_and_code"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/minecraft_designer/:channel_id/embed(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const minecraft_designer_project_iframe_embed_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"minecraft_designer"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"embed"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/minecraft_designer/:channel_id/embed(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const minecraft_designer_project_iframe_embed_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"minecraft_designer"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"embed"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/minecraft_designer(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const minecraft_designer_project_projects_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"minecraft_designer"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /projects/minecraft_designer(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const minecraft_designer_project_projects_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"minecraft_designer"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /projects/minecraft_designer/:channel_id/remix(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const minecraft_designer_project_remix_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"minecraft_designer"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"remix"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/minecraft_designer/:channel_id/remix(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const minecraft_designer_project_remix_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"minecraft_designer"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"remix"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/minecraft_designer/:channel_id(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const minecraft_designer_project_share_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"minecraft_designer"],[2,[7,"/"],[2,[3,"channel_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/minecraft_designer/:channel_id(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const minecraft_designer_project_share_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"minecraft_designer"],[2,[7,"/"],[2,[3,"channel_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/minecraft_designer/:channel_id/view(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const minecraft_designer_project_view_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"minecraft_designer"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"view"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/minecraft_designer/:channel_id/view(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const minecraft_designer_project_view_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"minecraft_designer"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"view"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /p/minecraft_hero(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const minecraft_hero_p_index_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[6,"minecraft_hero"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /p/minecraft_hero(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const minecraft_hero_p_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[6,"minecraft_hero"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /projects/minecraft_hero/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const minecraft_hero_project_create_new_projects_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"minecraft_hero"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/minecraft_hero/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const minecraft_hero_project_create_new_projects_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"minecraft_hero"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/minecraft_hero/:channel_id/edit(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const minecraft_hero_project_edit_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"minecraft_hero"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/minecraft_hero/:channel_id/edit(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const minecraft_hero_project_edit_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"minecraft_hero"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/minecraft_hero/:channel_id/export_config(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const minecraft_hero_project_export_config_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"minecraft_hero"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"export_config"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/minecraft_hero/:channel_id/export_config(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const minecraft_hero_project_export_config_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"minecraft_hero"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"export_config"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/minecraft_hero/:channel_id/export_create_channel(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const minecraft_hero_project_export_create_channel_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"minecraft_hero"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"export_create_channel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/minecraft_hero/:channel_id/export_create_channel(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const minecraft_hero_project_export_create_channel_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"minecraft_hero"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"export_create_channel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/minecraft_hero/:channel_id/embed_app_and_code(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const minecraft_hero_project_iframe_embed_app_and_code_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"minecraft_hero"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"embed_app_and_code"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/minecraft_hero/:channel_id/embed_app_and_code(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const minecraft_hero_project_iframe_embed_app_and_code_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"minecraft_hero"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"embed_app_and_code"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/minecraft_hero/:channel_id/embed(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const minecraft_hero_project_iframe_embed_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"minecraft_hero"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"embed"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/minecraft_hero/:channel_id/embed(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const minecraft_hero_project_iframe_embed_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"minecraft_hero"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"embed"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/minecraft_hero(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const minecraft_hero_project_projects_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"minecraft_hero"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /projects/minecraft_hero(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const minecraft_hero_project_projects_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"minecraft_hero"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /projects/minecraft_hero/:channel_id/remix(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const minecraft_hero_project_remix_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"minecraft_hero"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"remix"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/minecraft_hero/:channel_id/remix(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const minecraft_hero_project_remix_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"minecraft_hero"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"remix"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/minecraft_hero/:channel_id(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const minecraft_hero_project_share_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"minecraft_hero"],[2,[7,"/"],[2,[3,"channel_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/minecraft_hero/:channel_id(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const minecraft_hero_project_share_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"minecraft_hero"],[2,[7,"/"],[2,[3,"channel_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/minecraft_hero/:channel_id/view(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const minecraft_hero_project_view_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"minecraft_hero"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"view"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/minecraft_hero/:channel_id/view(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const minecraft_hero_project_view_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"minecraft_hero"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"view"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /p/music_dance_ai(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const music_dance_ai_p_index_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[6,"music_dance_ai"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /p/music_dance_ai(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const music_dance_ai_p_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[6,"music_dance_ai"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /projects/music_dance_ai/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const music_dance_ai_project_create_new_projects_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"music_dance_ai"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/music_dance_ai/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const music_dance_ai_project_create_new_projects_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"music_dance_ai"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/music_dance_ai/:channel_id/edit(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const music_dance_ai_project_edit_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"music_dance_ai"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/music_dance_ai/:channel_id/edit(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const music_dance_ai_project_edit_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"music_dance_ai"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/music_dance_ai/:channel_id/export_config(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const music_dance_ai_project_export_config_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"music_dance_ai"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"export_config"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/music_dance_ai/:channel_id/export_config(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const music_dance_ai_project_export_config_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"music_dance_ai"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"export_config"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/music_dance_ai/:channel_id/export_create_channel(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const music_dance_ai_project_export_create_channel_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"music_dance_ai"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"export_create_channel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/music_dance_ai/:channel_id/export_create_channel(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const music_dance_ai_project_export_create_channel_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"music_dance_ai"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"export_create_channel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/music_dance_ai/:channel_id/embed_app_and_code(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const music_dance_ai_project_iframe_embed_app_and_code_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"music_dance_ai"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"embed_app_and_code"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/music_dance_ai/:channel_id/embed_app_and_code(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const music_dance_ai_project_iframe_embed_app_and_code_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"music_dance_ai"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"embed_app_and_code"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/music_dance_ai/:channel_id/embed(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const music_dance_ai_project_iframe_embed_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"music_dance_ai"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"embed"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/music_dance_ai/:channel_id/embed(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const music_dance_ai_project_iframe_embed_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"music_dance_ai"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"embed"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/music_dance_ai(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const music_dance_ai_project_projects_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"music_dance_ai"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /projects/music_dance_ai(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const music_dance_ai_project_projects_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"music_dance_ai"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /projects/music_dance_ai/:channel_id/remix(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const music_dance_ai_project_remix_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"music_dance_ai"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"remix"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/music_dance_ai/:channel_id/remix(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const music_dance_ai_project_remix_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"music_dance_ai"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"remix"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/music_dance_ai/:channel_id(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const music_dance_ai_project_share_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"music_dance_ai"],[2,[7,"/"],[2,[3,"channel_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/music_dance_ai/:channel_id(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const music_dance_ai_project_share_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"music_dance_ai"],[2,[7,"/"],[2,[3,"channel_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/music_dance_ai/:channel_id/view(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const music_dance_ai_project_view_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"music_dance_ai"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"view"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/music_dance_ai/:channel_id/view(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const music_dance_ai_project_view_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"music_dance_ai"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"view"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /p/music(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const music_p_index_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[6,"music"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /p/music(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const music_p_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[6,"music"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /projects/music/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const music_project_create_new_projects_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"music"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/music/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const music_project_create_new_projects_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"music"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/music/:channel_id/edit(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const music_project_edit_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"music"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/music/:channel_id/edit(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const music_project_edit_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"music"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/music/:channel_id/export_config(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const music_project_export_config_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"music"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"export_config"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/music/:channel_id/export_config(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const music_project_export_config_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"music"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"export_config"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/music/:channel_id/export_create_channel(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const music_project_export_create_channel_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"music"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"export_create_channel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/music/:channel_id/export_create_channel(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const music_project_export_create_channel_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"music"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"export_create_channel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/music/:channel_id/embed_app_and_code(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const music_project_iframe_embed_app_and_code_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"music"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"embed_app_and_code"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/music/:channel_id/embed_app_and_code(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const music_project_iframe_embed_app_and_code_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"music"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"embed_app_and_code"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/music/:channel_id/embed(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const music_project_iframe_embed_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"music"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"embed"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/music/:channel_id/embed(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const music_project_iframe_embed_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"music"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"embed"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/music(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const music_project_projects_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"music"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /projects/music(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const music_project_projects_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"music"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /projects/music/:channel_id/remix(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const music_project_remix_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"music"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"remix"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/music/:channel_id/remix(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const music_project_remix_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"music"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"remix"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/music/:channel_id(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const music_project_share_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"music"],[2,[7,"/"],[2,[3,"channel_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/music/:channel_id(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const music_project_share_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"music"],[2,[7,"/"],[2,[3,"channel_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/music/:channel_id/view(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const music_project_view_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"music"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"view"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/music/:channel_id/view(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const music_project_view_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"music"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"view"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /musiclab(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const musiclab_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"musiclab"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /musiclab(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const musiclab_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"musiclab"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /musiclab/analytics_key(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const musiclab_analytics_key_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"musiclab"],[2,[7,"/"],[2,[6,"analytics_key"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /musiclab/analytics_key(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const musiclab_analytics_key_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"musiclab"],[2,[7,"/"],[2,[6,"analytics_key"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /musiclab/embed(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const musiclab_embed_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"musiclab"],[2,[7,"/"],[2,[6,"embed"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /musiclab/embed(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const musiclab_embed_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"musiclab"],[2,[7,"/"],[2,[6,"embed"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /musiclab/gallery(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const musiclab_gallery_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"musiclab"],[2,[7,"/"],[2,[6,"gallery"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /musiclab/gallery(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const musiclab_gallery_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"musiclab"],[2,[7,"/"],[2,[6,"gallery"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /musiclab/menu(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const musiclab_menu_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"musiclab"],[2,[7,"/"],[2,[6,"menu"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /musiclab/menu(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const musiclab_menu_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"musiclab"],[2,[7,"/"],[2,[6,"menu"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/ml_models/names(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const names_api_v1_ml_models_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"ml_models"],[2,[7,"/"],[2,[6,"names"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/v1/ml_models/names(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const names_api_v1_ml_models_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"ml_models"],[2,[7,"/"],[2,[6,"names"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /ai_lesson_summary_podcasts/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_ai_lesson_summary_podcast_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"ai_lesson_summary_podcasts"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /ai_lesson_summary_podcasts/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_ai_lesson_summary_podcast_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"ai_lesson_summary_podcasts"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/pd/workshops/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_api_v1_pd_workshop_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"pd"],[2,[7,"/"],[2,[6,"workshops"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/v1/pd/workshops/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_api_v1_pd_workshop_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"pd"],[2,[7,"/"],[2,[6,"workshops"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/users/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_api_v1_user_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/v1/users/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_api_v1_user_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /pools/:pool/blocks/new(.:format)
 * @param {any} pool
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_block_url = /*#__PURE__*/ __jsr.r({"pool":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"pools"],[2,[7,"/"],[2,[3,"pool"],[2,[7,"/"],[2,[6,"blocks"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /pools/:pool/blocks/new(.:format)
 * @param {any} pool
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_block_path = /*#__PURE__*/ __jsr.r({"pool":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"pools"],[2,[7,"/"],[2,[3,"pool"],[2,[7,"/"],[2,[6,"blocks"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /callouts/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_callout_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"callouts"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /callouts/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_callout_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"callouts"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /courses/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_course_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"courses"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /courses/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_course_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"courses"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /courses/:course_course_name/guides/new(.:format)
 * @param {any} course_course_name
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_course_reference_guide_url = /*#__PURE__*/ __jsr.r({"course_course_name":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"courses"],[2,[7,"/"],[2,[3,"course_course_name"],[2,[7,"/"],[2,[6,"guides"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /courses/:course_course_name/guides/new(.:format)
 * @param {any} course_course_name
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_course_reference_guide_path = /*#__PURE__*/ __jsr.r({"course_course_name":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"courses"],[2,[7,"/"],[2,[3,"course_course_name"],[2,[7,"/"],[2,[6,"guides"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /courses/:course_course_name/units/new(.:format)
 * @param {any} course_course_name
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_course_unit_url = /*#__PURE__*/ __jsr.r({"course_course_name":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"courses"],[2,[7,"/"],[2,[3,"course_course_name"],[2,[7,"/"],[2,[6,"units"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /courses/:course_course_name/units/new(.:format)
 * @param {any} course_course_name
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_course_unit_path = /*#__PURE__*/ __jsr.r({"course_course_name":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"courses"],[2,[7,"/"],[2,[3,"course_course_name"],[2,[7,"/"],[2,[6,"units"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /data_docs/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_data_doc_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"data_docs"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /data_docs/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_data_doc_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"data_docs"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /new_feature_feedback(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_feature_feedback_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"new_feature_feedback"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /new_feature_feedback(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_feature_feedback_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"new_feature_feedback"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /feedback/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_feedback_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"feedback"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /feedback/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_feedback_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"feedback"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /foorm/simple_survey_forms/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_foorm_simple_survey_form_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"foorm"],[2,[7,"/"],[2,[6,"simple_survey_forms"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /foorm/simple_survey_forms/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_foorm_simple_survey_form_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"foorm"],[2,[7,"/"],[2,[6,"simple_survey_forms"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /images/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_image_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"images"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /images/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_image_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"images"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /jit_pl_concepts/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_jit_pl_concept_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"jit_pl_concepts"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /jit_pl_concepts/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_jit_pl_concept_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"jit_pl_concepts"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /levels/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_level_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"levels"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /levels/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_level_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"levels"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /libraries/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_library_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"libraries"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /libraries/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_library_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"libraries"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /lti/v1/integrations/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_lti_v1_integration_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"lti"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /lti/v1/integrations/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_lti_v1_integration_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"lti"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /peer_reviews/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_peer_review_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"peer_reviews"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /peer_reviews/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_peer_review_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"peer_reviews"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /plc/user_course_enrollments/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_plc_user_course_enrollment_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"plc"],[2,[7,"/"],[2,[6,"user_course_enrollments"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /plc/user_course_enrollments/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_plc_user_course_enrollment_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"plc"],[2,[7,"/"],[2,[6,"user_course_enrollments"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /programming_classes/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_programming_class_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"programming_classes"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /programming_classes/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_programming_class_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"programming_classes"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /programming_environments/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_programming_environment_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"programming_environments"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /programming_environments/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_programming_environment_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"programming_environments"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /docs/ide/:programming_environment_name/classes/new(.:format)
 * @param {any} programming_environment_name
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_programming_environment_programming_class_url = /*#__PURE__*/ __jsr.r({"programming_environment_name":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"docs"],[2,[7,"/"],[2,[6,"ide"],[2,[7,"/"],[2,[3,"programming_environment_name"],[2,[7,"/"],[2,[6,"classes"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /docs/ide/:programming_environment_name/classes/new(.:format)
 * @param {any} programming_environment_name
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_programming_environment_programming_class_path = /*#__PURE__*/ __jsr.r({"programming_environment_name":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"docs"],[2,[7,"/"],[2,[6,"ide"],[2,[7,"/"],[2,[3,"programming_environment_name"],[2,[7,"/"],[2,[6,"classes"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /docs/ide/:programming_environment_name/expressions/new(.:format)
 * @param {any} programming_environment_name
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_programming_environment_programming_expression_url = /*#__PURE__*/ __jsr.r({"programming_environment_name":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"docs"],[2,[7,"/"],[2,[6,"ide"],[2,[7,"/"],[2,[3,"programming_environment_name"],[2,[7,"/"],[2,[6,"expressions"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /docs/ide/:programming_environment_name/expressions/new(.:format)
 * @param {any} programming_environment_name
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_programming_environment_programming_expression_path = /*#__PURE__*/ __jsr.r({"programming_environment_name":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"docs"],[2,[7,"/"],[2,[6,"ide"],[2,[7,"/"],[2,[3,"programming_environment_name"],[2,[7,"/"],[2,[6,"expressions"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /programming_expressions/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_programming_expression_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"programming_expressions"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /programming_expressions/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_programming_expression_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"programming_expressions"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/inbound_emails/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_rails_conductor_inbound_email_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/inbound_emails/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_rails_conductor_inbound_email_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/inbound_emails/sources/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_rails_conductor_inbound_email_source_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/inbound_emails/sources/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_rails_conductor_inbound_email_source_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /regional_partners/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_regional_partner_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"regional_partners"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /regional_partners/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_regional_partner_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"regional_partners"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /rubrics/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_rubric_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rubrics"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /rubrics/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_rubric_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rubrics"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /s/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_script_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"s"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /s/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_script_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"s"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /sections/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_section_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"sections"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /sections/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_section_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"sections"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /functions/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_shared_blockly_function_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"functions"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /functions/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_shared_blockly_function_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"functions"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/invitation/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_user_invitation_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"invitation"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /users/invitation/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_user_invitation_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"invitation"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/password/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_user_password_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"password"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /users/password/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_user_password_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"password"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/sign_up(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_user_registration_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"sign_up"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /users/sign_up(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_user_registration_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"sign_up"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/sign_in(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_user_session_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"sign_in"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /users/sign_in(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_user_session_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"sign_in"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/unlock/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_user_unlock_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"unlock"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /users/unlock/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_user_unlock_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"unlock"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /videos/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_video_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"videos"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /videos/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_video_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"videos"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /notifications(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const notifications_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"notifications"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /notifications(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const notifications_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"notifications"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /admin/nps/nps_form(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const nps_form_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"nps"],[2,[7,"/"],[2,[6,"nps_form"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/nps/nps_form(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const nps_form_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"nps"],[2,[7,"/"],[2,[6,"nps_form"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/nps/nps_update(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const nps_update_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"nps"],[2,[7,"/"],[2,[6,"nps_update"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/nps/nps_update(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const nps_update_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"nps"],[2,[7,"/"],[2,[6,"nps_update"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /oauth/jwks(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const oauth_jwks_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"oauth"],[2,[7,"/"],[2,[6,"jwks"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /oauth/jwks(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const oauth_jwks_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"oauth"],[2,[7,"/"],[2,[6,"jwks"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /oauth_sign_out/:provider(.:format)
 * @param {any} provider
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const oauth_sign_out_url = /*#__PURE__*/ __jsr.r({"provider":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"oauth_sign_out"],[2,[7,"/"],[2,[3,"provider"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /oauth_sign_out/:provider(.:format)
 * @param {any} provider
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const oauth_sign_out_path = /*#__PURE__*/ __jsr.r({"provider":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"oauth_sign_out"],[2,[7,"/"],[2,[3,"provider"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /r/:level_source_id_and_user_id(.:format)
 * @param {any} level_source_id_and_user_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const obfuscated_level_source_url = /*#__PURE__*/ __jsr.r({"level_source_id_and_user_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"r"],[2,[7,"/"],[2,[3,"level_source_id_and_user_id"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /r/:level_source_id_and_user_id(.:format)
 * @param {any} level_source_id_and_user_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const obfuscated_level_source_path = /*#__PURE__*/ __jsr.r({"level_source_id_and_user_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"r"],[2,[7,"/"],[2,[3,"level_source_id_and_user_id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /openai/evaluate(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const openai_evaluate_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"openai"],[2,[7,"/"],[2,[6,"evaluate"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /openai/evaluate(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const openai_evaluate_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"openai"],[2,[7,"/"],[2,[6,"evaluate"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /openai/evaluate_section(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const openai_evaluate_section_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"openai"],[2,[7,"/"],[2,[6,"evaluate_section"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /openai/evaluate_section(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const openai_evaluate_section_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"openai"],[2,[7,"/"],[2,[6,"evaluate_section"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /openai/match_teaching_profile(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const openai_match_teaching_profile_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"openai"],[2,[7,"/"],[2,[6,"match_teaching_profile"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /openai/match_teaching_profile(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const openai_match_teaching_profile_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"openai"],[2,[7,"/"],[2,[6,"match_teaching_profile"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /c/:id/original_image(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const original_image_level_source_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"c"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"original_image"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /c/:id/original_image(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const original_image_level_source_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"c"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"original_image"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /r/:level_source_id_and_user_id/original_image(.:format)
 * @param {any} level_source_id_and_user_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const original_image_obfuscated_level_source_url = /*#__PURE__*/ __jsr.r({"level_source_id_and_user_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"r"],[2,[7,"/"],[2,[3,"level_source_id_and_user_id"],[2,[7,"/"],[2,[6,"original_image"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /r/:level_source_id_and_user_id/original_image(.:format)
 * @param {any} level_source_id_and_user_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const original_image_obfuscated_level_source_path = /*#__PURE__*/ __jsr.r({"level_source_id_and_user_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"r"],[2,[7,"/"],[2,[3,"level_source_id_and_user_id"],[2,[7,"/"],[2,[6,"original_image"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /p(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const p_index_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"p"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /p(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const p_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"p"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /pairing(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pairing_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"pairing"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /pairing(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pairing_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"pairing"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /teacher_dashboard/sections/:section_id/parent_letter(.:format)
 * @param {any} section_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const parent_letter_teacher_dashboard_section_url = /*#__PURE__*/ __jsr.r({"section_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"teacher_dashboard"],[2,[7,"/"],[2,[6,"sections"],[2,[7,"/"],[2,[3,"section_id"],[2,[7,"/"],[2,[6,"parent_letter"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /teacher_dashboard/sections/:section_id/parent_letter(.:format)
 * @param {any} section_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const parent_letter_teacher_dashboard_section_path = /*#__PURE__*/ __jsr.r({"section_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"teacher_dashboard"],[2,[7,"/"],[2,[6,"sections"],[2,[7,"/"],[2,[3,"section_id"],[2,[7,"/"],[2,[6,"parent_letter"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /pd/workshop_dashboard/*path(.:format)
 * @param {any} path
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pd_url = /*#__PURE__*/ __jsr.r({"path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"pd"],[2,[7,"/"],[2,[6,"workshop_dashboard"],[2,[7,"/"],[2,[5,[3,"path"]],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /pd/workshop_dashboard/*path(.:format)
 * @param {any} path
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pd_path = /*#__PURE__*/ __jsr.r({"path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"pd"],[2,[7,"/"],[2,[6,"workshop_dashboard"],[2,[7,"/"],[2,[5,[3,"path"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /pd/workshop_user_management/facilitator_courses(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pd_facilitator_courses_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"pd"],[2,[7,"/"],[2,[6,"workshop_user_management"],[2,[7,"/"],[2,[6,"facilitator_courses"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /pd/workshop_user_management/facilitator_courses(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pd_facilitator_courses_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"pd"],[2,[7,"/"],[2,[6,"workshop_user_management"],[2,[7,"/"],[2,[6,"facilitator_courses"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /pd/international_workshop(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pd_international_workshop_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"pd"],[2,[7,"/"],[2,[6,"international_workshop"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /pd/international_workshop(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pd_international_workshop_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"pd"],[2,[7,"/"],[2,[6,"international_workshop"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /pd/misc_survey/submit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pd_misc_survey_submit_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"pd"],[2,[7,"/"],[2,[6,"misc_survey"],[2,[7,"/"],[2,[6,"submit"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /pd/misc_survey/submit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pd_misc_survey_submit_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"pd"],[2,[7,"/"],[2,[6,"misc_survey"],[2,[7,"/"],[2,[6,"submit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /pd/misc_survey/thanks(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pd_misc_survey_thanks_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"pd"],[2,[7,"/"],[2,[6,"misc_survey"],[2,[7,"/"],[2,[6,"thanks"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /pd/misc_survey/thanks(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pd_misc_survey_thanks_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"pd"],[2,[7,"/"],[2,[6,"misc_survey"],[2,[7,"/"],[2,[6,"thanks"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /pd/pre_workshop_survey/:enrollment_code(.:format)
 * @param {any} enrollment_code
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pd_new_pre_workshop_survey_url = /*#__PURE__*/ __jsr.r({"enrollment_code":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"pd"],[2,[7,"/"],[2,[6,"pre_workshop_survey"],[2,[7,"/"],[2,[3,"enrollment_code"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /pd/pre_workshop_survey/:enrollment_code(.:format)
 * @param {any} enrollment_code
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pd_new_pre_workshop_survey_path = /*#__PURE__*/ __jsr.r({"enrollment_code":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"pd"],[2,[7,"/"],[2,[6,"pre_workshop_survey"],[2,[7,"/"],[2,[3,"enrollment_code"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /pd/teachercon_survey/:enrollment_code(.:format)
 * @param {any} enrollment_code
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pd_new_teachercon_survey_url = /*#__PURE__*/ __jsr.r({"enrollment_code":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"pd"],[2,[7,"/"],[2,[6,"teachercon_survey"],[2,[7,"/"],[2,[3,"enrollment_code"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /pd/teachercon_survey/:enrollment_code(.:format)
 * @param {any} enrollment_code
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pd_new_teachercon_survey_path = /*#__PURE__*/ __jsr.r({"enrollment_code":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"pd"],[2,[7,"/"],[2,[6,"teachercon_survey"],[2,[7,"/"],[2,[3,"enrollment_code"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /pd/workshop_survey/post/:enrollment_code(.:format)
 * @param {any} enrollment_code
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pd_new_workshop_survey_url = /*#__PURE__*/ __jsr.r({"enrollment_code":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"pd"],[2,[7,"/"],[2,[6,"workshop_survey"],[2,[7,"/"],[2,[6,"post"],[2,[7,"/"],[2,[3,"enrollment_code"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /pd/workshop_survey/post/:enrollment_code(.:format)
 * @param {any} enrollment_code
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pd_new_workshop_survey_path = /*#__PURE__*/ __jsr.r({"enrollment_code":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"pd"],[2,[7,"/"],[2,[6,"workshop_survey"],[2,[7,"/"],[2,[6,"post"],[2,[7,"/"],[2,[3,"enrollment_code"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /pd/post_course_survey/submit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pd_post_course_survey_submit_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"pd"],[2,[7,"/"],[2,[6,"post_course_survey"],[2,[7,"/"],[2,[6,"submit"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /pd/post_course_survey/submit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pd_post_course_survey_submit_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"pd"],[2,[7,"/"],[2,[6,"post_course_survey"],[2,[7,"/"],[2,[6,"submit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /pd/post_course_survey/thanks(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pd_post_course_survey_thanks_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"pd"],[2,[7,"/"],[2,[6,"post_course_survey"],[2,[7,"/"],[2,[6,"thanks"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /pd/post_course_survey/thanks(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pd_post_course_survey_thanks_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"pd"],[2,[7,"/"],[2,[6,"post_course_survey"],[2,[7,"/"],[2,[6,"thanks"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /pd/regional_partner_contact/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pd_regional_partner_contact_new_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"pd"],[2,[7,"/"],[2,[6,"regional_partner_contact"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /pd/regional_partner_contact/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pd_regional_partner_contact_new_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"pd"],[2,[7,"/"],[2,[6,"regional_partner_contact"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /pd/regional_partner_mini_contact/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pd_regional_partner_mini_contact_new_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"pd"],[2,[7,"/"],[2,[6,"regional_partner_mini_contact"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /pd/regional_partner_mini_contact/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pd_regional_partner_mini_contact_new_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"pd"],[2,[7,"/"],[2,[6,"regional_partner_mini_contact"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /pd/workshop_admins(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pd_workshop_admins_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"pd"],[2,[7,"/"],[2,[6,"workshop_admins"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /pd/workshop_admins(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pd_workshop_admins_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"pd"],[2,[7,"/"],[2,[6,"workshop_admins"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /pd/workshop_dashboard(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pd_workshop_dashboard_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"pd"],[2,[7,"/"],[2,[6,"workshop_dashboard"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /pd/workshop_dashboard(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pd_workshop_dashboard_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"pd"],[2,[7,"/"],[2,[6,"workshop_dashboard"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /pd/workshop_post_survey(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pd_workshop_post_survey_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"pd"],[2,[7,"/"],[2,[6,"workshop_post_survey"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /pd/workshop_post_survey(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pd_workshop_post_survey_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"pd"],[2,[7,"/"],[2,[6,"workshop_post_survey"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /pd/workshop_pre_survey(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pd_workshop_pre_survey_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"pd"],[2,[7,"/"],[2,[6,"workshop_pre_survey"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /pd/workshop_pre_survey(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pd_workshop_pre_survey_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"pd"],[2,[7,"/"],[2,[6,"workshop_pre_survey"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /pd/workshop_survey/csf/pre201(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pd_workshop_survey_csf_pre201_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"pd"],[2,[7,"/"],[2,[6,"workshop_survey"],[2,[7,"/"],[2,[6,"csf"],[2,[7,"/"],[2,[6,"pre201"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /pd/workshop_survey/csf/pre201(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pd_workshop_survey_csf_pre201_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"pd"],[2,[7,"/"],[2,[6,"workshop_survey"],[2,[7,"/"],[2,[6,"csf"],[2,[7,"/"],[2,[6,"pre201"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /pd/workshop_survey/facilitator_post_foorm(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pd_workshop_survey_facilitator_post_foorm_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"pd"],[2,[7,"/"],[2,[6,"workshop_survey"],[2,[7,"/"],[2,[6,"facilitator_post_foorm"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /pd/workshop_survey/facilitator_post_foorm(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pd_workshop_survey_facilitator_post_foorm_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"pd"],[2,[7,"/"],[2,[6,"workshop_survey"],[2,[7,"/"],[2,[6,"facilitator_post_foorm"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /pd/workshop_survey/foorm/csf/pre201(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pd_workshop_survey_foorm_csf_pre201_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"pd"],[2,[7,"/"],[2,[6,"workshop_survey"],[2,[7,"/"],[2,[6,"foorm"],[2,[7,"/"],[2,[6,"csf"],[2,[7,"/"],[2,[6,"pre201"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /pd/workshop_survey/foorm/csf/pre201(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pd_workshop_survey_foorm_csf_pre201_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"pd"],[2,[7,"/"],[2,[6,"workshop_survey"],[2,[7,"/"],[2,[6,"foorm"],[2,[7,"/"],[2,[6,"csf"],[2,[7,"/"],[2,[6,"pre201"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /pd/workshop_survey/new_facilitator_post(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pd_workshop_survey_new_facilitator_post_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"pd"],[2,[7,"/"],[2,[6,"workshop_survey"],[2,[7,"/"],[2,[6,"new_facilitator_post"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /pd/workshop_survey/new_facilitator_post(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pd_workshop_survey_new_facilitator_post_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"pd"],[2,[7,"/"],[2,[6,"workshop_survey"],[2,[7,"/"],[2,[6,"new_facilitator_post"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /pd/workshop_survey/submit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pd_workshop_survey_submit_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"pd"],[2,[7,"/"],[2,[6,"workshop_survey"],[2,[7,"/"],[2,[6,"submit"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /pd/workshop_survey/submit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pd_workshop_survey_submit_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"pd"],[2,[7,"/"],[2,[6,"workshop_survey"],[2,[7,"/"],[2,[6,"submit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /pd/workshop_survey/thanks(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pd_workshop_survey_thanks_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"pd"],[2,[7,"/"],[2,[6,"workshop_survey"],[2,[7,"/"],[2,[6,"thanks"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /pd/workshop_survey/thanks(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pd_workshop_survey_thanks_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"pd"],[2,[7,"/"],[2,[6,"workshop_survey"],[2,[7,"/"],[2,[6,"thanks"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /pd/workshop_user_management/assign_course(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pd_workshop_user_management_assign_course_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"pd"],[2,[7,"/"],[2,[6,"workshop_user_management"],[2,[7,"/"],[2,[6,"assign_course"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /pd/workshop_user_management/assign_course(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pd_workshop_user_management_assign_course_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"pd"],[2,[7,"/"],[2,[6,"workshop_user_management"],[2,[7,"/"],[2,[6,"assign_course"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /pd/workshop_user_management/remove_course(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pd_workshop_user_management_remove_course_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"pd"],[2,[7,"/"],[2,[6,"workshop_user_management"],[2,[7,"/"],[2,[6,"remove_course"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /pd/workshop_user_management/remove_course(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pd_workshop_user_management_remove_course_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"pd"],[2,[7,"/"],[2,[6,"workshop_user_management"],[2,[7,"/"],[2,[6,"remove_course"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /peer_reviews/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const peer_review_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"peer_reviews"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /peer_reviews/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const peer_review_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"peer_reviews"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /peer_reviews(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const peer_reviews_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"peer_reviews"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /peer_reviews(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const peer_reviews_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"peer_reviews"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /peer_reviews/dashboard(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const peer_reviews_dashboard_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"peer_reviews"],[2,[7,"/"],[2,[6,"dashboard"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /peer_reviews/dashboard(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const peer_reviews_dashboard_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"peer_reviews"],[2,[7,"/"],[2,[6,"dashboard"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /code_reviews/peers_with_open_reviews(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const peers_with_open_reviews_code_reviews_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"code_reviews"],[2,[7,"/"],[2,[6,"peers_with_open_reviews"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /code_reviews/peers_with_open_reviews(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const peers_with_open_reviews_code_reviews_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"code_reviews"],[2,[7,"/"],[2,[6,"peers_with_open_reviews"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/permissions/csv(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const permissions_csv_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"permissions"],[2,[7,"/"],[2,[6,"csv"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/permissions/csv(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const permissions_csv_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"permissions"],[2,[7,"/"],[2,[6,"csv"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/permissions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const permissions_form_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"permissions"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /admin/permissions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const permissions_form_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"permissions"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /p/playlab_k1(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const playlab_k1_p_index_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[6,"playlab_k1"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /p/playlab_k1(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const playlab_k1_p_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[6,"playlab_k1"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /projects/playlab_k1/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const playlab_k1_project_create_new_projects_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"playlab_k1"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/playlab_k1/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const playlab_k1_project_create_new_projects_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"playlab_k1"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/playlab_k1/:channel_id/edit(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const playlab_k1_project_edit_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"playlab_k1"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/playlab_k1/:channel_id/edit(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const playlab_k1_project_edit_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"playlab_k1"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/playlab_k1/:channel_id/export_config(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const playlab_k1_project_export_config_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"playlab_k1"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"export_config"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/playlab_k1/:channel_id/export_config(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const playlab_k1_project_export_config_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"playlab_k1"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"export_config"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/playlab_k1/:channel_id/export_create_channel(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const playlab_k1_project_export_create_channel_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"playlab_k1"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"export_create_channel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/playlab_k1/:channel_id/export_create_channel(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const playlab_k1_project_export_create_channel_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"playlab_k1"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"export_create_channel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/playlab_k1/:channel_id/embed_app_and_code(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const playlab_k1_project_iframe_embed_app_and_code_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"playlab_k1"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"embed_app_and_code"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/playlab_k1/:channel_id/embed_app_and_code(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const playlab_k1_project_iframe_embed_app_and_code_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"playlab_k1"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"embed_app_and_code"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/playlab_k1/:channel_id/embed(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const playlab_k1_project_iframe_embed_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"playlab_k1"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"embed"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/playlab_k1/:channel_id/embed(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const playlab_k1_project_iframe_embed_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"playlab_k1"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"embed"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/playlab_k1(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const playlab_k1_project_projects_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"playlab_k1"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /projects/playlab_k1(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const playlab_k1_project_projects_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"playlab_k1"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /projects/playlab_k1/:channel_id/remix(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const playlab_k1_project_remix_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"playlab_k1"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"remix"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/playlab_k1/:channel_id/remix(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const playlab_k1_project_remix_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"playlab_k1"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"remix"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/playlab_k1/:channel_id(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const playlab_k1_project_share_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"playlab_k1"],[2,[7,"/"],[2,[3,"channel_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/playlab_k1/:channel_id(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const playlab_k1_project_share_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"playlab_k1"],[2,[7,"/"],[2,[3,"channel_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/playlab_k1/:channel_id/view(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const playlab_k1_project_view_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"playlab_k1"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"view"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/playlab_k1/:channel_id/view(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const playlab_k1_project_view_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"playlab_k1"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"view"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /playlab/lang/ar(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const playlab_lang_ar_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"playlab"],[2,[7,"/"],[2,[6,"lang"],[2,[7,"/"],[2,[6,"ar"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /playlab/lang/ar(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const playlab_lang_ar_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"playlab"],[2,[7,"/"],[2,[6,"lang"],[2,[7,"/"],[2,[6,"ar"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /p/playlab(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const playlab_p_index_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[6,"playlab"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /p/playlab(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const playlab_p_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[6,"playlab"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /projects/playlab/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const playlab_project_create_new_projects_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"playlab"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/playlab/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const playlab_project_create_new_projects_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"playlab"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/playlab/:channel_id/edit(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const playlab_project_edit_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"playlab"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/playlab/:channel_id/edit(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const playlab_project_edit_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"playlab"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/playlab/:channel_id/export_config(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const playlab_project_export_config_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"playlab"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"export_config"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/playlab/:channel_id/export_config(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const playlab_project_export_config_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"playlab"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"export_config"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/playlab/:channel_id/export_create_channel(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const playlab_project_export_create_channel_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"playlab"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"export_create_channel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/playlab/:channel_id/export_create_channel(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const playlab_project_export_create_channel_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"playlab"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"export_create_channel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/playlab/:channel_id/embed_app_and_code(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const playlab_project_iframe_embed_app_and_code_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"playlab"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"embed_app_and_code"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/playlab/:channel_id/embed_app_and_code(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const playlab_project_iframe_embed_app_and_code_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"playlab"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"embed_app_and_code"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/playlab/:channel_id/embed(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const playlab_project_iframe_embed_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"playlab"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"embed"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/playlab/:channel_id/embed(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const playlab_project_iframe_embed_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"playlab"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"embed"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/playlab(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const playlab_project_projects_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"playlab"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /projects/playlab(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const playlab_project_projects_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"playlab"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /projects/playlab/:channel_id/remix(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const playlab_project_remix_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"playlab"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"remix"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/playlab/:channel_id/remix(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const playlab_project_remix_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"playlab"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"remix"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/playlab/:channel_id(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const playlab_project_share_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"playlab"],[2,[7,"/"],[2,[3,"channel_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/playlab/:channel_id(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const playlab_project_share_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"playlab"],[2,[7,"/"],[2,[3,"channel_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/playlab/:channel_id/view(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const playlab_project_view_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"playlab"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"view"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/playlab/:channel_id/view(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const playlab_project_view_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"playlab"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"view"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /plc(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const plc_root_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"plc"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /plc(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const plc_root_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"plc"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /plc/user_course_enrollments/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const plc_user_course_enrollment_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"plc"],[2,[7,"/"],[2,[6,"user_course_enrollments"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /plc/user_course_enrollments/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const plc_user_course_enrollment_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"plc"],[2,[7,"/"],[2,[6,"user_course_enrollments"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /plc/user_course_enrollments/manager_view/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const plc_user_course_enrollment_manager_view_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"plc"],[2,[7,"/"],[2,[6,"user_course_enrollments"],[2,[7,"/"],[2,[6,"manager_view"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /plc/user_course_enrollments/manager_view/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const plc_user_course_enrollment_manager_view_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"plc"],[2,[7,"/"],[2,[6,"user_course_enrollments"],[2,[7,"/"],[2,[6,"manager_view"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /plc/user_course_enrollments(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const plc_user_course_enrollments_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"plc"],[2,[7,"/"],[2,[6,"user_course_enrollments"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /plc/user_course_enrollments(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const plc_user_course_enrollments_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"plc"],[2,[7,"/"],[2,[6,"user_course_enrollments"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /plc/user_course_enrollments/group_view(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const plc_user_course_enrollments_group_view_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"plc"],[2,[7,"/"],[2,[6,"user_course_enrollments"],[2,[7,"/"],[2,[6,"group_view"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /plc/user_course_enrollments/group_view(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const plc_user_course_enrollments_group_view_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"plc"],[2,[7,"/"],[2,[6,"user_course_enrollments"],[2,[7,"/"],[2,[6,"group_view"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /p/poetry_hoc(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const poetry_hoc_p_index_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[6,"poetry_hoc"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /p/poetry_hoc(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const poetry_hoc_p_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[6,"poetry_hoc"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /projects/poetry_hoc/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const poetry_hoc_project_create_new_projects_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"poetry_hoc"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/poetry_hoc/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const poetry_hoc_project_create_new_projects_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"poetry_hoc"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/poetry_hoc/:channel_id/edit(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const poetry_hoc_project_edit_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"poetry_hoc"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/poetry_hoc/:channel_id/edit(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const poetry_hoc_project_edit_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"poetry_hoc"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/poetry_hoc/:channel_id/export_config(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const poetry_hoc_project_export_config_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"poetry_hoc"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"export_config"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/poetry_hoc/:channel_id/export_config(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const poetry_hoc_project_export_config_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"poetry_hoc"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"export_config"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/poetry_hoc/:channel_id/export_create_channel(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const poetry_hoc_project_export_create_channel_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"poetry_hoc"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"export_create_channel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/poetry_hoc/:channel_id/export_create_channel(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const poetry_hoc_project_export_create_channel_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"poetry_hoc"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"export_create_channel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/poetry_hoc/:channel_id/embed_app_and_code(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const poetry_hoc_project_iframe_embed_app_and_code_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"poetry_hoc"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"embed_app_and_code"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/poetry_hoc/:channel_id/embed_app_and_code(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const poetry_hoc_project_iframe_embed_app_and_code_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"poetry_hoc"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"embed_app_and_code"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/poetry_hoc/:channel_id/embed(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const poetry_hoc_project_iframe_embed_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"poetry_hoc"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"embed"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/poetry_hoc/:channel_id/embed(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const poetry_hoc_project_iframe_embed_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"poetry_hoc"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"embed"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/poetry_hoc(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const poetry_hoc_project_projects_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"poetry_hoc"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /projects/poetry_hoc(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const poetry_hoc_project_projects_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"poetry_hoc"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /projects/poetry_hoc/:channel_id/remix(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const poetry_hoc_project_remix_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"poetry_hoc"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"remix"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/poetry_hoc/:channel_id/remix(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const poetry_hoc_project_remix_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"poetry_hoc"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"remix"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/poetry_hoc/:channel_id(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const poetry_hoc_project_share_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"poetry_hoc"],[2,[7,"/"],[2,[3,"channel_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/poetry_hoc/:channel_id(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const poetry_hoc_project_share_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"poetry_hoc"],[2,[7,"/"],[2,[3,"channel_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/poetry_hoc/:channel_id/view(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const poetry_hoc_project_view_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"poetry_hoc"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"view"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/poetry_hoc/:channel_id/view(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const poetry_hoc_project_view_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"poetry_hoc"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"view"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /p/poetry(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const poetry_p_index_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[6,"poetry"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /p/poetry(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const poetry_p_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[6,"poetry"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /projects/poetry/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const poetry_project_create_new_projects_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"poetry"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/poetry/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const poetry_project_create_new_projects_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"poetry"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/poetry/:channel_id/edit(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const poetry_project_edit_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"poetry"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/poetry/:channel_id/edit(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const poetry_project_edit_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"poetry"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/poetry/:channel_id/export_config(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const poetry_project_export_config_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"poetry"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"export_config"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/poetry/:channel_id/export_config(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const poetry_project_export_config_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"poetry"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"export_config"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/poetry/:channel_id/export_create_channel(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const poetry_project_export_create_channel_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"poetry"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"export_create_channel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/poetry/:channel_id/export_create_channel(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const poetry_project_export_create_channel_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"poetry"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"export_create_channel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/poetry/:channel_id/embed_app_and_code(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const poetry_project_iframe_embed_app_and_code_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"poetry"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"embed_app_and_code"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/poetry/:channel_id/embed_app_and_code(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const poetry_project_iframe_embed_app_and_code_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"poetry"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"embed_app_and_code"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/poetry/:channel_id/embed(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const poetry_project_iframe_embed_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"poetry"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"embed"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/poetry/:channel_id/embed(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const poetry_project_iframe_embed_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"poetry"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"embed"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/poetry(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const poetry_project_projects_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"poetry"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /projects/poetry(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const poetry_project_projects_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"poetry"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /projects/poetry/:channel_id/remix(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const poetry_project_remix_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"poetry"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"remix"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/poetry/:channel_id/remix(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const poetry_project_remix_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"poetry"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"remix"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/poetry/:channel_id(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const poetry_project_share_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"poetry"],[2,[7,"/"],[2,[3,"channel_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/poetry/:channel_id(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const poetry_project_share_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"poetry"],[2,[7,"/"],[2,[3,"channel_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/poetry/:channel_id/view(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const poetry_project_view_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"poetry"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"view"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/poetry/:channel_id/view(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const poetry_project_view_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"poetry"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"view"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /policy_compliance/child_account_consent(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const policy_compliance_child_account_consent_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"policy_compliance"],[2,[7,"/"],[2,[6,"child_account_consent"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /policy_compliance/child_account_consent(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const policy_compliance_child_account_consent_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"policy_compliance"],[2,[7,"/"],[2,[6,"child_account_consent"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /policy_compliance/pending_permission_request(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const policy_compliance_pending_permission_request_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"policy_compliance"],[2,[7,"/"],[2,[6,"pending_permission_request"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /policy_compliance/pending_permission_request(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const policy_compliance_pending_permission_request_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"policy_compliance"],[2,[7,"/"],[2,[6,"pending_permission_request"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /pools(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pools_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"pools"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /pools(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pools_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"pools"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /datablock_storage/:channel_id/populate_key_values(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const populate_key_values_datablock_storage_index_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"datablock_storage"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"populate_key_values"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /datablock_storage/:channel_id/populate_key_values(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const populate_key_values_datablock_storage_index_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"datablock_storage"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"populate_key_values"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /datablock_storage/:channel_id/populate_tables(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const populate_tables_datablock_storage_index_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"datablock_storage"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"populate_tables"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /datablock_storage/:channel_id/populate_tables(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const populate_tables_datablock_storage_index_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"datablock_storage"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"populate_tables"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/pd/workshops/:id/potential_organizers(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const potential_organizers_api_v1_pd_workshop_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"pd"],[2,[7,"/"],[2,[6,"workshops"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"potential_organizers"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/v1/pd/workshops/:id/potential_organizers(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const potential_organizers_api_v1_pd_workshop_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"pd"],[2,[7,"/"],[2,[6,"workshops"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"potential_organizers"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /potential_teachers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const potential_teachers_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"potential_teachers"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /potential_teachers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const potential_teachers_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"potential_teachers"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /practice_problems/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const practice_problem_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"practice_problems"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /practice_problems/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const practice_problem_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"practice_problems"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /practice_problems(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const practice_problems_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"practice_problems"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /practice_problems(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const practice_problems_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"practice_problems"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /api/v1/sections/demo/presets(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const presets_api_v1_sections_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"sections"],[2,[7,"/"],[2,[6,"demo"],[2,[7,"/"],[2,[6,"presets"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/v1/sections/demo/presets(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const presets_api_v1_sections_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"sections"],[2,[7,"/"],[2,[6,"demo"],[2,[7,"/"],[2,[6,"presets"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /dashboardapi/sections/demo/presets(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const presets_sections_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dashboardapi"],[2,[7,"/"],[2,[6,"sections"],[2,[7,"/"],[2,[6,"demo"],[2,[7,"/"],[2,[6,"presets"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /dashboardapi/sections/demo/presets(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const presets_sections_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dashboardapi"],[2,[7,"/"],[2,[6,"sections"],[2,[7,"/"],[2,[6,"demo"],[2,[7,"/"],[2,[6,"presets"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /print_certificates/:encoded_params(.:format)
 * @param {any} encoded_params
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const print_certificate_url = /*#__PURE__*/ __jsr.r({"encoded_params":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"print_certificates"],[2,[7,"/"],[2,[3,"encoded_params"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /print_certificates/:encoded_params(.:format)
 * @param {any} encoded_params
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const print_certificate_path = /*#__PURE__*/ __jsr.r({"encoded_params":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"print_certificates"],[2,[7,"/"],[2,[3,"encoded_params"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /profanity/find(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const profanity_find_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"profanity"],[2,[7,"/"],[2,[6,"find"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /profanity/find(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const profanity_find_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"profanity"],[2,[7,"/"],[2,[6,"find"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /my-professional-learning(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const professional_learning_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"my-professional-learning"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /my-professional-learning(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const professional_learning_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"my-professional-learning"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /professional-learning/contact-regional-partner(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const professional_learning_contact_regional_partner_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"professional-learning"],[2,[7,"/"],[2,[6,"contact-regional-partner"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /professional-learning/contact-regional-partner(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const professional_learning_contact_regional_partner_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"professional-learning"],[2,[7,"/"],[2,[6,"contact-regional-partner"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /professional-learning/courses(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const professional_learning_courses_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"professional-learning"],[2,[7,"/"],[2,[6,"courses"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /professional-learning/courses(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const professional_learning_courses_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"professional-learning"],[2,[7,"/"],[2,[6,"courses"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /professional-learning/facilitator/ai-fundamentals(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const professional_learning_facilitator_ai_fundamentals_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"professional-learning"],[2,[7,"/"],[2,[6,"facilitator"],[2,[7,"/"],[2,[6,"ai-fundamentals"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /professional-learning/facilitator/ai-fundamentals(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const professional_learning_facilitator_ai_fundamentals_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"professional-learning"],[2,[7,"/"],[2,[6,"facilitator"],[2,[7,"/"],[2,[6,"ai-fundamentals"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /professional-learning/facilitator/computer-science-a(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const professional_learning_facilitator_computer_science_a_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"professional-learning"],[2,[7,"/"],[2,[6,"facilitator"],[2,[7,"/"],[2,[6,"computer-science-a"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /professional-learning/facilitator/computer-science-a(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const professional_learning_facilitator_computer_science_a_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"professional-learning"],[2,[7,"/"],[2,[6,"facilitator"],[2,[7,"/"],[2,[6,"computer-science-a"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /professional-learning/facilitator/computer-science-discoveries(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const professional_learning_facilitator_computer_science_discoveries_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"professional-learning"],[2,[7,"/"],[2,[6,"facilitator"],[2,[7,"/"],[2,[6,"computer-science-discoveries"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /professional-learning/facilitator/computer-science-discoveries(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const professional_learning_facilitator_computer_science_discoveries_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"professional-learning"],[2,[7,"/"],[2,[6,"facilitator"],[2,[7,"/"],[2,[6,"computer-science-discoveries"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /professional-learning/facilitator/computer-science-fundamentals(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const professional_learning_facilitator_computer_science_fundamentals_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"professional-learning"],[2,[7,"/"],[2,[6,"facilitator"],[2,[7,"/"],[2,[6,"computer-science-fundamentals"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /professional-learning/facilitator/computer-science-fundamentals(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const professional_learning_facilitator_computer_science_fundamentals_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"professional-learning"],[2,[7,"/"],[2,[6,"facilitator"],[2,[7,"/"],[2,[6,"computer-science-fundamentals"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /professional-learning/facilitator/computer-science-principles(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const professional_learning_facilitator_computer_science_principles_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"professional-learning"],[2,[7,"/"],[2,[6,"facilitator"],[2,[7,"/"],[2,[6,"computer-science-principles"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /professional-learning/facilitator/computer-science-principles(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const professional_learning_facilitator_computer_science_principles_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"professional-learning"],[2,[7,"/"],[2,[6,"facilitator"],[2,[7,"/"],[2,[6,"computer-science-principles"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /professional-learning/regional-partner/playbook(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const professional_learning_regional_partner_playbook_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"professional-learning"],[2,[7,"/"],[2,[6,"regional-partner"],[2,[7,"/"],[2,[6,"playbook"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /professional-learning/regional-partner/playbook(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const professional_learning_regional_partner_playbook_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"professional-learning"],[2,[7,"/"],[2,[6,"regional-partner"],[2,[7,"/"],[2,[6,"playbook"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /professional-learning/workshops(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const professional_learning_workshops_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"professional-learning"],[2,[7,"/"],[2,[6,"workshops"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /professional-learning/workshops(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const professional_learning_workshops_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"professional-learning"],[2,[7,"/"],[2,[6,"workshops"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /professional-learning/workshops_as_facilitator_for_pl_page(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const professional_learning_workshops_as_facilitator_for_pl_page_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"professional-learning"],[2,[7,"/"],[2,[6,"workshops_as_facilitator_for_pl_page"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /professional-learning/workshops_as_facilitator_for_pl_page(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const professional_learning_workshops_as_facilitator_for_pl_page_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"professional-learning"],[2,[7,"/"],[2,[6,"workshops_as_facilitator_for_pl_page"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /professional-learning/workshops_as_organizer_for_pl_page(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const professional_learning_workshops_as_organizer_for_pl_page_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"professional-learning"],[2,[7,"/"],[2,[6,"workshops_as_organizer_for_pl_page"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /professional-learning/workshops_as_organizer_for_pl_page(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const professional_learning_workshops_as_organizer_for_pl_page_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"professional-learning"],[2,[7,"/"],[2,[6,"workshops_as_organizer_for_pl_page"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /professional-learning/workshops_as_program_manager_for_pl_page(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const professional_learning_workshops_as_program_manager_for_pl_page_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"professional-learning"],[2,[7,"/"],[2,[6,"workshops_as_program_manager_for_pl_page"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /professional-learning/workshops_as_program_manager_for_pl_page(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const professional_learning_workshops_as_program_manager_for_pl_page_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"professional-learning"],[2,[7,"/"],[2,[6,"workshops_as_program_manager_for_pl_page"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /programming_classes/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const programming_class_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"programming_classes"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /programming_classes/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const programming_class_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"programming_classes"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /programming_classes(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const programming_classes_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"programming_classes"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /programming_classes(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const programming_classes_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"programming_classes"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /docs/ide/:name(.:format)
 * @param {any} name
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const programming_environment_url = /*#__PURE__*/ __jsr.r({"name":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"docs"],[2,[7,"/"],[2,[6,"ide"],[2,[7,"/"],[2,[3,"name"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /docs/ide/:name(.:format)
 * @param {any} name
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const programming_environment_path = /*#__PURE__*/ __jsr.r({"name":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"docs"],[2,[7,"/"],[2,[6,"ide"],[2,[7,"/"],[2,[3,"name"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /docs/ide/:programming_environment_name/classes/:programming_class_key(.:format)
 * @param {any} programming_environment_name
 * @param {any} programming_class_key
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const programming_environment_programming_class_url = /*#__PURE__*/ __jsr.r({"programming_environment_name":{"r":true},"programming_class_key":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"docs"],[2,[7,"/"],[2,[6,"ide"],[2,[7,"/"],[2,[3,"programming_environment_name"],[2,[7,"/"],[2,[6,"classes"],[2,[7,"/"],[2,[3,"programming_class_key"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /docs/ide/:programming_environment_name/classes/:programming_class_key(.:format)
 * @param {any} programming_environment_name
 * @param {any} programming_class_key
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const programming_environment_programming_class_path = /*#__PURE__*/ __jsr.r({"programming_environment_name":{"r":true},"programming_class_key":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"docs"],[2,[7,"/"],[2,[6,"ide"],[2,[7,"/"],[2,[3,"programming_environment_name"],[2,[7,"/"],[2,[6,"classes"],[2,[7,"/"],[2,[3,"programming_class_key"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /docs/ide/:programming_environment_name/classes(.:format)
 * @param {any} programming_environment_name
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const programming_environment_programming_classes_url = /*#__PURE__*/ __jsr.r({"programming_environment_name":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"docs"],[2,[7,"/"],[2,[6,"ide"],[2,[7,"/"],[2,[3,"programming_environment_name"],[2,[7,"/"],[2,[6,"classes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /docs/ide/:programming_environment_name/classes(.:format)
 * @param {any} programming_environment_name
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const programming_environment_programming_classes_path = /*#__PURE__*/ __jsr.r({"programming_environment_name":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"docs"],[2,[7,"/"],[2,[6,"ide"],[2,[7,"/"],[2,[3,"programming_environment_name"],[2,[7,"/"],[2,[6,"classes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /docs/ide/:programming_environment_name/expressions/:programming_expression_key(.:format)
 * @param {any} programming_environment_name
 * @param {any} programming_expression_key
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const programming_environment_programming_expression_url = /*#__PURE__*/ __jsr.r({"programming_environment_name":{"r":true},"programming_expression_key":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"docs"],[2,[7,"/"],[2,[6,"ide"],[2,[7,"/"],[2,[3,"programming_environment_name"],[2,[7,"/"],[2,[6,"expressions"],[2,[7,"/"],[2,[3,"programming_expression_key"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /docs/ide/:programming_environment_name/expressions/:programming_expression_key(.:format)
 * @param {any} programming_environment_name
 * @param {any} programming_expression_key
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const programming_environment_programming_expression_path = /*#__PURE__*/ __jsr.r({"programming_environment_name":{"r":true},"programming_expression_key":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"docs"],[2,[7,"/"],[2,[6,"ide"],[2,[7,"/"],[2,[3,"programming_environment_name"],[2,[7,"/"],[2,[6,"expressions"],[2,[7,"/"],[2,[3,"programming_expression_key"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /docs/ide/:programming_environment_name/expressions(.:format)
 * @param {any} programming_environment_name
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const programming_environment_programming_expressions_url = /*#__PURE__*/ __jsr.r({"programming_environment_name":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"docs"],[2,[7,"/"],[2,[6,"ide"],[2,[7,"/"],[2,[3,"programming_environment_name"],[2,[7,"/"],[2,[6,"expressions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /docs/ide/:programming_environment_name/expressions(.:format)
 * @param {any} programming_environment_name
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const programming_environment_programming_expressions_path = /*#__PURE__*/ __jsr.r({"programming_environment_name":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"docs"],[2,[7,"/"],[2,[6,"ide"],[2,[7,"/"],[2,[3,"programming_environment_name"],[2,[7,"/"],[2,[6,"expressions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /docs/ide(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const programming_environments_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"docs"],[2,[7,"/"],[2,[6,"ide"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /docs/ide(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const programming_environments_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"docs"],[2,[7,"/"],[2,[6,"ide"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /programming_expressions/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const programming_expression_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"programming_expressions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /programming_expressions/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const programming_expression_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"programming_expressions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /programming_expressions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const programming_expressions_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"programming_expressions"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /programming_expressions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const programming_expressions_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"programming_expressions"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /programming_methods/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const programming_method_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"programming_methods"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /programming_methods/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const programming_method_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"programming_methods"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /project_commits(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_commits_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"project_commits"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /project_commits(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_commits_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"project_commits"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /project_commits/get_token(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_commits_get_token_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"project_commits"],[2,[7,"/"],[2,[6,"get_token"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /project_commits/get_token(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_commits_get_token_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"project_commits"],[2,[7,"/"],[2,[6,"get_token"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /datablock_storage/:channel_id/project_has_data(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_has_data_datablock_storage_index_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"datablock_storage"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"project_has_data"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /datablock_storage/:channel_id/project_has_data(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_has_data_datablock_storage_index_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"datablock_storage"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"project_has_data"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /projectbeats(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectbeats_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projectbeats"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /projectbeats(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectbeats_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projectbeats"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /projects(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projects_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /projects(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projects_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /projects/featured(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projects_featured_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"featured"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /projects/featured(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projects_featured_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"featured"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /foorm/forms/:id/publish(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const publish_foorm_form_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"foorm"],[2,[7,"/"],[2,[6,"forms"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"publish"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /foorm/forms/:id/publish(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const publish_foorm_form_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"foorm"],[2,[7,"/"],[2,[6,"forms"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"publish"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /foorm/library_questions/:id/published_forms_appeared_in(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const published_forms_appeared_in_foorm_library_question_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"foorm"],[2,[7,"/"],[2,[6,"library_questions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"published_forms_appeared_in"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /foorm/library_questions/:id/published_forms_appeared_in(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const published_forms_appeared_in_foorm_library_question_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"foorm"],[2,[7,"/"],[2,[6,"library_questions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"published_forms_appeared_in"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /courses/:course_course_name/units/:unit_position/lessons/:lesson_position/levels/:id/page/:puzzle_page
 * @param {any} course_course_name
 * @param {any} unit_position
 * @param {any} lesson_position
 * @param {any} id
 * @param {any} puzzle_page
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const puzzle_page_course_unit_lesson_script_level_url = /*#__PURE__*/ __jsr.r({"course_course_name":{"r":true},"unit_position":{"r":true},"lesson_position":{"r":true},"id":{"r":true},"puzzle_page":{"r":true}}, [2,[7,"/"],[2,[6,"courses"],[2,[7,"/"],[2,[3,"course_course_name"],[2,[7,"/"],[2,[6,"units"],[2,[7,"/"],[2,[3,"unit_position"],[2,[7,"/"],[2,[6,"lessons"],[2,[7,"/"],[2,[3,"lesson_position"],[2,[7,"/"],[2,[6,"levels"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"page"],[2,[7,"/"],[3,"puzzle_page"]]]]]]]]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /courses/:course_course_name/units/:unit_position/lessons/:lesson_position/levels/:id/page/:puzzle_page
 * @param {any} course_course_name
 * @param {any} unit_position
 * @param {any} lesson_position
 * @param {any} id
 * @param {any} puzzle_page
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const puzzle_page_course_unit_lesson_script_level_path = /*#__PURE__*/ __jsr.r({"course_course_name":{"r":true},"unit_position":{"r":true},"lesson_position":{"r":true},"id":{"r":true},"puzzle_page":{"r":true}}, [2,[7,"/"],[2,[6,"courses"],[2,[7,"/"],[2,[3,"course_course_name"],[2,[7,"/"],[2,[6,"units"],[2,[7,"/"],[2,[3,"unit_position"],[2,[7,"/"],[2,[6,"lessons"],[2,[7,"/"],[2,[3,"lesson_position"],[2,[7,"/"],[2,[6,"levels"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"page"],[2,[7,"/"],[3,"puzzle_page"]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /courses/:course_course_name/units/:unit_position/lockable/:lockable_lesson_position/levels/:id/page/:puzzle_page
 * @param {any} course_course_name
 * @param {any} unit_position
 * @param {any} lockable_lesson_position
 * @param {any} id
 * @param {any} puzzle_page
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const puzzle_page_course_unit_lockable_lesson_script_level_url = /*#__PURE__*/ __jsr.r({"course_course_name":{"r":true},"unit_position":{"r":true},"lockable_lesson_position":{"r":true},"id":{"r":true},"puzzle_page":{"r":true}}, [2,[7,"/"],[2,[6,"courses"],[2,[7,"/"],[2,[3,"course_course_name"],[2,[7,"/"],[2,[6,"units"],[2,[7,"/"],[2,[3,"unit_position"],[2,[7,"/"],[2,[6,"lockable"],[2,[7,"/"],[2,[3,"lockable_lesson_position"],[2,[7,"/"],[2,[6,"levels"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"page"],[2,[7,"/"],[3,"puzzle_page"]]]]]]]]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /courses/:course_course_name/units/:unit_position/lockable/:lockable_lesson_position/levels/:id/page/:puzzle_page
 * @param {any} course_course_name
 * @param {any} unit_position
 * @param {any} lockable_lesson_position
 * @param {any} id
 * @param {any} puzzle_page
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const puzzle_page_course_unit_lockable_lesson_script_level_path = /*#__PURE__*/ __jsr.r({"course_course_name":{"r":true},"unit_position":{"r":true},"lockable_lesson_position":{"r":true},"id":{"r":true},"puzzle_page":{"r":true}}, [2,[7,"/"],[2,[6,"courses"],[2,[7,"/"],[2,[3,"course_course_name"],[2,[7,"/"],[2,[6,"units"],[2,[7,"/"],[2,[3,"unit_position"],[2,[7,"/"],[2,[6,"lockable"],[2,[7,"/"],[2,[3,"lockable_lesson_position"],[2,[7,"/"],[2,[6,"levels"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"page"],[2,[7,"/"],[3,"puzzle_page"]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /s/:script_id/lessons/:lesson_position/levels/:id/page/:puzzle_page
 * @param {any} script_id
 * @param {any} lesson_position
 * @param {any} id
 * @param {any} puzzle_page
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const puzzle_page_script_lesson_script_level_url = /*#__PURE__*/ __jsr.r({"script_id":{"r":true},"lesson_position":{"r":true},"id":{"r":true},"puzzle_page":{"r":true}}, [2,[7,"/"],[2,[6,"s"],[2,[7,"/"],[2,[3,"script_id"],[2,[7,"/"],[2,[6,"lessons"],[2,[7,"/"],[2,[3,"lesson_position"],[2,[7,"/"],[2,[6,"levels"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"page"],[2,[7,"/"],[3,"puzzle_page"]]]]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /s/:script_id/lessons/:lesson_position/levels/:id/page/:puzzle_page
 * @param {any} script_id
 * @param {any} lesson_position
 * @param {any} id
 * @param {any} puzzle_page
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const puzzle_page_script_lesson_script_level_path = /*#__PURE__*/ __jsr.r({"script_id":{"r":true},"lesson_position":{"r":true},"id":{"r":true},"puzzle_page":{"r":true}}, [2,[7,"/"],[2,[6,"s"],[2,[7,"/"],[2,[3,"script_id"],[2,[7,"/"],[2,[6,"lessons"],[2,[7,"/"],[2,[3,"lesson_position"],[2,[7,"/"],[2,[6,"levels"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"page"],[2,[7,"/"],[3,"puzzle_page"]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /s/:script_id/lockable/:lockable_lesson_position/levels/:id/page/:puzzle_page
 * @param {any} script_id
 * @param {any} lockable_lesson_position
 * @param {any} id
 * @param {any} puzzle_page
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const puzzle_page_script_lockable_lesson_script_level_url = /*#__PURE__*/ __jsr.r({"script_id":{"r":true},"lockable_lesson_position":{"r":true},"id":{"r":true},"puzzle_page":{"r":true}}, [2,[7,"/"],[2,[6,"s"],[2,[7,"/"],[2,[3,"script_id"],[2,[7,"/"],[2,[6,"lockable"],[2,[7,"/"],[2,[3,"lockable_lesson_position"],[2,[7,"/"],[2,[6,"levels"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"page"],[2,[7,"/"],[3,"puzzle_page"]]]]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /s/:script_id/lockable/:lockable_lesson_position/levels/:id/page/:puzzle_page
 * @param {any} script_id
 * @param {any} lockable_lesson_position
 * @param {any} id
 * @param {any} puzzle_page
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const puzzle_page_script_lockable_lesson_script_level_path = /*#__PURE__*/ __jsr.r({"script_id":{"r":true},"lockable_lesson_position":{"r":true},"id":{"r":true},"puzzle_page":{"r":true}}, [2,[7,"/"],[2,[6,"s"],[2,[7,"/"],[2,[3,"script_id"],[2,[7,"/"],[2,[6,"lockable"],[2,[7,"/"],[2,[3,"lockable_lesson_position"],[2,[7,"/"],[2,[6,"levels"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"page"],[2,[7,"/"],[3,"puzzle_page"]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /puzzle_ratings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const puzzle_ratings_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"puzzle_ratings"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /puzzle_ratings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const puzzle_ratings_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"puzzle_ratings"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /p/pythonlab(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pythonlab_p_index_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[6,"pythonlab"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /p/pythonlab(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pythonlab_p_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[6,"pythonlab"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /projects/pythonlab/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pythonlab_project_create_new_projects_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"pythonlab"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/pythonlab/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pythonlab_project_create_new_projects_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"pythonlab"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/pythonlab/:channel_id/edit(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pythonlab_project_edit_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"pythonlab"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/pythonlab/:channel_id/edit(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pythonlab_project_edit_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"pythonlab"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/pythonlab/:channel_id/export_config(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pythonlab_project_export_config_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"pythonlab"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"export_config"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/pythonlab/:channel_id/export_config(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pythonlab_project_export_config_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"pythonlab"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"export_config"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/pythonlab/:channel_id/export_create_channel(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pythonlab_project_export_create_channel_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"pythonlab"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"export_create_channel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/pythonlab/:channel_id/export_create_channel(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pythonlab_project_export_create_channel_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"pythonlab"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"export_create_channel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/pythonlab/:channel_id/embed_app_and_code(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pythonlab_project_iframe_embed_app_and_code_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"pythonlab"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"embed_app_and_code"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/pythonlab/:channel_id/embed_app_and_code(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pythonlab_project_iframe_embed_app_and_code_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"pythonlab"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"embed_app_and_code"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/pythonlab/:channel_id/embed(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pythonlab_project_iframe_embed_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"pythonlab"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"embed"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/pythonlab/:channel_id/embed(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pythonlab_project_iframe_embed_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"pythonlab"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"embed"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/pythonlab(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pythonlab_project_projects_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"pythonlab"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /projects/pythonlab(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pythonlab_project_projects_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"pythonlab"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /projects/pythonlab/:channel_id/remix(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pythonlab_project_remix_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"pythonlab"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"remix"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/pythonlab/:channel_id/remix(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pythonlab_project_remix_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"pythonlab"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"remix"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/pythonlab/:channel_id(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pythonlab_project_share_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"pythonlab"],[2,[7,"/"],[2,[3,"channel_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/pythonlab/:channel_id(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pythonlab_project_share_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"pythonlab"],[2,[7,"/"],[2,[3,"channel_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/pythonlab/:channel_id/view(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pythonlab_project_view_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"pythonlab"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"view"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/pythonlab/:channel_id/view(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pythonlab_project_view_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"pythonlab"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"view"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /foorm/libraries/:id/question_names(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const question_names_foorm_library_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"foorm"],[2,[7,"/"],[2,[6,"libraries"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"question_names"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /foorm/libraries/:id/question_names(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const question_names_foorm_library_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"foorm"],[2,[7,"/"],[2,[6,"libraries"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"question_names"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /course_offerings/quick_assign_course_offerings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const quick_assign_course_offerings_course_offerings_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"course_offerings"],[2,[7,"/"],[2,[6,"quick_assign_course_offerings"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /course_offerings/quick_assign_course_offerings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const quick_assign_course_offerings_course_offerings_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"course_offerings"],[2,[7,"/"],[2,[6,"quick_assign_course_offerings"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/pd/applications/quick_view(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const quick_view_api_v1_pd_applications_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"pd"],[2,[7,"/"],[2,[6,"applications"],[2,[7,"/"],[2,[6,"quick_view"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/v1/pd/applications/quick_view(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const quick_view_api_v1_pd_applications_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"pd"],[2,[7,"/"],[2,[6,"applications"],[2,[7,"/"],[2,[6,"quick_view"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /quiz_attempts/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const quiz_attempt_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"quiz_attempts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /quiz_attempts/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const quiz_attempt_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"quiz_attempts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /quiz_attempts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const quiz_attempts_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"quiz_attempts"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /quiz_attempts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const quiz_attempts_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"quiz_attempts"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /quiz_questions/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const quiz_question_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"quiz_questions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /quiz_questions/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const quiz_question_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"quiz_questions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /quiz_question_responses(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const quiz_question_responses_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"quiz_question_responses"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /quiz_question_responses(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const quiz_question_responses_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"quiz_question_responses"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /quiz_questions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const quiz_questions_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"quiz_questions"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /quiz_questions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const quiz_questions_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"quiz_questions"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/representations/redirect/:signed_blob_id/:variation_key/*filename(.:format)
 * @param {any} signed_blob_id
 * @param {any} variation_key
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_blob_representation_url = /*#__PURE__*/ __jsr.r({"signed_blob_id":{"r":true},"variation_key":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"representations"],[2,[7,"/"],[2,[6,"redirect"],[2,[7,"/"],[2,[3,"signed_blob_id"],[2,[7,"/"],[2,[3,"variation_key"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /rails/active_storage/representations/redirect/:signed_blob_id/:variation_key/*filename(.:format)
 * @param {any} signed_blob_id
 * @param {any} variation_key
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_blob_representation_path = /*#__PURE__*/ __jsr.r({"signed_blob_id":{"r":true},"variation_key":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"representations"],[2,[7,"/"],[2,[6,"redirect"],[2,[7,"/"],[2,[3,"signed_blob_id"],[2,[7,"/"],[2,[3,"variation_key"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/representations/proxy/:signed_blob_id/:variation_key/*filename(.:format)
 * @param {any} signed_blob_id
 * @param {any} variation_key
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_blob_representation_proxy_url = /*#__PURE__*/ __jsr.r({"signed_blob_id":{"r":true},"variation_key":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"representations"],[2,[7,"/"],[2,[6,"proxy"],[2,[7,"/"],[2,[3,"signed_blob_id"],[2,[7,"/"],[2,[3,"variation_key"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /rails/active_storage/representations/proxy/:signed_blob_id/:variation_key/*filename(.:format)
 * @param {any} signed_blob_id
 * @param {any} variation_key
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_blob_representation_proxy_path = /*#__PURE__*/ __jsr.r({"signed_blob_id":{"r":true},"variation_key":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"representations"],[2,[7,"/"],[2,[6,"proxy"],[2,[7,"/"],[2,[3,"signed_blob_id"],[2,[7,"/"],[2,[3,"variation_key"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/inbound_emails/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_conductor_inbound_email_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/inbound_emails/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_conductor_inbound_email_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/:inbound_email_id/incinerate(.:format)
 * @param {any} inbound_email_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_conductor_inbound_email_incinerate_url = /*#__PURE__*/ __jsr.r({"inbound_email_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[3,"inbound_email_id"],[2,[7,"/"],[2,[6,"incinerate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/:inbound_email_id/incinerate(.:format)
 * @param {any} inbound_email_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_conductor_inbound_email_incinerate_path = /*#__PURE__*/ __jsr.r({"inbound_email_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[3,"inbound_email_id"],[2,[7,"/"],[2,[6,"incinerate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/:inbound_email_id/reroute(.:format)
 * @param {any} inbound_email_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_conductor_inbound_email_reroute_url = /*#__PURE__*/ __jsr.r({"inbound_email_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[3,"inbound_email_id"],[2,[7,"/"],[2,[6,"reroute"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/:inbound_email_id/reroute(.:format)
 * @param {any} inbound_email_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_conductor_inbound_email_reroute_path = /*#__PURE__*/ __jsr.r({"inbound_email_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[3,"inbound_email_id"],[2,[7,"/"],[2,[6,"reroute"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/inbound_emails/sources(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_conductor_inbound_email_sources_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[6,"sources"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/inbound_emails/sources(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_conductor_inbound_email_sources_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[6,"sources"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_conductor_inbound_emails_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_conductor_inbound_emails_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/direct_uploads(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_direct_uploads_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"direct_uploads"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /rails/active_storage/direct_uploads(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_direct_uploads_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"direct_uploads"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/disk/:encoded_key/*filename(.:format)
 * @param {any} encoded_key
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_disk_service_url = /*#__PURE__*/ __jsr.r({"encoded_key":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"disk"],[2,[7,"/"],[2,[3,"encoded_key"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /rails/active_storage/disk/:encoded_key/*filename(.:format)
 * @param {any} encoded_key
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_disk_service_path = /*#__PURE__*/ __jsr.r({"encoded_key":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"disk"],[2,[7,"/"],[2,[3,"encoded_key"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/mailers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_mailers_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"mailers"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /rails/mailers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_mailers_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"mailers"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /rails/action_mailbox/mailgun/inbound_emails/mime(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_mailgun_inbound_emails_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"mailgun"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[6,"mime"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /rails/action_mailbox/mailgun/inbound_emails/mime(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_mailgun_inbound_emails_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"mailgun"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[6,"mime"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/action_mailbox/mandrill/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_mandrill_inbound_emails_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"mandrill"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /rails/action_mailbox/mandrill/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_mandrill_inbound_emails_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"mandrill"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/action_mailbox/mandrill/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_mandrill_inbound_health_check_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"mandrill"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /rails/action_mailbox/mandrill/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_mandrill_inbound_health_check_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"mandrill"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/action_mailbox/postmark/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_postmark_inbound_emails_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"postmark"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /rails/action_mailbox/postmark/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_postmark_inbound_emails_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"postmark"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/action_mailbox/relay/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_relay_inbound_emails_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"relay"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /rails/action_mailbox/relay/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_relay_inbound_emails_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"relay"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/action_mailbox/sendgrid/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_sendgrid_inbound_emails_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"sendgrid"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /rails/action_mailbox/sendgrid/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_sendgrid_inbound_emails_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"sendgrid"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/blobs/redirect/:signed_id/*filename(.:format)
 * @param {any} signed_id
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_service_blob_url = /*#__PURE__*/ __jsr.r({"signed_id":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"blobs"],[2,[7,"/"],[2,[6,"redirect"],[2,[7,"/"],[2,[3,"signed_id"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /rails/active_storage/blobs/redirect/:signed_id/*filename(.:format)
 * @param {any} signed_id
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_service_blob_path = /*#__PURE__*/ __jsr.r({"signed_id":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"blobs"],[2,[7,"/"],[2,[6,"redirect"],[2,[7,"/"],[2,[3,"signed_id"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/blobs/proxy/:signed_id/*filename(.:format)
 * @param {any} signed_id
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_service_blob_proxy_url = /*#__PURE__*/ __jsr.r({"signed_id":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"blobs"],[2,[7,"/"],[2,[6,"proxy"],[2,[7,"/"],[2,[3,"signed_id"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /rails/active_storage/blobs/proxy/:signed_id/*filename(.:format)
 * @param {any} signed_id
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_service_blob_proxy_path = /*#__PURE__*/ __jsr.r({"signed_id":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"blobs"],[2,[7,"/"],[2,[6,"proxy"],[2,[7,"/"],[2,[3,"signed_id"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /datablock_storage/:channel_id/read_records(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const read_records_datablock_storage_index_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"datablock_storage"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"read_records"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /datablock_storage/:channel_id/read_records(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const read_records_datablock_storage_index_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"datablock_storage"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"read_records"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /redirected_url
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const redirected_url_url = /*#__PURE__*/ __jsr.r({}, [2,[7,"/"],[6,"redirected_url"]], true);

/**
 * Generates rails route to
 * /redirected_url
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const redirected_url_path = /*#__PURE__*/ __jsr.r({}, [2,[7,"/"],[6,"redirected_url"]]);

/**
 * Generates rails route to
 * /regional_partners/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const regional_partner_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"regional_partners"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /regional_partners/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const regional_partner_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"regional_partners"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /regional-partner-search(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const regional_partner_search_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"regional-partner-search"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /regional-partner-search(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const regional_partner_search_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"regional-partner-search"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /regional_partners(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const regional_partners_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"regional_partners"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /regional_partners(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const regional_partners_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"regional_partners"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /sprites/release_default_sprites_to_production(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const release_default_sprites_to_production_sprites_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"sprites"],[2,[7,"/"],[2,[6,"release_default_sprites_to_production"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /sprites/release_default_sprites_to_production(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const release_default_sprites_to_production_sprites_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"sprites"],[2,[7,"/"],[2,[6,"release_default_sprites_to_production"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/sections/:section_id/students/:id/remove(.:format)
 * @param {any} section_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const remove_api_v1_section_student_url = /*#__PURE__*/ __jsr.r({"section_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"sections"],[2,[7,"/"],[2,[3,"section_id"],[2,[7,"/"],[2,[6,"students"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"remove"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/v1/sections/:section_id/students/:id/remove(.:format)
 * @param {any} section_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const remove_api_v1_section_student_path = /*#__PURE__*/ __jsr.r({"section_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"sections"],[2,[7,"/"],[2,[3,"section_id"],[2,[7,"/"],[2,[6,"students"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"remove"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/pilots/remove_from_pilot(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const remove_from_pilot_admin_pilots_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"pilots"],[2,[7,"/"],[2,[6,"remove_from_pilot"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/pilots/remove_from_pilot(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const remove_from_pilot_admin_pilots_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"pilots"],[2,[7,"/"],[2,[6,"remove_from_pilot"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /dashboardapi/sections/:section_id/students/:id/remove(.:format)
 * @param {any} section_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const remove_section_student_url = /*#__PURE__*/ __jsr.r({"section_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"dashboardapi"],[2,[7,"/"],[2,[6,"sections"],[2,[7,"/"],[2,[3,"section_id"],[2,[7,"/"],[2,[6,"students"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"remove"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /dashboardapi/sections/:section_id/students/:id/remove(.:format)
 * @param {any} section_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const remove_section_student_path = /*#__PURE__*/ __jsr.r({"section_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"dashboardapi"],[2,[7,"/"],[2,[6,"sections"],[2,[7,"/"],[2,[3,"section_id"],[2,[7,"/"],[2,[6,"students"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"remove"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /levels/:id/remove_skill(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const remove_skill_level_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"levels"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"remove_skill"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /levels/:id/remove_skill(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const remove_skill_level_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"levels"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"remove_skill"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/invitation/remove(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const remove_user_invitation_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"invitation"],[2,[7,"/"],[2,[6,"remove"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /users/invitation/remove(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const remove_user_invitation_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"invitation"],[2,[7,"/"],[2,[6,"remove"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /datablock_storage/:channel_id/rename_column(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rename_column_datablock_storage_index_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"datablock_storage"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"rename_column"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /datablock_storage/:channel_id/rename_column(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rename_column_datablock_storage_index_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"datablock_storage"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"rename_column"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/pd/workshops/:id/reopen(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reopen_api_v1_pd_workshop_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"pd"],[2,[7,"/"],[2,[6,"workshops"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"reopen"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/v1/pd/workshops/:id/reopen(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reopen_api_v1_pd_workshop_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"pd"],[2,[7,"/"],[2,[6,"workshops"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"reopen"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /regional_partners/:id/replace_mappings(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const replace_mappings_regional_partner_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"regional_partners"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"replace_mappings"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /regional_partners/:id/replace_mappings(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const replace_mappings_regional_partner_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"regional_partners"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"replace_mappings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /report_abuse(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const report_abuse_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"report_abuse"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /report_abuse(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const report_abuse_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"report_abuse"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /ai_lesson_summaries/request_ai_lesson_summaries(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const request_ai_lesson_summaries_ai_lesson_summaries_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"ai_lesson_summaries"],[2,[7,"/"],[2,[6,"request_ai_lesson_summaries"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /ai_lesson_summaries/request_ai_lesson_summaries(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const request_ai_lesson_summaries_ai_lesson_summaries_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"ai_lesson_summaries"],[2,[7,"/"],[2,[6,"request_ai_lesson_summaries"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/sections/require_captcha(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const require_captcha_api_v1_sections_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"sections"],[2,[7,"/"],[2,[6,"require_captcha"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/v1/sections/require_captcha(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const require_captcha_api_v1_sections_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"sections"],[2,[7,"/"],[2,[6,"require_captcha"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /dashboardapi/sections/require_captcha(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const require_captcha_sections_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dashboardapi"],[2,[7,"/"],[2,[6,"sections"],[2,[7,"/"],[2,[6,"require_captcha"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /dashboardapi/sections/require_captcha(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const require_captcha_sections_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dashboardapi"],[2,[7,"/"],[2,[6,"sections"],[2,[7,"/"],[2,[6,"require_captcha"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/sections/demo/reset(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reset_demo_section_api_v1_sections_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"sections"],[2,[7,"/"],[2,[6,"demo"],[2,[7,"/"],[2,[6,"reset"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/v1/sections/demo/reset(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reset_demo_section_api_v1_sections_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"sections"],[2,[7,"/"],[2,[6,"demo"],[2,[7,"/"],[2,[6,"reset"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /dashboardapi/sections/demo/reset(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reset_demo_section_sections_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dashboardapi"],[2,[7,"/"],[2,[6,"sections"],[2,[7,"/"],[2,[6,"demo"],[2,[7,"/"],[2,[6,"reset"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /dashboardapi/sections/demo/reset(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reset_demo_section_sections_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dashboardapi"],[2,[7,"/"],[2,[6,"sections"],[2,[7,"/"],[2,[6,"demo"],[2,[7,"/"],[2,[6,"reset"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /reset_session(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reset_session_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"reset_session"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /reset_session(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reset_session_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"reset_session"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /resources/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resource_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"resources"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /resources/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resource_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"resources"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /resources(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resources_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"resources"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /resources(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resources_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"resources"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /courses/:course_name/resources(.:format)
 * @param {any} course_name
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resources_course_url = /*#__PURE__*/ __jsr.r({"course_name":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"courses"],[2,[7,"/"],[2,[3,"course_name"],[2,[7,"/"],[2,[6,"resources"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /courses/:course_name/resources(.:format)
 * @param {any} course_name
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resources_course_path = /*#__PURE__*/ __jsr.r({"course_name":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"courses"],[2,[7,"/"],[2,[3,"course_name"],[2,[7,"/"],[2,[6,"resources"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /courses/:course_course_name/units/:position/resources(.:format)
 * @param {any} course_course_name
 * @param {any} position
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resources_course_unit_url = /*#__PURE__*/ __jsr.r({"course_course_name":{"r":true},"position":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"courses"],[2,[7,"/"],[2,[3,"course_course_name"],[2,[7,"/"],[2,[6,"units"],[2,[7,"/"],[2,[3,"position"],[2,[7,"/"],[2,[6,"resources"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /courses/:course_course_name/units/:position/resources(.:format)
 * @param {any} course_course_name
 * @param {any} position
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resources_course_unit_path = /*#__PURE__*/ __jsr.r({"course_course_name":{"r":true},"position":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"courses"],[2,[7,"/"],[2,[3,"course_course_name"],[2,[7,"/"],[2,[6,"units"],[2,[7,"/"],[2,[3,"position"],[2,[7,"/"],[2,[6,"resources"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /s/:id/resources(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resources_script_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"s"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"resources"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /s/:id/resources(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resources_script_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"s"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"resources"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /sections/:id/retrieve_lessons_for_dropdown(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const retrieve_lessons_for_dropdown_section_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"sections"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"retrieve_lessons_for_dropdown"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /sections/:id/retrieve_lessons_for_dropdown(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const retrieve_lessons_for_dropdown_section_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"sections"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"retrieve_lessons_for_dropdown"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /ai_student_podcasts/retrieve_podcast_from_s3(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const retrieve_podcast_from_s3_ai_student_podcasts_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"ai_student_podcasts"],[2,[7,"/"],[2,[6,"retrieve_podcast_from_s3"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /ai_student_podcasts/retrieve_podcast_from_s3(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const retrieve_podcast_from_s3_ai_student_podcasts_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"ai_student_podcasts"],[2,[7,"/"],[2,[6,"retrieve_podcast_from_s3"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/revoke_permission(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const revoke_permission_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"revoke_permission"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /admin/revoke_permission(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const revoke_permission_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"revoke_permission"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const root_url = /*#__PURE__*/ __jsr.r({}, [7,"/"], true);

/**
 * Generates rails route to
 * /
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const root_path = /*#__PURE__*/ __jsr.r({}, [7,"/"]);

/**
 * Generates rails route to
 * /rubrics/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rubric_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rubrics"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /rubrics/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rubric_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rubrics"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /rubrics(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rubrics_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rubrics"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /rubrics(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rubrics_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rubrics"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /rubrics/:id/run_ai_evaluations_for_all(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const run_ai_evaluations_for_all_rubric_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rubrics"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"run_ai_evaluations_for_all"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /rubrics/:id/run_ai_evaluations_for_all(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const run_ai_evaluations_for_all_rubric_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rubrics"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"run_ai_evaluations_for_all"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /rubrics/:id/run_ai_evaluations_for_user(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const run_ai_evaluations_for_user_rubric_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rubrics"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"run_ai_evaluations_for_user"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /rubrics/:id/run_ai_evaluations_for_user(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const run_ai_evaluations_for_user_rubric_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rubrics"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"run_ai_evaluations_for_user"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /s/csp5(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const s_csp5_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"s"],[2,[7,"/"],[2,[6,"csp5"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /s/csp5(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const s_csp5_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"s"],[2,[7,"/"],[2,[6,"csp5"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /s/csp-create(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const s_csp_create_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"s"],[2,[7,"/"],[2,[6,"csp-create"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /s/csp-create(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const s_csp_create_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"s"],[2,[7,"/"],[2,[6,"csp-create"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /s/csp-explore(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const s_csp_explore_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"s"],[2,[7,"/"],[2,[6,"csp-explore"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /s/csp-explore(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const s_csp_explore_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"s"],[2,[7,"/"],[2,[6,"csp-explore"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /s/csppostap(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const s_csppostap_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"s"],[2,[7,"/"],[2,[6,"csppostap"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /s/csppostap(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const s_csppostap_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"s"],[2,[7,"/"],[2,[6,"csppostap"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /safe_browsing(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const safe_browsing_url = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"safe_browsing"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /safe_browsing(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const safe_browsing_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"safe_browsing"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /api/v1/ml_models/save(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const save_api_v1_ml_models_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"ml_models"],[2,[7,"/"],[2,[6,"save"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/v1/ml_models/save(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const save_api_v1_ml_models_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"ml_models"],[2,[7,"/"],[2,[6,"save"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /p/science(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const science_p_index_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[6,"science"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /p/science(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const science_p_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[6,"science"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /projects/science/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const science_project_create_new_projects_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"science"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/science/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const science_project_create_new_projects_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"science"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/science/:channel_id/edit(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const science_project_edit_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"science"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/science/:channel_id/edit(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const science_project_edit_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"science"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/science/:channel_id/export_config(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const science_project_export_config_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"science"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"export_config"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/science/:channel_id/export_config(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const science_project_export_config_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"science"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"export_config"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/science/:channel_id/export_create_channel(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const science_project_export_create_channel_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"science"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"export_create_channel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/science/:channel_id/export_create_channel(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const science_project_export_create_channel_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"science"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"export_create_channel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/science/:channel_id/embed_app_and_code(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const science_project_iframe_embed_app_and_code_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"science"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"embed_app_and_code"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/science/:channel_id/embed_app_and_code(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const science_project_iframe_embed_app_and_code_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"science"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"embed_app_and_code"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/science/:channel_id/embed(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const science_project_iframe_embed_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"science"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"embed"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/science/:channel_id/embed(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const science_project_iframe_embed_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"science"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"embed"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/science(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const science_project_projects_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"science"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /projects/science(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const science_project_projects_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"science"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /projects/science/:channel_id/remix(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const science_project_remix_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"science"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"remix"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/science/:channel_id/remix(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const science_project_remix_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"science"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"remix"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/science/:channel_id(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const science_project_share_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"science"],[2,[7,"/"],[2,[3,"channel_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/science/:channel_id(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const science_project_share_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"science"],[2,[7,"/"],[2,[3,"channel_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/science/:channel_id/view(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const science_project_view_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"science"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"view"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/science/:channel_id/view(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const science_project_view_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"science"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"view"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /scrapbook(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const scrapbook_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"scrapbook"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /scrapbook(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const scrapbook_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"scrapbook"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /s/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const script_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"s"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /s/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const script_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"s"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /s/:script_id/confirm_assignments(.:format)
 * @param {any} script_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const script_confirm_assignments_url = /*#__PURE__*/ __jsr.r({"script_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"s"],[2,[7,"/"],[2,[3,"script_id"],[2,[7,"/"],[2,[6,"confirm_assignments"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /s/:script_id/confirm_assignments(.:format)
 * @param {any} script_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const script_confirm_assignments_path = /*#__PURE__*/ __jsr.r({"script_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"s"],[2,[7,"/"],[2,[3,"script_id"],[2,[7,"/"],[2,[6,"confirm_assignments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /s/:script_id/hidden_lessons(.:format)
 * @param {any} script_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const script_hidden_lessons_url = /*#__PURE__*/ __jsr.r({"script_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"s"],[2,[7,"/"],[2,[3,"script_id"],[2,[7,"/"],[2,[6,"hidden_lessons"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /s/:script_id/hidden_lessons(.:format)
 * @param {any} script_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const script_hidden_lessons_path = /*#__PURE__*/ __jsr.r({"script_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"s"],[2,[7,"/"],[2,[3,"script_id"],[2,[7,"/"],[2,[6,"hidden_lessons"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /s/:script_id/lessons/:position
 * @param {any} script_id
 * @param {any} position
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const script_lesson_url = /*#__PURE__*/ __jsr.r({"script_id":{"r":true},"position":{"r":true}}, [2,[7,"/"],[2,[6,"s"],[2,[7,"/"],[2,[3,"script_id"],[2,[7,"/"],[2,[6,"lessons"],[2,[7,"/"],[3,"position"]]]]]]]], true);

/**
 * Generates rails route to
 * /s/:script_id/lessons/:position
 * @param {any} script_id
 * @param {any} position
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const script_lesson_path = /*#__PURE__*/ __jsr.r({"script_id":{"r":true},"position":{"r":true}}, [2,[7,"/"],[2,[6,"s"],[2,[7,"/"],[2,[3,"script_id"],[2,[7,"/"],[2,[6,"lessons"],[2,[7,"/"],[3,"position"]]]]]]]]);

/**
 * Generates rails route to
 * /s/:script_id/lessons/:lesson_position/edit
 * @param {any} script_id
 * @param {any} lesson_position
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const script_lesson_edit_url = /*#__PURE__*/ __jsr.r({"script_id":{"r":true},"lesson_position":{"r":true}}, [2,[7,"/"],[2,[6,"s"],[2,[7,"/"],[2,[3,"script_id"],[2,[7,"/"],[2,[6,"lessons"],[2,[7,"/"],[2,[3,"lesson_position"],[2,[7,"/"],[6,"edit"]]]]]]]]]], true);

/**
 * Generates rails route to
 * /s/:script_id/lessons/:lesson_position/edit
 * @param {any} script_id
 * @param {any} lesson_position
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const script_lesson_edit_path = /*#__PURE__*/ __jsr.r({"script_id":{"r":true},"lesson_position":{"r":true}}, [2,[7,"/"],[2,[6,"s"],[2,[7,"/"],[2,[3,"script_id"],[2,[7,"/"],[2,[6,"lessons"],[2,[7,"/"],[2,[3,"lesson_position"],[2,[7,"/"],[6,"edit"]]]]]]]]]]);

/**
 * Generates rails route to
 * /s/:script_id/lessons/:lesson_position/extras
 * @param {any} script_id
 * @param {any} lesson_position
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const script_lesson_extras_url = /*#__PURE__*/ __jsr.r({"script_id":{"r":true},"lesson_position":{"r":true}}, [2,[7,"/"],[2,[6,"s"],[2,[7,"/"],[2,[3,"script_id"],[2,[7,"/"],[2,[6,"lessons"],[2,[7,"/"],[2,[3,"lesson_position"],[2,[7,"/"],[6,"extras"]]]]]]]]]], true);

/**
 * Generates rails route to
 * /s/:script_id/lessons/:lesson_position/extras
 * @param {any} script_id
 * @param {any} lesson_position
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const script_lesson_extras_path = /*#__PURE__*/ __jsr.r({"script_id":{"r":true},"lesson_position":{"r":true}}, [2,[7,"/"],[2,[6,"s"],[2,[7,"/"],[2,[3,"script_id"],[2,[7,"/"],[2,[6,"lessons"],[2,[7,"/"],[2,[3,"lesson_position"],[2,[7,"/"],[6,"extras"]]]]]]]]]]);

/**
 * Generates rails route to
 * /s/:script_id/lessons/:lesson_position/generate
 * @param {any} script_id
 * @param {any} lesson_position
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const script_lesson_generate_url = /*#__PURE__*/ __jsr.r({"script_id":{"r":true},"lesson_position":{"r":true}}, [2,[7,"/"],[2,[6,"s"],[2,[7,"/"],[2,[3,"script_id"],[2,[7,"/"],[2,[6,"lessons"],[2,[7,"/"],[2,[3,"lesson_position"],[2,[7,"/"],[6,"generate"]]]]]]]]]], true);

/**
 * Generates rails route to
 * /s/:script_id/lessons/:lesson_position/generate
 * @param {any} script_id
 * @param {any} lesson_position
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const script_lesson_generate_path = /*#__PURE__*/ __jsr.r({"script_id":{"r":true},"lesson_position":{"r":true}}, [2,[7,"/"],[2,[6,"s"],[2,[7,"/"],[2,[3,"script_id"],[2,[7,"/"],[2,[6,"lessons"],[2,[7,"/"],[2,[3,"lesson_position"],[2,[7,"/"],[6,"generate"]]]]]]]]]]);

/**
 * Generates rails route to
 * /s/:script_id/lessons/:lesson_position/level_properties
 * @param {any} script_id
 * @param {any} lesson_position
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const script_lesson_level_properties_url = /*#__PURE__*/ __jsr.r({"script_id":{"r":true},"lesson_position":{"r":true}}, [2,[7,"/"],[2,[6,"s"],[2,[7,"/"],[2,[3,"script_id"],[2,[7,"/"],[2,[6,"lessons"],[2,[7,"/"],[2,[3,"lesson_position"],[2,[7,"/"],[6,"level_properties"]]]]]]]]]], true);

/**
 * Generates rails route to
 * /s/:script_id/lessons/:lesson_position/level_properties
 * @param {any} script_id
 * @param {any} lesson_position
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const script_lesson_level_properties_path = /*#__PURE__*/ __jsr.r({"script_id":{"r":true},"lesson_position":{"r":true}}, [2,[7,"/"],[2,[6,"s"],[2,[7,"/"],[2,[3,"script_id"],[2,[7,"/"],[2,[6,"lessons"],[2,[7,"/"],[2,[3,"lesson_position"],[2,[7,"/"],[6,"level_properties"]]]]]]]]]]);

/**
 * Generates rails route to
 * /s/:script_id/lessons/:lesson_position/levels/:id
 * @param {any} script_id
 * @param {any} lesson_position
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const script_lesson_script_level_url = /*#__PURE__*/ __jsr.r({"script_id":{"r":true},"lesson_position":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"s"],[2,[7,"/"],[2,[3,"script_id"],[2,[7,"/"],[2,[6,"lessons"],[2,[7,"/"],[2,[3,"lesson_position"],[2,[7,"/"],[2,[6,"levels"],[2,[7,"/"],[3,"id"]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /s/:script_id/lessons/:lesson_position/levels/:id
 * @param {any} script_id
 * @param {any} lesson_position
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const script_lesson_script_level_path = /*#__PURE__*/ __jsr.r({"script_id":{"r":true},"lesson_position":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"s"],[2,[7,"/"],[2,[3,"script_id"],[2,[7,"/"],[2,[6,"lessons"],[2,[7,"/"],[2,[3,"lesson_position"],[2,[7,"/"],[2,[6,"levels"],[2,[7,"/"],[3,"id"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /s/:script_id/lessons/:lesson_position/slides
 * @param {any} script_id
 * @param {any} lesson_position
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const script_lesson_slides_url = /*#__PURE__*/ __jsr.r({"script_id":{"r":true},"lesson_position":{"r":true}}, [2,[7,"/"],[2,[6,"s"],[2,[7,"/"],[2,[3,"script_id"],[2,[7,"/"],[2,[6,"lessons"],[2,[7,"/"],[2,[3,"lesson_position"],[2,[7,"/"],[6,"slides"]]]]]]]]]], true);

/**
 * Generates rails route to
 * /s/:script_id/lessons/:lesson_position/slides
 * @param {any} script_id
 * @param {any} lesson_position
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const script_lesson_slides_path = /*#__PURE__*/ __jsr.r({"script_id":{"r":true},"lesson_position":{"r":true}}, [2,[7,"/"],[2,[6,"s"],[2,[7,"/"],[2,[3,"script_id"],[2,[7,"/"],[2,[6,"lessons"],[2,[7,"/"],[2,[3,"lesson_position"],[2,[7,"/"],[6,"slides"]]]]]]]]]]);

/**
 * Generates rails route to
 * /s/:script_id/lessons/:lesson_position/slides/edit
 * @param {any} script_id
 * @param {any} lesson_position
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const script_lesson_slides_edit_url = /*#__PURE__*/ __jsr.r({"script_id":{"r":true},"lesson_position":{"r":true}}, [2,[7,"/"],[2,[6,"s"],[2,[7,"/"],[2,[3,"script_id"],[2,[7,"/"],[2,[6,"lessons"],[2,[7,"/"],[2,[3,"lesson_position"],[2,[7,"/"],[2,[6,"slides"],[2,[7,"/"],[6,"edit"]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /s/:script_id/lessons/:lesson_position/slides/edit
 * @param {any} script_id
 * @param {any} lesson_position
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const script_lesson_slides_edit_path = /*#__PURE__*/ __jsr.r({"script_id":{"r":true},"lesson_position":{"r":true}}, [2,[7,"/"],[2,[6,"s"],[2,[7,"/"],[2,[3,"script_id"],[2,[7,"/"],[2,[6,"lessons"],[2,[7,"/"],[2,[3,"lesson_position"],[2,[7,"/"],[2,[6,"slides"],[2,[7,"/"],[6,"edit"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /s/:script_id/lessons/:lesson_position/slides/generate
 * @param {any} script_id
 * @param {any} lesson_position
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const script_lesson_slides_generate_url = /*#__PURE__*/ __jsr.r({"script_id":{"r":true},"lesson_position":{"r":true}}, [2,[7,"/"],[2,[6,"s"],[2,[7,"/"],[2,[3,"script_id"],[2,[7,"/"],[2,[6,"lessons"],[2,[7,"/"],[2,[3,"lesson_position"],[2,[7,"/"],[2,[6,"slides"],[2,[7,"/"],[6,"generate"]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /s/:script_id/lessons/:lesson_position/slides/generate
 * @param {any} script_id
 * @param {any} lesson_position
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const script_lesson_slides_generate_path = /*#__PURE__*/ __jsr.r({"script_id":{"r":true},"lesson_position":{"r":true}}, [2,[7,"/"],[2,[6,"s"],[2,[7,"/"],[2,[3,"script_id"],[2,[7,"/"],[2,[6,"lessons"],[2,[7,"/"],[2,[3,"lesson_position"],[2,[7,"/"],[2,[6,"slides"],[2,[7,"/"],[6,"generate"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /s/:script_id/lessons/:lesson_position/student
 * @param {any} script_id
 * @param {any} lesson_position
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const script_lesson_student_url = /*#__PURE__*/ __jsr.r({"script_id":{"r":true},"lesson_position":{"r":true}}, [2,[7,"/"],[2,[6,"s"],[2,[7,"/"],[2,[3,"script_id"],[2,[7,"/"],[2,[6,"lessons"],[2,[7,"/"],[2,[3,"lesson_position"],[2,[7,"/"],[6,"student"]]]]]]]]]], true);

/**
 * Generates rails route to
 * /s/:script_id/lessons/:lesson_position/student
 * @param {any} script_id
 * @param {any} lesson_position
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const script_lesson_student_path = /*#__PURE__*/ __jsr.r({"script_id":{"r":true},"lesson_position":{"r":true}}, [2,[7,"/"],[2,[6,"s"],[2,[7,"/"],[2,[3,"script_id"],[2,[7,"/"],[2,[6,"lessons"],[2,[7,"/"],[2,[3,"lesson_position"],[2,[7,"/"],[6,"student"]]]]]]]]]]);

/**
 * Generates rails route to
 * /s/:script_id/lessons/:lesson_position/summary_for_lesson_plans
 * @param {any} script_id
 * @param {any} lesson_position
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const script_lesson_summary_for_lesson_plans_url = /*#__PURE__*/ __jsr.r({"script_id":{"r":true},"lesson_position":{"r":true}}, [2,[7,"/"],[2,[6,"s"],[2,[7,"/"],[2,[3,"script_id"],[2,[7,"/"],[2,[6,"lessons"],[2,[7,"/"],[2,[3,"lesson_position"],[2,[7,"/"],[6,"summary_for_lesson_plans"]]]]]]]]]], true);

/**
 * Generates rails route to
 * /s/:script_id/lessons/:lesson_position/summary_for_lesson_plans
 * @param {any} script_id
 * @param {any} lesson_position
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const script_lesson_summary_for_lesson_plans_path = /*#__PURE__*/ __jsr.r({"script_id":{"r":true},"lesson_position":{"r":true}}, [2,[7,"/"],[2,[6,"s"],[2,[7,"/"],[2,[3,"script_id"],[2,[7,"/"],[2,[6,"lessons"],[2,[7,"/"],[2,[3,"lesson_position"],[2,[7,"/"],[6,"summary_for_lesson_plans"]]]]]]]]]]);

/**
 * Generates rails route to
 * /s/:script_id/lessons/:lesson_position/tutor
 * @param {any} script_id
 * @param {any} lesson_position
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const script_lesson_tutor_url = /*#__PURE__*/ __jsr.r({"script_id":{"r":true},"lesson_position":{"r":true}}, [2,[7,"/"],[2,[6,"s"],[2,[7,"/"],[2,[3,"script_id"],[2,[7,"/"],[2,[6,"lessons"],[2,[7,"/"],[2,[3,"lesson_position"],[2,[7,"/"],[6,"tutor"]]]]]]]]]], true);

/**
 * Generates rails route to
 * /s/:script_id/lessons/:lesson_position/tutor
 * @param {any} script_id
 * @param {any} lesson_position
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const script_lesson_tutor_path = /*#__PURE__*/ __jsr.r({"script_id":{"r":true},"lesson_position":{"r":true}}, [2,[7,"/"],[2,[6,"s"],[2,[7,"/"],[2,[3,"script_id"],[2,[7,"/"],[2,[6,"lessons"],[2,[7,"/"],[2,[3,"lesson_position"],[2,[7,"/"],[6,"tutor"]]]]]]]]]]);

/**
 * Generates rails route to
 * /s/:script_id/lessons/:lesson_position/tutor/gallery
 * @param {any} script_id
 * @param {any} lesson_position
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const script_lesson_tutor_gallery_url = /*#__PURE__*/ __jsr.r({"script_id":{"r":true},"lesson_position":{"r":true}}, [2,[7,"/"],[2,[6,"s"],[2,[7,"/"],[2,[3,"script_id"],[2,[7,"/"],[2,[6,"lessons"],[2,[7,"/"],[2,[3,"lesson_position"],[2,[7,"/"],[2,[6,"tutor"],[2,[7,"/"],[6,"gallery"]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /s/:script_id/lessons/:lesson_position/tutor/gallery
 * @param {any} script_id
 * @param {any} lesson_position
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const script_lesson_tutor_gallery_path = /*#__PURE__*/ __jsr.r({"script_id":{"r":true},"lesson_position":{"r":true}}, [2,[7,"/"],[2,[6,"s"],[2,[7,"/"],[2,[3,"script_id"],[2,[7,"/"],[2,[6,"lessons"],[2,[7,"/"],[2,[3,"lesson_position"],[2,[7,"/"],[2,[6,"tutor"],[2,[7,"/"],[6,"gallery"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /s/:script_id/lessons
 * @param {any} script_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const script_lessons_url = /*#__PURE__*/ __jsr.r({"script_id":{"r":true}}, [2,[7,"/"],[2,[6,"s"],[2,[7,"/"],[2,[3,"script_id"],[2,[7,"/"],[6,"lessons"]]]]]], true);

/**
 * Generates rails route to
 * /s/:script_id/lessons
 * @param {any} script_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const script_lessons_path = /*#__PURE__*/ __jsr.r({"script_id":{"r":true}}, [2,[7,"/"],[2,[6,"s"],[2,[7,"/"],[2,[3,"script_id"],[2,[7,"/"],[6,"lessons"]]]]]]);

/**
 * Generates rails route to
 * /s/:script_id/lockable/:lockable_lesson_position/levels/:id
 * @param {any} script_id
 * @param {any} lockable_lesson_position
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const script_lockable_lesson_script_level_url = /*#__PURE__*/ __jsr.r({"script_id":{"r":true},"lockable_lesson_position":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"s"],[2,[7,"/"],[2,[3,"script_id"],[2,[7,"/"],[2,[6,"lockable"],[2,[7,"/"],[2,[3,"lockable_lesson_position"],[2,[7,"/"],[2,[6,"levels"],[2,[7,"/"],[3,"id"]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /s/:script_id/lockable/:lockable_lesson_position/levels/:id
 * @param {any} script_id
 * @param {any} lockable_lesson_position
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const script_lockable_lesson_script_level_path = /*#__PURE__*/ __jsr.r({"script_id":{"r":true},"lockable_lesson_position":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"s"],[2,[7,"/"],[2,[3,"script_id"],[2,[7,"/"],[2,[6,"lockable"],[2,[7,"/"],[2,[3,"lockable_lesson_position"],[2,[7,"/"],[2,[6,"levels"],[2,[7,"/"],[3,"id"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /s/:script_id/lockable/:lockable_lesson_position/summary_for_lesson_plans
 * @param {any} script_id
 * @param {any} lockable_lesson_position
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const script_lockable_lesson_summary_for_lesson_plans_url = /*#__PURE__*/ __jsr.r({"script_id":{"r":true},"lockable_lesson_position":{"r":true}}, [2,[7,"/"],[2,[6,"s"],[2,[7,"/"],[2,[3,"script_id"],[2,[7,"/"],[2,[6,"lockable"],[2,[7,"/"],[2,[3,"lockable_lesson_position"],[2,[7,"/"],[6,"summary_for_lesson_plans"]]]]]]]]]], true);

/**
 * Generates rails route to
 * /s/:script_id/lockable/:lockable_lesson_position/summary_for_lesson_plans
 * @param {any} script_id
 * @param {any} lockable_lesson_position
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const script_lockable_lesson_summary_for_lesson_plans_path = /*#__PURE__*/ __jsr.r({"script_id":{"r":true},"lockable_lesson_position":{"r":true}}, [2,[7,"/"],[2,[6,"s"],[2,[7,"/"],[2,[3,"script_id"],[2,[7,"/"],[2,[6,"lockable"],[2,[7,"/"],[2,[3,"lockable_lesson_position"],[2,[7,"/"],[6,"summary_for_lesson_plans"]]]]]]]]]]);

/**
 * Generates rails route to
 * /s/:script_id/next(.:format)
 * @param {any} script_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const script_next_url = /*#__PURE__*/ __jsr.r({"script_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"s"],[2,[7,"/"],[2,[3,"script_id"],[2,[7,"/"],[2,[6,"next"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /s/:script_id/next(.:format)
 * @param {any} script_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const script_next_path = /*#__PURE__*/ __jsr.r({"script_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"s"],[2,[7,"/"],[2,[3,"script_id"],[2,[7,"/"],[2,[6,"next"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /s/:script_id/preview-assignments(.:format)
 * @param {any} script_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const script_preview_assignments_url = /*#__PURE__*/ __jsr.r({"script_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"s"],[2,[7,"/"],[2,[3,"script_id"],[2,[7,"/"],[2,[6,"preview-assignments"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /s/:script_id/preview-assignments(.:format)
 * @param {any} script_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const script_preview_assignments_path = /*#__PURE__*/ __jsr.r({"script_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"s"],[2,[7,"/"],[2,[3,"script_id"],[2,[7,"/"],[2,[6,"preview-assignments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /s/:script_id/pull-review(.:format)
 * @param {any} script_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const script_pull_review_url = /*#__PURE__*/ __jsr.r({"script_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"s"],[2,[7,"/"],[2,[3,"script_id"],[2,[7,"/"],[2,[6,"pull-review"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /s/:script_id/pull-review(.:format)
 * @param {any} script_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const script_pull_review_path = /*#__PURE__*/ __jsr.r({"script_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"s"],[2,[7,"/"],[2,[3,"script_id"],[2,[7,"/"],[2,[6,"pull-review"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /s/:script_id/reset(.:format)
 * @param {any} script_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const script_reset_url = /*#__PURE__*/ __jsr.r({"script_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"s"],[2,[7,"/"],[2,[3,"script_id"],[2,[7,"/"],[2,[6,"reset"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /s/:script_id/reset(.:format)
 * @param {any} script_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const script_reset_path = /*#__PURE__*/ __jsr.r({"script_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"s"],[2,[7,"/"],[2,[3,"script_id"],[2,[7,"/"],[2,[6,"reset"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /s/:script_id/toggle_hidden(.:format)
 * @param {any} script_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const script_toggle_hidden_url = /*#__PURE__*/ __jsr.r({"script_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"s"],[2,[7,"/"],[2,[3,"script_id"],[2,[7,"/"],[2,[6,"toggle_hidden"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /s/:script_id/toggle_hidden(.:format)
 * @param {any} script_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const script_toggle_hidden_path = /*#__PURE__*/ __jsr.r({"script_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"s"],[2,[7,"/"],[2,[3,"script_id"],[2,[7,"/"],[2,[6,"toggle_hidden"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /s(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const scripts_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"s"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /s(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const scripts_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"s"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /api/v1/pd/applications/search(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const search_api_v1_pd_applications_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"pd"],[2,[7,"/"],[2,[6,"applications"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/v1/pd/applications/search(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const search_api_v1_pd_applications_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"pd"],[2,[7,"/"],[2,[6,"applications"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /json_videos/search(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const search_json_videos_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"json_videos"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /json_videos/search(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const search_json_videos_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"json_videos"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /programming_expressions/search(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const search_programming_expressions_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"programming_expressions"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /programming_expressions/search(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const search_programming_expressions_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"programming_expressions"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /resources/search(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const search_resources_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"resources"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /resources/search(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const search_resources_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"resources"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /standards/search(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const search_standards_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"standards"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /standards/search(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const search_standards_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"standards"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /vocabularies/search(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const search_vocabularies_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"vocabularies"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /vocabularies/search(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const search_vocabularies_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"vocabularies"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /sections/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const section_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"sections"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /sections/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const section_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"sections"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /dashboardapi/assessments/section_feedback(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const section_feedback_assessments_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dashboardapi"],[2,[7,"/"],[2,[6,"assessments"],[2,[7,"/"],[2,[6,"section_feedback"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /dashboardapi/assessments/section_feedback(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const section_feedback_assessments_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dashboardapi"],[2,[7,"/"],[2,[6,"assessments"],[2,[7,"/"],[2,[6,"section_feedback"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /sections/section_instructors_verified(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const section_instructors_verified_sections_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"sections"],[2,[7,"/"],[2,[6,"section_instructors_verified"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /sections/section_instructors_verified(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const section_instructors_verified_sections_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"sections"],[2,[7,"/"],[2,[6,"section_instructors_verified"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /dashboardapi/section_level_progress/:section_id(.:format)
 * @param {any} section_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const section_level_progress_url = /*#__PURE__*/ __jsr.r({"section_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"dashboardapi"],[2,[7,"/"],[2,[6,"section_level_progress"],[2,[7,"/"],[2,[3,"section_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /dashboardapi/section_level_progress/:section_id(.:format)
 * @param {any} section_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const section_level_progress_path = /*#__PURE__*/ __jsr.r({"section_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"dashboardapi"],[2,[7,"/"],[2,[6,"section_level_progress"],[2,[7,"/"],[2,[3,"section_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /dashboardapi/assessments/section_responses(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const section_responses_assessments_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dashboardapi"],[2,[7,"/"],[2,[6,"assessments"],[2,[7,"/"],[2,[6,"section_responses"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /dashboardapi/assessments/section_responses(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const section_responses_assessments_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dashboardapi"],[2,[7,"/"],[2,[6,"assessments"],[2,[7,"/"],[2,[6,"section_responses"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /dashboardapi/sections/:section_id/students/:id(.:format)
 * @param {any} section_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const section_student_url = /*#__PURE__*/ __jsr.r({"section_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"dashboardapi"],[2,[7,"/"],[2,[6,"sections"],[2,[7,"/"],[2,[3,"section_id"],[2,[7,"/"],[2,[6,"students"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /dashboardapi/sections/:section_id/students/:id(.:format)
 * @param {any} section_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const section_student_path = /*#__PURE__*/ __jsr.r({"section_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"dashboardapi"],[2,[7,"/"],[2,[6,"sections"],[2,[7,"/"],[2,[3,"section_id"],[2,[7,"/"],[2,[6,"students"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /dashboardapi/sections/:section_id/students(.:format)
 * @param {any} section_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const section_students_url = /*#__PURE__*/ __jsr.r({"section_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"dashboardapi"],[2,[7,"/"],[2,[6,"sections"],[2,[7,"/"],[2,[3,"section_id"],[2,[7,"/"],[2,[6,"students"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /dashboardapi/sections/:section_id/students(.:format)
 * @param {any} section_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const section_students_path = /*#__PURE__*/ __jsr.r({"section_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"dashboardapi"],[2,[7,"/"],[2,[6,"sections"],[2,[7,"/"],[2,[3,"section_id"],[2,[7,"/"],[2,[6,"students"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /dashboardapi/assessments/section_surveys(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const section_surveys_assessments_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dashboardapi"],[2,[7,"/"],[2,[6,"assessments"],[2,[7,"/"],[2,[6,"section_surveys"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /dashboardapi/assessments/section_surveys(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const section_surveys_assessments_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dashboardapi"],[2,[7,"/"],[2,[6,"assessments"],[2,[7,"/"],[2,[6,"section_surveys"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /dashboardapi/sections(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sections_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dashboardapi"],[2,[7,"/"],[2,[6,"sections"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /dashboardapi/sections(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sections_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dashboardapi"],[2,[7,"/"],[2,[6,"sections"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /sprites/select_start_animations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const select_start_animations_sprites_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"sprites"],[2,[7,"/"],[2,[6,"select_start_animations"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /sprites/select_start_animations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const select_start_animations_sprites_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"sprites"],[2,[7,"/"],[2,[6,"select_start_animations"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /sms/send(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const send_to_phone_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"sms"],[2,[7,"/"],[2,[6,"send"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /sms/send(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const send_to_phone_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"sms"],[2,[7,"/"],[2,[6,"send"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /datablock_storage/:channel_id/set_key_value(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const set_key_value_datablock_storage_index_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"datablock_storage"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"set_key_value"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /datablock_storage/:channel_id/set_key_value(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const set_key_value_datablock_storage_index_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"datablock_storage"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"set_key_value"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /maker/setup(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const setup_maker_index_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"maker"],[2,[7,"/"],[2,[6,"setup"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /maker/setup(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const setup_maker_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"maker"],[2,[7,"/"],[2,[6,"setup"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /functions/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const shared_blockly_function_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"functions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /functions/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const shared_blockly_function_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"functions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /functions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const shared_blockly_functions_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"functions"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /functions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const shared_blockly_functions_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"functions"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /api/v1/users/signed_in(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const signed_in_api_v1_users_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"signed_in"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/v1/users/signed_in(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const signed_in_api_v1_users_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"signed_in"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /p/sketchlab(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sketchlab_p_index_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[6,"sketchlab"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /p/sketchlab(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sketchlab_p_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[6,"sketchlab"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /projects/sketchlab/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sketchlab_project_create_new_projects_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"sketchlab"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/sketchlab/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sketchlab_project_create_new_projects_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"sketchlab"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/sketchlab/:channel_id/edit(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sketchlab_project_edit_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"sketchlab"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/sketchlab/:channel_id/edit(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sketchlab_project_edit_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"sketchlab"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/sketchlab/:channel_id/export_config(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sketchlab_project_export_config_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"sketchlab"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"export_config"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/sketchlab/:channel_id/export_config(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sketchlab_project_export_config_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"sketchlab"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"export_config"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/sketchlab/:channel_id/export_create_channel(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sketchlab_project_export_create_channel_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"sketchlab"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"export_create_channel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/sketchlab/:channel_id/export_create_channel(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sketchlab_project_export_create_channel_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"sketchlab"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"export_create_channel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/sketchlab/:channel_id/embed_app_and_code(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sketchlab_project_iframe_embed_app_and_code_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"sketchlab"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"embed_app_and_code"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/sketchlab/:channel_id/embed_app_and_code(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sketchlab_project_iframe_embed_app_and_code_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"sketchlab"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"embed_app_and_code"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/sketchlab/:channel_id/embed(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sketchlab_project_iframe_embed_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"sketchlab"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"embed"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/sketchlab/:channel_id/embed(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sketchlab_project_iframe_embed_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"sketchlab"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"embed"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/sketchlab(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sketchlab_project_projects_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"sketchlab"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /projects/sketchlab(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sketchlab_project_projects_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"sketchlab"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /projects/sketchlab/:channel_id/remix(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sketchlab_project_remix_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"sketchlab"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"remix"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/sketchlab/:channel_id/remix(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sketchlab_project_remix_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"sketchlab"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"remix"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/sketchlab/:channel_id(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sketchlab_project_share_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"sketchlab"],[2,[7,"/"],[2,[3,"channel_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/sketchlab/:channel_id(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sketchlab_project_share_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"sketchlab"],[2,[7,"/"],[2,[3,"channel_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/sketchlab/:channel_id/view(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sketchlab_project_view_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"sketchlab"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"view"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/sketchlab/:channel_id/view(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sketchlab_project_view_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"sketchlab"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"view"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /skills/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const skill_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"skills"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /skills/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const skill_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"skills"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /skills(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const skills_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"skills"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /skills(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const skills_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"skills"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /lessons/:id/slides_data(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const slides_data_lesson_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"lessons"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"slides_data"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /lessons/:id/slides_data(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const slides_data_lesson_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"lessons"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"slides_data"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /lessons/:id/slides/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const slides_edit_lesson_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"lessons"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"slides"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /lessons/:id/slides/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const slides_edit_lesson_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"lessons"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"slides"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /lessons/:id/slides(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const slides_lesson_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"lessons"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"slides"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /lessons/:id/slides(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const slides_lesson_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"lessons"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"slides"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /p/sports(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sports_p_index_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[6,"sports"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /p/sports(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sports_p_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[6,"sports"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /projects/sports/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sports_project_create_new_projects_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"sports"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/sports/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sports_project_create_new_projects_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"sports"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/sports/:channel_id/edit(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sports_project_edit_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"sports"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/sports/:channel_id/edit(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sports_project_edit_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"sports"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/sports/:channel_id/export_config(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sports_project_export_config_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"sports"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"export_config"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/sports/:channel_id/export_config(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sports_project_export_config_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"sports"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"export_config"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/sports/:channel_id/export_create_channel(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sports_project_export_create_channel_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"sports"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"export_create_channel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/sports/:channel_id/export_create_channel(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sports_project_export_create_channel_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"sports"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"export_create_channel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/sports/:channel_id/embed_app_and_code(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sports_project_iframe_embed_app_and_code_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"sports"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"embed_app_and_code"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/sports/:channel_id/embed_app_and_code(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sports_project_iframe_embed_app_and_code_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"sports"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"embed_app_and_code"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/sports/:channel_id/embed(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sports_project_iframe_embed_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"sports"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"embed"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/sports/:channel_id/embed(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sports_project_iframe_embed_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"sports"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"embed"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/sports(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sports_project_projects_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"sports"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /projects/sports(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sports_project_projects_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"sports"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /projects/sports/:channel_id/remix(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sports_project_remix_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"sports"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"remix"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/sports/:channel_id/remix(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sports_project_remix_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"sports"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"remix"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/sports/:channel_id(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sports_project_share_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"sports"],[2,[7,"/"],[2,[3,"channel_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/sports/:channel_id(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sports_project_share_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"sports"],[2,[7,"/"],[2,[3,"channel_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/sports/:channel_id/view(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sports_project_view_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"sports"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"view"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/sports/:channel_id/view(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sports_project_view_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"sports"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"view"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /sprite_lab2/external_scenes(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sprite_lab2_external_scenes_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"sprite_lab2"],[2,[7,"/"],[2,[6,"external_scenes"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /sprite_lab2/external_scenes(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sprite_lab2_external_scenes_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"sprite_lab2"],[2,[7,"/"],[2,[6,"external_scenes"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /sprite_lab2/section_scenes(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sprite_lab2_section_scenes_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"sprite_lab2"],[2,[7,"/"],[2,[6,"section_scenes"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /sprite_lab2/section_scenes(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sprite_lab2_section_scenes_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"sprite_lab2"],[2,[7,"/"],[2,[6,"section_scenes"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /sprites/sprite_upload(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sprite_upload_sprites_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"sprites"],[2,[7,"/"],[2,[6,"sprite_upload"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /sprites/sprite_upload(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sprite_upload_sprites_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"sprites"],[2,[7,"/"],[2,[6,"sprite_upload"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /spritelab_lab2_images_review(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spritelab_lab2_images_review_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"spritelab_lab2_images_review"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /spritelab_lab2_images_review(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spritelab_lab2_images_review_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"spritelab_lab2_images_review"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /p/spritelab(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spritelab_p_index_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[6,"spritelab"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /p/spritelab(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spritelab_p_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[6,"spritelab"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /projects/spritelab/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spritelab_project_create_new_projects_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"spritelab"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/spritelab/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spritelab_project_create_new_projects_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"spritelab"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/spritelab/:channel_id/edit(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spritelab_project_edit_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"spritelab"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/spritelab/:channel_id/edit(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spritelab_project_edit_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"spritelab"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/spritelab/:channel_id/export_config(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spritelab_project_export_config_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"spritelab"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"export_config"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/spritelab/:channel_id/export_config(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spritelab_project_export_config_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"spritelab"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"export_config"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/spritelab/:channel_id/export_create_channel(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spritelab_project_export_create_channel_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"spritelab"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"export_create_channel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/spritelab/:channel_id/export_create_channel(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spritelab_project_export_create_channel_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"spritelab"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"export_create_channel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/spritelab/:channel_id/embed_app_and_code(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spritelab_project_iframe_embed_app_and_code_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"spritelab"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"embed_app_and_code"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/spritelab/:channel_id/embed_app_and_code(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spritelab_project_iframe_embed_app_and_code_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"spritelab"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"embed_app_and_code"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/spritelab/:channel_id/embed(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spritelab_project_iframe_embed_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"spritelab"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"embed"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/spritelab/:channel_id/embed(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spritelab_project_iframe_embed_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"spritelab"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"embed"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/spritelab(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spritelab_project_projects_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"spritelab"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /projects/spritelab(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spritelab_project_projects_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"spritelab"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /projects/spritelab/:channel_id/remix(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spritelab_project_remix_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"spritelab"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"remix"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/spritelab/:channel_id/remix(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spritelab_project_remix_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"spritelab"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"remix"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/spritelab/:channel_id(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spritelab_project_share_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"spritelab"],[2,[7,"/"],[2,[3,"channel_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/spritelab/:channel_id(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spritelab_project_share_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"spritelab"],[2,[7,"/"],[2,[3,"channel_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/spritelab/:channel_id/view(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spritelab_project_view_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"spritelab"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"view"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/spritelab/:channel_id/view(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spritelab_project_view_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"spritelab"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"view"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /sprites(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sprites_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"sprites"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /sprites(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sprites_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"sprites"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /courses/:course_name/standards(.:format)
 * @param {any} course_name
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const standards_course_url = /*#__PURE__*/ __jsr.r({"course_name":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"courses"],[2,[7,"/"],[2,[3,"course_name"],[2,[7,"/"],[2,[6,"standards"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /courses/:course_name/standards(.:format)
 * @param {any} course_name
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const standards_course_path = /*#__PURE__*/ __jsr.r({"course_name":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"courses"],[2,[7,"/"],[2,[3,"course_name"],[2,[7,"/"],[2,[6,"standards"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /courses/:course_course_name/units/:position/standards(.:format)
 * @param {any} course_course_name
 * @param {any} position
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const standards_course_unit_url = /*#__PURE__*/ __jsr.r({"course_course_name":{"r":true},"position":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"courses"],[2,[7,"/"],[2,[3,"course_course_name"],[2,[7,"/"],[2,[6,"units"],[2,[7,"/"],[2,[3,"position"],[2,[7,"/"],[2,[6,"standards"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /courses/:course_course_name/units/:position/standards(.:format)
 * @param {any} course_course_name
 * @param {any} position
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const standards_course_unit_path = /*#__PURE__*/ __jsr.r({"course_course_name":{"r":true},"position":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"courses"],[2,[7,"/"],[2,[3,"course_course_name"],[2,[7,"/"],[2,[6,"units"],[2,[7,"/"],[2,[3,"position"],[2,[7,"/"],[2,[6,"standards"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /s/:id/standards(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const standards_script_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"s"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"standards"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /s/:id/standards(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const standards_script_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"s"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"standards"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/pd/workshops/:id/start(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const start_api_v1_pd_workshop_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"pd"],[2,[7,"/"],[2,[6,"workshops"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"start"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/v1/pd/workshops/:id/start(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const start_api_v1_pd_workshop_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"pd"],[2,[7,"/"],[2,[6,"workshops"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"start"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /challenges/:id/starter_image(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const starter_image_challenge_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"challenges"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"starter_image"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /challenges/:id/starter_image(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const starter_image_challenge_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"challenges"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"starter_image"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /p/starwars(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const starwars_p_index_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[6,"starwars"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /p/starwars(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const starwars_p_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[6,"starwars"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /projects/starwars/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const starwars_project_create_new_projects_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"starwars"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/starwars/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const starwars_project_create_new_projects_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"starwars"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/starwars/:channel_id/edit(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const starwars_project_edit_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"starwars"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/starwars/:channel_id/edit(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const starwars_project_edit_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"starwars"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/starwars/:channel_id/export_config(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const starwars_project_export_config_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"starwars"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"export_config"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/starwars/:channel_id/export_config(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const starwars_project_export_config_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"starwars"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"export_config"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/starwars/:channel_id/export_create_channel(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const starwars_project_export_create_channel_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"starwars"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"export_create_channel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/starwars/:channel_id/export_create_channel(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const starwars_project_export_create_channel_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"starwars"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"export_create_channel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/starwars/:channel_id/embed_app_and_code(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const starwars_project_iframe_embed_app_and_code_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"starwars"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"embed_app_and_code"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/starwars/:channel_id/embed_app_and_code(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const starwars_project_iframe_embed_app_and_code_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"starwars"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"embed_app_and_code"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/starwars/:channel_id/embed(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const starwars_project_iframe_embed_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"starwars"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"embed"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/starwars/:channel_id/embed(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const starwars_project_iframe_embed_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"starwars"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"embed"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/starwars(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const starwars_project_projects_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"starwars"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /projects/starwars(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const starwars_project_projects_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"starwars"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /projects/starwars/:channel_id/remix(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const starwars_project_remix_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"starwars"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"remix"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/starwars/:channel_id/remix(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const starwars_project_remix_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"starwars"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"remix"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/starwars/:channel_id(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const starwars_project_share_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"starwars"],[2,[7,"/"],[2,[3,"channel_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/starwars/:channel_id(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const starwars_project_share_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"starwars"],[2,[7,"/"],[2,[3,"channel_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/starwars/:channel_id/view(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const starwars_project_view_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"starwars"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"view"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/starwars/:channel_id/view(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const starwars_project_view_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"starwars"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"view"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /p/starwarsblocks_hour(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const starwarsblocks_hour_p_index_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[6,"starwarsblocks_hour"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /p/starwarsblocks_hour(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const starwarsblocks_hour_p_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[6,"starwarsblocks_hour"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /projects/starwarsblocks_hour/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const starwarsblocks_hour_project_create_new_projects_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"starwarsblocks_hour"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/starwarsblocks_hour/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const starwarsblocks_hour_project_create_new_projects_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"starwarsblocks_hour"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/starwarsblocks_hour/:channel_id/edit(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const starwarsblocks_hour_project_edit_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"starwarsblocks_hour"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/starwarsblocks_hour/:channel_id/edit(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const starwarsblocks_hour_project_edit_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"starwarsblocks_hour"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/starwarsblocks_hour/:channel_id/export_config(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const starwarsblocks_hour_project_export_config_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"starwarsblocks_hour"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"export_config"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/starwarsblocks_hour/:channel_id/export_config(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const starwarsblocks_hour_project_export_config_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"starwarsblocks_hour"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"export_config"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/starwarsblocks_hour/:channel_id/export_create_channel(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const starwarsblocks_hour_project_export_create_channel_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"starwarsblocks_hour"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"export_create_channel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/starwarsblocks_hour/:channel_id/export_create_channel(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const starwarsblocks_hour_project_export_create_channel_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"starwarsblocks_hour"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"export_create_channel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/starwarsblocks_hour/:channel_id/embed_app_and_code(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const starwarsblocks_hour_project_iframe_embed_app_and_code_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"starwarsblocks_hour"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"embed_app_and_code"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/starwarsblocks_hour/:channel_id/embed_app_and_code(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const starwarsblocks_hour_project_iframe_embed_app_and_code_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"starwarsblocks_hour"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"embed_app_and_code"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/starwarsblocks_hour/:channel_id/embed(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const starwarsblocks_hour_project_iframe_embed_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"starwarsblocks_hour"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"embed"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/starwarsblocks_hour/:channel_id/embed(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const starwarsblocks_hour_project_iframe_embed_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"starwarsblocks_hour"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"embed"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/starwarsblocks_hour(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const starwarsblocks_hour_project_projects_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"starwarsblocks_hour"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /projects/starwarsblocks_hour(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const starwarsblocks_hour_project_projects_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"starwarsblocks_hour"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /projects/starwarsblocks_hour/:channel_id/remix(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const starwarsblocks_hour_project_remix_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"starwarsblocks_hour"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"remix"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/starwarsblocks_hour/:channel_id/remix(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const starwarsblocks_hour_project_remix_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"starwarsblocks_hour"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"remix"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/starwarsblocks_hour/:channel_id(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const starwarsblocks_hour_project_share_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"starwarsblocks_hour"],[2,[7,"/"],[2,[3,"channel_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/starwarsblocks_hour/:channel_id(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const starwarsblocks_hour_project_share_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"starwarsblocks_hour"],[2,[7,"/"],[2,[3,"channel_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/starwarsblocks_hour/:channel_id/view(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const starwarsblocks_hour_project_view_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"starwarsblocks_hour"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"view"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/starwarsblocks_hour/:channel_id/view(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const starwarsblocks_hour_project_view_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"starwarsblocks_hour"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"view"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /p/starwarsblocks(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const starwarsblocks_p_index_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[6,"starwarsblocks"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /p/starwarsblocks(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const starwarsblocks_p_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[6,"starwarsblocks"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /projects/starwarsblocks/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const starwarsblocks_project_create_new_projects_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"starwarsblocks"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/starwarsblocks/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const starwarsblocks_project_create_new_projects_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"starwarsblocks"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/starwarsblocks/:channel_id/edit(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const starwarsblocks_project_edit_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"starwarsblocks"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/starwarsblocks/:channel_id/edit(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const starwarsblocks_project_edit_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"starwarsblocks"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/starwarsblocks/:channel_id/export_config(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const starwarsblocks_project_export_config_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"starwarsblocks"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"export_config"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/starwarsblocks/:channel_id/export_config(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const starwarsblocks_project_export_config_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"starwarsblocks"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"export_config"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/starwarsblocks/:channel_id/export_create_channel(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const starwarsblocks_project_export_create_channel_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"starwarsblocks"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"export_create_channel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/starwarsblocks/:channel_id/export_create_channel(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const starwarsblocks_project_export_create_channel_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"starwarsblocks"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"export_create_channel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/starwarsblocks/:channel_id/embed_app_and_code(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const starwarsblocks_project_iframe_embed_app_and_code_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"starwarsblocks"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"embed_app_and_code"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/starwarsblocks/:channel_id/embed_app_and_code(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const starwarsblocks_project_iframe_embed_app_and_code_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"starwarsblocks"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"embed_app_and_code"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/starwarsblocks/:channel_id/embed(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const starwarsblocks_project_iframe_embed_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"starwarsblocks"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"embed"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/starwarsblocks/:channel_id/embed(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const starwarsblocks_project_iframe_embed_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"starwarsblocks"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"embed"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/starwarsblocks(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const starwarsblocks_project_projects_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"starwarsblocks"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /projects/starwarsblocks(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const starwarsblocks_project_projects_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"starwarsblocks"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /projects/starwarsblocks/:channel_id/remix(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const starwarsblocks_project_remix_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"starwarsblocks"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"remix"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/starwarsblocks/:channel_id/remix(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const starwarsblocks_project_remix_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"starwarsblocks"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"remix"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/starwarsblocks/:channel_id(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const starwarsblocks_project_share_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"starwarsblocks"],[2,[7,"/"],[2,[3,"channel_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/starwarsblocks/:channel_id(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const starwarsblocks_project_share_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"starwarsblocks"],[2,[7,"/"],[2,[3,"channel_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/starwarsblocks/:channel_id/view(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const starwarsblocks_project_view_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"starwarsblocks"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"view"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/starwarsblocks/:channel_id/view(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const starwarsblocks_project_view_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"starwarsblocks"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"view"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /p/story(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const story_p_index_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[6,"story"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /p/story(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const story_p_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[6,"story"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /projects/story/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const story_project_create_new_projects_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"story"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/story/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const story_project_create_new_projects_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"story"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/story/:channel_id/edit(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const story_project_edit_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"story"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/story/:channel_id/edit(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const story_project_edit_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"story"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/story/:channel_id/export_config(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const story_project_export_config_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"story"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"export_config"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/story/:channel_id/export_config(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const story_project_export_config_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"story"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"export_config"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/story/:channel_id/export_create_channel(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const story_project_export_create_channel_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"story"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"export_create_channel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/story/:channel_id/export_create_channel(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const story_project_export_create_channel_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"story"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"export_create_channel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/story/:channel_id/embed_app_and_code(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const story_project_iframe_embed_app_and_code_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"story"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"embed_app_and_code"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/story/:channel_id/embed_app_and_code(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const story_project_iframe_embed_app_and_code_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"story"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"embed_app_and_code"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/story/:channel_id/embed(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const story_project_iframe_embed_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"story"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"embed"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/story/:channel_id/embed(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const story_project_iframe_embed_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"story"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"embed"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/story(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const story_project_projects_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"story"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /projects/story(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const story_project_projects_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"story"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /projects/story/:channel_id/remix(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const story_project_remix_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"story"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"remix"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/story/:channel_id/remix(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const story_project_remix_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"story"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"remix"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/story/:channel_id(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const story_project_share_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"story"],[2,[7,"/"],[2,[3,"channel_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/story/:channel_id(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const story_project_share_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"story"],[2,[7,"/"],[2,[3,"channel_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/story/:channel_id/view(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const story_project_view_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"story"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"view"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/story/:channel_id/view(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const story_project_view_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"story"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"view"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /student_code_samples(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const student_code_samples_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"student_code_samples"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /student_code_samples(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const student_code_samples_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"student_code_samples"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /student_snapshots/student_has_work_in_lesson(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const student_has_work_in_lesson_student_snapshots_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"student_snapshots"],[2,[7,"/"],[2,[6,"student_has_work_in_lesson"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /student_snapshots/student_has_work_in_lesson(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const student_has_work_in_lesson_student_snapshots_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"student_snapshots"],[2,[7,"/"],[2,[6,"student_has_work_in_lesson"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /join(/:section_code)(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const student_register_url = /*#__PURE__*/ __jsr.r({"section_code":{},"format":{}}, [2,[7,"/"],[2,[6,"join"],[2,[1,[2,[7,"/"],[3,"section_code"]]],[1,[2,[8,"."],[3,"format"]]]]]], true);

/**
 * Generates rails route to
 * /join(/:section_code)(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const student_register_path = /*#__PURE__*/ __jsr.r({"section_code":{},"format":{}}, [2,[7,"/"],[2,[6,"join"],[2,[1,[2,[7,"/"],[3,"section_code"]]],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * /join(/:section_code)(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const student_user_new_url = /*#__PURE__*/ __jsr.r({"section_code":{},"format":{}}, [2,[7,"/"],[2,[6,"join"],[2,[1,[2,[7,"/"],[3,"section_code"]]],[1,[2,[8,"."],[3,"format"]]]]]], true);

/**
 * Generates rails route to
 * /join(/:section_code)(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const student_user_new_path = /*#__PURE__*/ __jsr.r({"section_code":{},"format":{}}, [2,[7,"/"],[2,[6,"join"],[2,[1,[2,[7,"/"],[3,"section_code"]]],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * /student_work_evaluation_summaries(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const student_work_evaluation_summaries_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"student_work_evaluation_summaries"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /student_work_evaluation_summaries(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const student_work_evaluation_summaries_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"student_work_evaluation_summaries"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /student_work_evaluations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const student_work_evaluations_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"student_work_evaluations"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /student_work_evaluations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const student_work_evaluations_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"student_work_evaluations"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /admin/studio_person_add_email_to_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const studio_person_add_email_to_emails_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"studio_person_add_email_to_emails"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /admin/studio_person_add_email_to_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const studio_person_add_email_to_emails_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"studio_person_add_email_to_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/studio_person(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const studio_person_form_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"studio_person"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /admin/studio_person(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const studio_person_form_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"studio_person"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/studio_person_merge(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const studio_person_merge_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"studio_person_merge"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /admin/studio_person_merge(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const studio_person_merge_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"studio_person_merge"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/studio_person_split(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const studio_person_split_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"studio_person_split"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /admin/studio_person_split(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const studio_person_split_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"studio_person_split"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /courses/:course_course_name/units/:unit_position/lessons/:lesson_position/levels/:id/sublevel/:sublevel_position
 * @param {any} course_course_name
 * @param {any} unit_position
 * @param {any} lesson_position
 * @param {any} id
 * @param {any} sublevel_position
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sublevel_course_unit_lesson_script_level_url = /*#__PURE__*/ __jsr.r({"course_course_name":{"r":true},"unit_position":{"r":true},"lesson_position":{"r":true},"id":{"r":true},"sublevel_position":{"r":true}}, [2,[7,"/"],[2,[6,"courses"],[2,[7,"/"],[2,[3,"course_course_name"],[2,[7,"/"],[2,[6,"units"],[2,[7,"/"],[2,[3,"unit_position"],[2,[7,"/"],[2,[6,"lessons"],[2,[7,"/"],[2,[3,"lesson_position"],[2,[7,"/"],[2,[6,"levels"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"sublevel"],[2,[7,"/"],[3,"sublevel_position"]]]]]]]]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /courses/:course_course_name/units/:unit_position/lessons/:lesson_position/levels/:id/sublevel/:sublevel_position
 * @param {any} course_course_name
 * @param {any} unit_position
 * @param {any} lesson_position
 * @param {any} id
 * @param {any} sublevel_position
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sublevel_course_unit_lesson_script_level_path = /*#__PURE__*/ __jsr.r({"course_course_name":{"r":true},"unit_position":{"r":true},"lesson_position":{"r":true},"id":{"r":true},"sublevel_position":{"r":true}}, [2,[7,"/"],[2,[6,"courses"],[2,[7,"/"],[2,[3,"course_course_name"],[2,[7,"/"],[2,[6,"units"],[2,[7,"/"],[2,[3,"unit_position"],[2,[7,"/"],[2,[6,"lessons"],[2,[7,"/"],[2,[3,"lesson_position"],[2,[7,"/"],[2,[6,"levels"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"sublevel"],[2,[7,"/"],[3,"sublevel_position"]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /s/:script_id/lessons/:lesson_position/levels/:id/sublevel/:sublevel_position
 * @param {any} script_id
 * @param {any} lesson_position
 * @param {any} id
 * @param {any} sublevel_position
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sublevel_script_lesson_script_level_url = /*#__PURE__*/ __jsr.r({"script_id":{"r":true},"lesson_position":{"r":true},"id":{"r":true},"sublevel_position":{"r":true}}, [2,[7,"/"],[2,[6,"s"],[2,[7,"/"],[2,[3,"script_id"],[2,[7,"/"],[2,[6,"lessons"],[2,[7,"/"],[2,[3,"lesson_position"],[2,[7,"/"],[2,[6,"levels"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"sublevel"],[2,[7,"/"],[3,"sublevel_position"]]]]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /s/:script_id/lessons/:lesson_position/levels/:id/sublevel/:sublevel_position
 * @param {any} script_id
 * @param {any} lesson_position
 * @param {any} id
 * @param {any} sublevel_position
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sublevel_script_lesson_script_level_path = /*#__PURE__*/ __jsr.r({"script_id":{"r":true},"lesson_position":{"r":true},"id":{"r":true},"sublevel_position":{"r":true}}, [2,[7,"/"],[2,[6,"s"],[2,[7,"/"],[2,[3,"script_id"],[2,[7,"/"],[2,[6,"lessons"],[2,[7,"/"],[2,[3,"lesson_position"],[2,[7,"/"],[2,[6,"levels"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"sublevel"],[2,[7,"/"],[3,"sublevel_position"]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rubrics/:id/submit_evaluations(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const submit_evaluations_rubric_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rubrics"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"submit_evaluations"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /rubrics/:id/submit_evaluations(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const submit_evaluations_rubric_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rubrics"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"submit_evaluations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /aidiff_messages/:id/submit_feedback(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const submit_feedback_aidiff_message_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"aidiff_messages"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"submit_feedback"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /aidiff_messages/:id/submit_feedback(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const submit_feedback_aidiff_message_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"aidiff_messages"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"submit_feedback"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /lti/v1/deep_linking/submit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const submit_lti_v1_deep_linking_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"lti"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"deep_linking"],[2,[7,"/"],[2,[6,"submit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /lti/v1/deep_linking/submit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const submit_lti_v1_deep_linking_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"lti"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"deep_linking"],[2,[7,"/"],[2,[6,"submit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /teacher_dashboard/sections/:section_id/*path(.:format)
 * @param {any} section_id
 * @param {any} path
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const subpath_teacher_dashboard_section_url = /*#__PURE__*/ __jsr.r({"section_id":{"r":true},"path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"teacher_dashboard"],[2,[7,"/"],[2,[6,"sections"],[2,[7,"/"],[2,[3,"section_id"],[2,[7,"/"],[2,[5,[3,"path"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /teacher_dashboard/sections/:section_id/*path(.:format)
 * @param {any} section_id
 * @param {any} path
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const subpath_teacher_dashboard_section_path = /*#__PURE__*/ __jsr.r({"section_id":{"r":true},"path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"teacher_dashboard"],[2,[7,"/"],[2,[6,"sections"],[2,[7,"/"],[2,[3,"section_id"],[2,[7,"/"],[2,[5,[3,"path"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/sections/:id/suggested_lesson(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const suggested_lesson_api_v1_section_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"sections"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"suggested_lesson"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/v1/sections/:id/suggested_lesson(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const suggested_lesson_api_v1_section_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"sections"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"suggested_lesson"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /dashboardapi/sections/:id/suggested_lesson(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const suggested_lesson_section_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"dashboardapi"],[2,[7,"/"],[2,[6,"sections"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"suggested_lesson"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /dashboardapi/sections/:id/suggested_lesson(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const suggested_lesson_section_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"dashboardapi"],[2,[7,"/"],[2,[6,"sections"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"suggested_lesson"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/sections/suggested_lessons(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const suggested_lessons_api_v1_sections_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"sections"],[2,[7,"/"],[2,[6,"suggested_lessons"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/v1/sections/suggested_lessons(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const suggested_lessons_api_v1_sections_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"sections"],[2,[7,"/"],[2,[6,"suggested_lessons"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /dashboardapi/sections/suggested_lessons(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const suggested_lessons_sections_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dashboardapi"],[2,[7,"/"],[2,[6,"sections"],[2,[7,"/"],[2,[6,"suggested_lessons"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /dashboardapi/sections/suggested_lessons(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const suggested_lessons_sections_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dashboardapi"],[2,[7,"/"],[2,[6,"sections"],[2,[7,"/"],[2,[6,"suggested_lessons"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/pd/workshops/:id/summary(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const summary_api_v1_pd_workshop_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"pd"],[2,[7,"/"],[2,[6,"workshops"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"summary"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/v1/pd/workshops/:id/summary(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const summary_api_v1_pd_workshop_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"pd"],[2,[7,"/"],[2,[6,"workshops"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"summary"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /courses/:course_course_name/units/:unit_position/lessons/:lesson_position/levels/:id/summary
 * @param {any} course_course_name
 * @param {any} unit_position
 * @param {any} lesson_position
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const summary_course_unit_lesson_script_level_url = /*#__PURE__*/ __jsr.r({"course_course_name":{"r":true},"unit_position":{"r":true},"lesson_position":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"courses"],[2,[7,"/"],[2,[3,"course_course_name"],[2,[7,"/"],[2,[6,"units"],[2,[7,"/"],[2,[3,"unit_position"],[2,[7,"/"],[2,[6,"lessons"],[2,[7,"/"],[2,[3,"lesson_position"],[2,[7,"/"],[2,[6,"levels"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"summary"]]]]]]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /courses/:course_course_name/units/:unit_position/lessons/:lesson_position/levels/:id/summary
 * @param {any} course_course_name
 * @param {any} unit_position
 * @param {any} lesson_position
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const summary_course_unit_lesson_script_level_path = /*#__PURE__*/ __jsr.r({"course_course_name":{"r":true},"unit_position":{"r":true},"lesson_position":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"courses"],[2,[7,"/"],[2,[3,"course_course_name"],[2,[7,"/"],[2,[6,"units"],[2,[7,"/"],[2,[3,"unit_position"],[2,[7,"/"],[2,[6,"lessons"],[2,[7,"/"],[2,[3,"lesson_position"],[2,[7,"/"],[2,[6,"levels"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"summary"]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /s/:script_id/lessons/:lesson_position/levels/:id/summary
 * @param {any} script_id
 * @param {any} lesson_position
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const summary_script_lesson_script_level_url = /*#__PURE__*/ __jsr.r({"script_id":{"r":true},"lesson_position":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"s"],[2,[7,"/"],[2,[3,"script_id"],[2,[7,"/"],[2,[6,"lessons"],[2,[7,"/"],[2,[3,"lesson_position"],[2,[7,"/"],[2,[6,"levels"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"summary"]]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /s/:script_id/lessons/:lesson_position/levels/:id/summary
 * @param {any} script_id
 * @param {any} lesson_position
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const summary_script_lesson_script_level_path = /*#__PURE__*/ __jsr.r({"script_id":{"r":true},"lesson_position":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"s"],[2,[7,"/"],[2,[3,"script_id"],[2,[7,"/"],[2,[6,"lessons"],[2,[7,"/"],[2,[3,"lesson_position"],[2,[7,"/"],[2,[6,"levels"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"summary"]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /survey_results(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const survey_results_url = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"survey_results"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /survey_results(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const survey_results_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"survey_results"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /api/v1/roster/clever/sections/sync(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sync_api_v1_roster_clever_sections_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"roster"],[2,[7,"/"],[2,[6,"clever"],[2,[7,"/"],[2,[6,"sections"],[2,[7,"/"],[2,[6,"sync"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/v1/roster/clever/sections/sync(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sync_api_v1_roster_clever_sections_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"roster"],[2,[7,"/"],[2,[6,"clever"],[2,[7,"/"],[2,[6,"sections"],[2,[7,"/"],[2,[6,"sync"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /teacher_account_required(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const teacher_account_required_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"teacher_account_required"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /teacher_account_required(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const teacher_account_required_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"teacher_account_required"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /teacher_dashboard/sections/:section_id(.:format)
 * @param {any} section_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const teacher_dashboard_section_url = /*#__PURE__*/ __jsr.r({"section_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"teacher_dashboard"],[2,[7,"/"],[2,[6,"sections"],[2,[7,"/"],[2,[3,"section_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /teacher_dashboard/sections/:section_id(.:format)
 * @param {any} section_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const teacher_dashboard_section_path = /*#__PURE__*/ __jsr.r({"section_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"teacher_dashboard"],[2,[7,"/"],[2,[6,"sections"],[2,[7,"/"],[2,[3,"section_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /teaching_profile_data(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const teaching_profile_data_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"teaching_profile_data"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /teaching_profile_data(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const teaching_profile_data_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"teaching_profile_data"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /terms-and-privacy(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const terms_and_privacy_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"terms-and-privacy"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /terms-and-privacy(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const terms_and_privacy_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"terms-and-privacy"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /p/thebadguys(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const thebadguys_p_index_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[6,"thebadguys"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /p/thebadguys(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const thebadguys_p_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[6,"thebadguys"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /projects/thebadguys/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const thebadguys_project_create_new_projects_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"thebadguys"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/thebadguys/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const thebadguys_project_create_new_projects_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"thebadguys"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/thebadguys/:channel_id/edit(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const thebadguys_project_edit_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"thebadguys"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/thebadguys/:channel_id/edit(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const thebadguys_project_edit_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"thebadguys"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/thebadguys/:channel_id/export_config(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const thebadguys_project_export_config_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"thebadguys"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"export_config"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/thebadguys/:channel_id/export_config(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const thebadguys_project_export_config_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"thebadguys"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"export_config"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/thebadguys/:channel_id/export_create_channel(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const thebadguys_project_export_create_channel_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"thebadguys"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"export_create_channel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/thebadguys/:channel_id/export_create_channel(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const thebadguys_project_export_create_channel_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"thebadguys"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"export_create_channel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/thebadguys/:channel_id/embed_app_and_code(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const thebadguys_project_iframe_embed_app_and_code_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"thebadguys"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"embed_app_and_code"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/thebadguys/:channel_id/embed_app_and_code(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const thebadguys_project_iframe_embed_app_and_code_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"thebadguys"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"embed_app_and_code"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/thebadguys/:channel_id/embed(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const thebadguys_project_iframe_embed_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"thebadguys"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"embed"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/thebadguys/:channel_id/embed(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const thebadguys_project_iframe_embed_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"thebadguys"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"embed"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/thebadguys(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const thebadguys_project_projects_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"thebadguys"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /projects/thebadguys(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const thebadguys_project_projects_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"thebadguys"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /projects/thebadguys/:channel_id/remix(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const thebadguys_project_remix_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"thebadguys"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"remix"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/thebadguys/:channel_id/remix(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const thebadguys_project_remix_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"thebadguys"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"remix"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/thebadguys/:channel_id(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const thebadguys_project_share_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"thebadguys"],[2,[7,"/"],[2,[3,"channel_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/thebadguys/:channel_id(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const thebadguys_project_share_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"thebadguys"],[2,[7,"/"],[2,[3,"channel_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/thebadguys/:channel_id/view(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const thebadguys_project_view_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"thebadguys"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"view"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/thebadguys/:channel_id/view(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const thebadguys_project_view_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"thebadguys"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"view"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /user_preference/theme(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const theme_user_preference_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"user_preference"],[2,[7,"/"],[2,[6,"theme"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /user_preference/theme(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const theme_user_preference_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"user_preference"],[2,[7,"/"],[2,[6,"theme"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /p/time_capsule(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const time_capsule_p_index_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[6,"time_capsule"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /p/time_capsule(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const time_capsule_p_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[6,"time_capsule"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /projects/time_capsule/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const time_capsule_project_create_new_projects_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"time_capsule"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/time_capsule/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const time_capsule_project_create_new_projects_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"time_capsule"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/time_capsule/:channel_id/edit(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const time_capsule_project_edit_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"time_capsule"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/time_capsule/:channel_id/edit(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const time_capsule_project_edit_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"time_capsule"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/time_capsule/:channel_id/export_config(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const time_capsule_project_export_config_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"time_capsule"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"export_config"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/time_capsule/:channel_id/export_config(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const time_capsule_project_export_config_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"time_capsule"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"export_config"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/time_capsule/:channel_id/export_create_channel(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const time_capsule_project_export_create_channel_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"time_capsule"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"export_create_channel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/time_capsule/:channel_id/export_create_channel(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const time_capsule_project_export_create_channel_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"time_capsule"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"export_create_channel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/time_capsule/:channel_id/embed_app_and_code(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const time_capsule_project_iframe_embed_app_and_code_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"time_capsule"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"embed_app_and_code"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/time_capsule/:channel_id/embed_app_and_code(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const time_capsule_project_iframe_embed_app_and_code_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"time_capsule"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"embed_app_and_code"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/time_capsule/:channel_id/embed(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const time_capsule_project_iframe_embed_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"time_capsule"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"embed"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/time_capsule/:channel_id/embed(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const time_capsule_project_iframe_embed_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"time_capsule"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"embed"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/time_capsule(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const time_capsule_project_projects_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"time_capsule"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /projects/time_capsule(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const time_capsule_project_projects_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"time_capsule"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /projects/time_capsule/:channel_id/remix(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const time_capsule_project_remix_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"time_capsule"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"remix"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/time_capsule/:channel_id/remix(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const time_capsule_project_remix_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"time_capsule"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"remix"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/time_capsule/:channel_id(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const time_capsule_project_share_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"time_capsule"],[2,[7,"/"],[2,[3,"channel_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/time_capsule/:channel_id(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const time_capsule_project_share_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"time_capsule"],[2,[7,"/"],[2,[3,"channel_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/time_capsule/:channel_id/view(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const time_capsule_project_view_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"time_capsule"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"view"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/time_capsule/:channel_id/view(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const time_capsule_project_view_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"time_capsule"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"view"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /too_young(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const too_young_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"too_young"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /too_young(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const too_young_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"too_young"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /p/transformers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const transformers_p_index_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[6,"transformers"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /p/transformers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const transformers_p_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[6,"transformers"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /projects/transformers/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const transformers_project_create_new_projects_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"transformers"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/transformers/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const transformers_project_create_new_projects_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"transformers"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/transformers/:channel_id/edit(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const transformers_project_edit_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"transformers"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/transformers/:channel_id/edit(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const transformers_project_edit_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"transformers"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/transformers/:channel_id/export_config(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const transformers_project_export_config_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"transformers"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"export_config"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/transformers/:channel_id/export_config(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const transformers_project_export_config_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"transformers"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"export_config"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/transformers/:channel_id/export_create_channel(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const transformers_project_export_create_channel_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"transformers"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"export_create_channel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/transformers/:channel_id/export_create_channel(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const transformers_project_export_create_channel_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"transformers"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"export_create_channel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/transformers/:channel_id/embed_app_and_code(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const transformers_project_iframe_embed_app_and_code_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"transformers"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"embed_app_and_code"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/transformers/:channel_id/embed_app_and_code(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const transformers_project_iframe_embed_app_and_code_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"transformers"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"embed_app_and_code"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/transformers/:channel_id/embed(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const transformers_project_iframe_embed_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"transformers"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"embed"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/transformers/:channel_id/embed(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const transformers_project_iframe_embed_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"transformers"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"embed"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/transformers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const transformers_project_projects_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"transformers"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /projects/transformers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const transformers_project_projects_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"transformers"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /projects/transformers/:channel_id/remix(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const transformers_project_remix_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"transformers"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"remix"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/transformers/:channel_id/remix(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const transformers_project_remix_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"transformers"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"remix"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/transformers/:channel_id(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const transformers_project_share_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"transformers"],[2,[7,"/"],[2,[3,"channel_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/transformers/:channel_id(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const transformers_project_share_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"transformers"],[2,[7,"/"],[2,[3,"channel_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/transformers/:channel_id/view(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const transformers_project_view_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"transformers"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"view"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/transformers/:channel_id/view(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const transformers_project_view_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"transformers"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"view"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/undelete_section(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const undelete_section_admin_search_index_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"undelete_section"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /admin/undelete_section(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const undelete_section_admin_search_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"undelete_section"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/undelete_user(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const undelete_user_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"undelete_user"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /admin/undelete_user(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const undelete_user_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"undelete_user"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /challenge_responses/unit_counts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unit_counts_challenge_responses_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"challenge_responses"],[2,[7,"/"],[2,[6,"unit_counts"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /challenge_responses/unit_counts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unit_counts_challenge_responses_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"challenge_responses"],[2,[7,"/"],[2,[6,"unit_counts"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /teacher_dashboard/sections/:section_id/unit(.:format)
 * @param {any} section_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unit_teacher_dashboard_section_url = /*#__PURE__*/ __jsr.r({"section_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"teacher_dashboard"],[2,[7,"/"],[2,[6,"sections"],[2,[7,"/"],[2,[3,"section_id"],[2,[7,"/"],[2,[6,"unit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /teacher_dashboard/sections/:section_id/unit(.:format)
 * @param {any} section_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unit_teacher_dashboard_section_path = /*#__PURE__*/ __jsr.r({"section_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"teacher_dashboard"],[2,[7,"/"],[2,[6,"sections"],[2,[7,"/"],[2,[3,"section_id"],[2,[7,"/"],[2,[6,"unit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/pd/workshops/:id/unstart(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unstart_api_v1_pd_workshop_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"pd"],[2,[7,"/"],[2,[6,"workshops"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"unstart"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/v1/pd/workshops/:id/unstart(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unstart_api_v1_pd_workshop_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"pd"],[2,[7,"/"],[2,[6,"workshops"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"unstart"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/pd/workshops/upcoming_teachercons(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const upcoming_teachercons_api_v1_pd_workshops_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"pd"],[2,[7,"/"],[2,[6,"workshops"],[2,[7,"/"],[2,[6,"upcoming_teachercons"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/v1/pd/workshops/upcoming_teachercons(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const upcoming_teachercons_api_v1_pd_workshops_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"pd"],[2,[7,"/"],[2,[6,"workshops"],[2,[7,"/"],[2,[6,"upcoming_teachercons"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rubrics/:id/update_ai_rubrics_tour_seen(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_ai_rubrics_tour_seen_rubric_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rubrics"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_ai_rubrics_tour_seen"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /rubrics/:id/update_ai_rubrics_tour_seen(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_ai_rubrics_tour_seen_rubric_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rubrics"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_ai_rubrics_tour_seen"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /levels/:id/update_blocks/:type(.:format)
 * @param {any} id
 * @param {any} type
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_blocks_level_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"type":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"levels"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_blocks"],[2,[7,"/"],[2,[3,"type"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /levels/:id/update_blocks/:type(.:format)
 * @param {any} id
 * @param {any} type
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_blocks_level_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"type":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"levels"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_blocks"],[2,[7,"/"],[2,[3,"type"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /levels/:id/update_bubble_choice_settings(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_bubble_choice_settings_level_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"levels"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_bubble_choice_settings"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /levels/:id/update_bubble_choice_settings(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_bubble_choice_settings_level_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"levels"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_bubble_choice_settings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/update_cap_state(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_cap_state_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"update_cap_state"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /admin/update_cap_state(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_cap_state_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"update_cap_state"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /levels/:id/update_exemplar_code(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_exemplar_code_level_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"levels"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_exemplar_code"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /levels/:id/update_exemplar_code(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_exemplar_code_level_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"levels"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_exemplar_code"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /levels/:id/update_properties(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_properties_level_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"levels"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_properties"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /levels/:id/update_properties(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_properties_level_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"levels"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_properties"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /foorm/forms/:id/update_questions(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_questions_foorm_form_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"foorm"],[2,[7,"/"],[2,[6,"forms"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_questions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /foorm/forms/:id/update_questions(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_questions_foorm_form_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"foorm"],[2,[7,"/"],[2,[6,"forms"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_questions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/disk/:encoded_token(.:format)
 * @param {any} encoded_token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_rails_disk_service_url = /*#__PURE__*/ __jsr.r({"encoded_token":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"disk"],[2,[7,"/"],[2,[3,"encoded_token"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /rails/active_storage/disk/:encoded_token(.:format)
 * @param {any} encoded_token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_rails_disk_service_path = /*#__PURE__*/ __jsr.r({"encoded_token":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"disk"],[2,[7,"/"],[2,[3,"encoded_token"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /datablock_storage/:channel_id/update_record(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_record_datablock_storage_index_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"datablock_storage"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"update_record"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /datablock_storage/:channel_id/update_record(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_record_datablock_storage_index_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"datablock_storage"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"update_record"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /levels/:id/update_start_code(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_start_code_level_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"levels"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_start_code"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /levels/:id/update_start_code(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_start_code_level_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"levels"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_start_code"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /challenge_response_assets/:id/upload(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const upload_challenge_response_asset_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"challenge_response_assets"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"upload"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /challenge_response_assets/:id/upload(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const upload_challenge_response_asset_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"challenge_response_assets"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"upload"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/user_app_options/:script/:lesson_position/:level_position/:level(.:format)
 * @param {any} script
 * @param {any} lesson_position
 * @param {any} level_position
 * @param {any} level
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_app_options_url = /*#__PURE__*/ __jsr.r({"script":{"r":true},"lesson_position":{"r":true},"level_position":{"r":true},"level":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"user_app_options"],[2,[7,"/"],[2,[3,"script"],[2,[7,"/"],[2,[3,"lesson_position"],[2,[7,"/"],[2,[3,"level_position"],[2,[7,"/"],[2,[3,"level"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/user_app_options/:script/:lesson_position/:level_position/:level(.:format)
 * @param {any} script
 * @param {any} lesson_position
 * @param {any} level_position
 * @param {any} level
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_app_options_path = /*#__PURE__*/ __jsr.r({"script":{"r":true},"lesson_position":{"r":true},"level_position":{"r":true},"level":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"user_app_options"],[2,[7,"/"],[2,[3,"script"],[2,[7,"/"],[2,[3,"lesson_position"],[2,[7,"/"],[2,[3,"level_position"],[2,[7,"/"],[2,[3,"level"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/auth/classlink(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_classlink_omniauth_authorize_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"classlink"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /users/auth/classlink(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_classlink_omniauth_authorize_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"classlink"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/auth/classlink/callback(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_classlink_omniauth_callback_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"classlink"],[2,[7,"/"],[2,[6,"callback"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /users/auth/classlink/callback(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_classlink_omniauth_callback_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"classlink"],[2,[7,"/"],[2,[6,"callback"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/auth/clever(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_clever_omniauth_authorize_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"clever"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /users/auth/clever(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_clever_omniauth_authorize_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"clever"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/auth/clever/callback(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_clever_omniauth_callback_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"clever"],[2,[7,"/"],[2,[6,"callback"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /users/auth/clever/callback(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_clever_omniauth_callback_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"clever"],[2,[7,"/"],[2,[6,"callback"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/auth/facebook(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_facebook_omniauth_authorize_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"facebook"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /users/auth/facebook(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_facebook_omniauth_authorize_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"facebook"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/auth/facebook/callback(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_facebook_omniauth_callback_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"facebook"],[2,[7,"/"],[2,[6,"callback"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /users/auth/facebook/callback(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_facebook_omniauth_callback_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"facebook"],[2,[7,"/"],[2,[6,"callback"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/auth/google_oauth2(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_google_oauth2_omniauth_authorize_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"google_oauth2"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /users/auth/google_oauth2(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_google_oauth2_omniauth_authorize_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"google_oauth2"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/auth/google_oauth2/callback(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_google_oauth2_omniauth_callback_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"google_oauth2"],[2,[7,"/"],[2,[6,"callback"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /users/auth/google_oauth2/callback(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_google_oauth2_omniauth_callback_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"google_oauth2"],[2,[7,"/"],[2,[6,"callback"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/invitation(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_invitation_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"invitation"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /users/invitation(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_invitation_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"invitation"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /user_lesson_objective_reflections(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_lesson_objective_reflections_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"user_lesson_objective_reflections"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /user_lesson_objective_reflections(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_lesson_objective_reflections_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"user_lesson_objective_reflections"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /user_lesson_reflections(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_lesson_reflections_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"user_lesson_reflections"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /user_lesson_reflections(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_lesson_reflections_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"user_lesson_reflections"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /user_levels/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_level_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"user_levels"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /user_levels/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_level_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"user_levels"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /user_level_interactions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_level_interactions_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"user_level_interactions"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /user_level_interactions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_level_interactions_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"user_level_interactions"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /user_levels/get_token(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_levels_get_token_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"user_levels"],[2,[7,"/"],[2,[6,"get_token"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /user_levels/get_token(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_levels_get_token_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"user_levels"],[2,[7,"/"],[2,[6,"get_token"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/auth/microsoft_v2_auth(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_microsoft_v2_auth_omniauth_authorize_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"microsoft_v2_auth"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /users/auth/microsoft_v2_auth(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_microsoft_v2_auth_omniauth_authorize_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"microsoft_v2_auth"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/auth/microsoft_v2_auth/callback(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_microsoft_v2_auth_omniauth_callback_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"microsoft_v2_auth"],[2,[7,"/"],[2,[6,"callback"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /users/auth/microsoft_v2_auth/callback(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_microsoft_v2_auth_omniauth_callback_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"microsoft_v2_auth"],[2,[7,"/"],[2,[6,"callback"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/password(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_password_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"password"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /users/password(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_password_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"password"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /user_practice_problem_attempts/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_practice_problem_attempt_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"user_practice_problem_attempts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /user_practice_problem_attempts/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_practice_problem_attempt_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"user_practice_problem_attempts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /user_practice_problem_attempts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_practice_problem_attempts_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"user_practice_problem_attempts"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /user_practice_problem_attempts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_practice_problem_attempts_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"user_practice_problem_attempts"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /user_preference(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_preference_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"user_preference"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /user_preference(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_preference_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"user_preference"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /api/user_progress/:script(.:format)
 * @param {any} script
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_progress_url = /*#__PURE__*/ __jsr.r({"script":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"user_progress"],[2,[7,"/"],[2,[3,"script"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/user_progress/:script(.:format)
 * @param {any} script
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_progress_path = /*#__PURE__*/ __jsr.r({"script":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"user_progress"],[2,[7,"/"],[2,[3,"script"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/user_progress(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_progress_form_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"user_progress"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /admin/user_progress(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_progress_form_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"user_progress"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/user_project(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_project_restore_form_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"user_project"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /admin/user_project(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_project_restore_form_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"user_project"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/user_projects(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_projects_form_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"user_projects"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /admin/user_projects(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_projects_form_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"user_projects"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_registration_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /users(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_registration_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /admin/user_sections(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_sections_form_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"user_sections"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /admin/user_sections(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_sections_form_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"user_sections"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/sign_in(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_session_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"sign_in"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /users/sign_in(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_session_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"sign_in"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/unlock(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_unlock_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"unlock"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /users/unlock(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_unlock_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"unlock"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/begin_sign_up(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const users_begin_sign_up_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"begin_sign_up"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /users/begin_sign_up(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const users_begin_sign_up_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"begin_sign_up"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/cancel(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const users_cancel_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"cancel"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /users/cancel(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const users_cancel_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"cancel"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const users_edit_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /users/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const users_edit_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/email(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const users_email_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"email"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /users/email(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const users_email_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"email"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/existing_account(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const users_existing_account_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"existing_account"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /users/existing_account(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const users_existing_account_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"existing_account"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/gdpr_check(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const users_gdpr_check_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"gdpr_check"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /users/gdpr_check(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const users_gdpr_check_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"gdpr_check"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/migrate_to_multi_auth(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const users_migrate_to_multi_auth_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"migrate_to_multi_auth"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /users/migrate_to_multi_auth(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const users_migrate_to_multi_auth_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"migrate_to_multi_auth"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/new_sign_up/account_type(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const users_new_sign_up_account_type_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"new_sign_up"],[2,[7,"/"],[2,[6,"account_type"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /users/new_sign_up/account_type(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const users_new_sign_up_account_type_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"new_sign_up"],[2,[7,"/"],[2,[6,"account_type"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/new_sign_up/finish_student_account(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const users_new_sign_up_finish_student_account_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"new_sign_up"],[2,[7,"/"],[2,[6,"finish_student_account"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /users/new_sign_up/finish_student_account(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const users_new_sign_up_finish_student_account_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"new_sign_up"],[2,[7,"/"],[2,[6,"finish_student_account"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/new_sign_up/finish_teacher_account(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const users_new_sign_up_finish_teacher_account_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"new_sign_up"],[2,[7,"/"],[2,[6,"finish_teacher_account"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /users/new_sign_up/finish_teacher_account(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const users_new_sign_up_finish_teacher_account_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"new_sign_up"],[2,[7,"/"],[2,[6,"finish_teacher_account"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/new_sign_up/login_type(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const users_new_sign_up_login_type_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"new_sign_up"],[2,[7,"/"],[2,[6,"login_type"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /users/new_sign_up/login_type(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const users_new_sign_up_login_type_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"new_sign_up"],[2,[7,"/"],[2,[6,"login_type"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/parent_email(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const users_parent_email_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"parent_email"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /users/parent_email(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const users_parent_email_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"parent_email"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/personalization_information(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const users_personalization_information_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"personalization_information"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /users/personalization_information(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const users_personalization_information_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"personalization_information"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/set_student_information(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const users_set_student_information_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"set_student_information"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /users/set_student_information(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const users_set_student_information_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"set_student_information"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/sign_up(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const users_sign_up_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"sign_up"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /users/sign_up(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const users_sign_up_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"sign_up"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/sign_up/account_type(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const users_sign_up_account_type_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"sign_up"],[2,[7,"/"],[2,[6,"account_type"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /users/sign_up/account_type(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const users_sign_up_account_type_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"sign_up"],[2,[7,"/"],[2,[6,"account_type"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/sign_up/finish_student_account(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const users_sign_up_finish_student_account_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"sign_up"],[2,[7,"/"],[2,[6,"finish_student_account"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /users/sign_up/finish_student_account(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const users_sign_up_finish_student_account_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"sign_up"],[2,[7,"/"],[2,[6,"finish_student_account"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/sign_up/finish_teacher_account(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const users_sign_up_finish_teacher_account_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"sign_up"],[2,[7,"/"],[2,[6,"finish_teacher_account"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /users/sign_up/finish_teacher_account(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const users_sign_up_finish_teacher_account_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"sign_up"],[2,[7,"/"],[2,[6,"finish_teacher_account"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/sign_up/login_type(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const users_sign_up_login_type_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"sign_up"],[2,[7,"/"],[2,[6,"login_type"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /users/sign_up/login_type(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const users_sign_up_login_type_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"sign_up"],[2,[7,"/"],[2,[6,"login_type"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/to_destroy(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const users_to_destroy_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"to_destroy"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /users/to_destroy(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const users_to_destroy_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"to_destroy"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/upgrade(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const users_upgrade_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"upgrade"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /users/upgrade(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const users_upgrade_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"upgrade"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/user_type(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const users_user_type_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"user_type"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /users/user_type(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const users_user_type_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"user_type"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/sections/valid_course_offerings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const valid_course_offerings_api_v1_sections_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"sections"],[2,[7,"/"],[2,[6,"valid_course_offerings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/v1/sections/valid_course_offerings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const valid_course_offerings_api_v1_sections_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"sections"],[2,[7,"/"],[2,[6,"valid_course_offerings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /dashboardapi/sections/valid_course_offerings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const valid_course_offerings_sections_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dashboardapi"],[2,[7,"/"],[2,[6,"sections"],[2,[7,"/"],[2,[6,"valid_course_offerings"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /dashboardapi/sections/valid_course_offerings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const valid_course_offerings_sections_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dashboardapi"],[2,[7,"/"],[2,[6,"sections"],[2,[7,"/"],[2,[6,"valid_course_offerings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /videos/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const video_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"videos"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /videos/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const video_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"videos"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /videos(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const videos_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"videos"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /videos(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const videos_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"videos"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /courses/:course_name/vocab(.:format)
 * @param {any} course_name
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const vocab_course_url = /*#__PURE__*/ __jsr.r({"course_name":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"courses"],[2,[7,"/"],[2,[3,"course_name"],[2,[7,"/"],[2,[6,"vocab"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /courses/:course_name/vocab(.:format)
 * @param {any} course_name
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const vocab_course_path = /*#__PURE__*/ __jsr.r({"course_name":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"courses"],[2,[7,"/"],[2,[3,"course_name"],[2,[7,"/"],[2,[6,"vocab"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /courses/:course_course_name/units/:position/vocab(.:format)
 * @param {any} course_course_name
 * @param {any} position
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const vocab_course_unit_url = /*#__PURE__*/ __jsr.r({"course_course_name":{"r":true},"position":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"courses"],[2,[7,"/"],[2,[3,"course_course_name"],[2,[7,"/"],[2,[6,"units"],[2,[7,"/"],[2,[3,"position"],[2,[7,"/"],[2,[6,"vocab"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /courses/:course_course_name/units/:position/vocab(.:format)
 * @param {any} course_course_name
 * @param {any} position
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const vocab_course_unit_path = /*#__PURE__*/ __jsr.r({"course_course_name":{"r":true},"position":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"courses"],[2,[7,"/"],[2,[3,"course_course_name"],[2,[7,"/"],[2,[6,"units"],[2,[7,"/"],[2,[3,"position"],[2,[7,"/"],[2,[6,"vocab"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /s/:id/vocab(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const vocab_script_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"s"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"vocab"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /s/:id/vocab(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const vocab_script_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"s"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"vocab"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /vocabularies(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const vocabularies_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"vocabularies"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /vocabularies(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const vocabularies_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"vocabularies"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /vocabularies/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const vocabulary_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"vocabularies"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /vocabularies/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const vocabulary_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"vocabularies"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /p/weblab2(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const weblab2_p_index_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[6,"weblab2"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /p/weblab2(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const weblab2_p_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[6,"weblab2"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /projects/weblab2/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const weblab2_project_create_new_projects_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"weblab2"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/weblab2/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const weblab2_project_create_new_projects_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"weblab2"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/weblab2/:channel_id/edit(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const weblab2_project_edit_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"weblab2"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/weblab2/:channel_id/edit(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const weblab2_project_edit_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"weblab2"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/weblab2/:channel_id/export_config(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const weblab2_project_export_config_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"weblab2"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"export_config"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/weblab2/:channel_id/export_config(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const weblab2_project_export_config_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"weblab2"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"export_config"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/weblab2/:channel_id/export_create_channel(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const weblab2_project_export_create_channel_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"weblab2"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"export_create_channel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/weblab2/:channel_id/export_create_channel(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const weblab2_project_export_create_channel_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"weblab2"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"export_create_channel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/weblab2/:channel_id/embed_app_and_code(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const weblab2_project_iframe_embed_app_and_code_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"weblab2"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"embed_app_and_code"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/weblab2/:channel_id/embed_app_and_code(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const weblab2_project_iframe_embed_app_and_code_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"weblab2"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"embed_app_and_code"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/weblab2/:channel_id/embed(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const weblab2_project_iframe_embed_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"weblab2"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"embed"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/weblab2/:channel_id/embed(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const weblab2_project_iframe_embed_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"weblab2"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"embed"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/weblab2(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const weblab2_project_projects_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"weblab2"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /projects/weblab2(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const weblab2_project_projects_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"weblab2"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /projects/weblab2/:channel_id/remix(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const weblab2_project_remix_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"weblab2"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"remix"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/weblab2/:channel_id/remix(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const weblab2_project_remix_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"weblab2"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"remix"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/weblab2/:channel_id(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const weblab2_project_share_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"weblab2"],[2,[7,"/"],[2,[3,"channel_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/weblab2/:channel_id(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const weblab2_project_share_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"weblab2"],[2,[7,"/"],[2,[3,"channel_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/weblab2/:channel_id/view(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const weblab2_project_view_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"weblab2"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"view"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/weblab2/:channel_id/view(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const weblab2_project_view_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"weblab2"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"view"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /weblab/host(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const weblab_host_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"weblab"],[2,[7,"/"],[2,[6,"host"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /weblab/host(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const weblab_host_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"weblab"],[2,[7,"/"],[2,[6,"host"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /weblab/network-check(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const weblab_network_check_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"weblab"],[2,[7,"/"],[2,[6,"network-check"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /weblab/network-check(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const weblab_network_check_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"weblab"],[2,[7,"/"],[2,[6,"network-check"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /p/weblab(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const weblab_p_index_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[6,"weblab"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /p/weblab(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const weblab_p_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[6,"weblab"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /projects/weblab/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const weblab_project_create_new_projects_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"weblab"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/weblab/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const weblab_project_create_new_projects_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"weblab"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/weblab/:channel_id/edit(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const weblab_project_edit_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"weblab"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/weblab/:channel_id/edit(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const weblab_project_edit_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"weblab"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/weblab/:channel_id/export_config(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const weblab_project_export_config_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"weblab"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"export_config"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/weblab/:channel_id/export_config(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const weblab_project_export_config_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"weblab"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"export_config"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/weblab/:channel_id/export_create_channel(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const weblab_project_export_create_channel_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"weblab"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"export_create_channel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/weblab/:channel_id/export_create_channel(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const weblab_project_export_create_channel_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"weblab"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"export_create_channel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/weblab/:channel_id/embed_app_and_code(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const weblab_project_iframe_embed_app_and_code_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"weblab"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"embed_app_and_code"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/weblab/:channel_id/embed_app_and_code(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const weblab_project_iframe_embed_app_and_code_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"weblab"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"embed_app_and_code"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/weblab/:channel_id/embed(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const weblab_project_iframe_embed_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"weblab"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"embed"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/weblab/:channel_id/embed(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const weblab_project_iframe_embed_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"weblab"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"embed"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/weblab(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const weblab_project_projects_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"weblab"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /projects/weblab(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const weblab_project_projects_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"weblab"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /projects/weblab/:channel_id/remix(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const weblab_project_remix_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"weblab"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"remix"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/weblab/:channel_id/remix(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const weblab_project_remix_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"weblab"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"remix"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/weblab/:channel_id/view(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const weblab_project_view_projects_url = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"weblab"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"view"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /projects/weblab/:channel_id/view(.:format)
 * @param {any} channel_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const weblab_project_view_projects_path = /*#__PURE__*/ __jsr.r({"channel_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"weblab"],[2,[7,"/"],[2,[3,"channel_id"],[2,[7,"/"],[2,[6,"view"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /widget2(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const widget2_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"widget2"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /widget2(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const widget2_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"widget2"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /widget2/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const widget2_new_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"widget2"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /widget2/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const widget2_new_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"widget2"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /xhr
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const xhr_url = /*#__PURE__*/ __jsr.r({}, [2,[7,"/"],[6,"xhr"]], true);

/**
 * Generates rails route to
 * /xhr
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const xhr_path = /*#__PURE__*/ __jsr.r({}, [2,[7,"/"],[6,"xhr"]]);

/**
 * Generates rails route to
 * /zendesk_session(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const zendesk_session_index_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"zendesk_session"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /zendesk_session(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const zendesk_session_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"zendesk_session"],[1,[2,[8,"."],[3,"format"]]]]]);

